webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(13);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(880), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(845);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(844);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(431);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(431);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(879), __esModule: true };

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(42);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(878), __esModule: true };

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(43);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1553);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Icon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _isString = __webpack_require__(323);

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaIcon = function FaIcon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      auto = _ref.auto,
      size = _ref.size,
      color = _ref.color,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['name', 'className', 'auto', 'size', 'color']);

  return _react2.default.createElement('i', (0, _extends3.default)({}, rest, {
    className: (0, _classnames2.default)('Icon fa fa-' + name, className),
    style: (0, _extends3.default)({}, !auto && {
      fontSize: size,
      width: size,
      height: size,
      lineHeight: (0, _isString2.default)(size) ? size : size + 'px'
    }, {
      color: color
    })
  }));
};

FaIcon.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.number,
  color: _propTypes2.default.string,
  auto: _propTypes2.default.bool
};

FaIcon.defaultProps = {
  size: 21
};

var RE_MATERIAL_NAME = /\s/g;

var MaterialIcon = function MaterialIcon(_ref2) {
  var name = _ref2.name,
      className = _ref2.className,
      small = _ref2.small,
      medium = _ref2.medium,
      large = _ref2.large,
      color = _ref2.color,
      light = _ref2.light,
      size = _ref2.size,
      rest = (0, _objectWithoutProperties3.default)(_ref2, ['name', 'className', 'small', 'medium', 'large', 'color', 'light', 'size']);
  return _react2.default.createElement(
    'i',
    (0, _extends3.default)({}, rest, {
      className: (0, _classnames2.default)('material-icons', small && 'md-18', medium && 'md-36', large && 'md-48', light && 'md-light', className),
      style: {
        color: color,
        fontSize: size
      }
    }),
    name.replace(RE_MATERIAL_NAME, '_')
  );
};

MaterialIcon.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  small: _propTypes2.default.bool,
  medium: _propTypes2.default.bool,
  large: _propTypes2.default.bool,
  light: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

/**
 * Icon component, using Font Awesome or Material Icons, depending on the `material` prop.
 */
function Icon(_ref3) {
  var material = _ref3.material,
      props = (0, _objectWithoutProperties3.default)(_ref3, ['material']);

  return material ? _react2.default.createElement(MaterialIcon, props) : _react2.default.createElement(FaIcon, props);
}

Icon.propTypes = {
  material: _propTypes2.default.bool
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexItem = exports.FlexContainer = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(1008);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Flex container - use this instead of bulma columns when you don't want the extra
 * cruft of the bulma grid.
 */
var FlexContainer = function FlexContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignItems = _ref.alignItems,
      alignContent = _ref.alignContent,
      style = _ref.style,
      direction = _ref.direction,
      justifyContent = _ref.justifyContent,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'alignItems', 'alignContent', 'style', 'direction', 'justifyContent']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)('FlexContainer', className), style: (0, _extends3.default)({ alignItems: alignItems, flexDirection: direction, justifyContent: justifyContent, alignContent: alignContent }, style) }, props),
    children
  );
};

exports.FlexContainer = FlexContainer;
FlexContainer.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  direction: _propTypes2.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse', 'initial', 'inherit']),
  alignContent: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around', 'initial', 'inherit']),
  alignItems: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline', 'initial', 'inherit']),
  justifyContent: _propTypes2.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'initial', 'inherit'])
};

/**
 * Flex item.
 */
var FlexItem = function FlexItem(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      stretch = _ref2.stretch,
      vcentered = _ref2.vcentered,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['children', 'className', 'stretch', 'vcentered']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('FlexItem', {
        'FlexItem--stretch': stretch,
        'FlexItem--vcentered': vcentered
      }, className)
    }, props),
    children
  );
};

exports.FlexItem = FlexItem;
FlexItem.propTypes = {
  className: _propTypes2.default.string,
  stretch: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  vcentered: _propTypes2.default.bool
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  logout: function logout() {
    return '/logout';
  },
  login: function login() {
    return '/login';
  },
  projects: function projects() {
    return '/';
  },
  projectDetails: function projectDetails(projectId) {
    return '/project/' + projectId;
  },
  projectEditor: function projectEditor(projectId) {
    return '/project/' + projectId + '/edit';
  },
  rateProject: function rateProject(projectId) {
    return '/project/' + projectId + '/rate';
  },
  allDocuments: function allDocuments() {
    return '/documents';
  },
  profile: function profile() {
    return '/profile';
  },
  linkedAccounts: function linkedAccounts() {
    return '/linked-accounts';
  },
  coupons: function coupons() {
    return '/coupons';
  },
  referAFriend: function referAFriend() {
    return '/refer';
  },
  newProject: function newProject() {
    return '/new';
  },
  billing: function billing() {
    return '/billing';
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvbWlzYy9saW5rcy5qcyJdLCJuYW1lcyI6WyJsb2dvdXQiLCJsb2dpbiIsInByb2plY3RzIiwicHJvamVjdERldGFpbHMiLCJwcm9qZWN0SWQiLCJwcm9qZWN0RWRpdG9yIiwicmF0ZVByb2plY3QiLCJhbGxEb2N1bWVudHMiLCJwcm9maWxlIiwibGlua2VkQWNjb3VudHMiLCJjb3Vwb25zIiwicmVmZXJBRnJpZW5kIiwibmV3UHJvamVjdCIsImJpbGxpbmciXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7QUFDYkEsVUFBUTtBQUFBLFdBQU0sU0FBTjtBQUFBLEdBREs7QUFFYkMsU0FBTztBQUFBLFdBQU0sUUFBTjtBQUFBLEdBRk07QUFHYkMsWUFBVTtBQUFBLFdBQU0sR0FBTjtBQUFBLEdBSEc7QUFJYkMsa0JBQWdCLHdCQUFDQyxTQUFEO0FBQUEseUJBQTJCQSxTQUEzQjtBQUFBLEdBSkg7QUFLYkMsaUJBQWUsdUJBQUNELFNBQUQ7QUFBQSx5QkFBMkJBLFNBQTNCO0FBQUEsR0FMRjtBQU1iRSxlQUFhLHFCQUFDRixTQUFEO0FBQUEseUJBQTJCQSxTQUEzQjtBQUFBLEdBTkE7QUFPYkcsZ0JBQWM7QUFBQSxXQUFNLFlBQU47QUFBQSxHQVBEO0FBUWJDLFdBQVM7QUFBQSxXQUFNLFVBQU47QUFBQSxHQVJJO0FBU2JDLGtCQUFnQjtBQUFBLFdBQU0sa0JBQU47QUFBQSxHQVRIO0FBVWJDLFdBQVM7QUFBQSxXQUFNLFVBQU47QUFBQSxHQVZJO0FBV2JDLGdCQUFjO0FBQUEsV0FBTSxRQUFOO0FBQUEsR0FYRDtBQVliQyxjQUFZO0FBQUEsV0FBTSxNQUFOO0FBQUEsR0FaQztBQWFiQyxXQUFTO0FBQUEsV0FBTSxVQUFOO0FBQUE7QUFiSSxDQUFmIiwiZmlsZSI6ImxpbmtzLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBsb2dvdXQ6ICgpID0+ICcvbG9nb3V0JyxcbiAgbG9naW46ICgpID0+ICcvbG9naW4nLFxuICBwcm9qZWN0czogKCkgPT4gJy8nLFxuICBwcm9qZWN0RGV0YWlsczogKHByb2plY3RJZCkgPT4gYC9wcm9qZWN0LyR7cHJvamVjdElkfWAsXG4gIHByb2plY3RFZGl0b3I6IChwcm9qZWN0SWQpID0+IGAvcHJvamVjdC8ke3Byb2plY3RJZH0vZWRpdGAsXG4gIHJhdGVQcm9qZWN0OiAocHJvamVjdElkKSA9PiBgL3Byb2plY3QvJHtwcm9qZWN0SWR9L3JhdGVgLFxuICBhbGxEb2N1bWVudHM6ICgpID0+ICcvZG9jdW1lbnRzJyxcbiAgcHJvZmlsZTogKCkgPT4gJy9wcm9maWxlJyxcbiAgbGlua2VkQWNjb3VudHM6ICgpID0+ICcvbGlua2VkLWFjY291bnRzJyxcbiAgY291cG9uczogKCkgPT4gJy9jb3Vwb25zJyxcbiAgcmVmZXJBRnJpZW5kOiAoKSA9PiAnL3JlZmVyJyxcbiAgbmV3UHJvamVjdDogKCkgPT4gJy9uZXcnLFxuICBiaWxsaW5nOiAoKSA9PiAnL2JpbGxpbmcnXG59XG4iXX0=

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(876), __esModule: true };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(883), __esModule: true };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(288)('wks')
  , uid        = __webpack_require__(208)
  , Symbol     = __webpack_require__(54).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tinycolor = __webpack_require__(377);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

__webpack_require__(1016);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconStyle = function getIconStyle(_ref) {
  var color = _ref.color,
      size = _ref.size,
      thickness = _ref.thickness,
      blue = _ref.blue;

  if (blue) {
    color = '#2395F3';
  }

  var $color = (0, _tinycolor2.default)(color);
  var $offColor = $color.clone().setAlpha(0.2);

  return {
    borderColor: $offColor,
    borderTopColor: $color,
    width: size,
    height: size,
    borderWidth: thickness
  };
};

var ProgressSpinner = function ProgressSpinner(props) {
  return _react2.default.createElement(
    'div',
    { className: 'ProgressSpinner' },
    _react2.default.createElement('div', { className: 'ProgressSpinner__icon', style: getIconStyle(props) })
  );
};

ProgressSpinner.defaultProps = {
  color: '#fff',
  size: 24,
  thickness: 3
};

ProgressSpinner.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  thickness: _propTypes2.default.number,
  blue: _propTypes2.default.bool
};

exports.default = ProgressSpinner;
//# sourceMappingURL=index.js.map

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(1020);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShadowBox = function ShadowBox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      pad = _ref.pad,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? 1 : _ref$level,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'children', 'pad', 'level']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('shadow-box', 'shadow-box--level-' + level, pad && 'shadow-box--pad', className)
    }, props),
    children
  );
};

ShadowBox.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  pad: _propTypes2.default.bool,
  level: _propTypes2.default.number
};

exports.default = ShadowBox;
//# sourceMappingURL=index.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(54)
  , core      = __webpack_require__(30)
  , ctx       = __webpack_require__(91)
  , hide      = __webpack_require__(92)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(81)
  , IE8_DOM_DEFINE = __webpack_require__(446)
  , toPrimitive    = __webpack_require__(290)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(70) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = AgnosticLink;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A link that is either a <Link> or an <IndexLink> based on the `index` property.
 */
function AgnosticLink(_ref) {
  var index = _ref.index,
      props = (0, _objectWithoutProperties3.default)(_ref, ['index']);

  var LinkComponent = props.to ? index ? _reactRouter.IndexLink : _reactRouter.Link : 'a';
  return _react2.default.createElement(LinkComponent, props);
}

AgnosticLink.propTypes = {
  index: _propTypes2.default.bool,
  to: _propTypes2.default.string
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intercomUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







function intercomUpdate(attrs) {
  return function decorator(Target) {
    return function (_React$Component) {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Wrapped, _React$Component);

      function Wrapped() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Wrapped);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Wrapped.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Wrapped)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Wrapped, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.props.rootStore.intercomStore.update(attrs);
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Target, this.props);
        }
      }]);

      return Wrapped;
    }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZGVjb3JhdG9ycy9pbnRlcmNvbVVwZGF0ZS5qcyJdLCJuYW1lcyI6WyJSZWFjdCIsImludGVyY29tVXBkYXRlIiwiYXR0cnMiLCJkZWNvcmF0b3IiLCJUYXJnZXQiLCJwcm9wcyIsInJvb3RTdG9yZSIsImludGVyY29tU3RvcmUiLCJ1cGRhdGUiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBT0EsS0FBUCxNQUFrQixPQUFsQjs7QUFFQSxlQUFlLFNBQVNDLGNBQVQsQ0FBeUJDLEtBQXpCLEVBQWdDO0FBQzdDLFNBQU8sU0FBU0MsU0FBVCxDQUFvQkMsTUFBcEIsRUFBNEI7QUFDakM7QUFBQTs7QUFBQTtBQUFBOztBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBLDRDQUN1QjtBQUNuQixlQUFLQyxLQUFMLENBQVdDLFNBQVgsQ0FBcUJDLGFBQXJCLENBQW1DQyxNQUFuQyxDQUEwQ04sS0FBMUM7QUFDRDtBQUhIO0FBQUE7QUFBQSxpQ0FLWTtBQUNSLGlCQUNFLG9CQUFDLE1BQUQsRUFBWSxLQUFLRyxLQUFqQixDQURGO0FBR0Q7QUFUSDs7QUFBQTtBQUFBLE1BQTZCTCxNQUFNUyxTQUFuQztBQVdELEdBWkQ7QUFhRCIsImZpbGUiOiJpbnRlcmNvbVVwZGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gaW50ZXJjb21VcGRhdGUgKGF0dHJzKSB7XG4gIHJldHVybiBmdW5jdGlvbiBkZWNvcmF0b3IgKFRhcmdldCkge1xuICAgIHJldHVybiBjbGFzcyBXcmFwcGVkIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgICAgIGNvbXBvbmVudERpZE1vdW50ICgpIHtcbiAgICAgICAgdGhpcy5wcm9wcy5yb290U3RvcmUuaW50ZXJjb21TdG9yZS51cGRhdGUoYXR0cnMpXG4gICAgICB9XG5cbiAgICAgIHJlbmRlciAoKSB7XG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgPFRhcmdldCB7Li4udGhpcy5wcm9wc30gLz5cbiAgICAgICAgKVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl19

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(106)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(90);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(12);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = makePrefix;

var _reduce = __webpack_require__(538);

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Makes a function that prefixes object keys.
 */
function makePrefix(prefix) {
  return function prefixer(obj) {
    return (0, _reduce2.default)(obj, function (accum, value, key) {
      return (0, _extends4.default)({}, accum, (0, _defineProperty3.default)({}, prefix + key, value));
    }, {});
  };
}
//# sourceMappingURL=prefix.js.map

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeaderRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderSink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_FloatingActionButton__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_FloatingActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_FloatingActionButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Avatar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_img_logo_white_png__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_img_logo_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_assets_img_logo_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Tabs__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_ComponentSink__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_ComponentSink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_ComponentSink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__header_background_2x_png__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__header_background_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__header_background_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_img_logo_white_2x_png__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_img_logo_white_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_assets_img_logo_white_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_sass__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_sass__);








var _class;





















var Header = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Header, _React$Component);

  function Header() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Header);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Header.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Header)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$rootStore = _props.rootStore,
          authStore = _props$rootStore.authStore,
          desktopNotificationStore = _props$rootStore.desktopNotificationStore,
          soundStore = _props$rootStore.soundStore,
          onClickBack = _props.onClickBack,
          children = _props.children,
          showTabs = _props.showTabs,
          small = _props.small,
          backTo = _props.backTo,
          onFabClick = _props.onFabClick,
          fabTo = _props.fabTo;


      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'header',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('app-header animated fadeIn is-faster', small && 'app-header--small') },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Navbar, {
          user: authStore.user,
          onClickBack: onClickBack,
          backTo: backTo,
          supportsNotifications: desktopNotificationStore.isSupported,
          notificationsEnabled: desktopNotificationStore.isEnabled,
          onToggleNotificationsClick: function onToggleNotificationsClick() {
            return desktopNotificationStore.setEnabled(!desktopNotificationStore.isEnabled);
          },
          soundEnabled: soundStore.isEnabled,
          onToggleSoundClick: function onToggleSoundClick() {
            return soundStore.setEnabled(!soundStore.isEnabled);
          },
          onLogoutClick: function onLogoutClick() {
            return authStore.logout();
          }
        }),
        children || __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Welcome, { user: authStore.user }),
        showTabs && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(HeaderTabs, null),
        (onFabClick || fabTo) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'fab-container' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_FloatingActionButton___default.a, {
            pull: true,
            large: true,
            icon: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Icon___default.a, { material: true, name: 'add' }),
            'data-test': 'new-project',
            onClick: onFabClick,
            to: fabTo
          })
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component)) || _class;




var HeaderTitle = function HeaderTitle(_ref) {
  var children = _ref.children,
      spacingTop = _ref.spacingTop,
      large = _ref.large;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('header-title-container', spacingTop && 'has-spacing-top', large && 'is-large')
    },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h1',
      { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('header-title title is-white has-text-centered', !large && 'is-semibold') },
      children
    )
  );
};

var Welcome = function Welcome(_ref2) {
  var user = _ref2.user;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    HeaderTitle,
    { spacingTop: true, large: true },
    'Welcome ',
    user.name,
    '!'
  );
};

Welcome = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx_react__["observer"])(Welcome);

// These are not used at the moment,
// but if they were, the FAB would be in
// the way, which is bad.
var HeaderTabs = function HeaderTabs(_ref3) {
  var children = _ref3.children;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: 'tab-bar-container animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_18_components_Tabs__["a" /* Tabs */],
      null,
      children
    )
  );
};

var Navbar = function Navbar(_ref4) {
  var user = _ref4.user,
      onClickBack = _ref4.onClickBack,
      backTo = _ref4.backTo,
      isIndex = _ref4.isIndex,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['user', 'onClickBack', 'backTo', 'isIndex']);

  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexContainer"],
    { className: 'navbar' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
      null,
      onClickBack || backTo ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(BackButton, { onClick: onClickBack, backTo: backTo, isIndex: isIndex }) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components_Link___default.a,
        { to: '/', className: 'brand animated fadeIn' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_16_assets_img_logo_white_png___default.a, alt: 'Taxfyle', className: 'logo' })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"], { stretch: true }),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
      null,
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(UserInfo, {
        name: user.name,
        avatar: user.avatar
      })
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
      null,
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(NavbarActions, rest)
    )
  );
};

Navbar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx_react__["observer"])(Navbar);

var UserInfo = function UserInfo(_ref5) {
  var avatar = _ref5.avatar,
      name = _ref5.name;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: 'user-info animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexContainer"],
      null,
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
        { vcentered: true },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Avatar___default.a, { size: 24, url: avatar, alt: name, className: 'avatar' })
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
        { className: 'name' },
        name
      )
    )
  );
};

// const NavbarActions = () => (
//   <div className="actions animated fadeIn">
//     <Link to={links.logout()} className="action button is-icon-only is-white is-faded" title="Log out">
//       <Icon material name="power settings new" />
//     </Link>
//   </div>
// )

var NavbarActions = function NavbarActions(_ref6) {
  var supportsNotifications = _ref6.supportsNotifications,
      notificationsEnabled = _ref6.notificationsEnabled,
      onToggleNotificationsClick = _ref6.onToggleNotificationsClick,
      soundEnabled = _ref6.soundEnabled,
      onToggleSoundClick = _ref6.onToggleSoundClick,
      onLogoutClick = _ref6.onLogoutClick;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: 'actions animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["Dropdown"],
      {
        position: 'right',
        button: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'a',
          { className: 'action button is-icon-only is-white is-faded', 'data-test': 'toggle-header-dropdown' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Icon___default.a, { material: true, name: 'more vert' })
        )
      },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { to: __WEBPACK_IMPORTED_MODULE_17_misc_links__["a" /* default */].profile(), 'data-test': 'goto-profile' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: 'account circle' }),
        'Account'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { to: __WEBPACK_IMPORTED_MODULE_17_misc_links__["a" /* default */].billing(), 'data-test': 'goto-billing' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: 'credit card' }),
        'Billing'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { to: __WEBPACK_IMPORTED_MODULE_17_misc_links__["a" /* default */].allDocuments(), 'data-test': 'goto-all-documents' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: 'attach file' }),
        'All Documents'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { to: __WEBPACK_IMPORTED_MODULE_17_misc_links__["a" /* default */].coupons(), 'data-test': 'goto-coupons' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: 'attach money' }),
        'Coupons'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { to: __WEBPACK_IMPORTED_MODULE_17_misc_links__["a" /* default */].referAFriend(), 'data-test': 'refer-a-friend' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: 'group' }),
        'Refer a Friend'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('hr', null),
      supportsNotifications && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { onClick: function onClick() {
            return onToggleNotificationsClick();
          } },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: notificationsEnabled ? 'notifications' : 'notifications off' }),
        notificationsEnabled ? 'Notifications enabled' : 'Notifications disabled'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { onClick: function onClick() {
            return onToggleSoundClick();
          } },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: soundEnabled ? 'volume up' : 'volume off' }),
        soundEnabled ? 'Sound enabled' : 'Sound muted'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('hr', null),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItem"],
        { onClick: function onClick() {
            return onLogoutClick();
          }, 'data-test': 'logout' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Dropdown__["DropdownItemIcon"], { material: true, name: 'power settings new' }),
        'Log out'
      )
    )
  );
};

var BackButton = function BackButton(_ref7) {
  var onClick = _ref7.onClick,
      backTo = _ref7.backTo,
      isIndex = _ref7.isIndex;

  var Button = function Button(props) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { onClick: onClick }));
  };
  var LinkComponent = function LinkComponent(props) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Link___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ index: isIndex }, props, { to: backTo }));
  };
  var ButtonComponent = backTo ? LinkComponent : Button;

  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    ButtonComponent,
    { className: 'button is-icon-only is-white is-faded animated fadeIn', 'data-test': 'header-back-button' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Icon___default.a, { material: true, medium: true, name: 'arrow back' })
  );
};

// The following 2 components lets us declare props for the header
// in sub components, even though the actual header is mounted further up the tree.
// This is used to prevent remounting with React Router, which will kill certain
// animations.

var _makeSink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_components_ComponentSink__["makeSink"])(Header),
    Sink = _makeSink.Sink,
    Renderer = _makeSink.Renderer;

var HeaderRenderer = Renderer;
var HeaderSink = Sink;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getError = exports.Select = exports.DatePicker = exports.Input = exports.Help = exports.FormGroup = exports.Form = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = __webpack_require__(1436);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _mobxReact = __webpack_require__(8);

var _mobx = __webpack_require__(7);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _first = __webpack_require__(1376);

var _first2 = _interopRequireDefault(_first);

__webpack_require__(1010);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a submit handler that will invoke the
 * specified function after preventing defaults.
 */
var createSubmitHandler = function createSubmitHandler(onSubmit) {
  return function (e) {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };
};

/**
 * Help block.
 */
var Help = function Help(_ref) {
  var help = _ref.help,
      error = _ref.error;
  return error || help ? _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)('help', error && 'is-danger') },
    error || help
  ) : null;
};

Help.propTypes = {
  help: _propTypes2.default.node,
  error: _propTypes2.default.node
};

/**
 * Form.
 */
var Form = function Form(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      onSubmit = _ref2.onSubmit,
      opts = (0, _objectWithoutProperties3.default)(_ref2, ['children', 'className', 'onSubmit']);
  return _react2.default.createElement(
    'form',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('Form', className)
    }, opts, {
      onSubmit: createSubmitHandler(onSubmit)
    }),
    children
  );
};

Form.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func
};

exports.Form = Form = (0, _mobxReact.observer)(Form);

/**
 * Form group, wraps form components with proper spacing.
 */
var FormGroup = function FormGroup(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      label = _ref3.label;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('FormGroup', className) },
    label && _react2.default.createElement(
      'label',
      { className: 'label' },
      label
    ),
    children
  );
};

FormGroup.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  label: _propTypes2.default.node
};

/**
 * Helper to grab an error from a model.
 */
var getError = function getError(model, field) {
  if (!model.validation || !model.validation.errors) return undefined;
  var errors = model.validation.errors[field];
  if (errors) {
    return (0, _first2.default)(errors);
  }

  return undefined;
};

/**
 * Input field component.
 */
var Input = function Input(_ref4) {
  var model = _ref4.model,
      field = _ref4.field,
      label = _ref4.label,
      help = _ref4.help,
      className = _ref4.className,
      props = (0, _objectWithoutProperties3.default)(_ref4, ['model', 'field', 'label', 'help', 'className']);

  var error = getError(model, field);
  return _react2.default.createElement(
    FormGroup,
    { className: 'Input', label: label },
    _react2.default.createElement(
      'div',
      { className: 'control' },
      _react2.default.createElement('input', (0, _extends3.default)({
        type: 'text',
        className: (0, _classnames2.default)('input', error && 'is-danger', className),
        value: model[field] === undefined ? '' : model[field],
        onChange: (0, _mobx.action)(function (e) {
          model[field] = e.target.value;
        }),
        disabled: model.disabled
      }, props)),
      _react2.default.createElement(Help, { error: error, help: help })
    )
  );
};

Input.propTypes = {
  model: _propTypes2.default.object,
  field: _propTypes2.default.string,
  label: _propTypes2.default.node,
  help: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.Input = Input = (0, _mobxReact.observer)(Input);

/**
 * Select field component.
 */
var Select = function Select(_ref5) {
  var model = _ref5.model,
      field = _ref5.field,
      label = _ref5.label,
      help = _ref5.help,
      className = _ref5.className,
      props = (0, _objectWithoutProperties3.default)(_ref5, ['model', 'field', 'label', 'help', 'className']);

  var error = getError(model, field);
  return _react2.default.createElement(
    FormGroup,
    { className: 'Select', label: label },
    _react2.default.createElement(
      'div',
      { className: 'control' },
      _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('select', error && 'is-danger', className) },
        _react2.default.createElement('select', (0, _extends3.default)({
          value: model[field] === undefined ? '' : model[field],
          onChange: (0, _mobx.action)(function (e) {
            model[field] = e.target.value;
          }),
          disabled: model.disabled
        }, props))
      ),
      _react2.default.createElement(Help, { error: error, help: help })
    )
  );
};

Select.propTypes = {
  model: _propTypes2.default.object,
  field: _propTypes2.default.string,
  label: _propTypes2.default.node,
  help: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.Select = Select = (0, _mobxReact.observer)(Select);

/**
 * Date picker component.
 */
var DatePicker = function DatePicker(_ref6) {
  var model = _ref6.model,
      field = _ref6.field,
      label = _ref6.label,
      help = _ref6.help,
      className = _ref6.className,
      props = (0, _objectWithoutProperties3.default)(_ref6, ['model', 'field', 'label', 'help', 'className']);

  var error = getError(model, field);
  return _react2.default.createElement(
    FormGroup,
    { className: 'Input', label: label },
    _react2.default.createElement(
      'div',
      { className: 'control' },
      _react2.default.createElement(_reactDatepicker2.default, (0, _extends3.default)({
        className: (0, _classnames2.default)('input', error && 'is-danger', className),
        selected: model[field] === undefined ? null : model[field],
        onChange: (0, _mobx.action)(function (date) {
          model[field] = date;
        }),
        disabled: model.disabled
      }, props)),
      _react2.default.createElement(Help, { error: error, help: help })
    )
  );
};

DatePicker.propTypes = {
  model: _propTypes2.default.object,
  field: _propTypes2.default.string,
  label: _propTypes2.default.node,
  help: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.DatePicker = DatePicker = (0, _mobxReact.observer)(DatePicker);

exports.Form = Form;
exports.FormGroup = FormGroup;
exports.Help = Help;
exports.Input = Input;
exports.DatePicker = DatePicker;
exports.Select = Select;
exports.getError = getError;
//# sourceMappingURL=index.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = scrollToTop;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Higher-order component for scrolling to top upon mount.
 */
function scrollToTop(Target) {
  return function (_React$Component) {
    (0, _inherits3.default)(ScrollToTop, _React$Component);

    function ScrollToTop() {
      (0, _classCallCheck3.default)(this, ScrollToTop);
      return (0, _possibleConstructorReturn3.default)(this, (ScrollToTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollToTop)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollToTop, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        window.scrollTo(0, 0);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Target, this.props);
      }
    }]);
    return ScrollToTop;
  }(_react2.default.Component);
}
//# sourceMappingURL=scrollToTop.js.map

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(13);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(276);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(60)
  , createDesc = __webpack_require__(160);
module.exports = __webpack_require__(70) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(280)
  , defined = __webpack_require__(202);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(996);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Avatar component with support for fallback images.
 */
var Avatar = function (_React$Component) {
  (0, _inherits3.default)(Avatar, _React$Component);

  function Avatar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Avatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      usingFallback: false
    }, _this.onError = function () {
      if (!_this.state.usingFallback) {
        _this.setState({ usingFallback: true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Avatar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // When we receive new props, reset the fallback.
      if (this.props.url !== nextProps.url && this.state.usingFallback === true) {
        this.setState({ usingFallback: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          size = _props.size,
          style = _props.style,
          fallback = _props.fallback,
          className = _props.className,
          props = (0, _objectWithoutProperties3.default)(_props, ['url', 'size', 'style', 'fallback', 'className']);
      var usingFallback = this.state.usingFallback;

      return _react2.default.createElement('img', (0, _extends3.default)({
        src: usingFallback && fallback ? fallback : url,
        onError: this.onError,
        className: (0, _classnames2.default)('Avatar', className),
        style: (0, _extends3.default)({ width: size, height: size }, style)
      }, props));
    }
  }]);
  return Avatar;
}(_react2.default.Component);

exports.default = Avatar;


Avatar.propTypes = {
  url: _propTypes2.default.string,
  size: _propTypes2.default.number,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  fallback: _propTypes2.default.string
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT = undefined;

var _symbol = __webpack_require__(270);

var _symbol2 = _interopRequireDefault(_symbol);

exports.match = match;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT = exports.DEFAULT = (0, _symbol2.default)('Default');

function match(matchOn, cases) {
  var val = matchOn in cases ? cases[matchOn] : DEFAULT in cases ? cases[DEFAULT] : noMatch(matchOn);

  return typeof val === 'function' ? val() : val;
}

function noMatch(matchOn) {
  throw new Error('No match for ' + matchOn);
}

match.DEFAULT = DEFAULT;
//# sourceMappingURL=patternMatchUtil.js.map

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(454)
  , enumBugKeys = __webpack_require__(279);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(202);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(906)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(281)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckListItem = exports.CheckList = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = __webpack_require__(77);

var _prefix2 = _interopRequireDefault(_prefix);

__webpack_require__(999);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('checklist-item--');

var CheckList = exports.CheckList = function CheckList(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'checklist' },
    children
  );
};

CheckList.propTypes = {
  children: _propTypes2.default.node
};

var CheckListItem = exports.CheckListItem = function CheckListItem(_ref2) {
  var onChange = _ref2.onChange,
      small = _ref2.small,
      checked = _ref2.checked,
      children = _ref2.children;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('checklist-item', modifiers({ checked: checked, small: small })),
      role: 'checkbox',
      'aria-checked': checked,
      onClick: function onClick() {
        return onChange && onChange(!checked);
      }
    },
    _react2.default.createElement(
      'span',
      { className: 'checklist-item__label' },
      children
    )
  );
};

CheckListItem.propTypes = {
  onChange: _propTypes2.default.func,
  checked: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = __webpack_require__(77);

var _prefix2 = _interopRequireDefault(_prefix);

var _ProgressSpinner = __webpack_require__(52);

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

__webpack_require__(1001);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('content-loader--');

var ContentLoader = function ContentLoader(_ref) {
  var small = _ref.small;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('content-loader', modifiers({ small: small })) },
    _react2.default.createElement(_ProgressSpinner2.default, {
      thickness: 3,
      size: 36,
      blue: true
    })
  );
};

ContentLoader.propTypes = {
  small: _propTypes2.default.bool
};

exports.default = ContentLoader;
//# sourceMappingURL=index.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = exports.DialogFooter = exports.DialogButton = exports.DialogContent = exports.DialogTitle = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(1002);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dialog title.
 */
var DialogTitle = exports.DialogTitle = function DialogTitle(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('DialogTitle', className) },
    children
  );
};

DialogTitle.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

/**
 * Dialog content.
 */
var DialogContent = function DialogContent(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      other = (0, _objectWithoutProperties3.default)(_ref2, ['children', 'className']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)('DialogContent', className) }, other),
    children
  );
};

exports.DialogContent = DialogContent;
DialogContent.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

/**
 * Dialog button.
 */
var DialogButton = function DialogButton(_ref3) {
  var primary = _ref3.primary,
      danger = _ref3.danger,
      children = _ref3.children,
      className = _ref3.className,
      other = (0, _objectWithoutProperties3.default)(_ref3, ['primary', 'danger', 'children', 'className']);
  return _react2.default.createElement(
    'button',
    (0, _extends3.default)({ className: (0, _classnames2.default)('DialogButton', { primary: primary, danger: danger }, className) }, other),
    children
  );
};

exports.DialogButton = DialogButton;
DialogButton.propTypes = {
  children: _propTypes2.default.node,
  primary: _propTypes2.default.bool,
  danger: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

/**
 * Dialog footer. Used to place buttons in.
 * Stuff is aligned to the right using flexbox.
 */
var DialogFooter = exports.DialogFooter = function DialogFooter(_ref4) {
  var children = _ref4.children,
      className = _ref4.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('DialogFooter', className) },
    children
  );
};

DialogFooter.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

/**
 * Dialog.
 */
var Dialog = exports.Dialog = function Dialog(_ref5) {
  var children = _ref5.children,
      className = _ref5.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('Dialog', className) },
    children
  );
};

Dialog.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPortal = __webpack_require__(374);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

__webpack_require__(1014);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The actual modal.
 */
var ActualModal = function (_React$Component) {
  (0, _inherits3.default)(ActualModal, _React$Component);

  function ActualModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActualModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActualModal.__proto__ || (0, _getPrototypeOf2.default)(ActualModal)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      if (_this.props.isControlled) {
        if (_this.props.onRequestClose) {
          _this.props.onRequestClose();
          return;
        }
      }

      _this.props.closePortal();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActualModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Modal modal is-active', className) },
        _react2.default.createElement('div', { className: 'modal-background', onClick: this.close }),
        _react2.default.createElement(
          'div',
          { className: 'modal-container' },
          _react2.default.createElement(
            'div',
            { className: 'modal-content' },
            children
          )
        ),
        _react2.default.createElement('button', { className: 'modal-close', onClick: this.close })
      );
    }
  }]);
  return ActualModal;
}(_react2.default.Component);

ActualModal.propTypes = {
  isControlled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onRequestClose: _propTypes2.default.func,
  closePortal: _propTypes2.default.func,
  children: _propTypes2.default.node
};

/**
 * A nice Modal component.
 *
 * Simple usage: <Modal openByClickOn={<button>lol</button>}>content</Modal>
 */

var Modal = function (_React$Component2) {
  (0, _inherits3.default)(Modal, _React$Component2);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          onRequestClose = _props2.onRequestClose,
          isOpened = _props2.isOpened,
          className = _props2.className,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'onRequestClose', 'isOpened', 'className']);

      return _react2.default.createElement(
        _reactPortal2.default,
        (0, _extends3.default)({}, isOpened !== undefined && { isOpened: isOpened }, other),
        _react2.default.createElement(
          ActualModal,
          { onRequestClose: onRequestClose, isControlled: isOpened !== undefined, className: className },
          children
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

Modal.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onRequestClose: _propTypes2.default.func,
  isOpened: _propTypes2.default.bool
};

exports.default = Modal;
//# sourceMappingURL=index.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupByBinary = exports.makeMomentSorter = exports.toArray = undefined;

var _identity = __webpack_require__(117);

var _identity2 = _interopRequireDefault(_identity);

var _moment = __webpack_require__(47);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a value to an array with it being
 * the only item, if the value isn't already an array.
 *
 * @param  {*} value
 * @return {*[]}
 */
var toArray = exports.toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

/**
 * Makes a moment sorter function to be passed into an array.
 *
 * @param  {String}   direction
 * asc or desc
 *
 * @param  {Function} getter
 * Invoked to get the moment on the element. Default is identity.
 *
 * @return {Function}
 * A function to pass into Array.prototype.sort
 */
var makeMomentSorter = exports.makeMomentSorter = function makeMomentSorter() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';
  var getter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
  return function (left, right) {
    var leftMoment = (0, _moment2.default)(getter(left));
    var rightMoment = (0, _moment2.default)(getter(right));

    var first = direction === 'asc' ? -1 : 1;
    var last = direction === 'asc' ? 1 : -1;

    if (leftMoment.isBefore(rightMoment)) return first;
    if (leftMoment.isAfter(rightMoment)) return last;

    return 0;
  };
};

/**
 * Like groupBy, but groups by whether the iteratee returns true or false.
 *
 * @param array
 * @param iteratee
 * @return
 * An array where the first item is the true array, and the second is the false array.
 * @example
 *    const [even, odd] = groupByBinary([1, 2, 3, 4], i => i % 2 === 0)
 *    even = [2, 4]
 *    odd = [1, 3]
 */
var groupByBinary = exports.groupByBinary = function groupByBinary(array, iteratee) {
  var trueItems = [];
  var falseItems = [];
  array.forEach(function (item) {
    if (iteratee(item)) {
      trueItems.push(item);
    } else {
      falseItems.push(item);
    }
  });

  return [trueItems, falseItems];
};
//# sourceMappingURL=arrayUtil.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatCurrency;

var _memoize = __webpack_require__(138);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a formatter for the given currency.
 *
 * @param  {string} currency
 * @return {Intl.NumberFormat}
 */
var formatterFor = function formatterFor(currency) {
  return new Intl.NumberFormat('en-US', { currency: currency, style: 'currency' });
};

// Memoizes formatter instances.
formatterFor = (0, _memoize2.default)(formatterFor);

/**
 * Formats the given value for the specified currency.
 *
 * @param  {Number} value
 * The value to format.
 *
 * @param  {string} currency
 * The currency to format as. Defaults to usd.
 *
 * @return {string}
 * The formatted currency.
 */
function formatCurrency(value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'usd';

  return formatterFor(currency).format(value);
}
//# sourceMappingURL=formatCurrency.js.map

/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (window.__env);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvbWlzYy9lbnYuanMiXSwibmFtZXMiOlsid2luZG93IiwiX19lbnYiXSwibWFwcGluZ3MiOiJBQUFBLGVBQWVBLE9BQU9DLEtBQXRCIiwiZmlsZSI6ImVudi5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHdpbmRvdy5fX2VudlxuIl19

/***/ }),
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(60).f
  , has = __webpack_require__(107)
  , TAG = __webpack_require__(44)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(911);
var global        = __webpack_require__(54)
  , hide          = __webpack_require__(92)
  , Iterators     = __webpack_require__(129)
  , TO_STRING_TAG = __webpack_require__(44)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

var _prefix = __webpack_require__(77);

var _prefix2 = _interopRequireDefault(_prefix);

__webpack_require__(1000);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('content-error--');

var ContentError = function ContentError(_ref) {
  var title = _ref.title,
      error = _ref.error,
      large = _ref.large,
      onRetryClick = _ref.onRetryClick;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('content-error', modifiers({ large: large })) },
    _react2.default.createElement(_Icon2.default, { material: true, name: 'error outline', color: '#F44336', large: true }),
    _react2.default.createElement(
      'h3',
      { className: 'title is-3 content-error__title' },
      title
    ),
    error && _react2.default.createElement(
      'div',
      { className: 'content-error__error' },
      typeof error === 'string' ? error : error.response && error.response.data ? error.response.data.message : error.message
    ),
    onRetryClick && _react2.default.createElement(
      'div',
      { className: 'content-error__retry-container' },
      _react2.default.createElement(
        'a',
        { className: 'button is-danger is-outlined', onClick: function onClick(e) {
            return e.preventDefault() || onRetryClick();
          } },
        'Retry'
      )
    )
  );
};

ContentError.propTypes = {
  title: _propTypes2.default.string,
  error: _propTypes2.default.any,
  large: _propTypes2.default.bool,
  onRetryClick: _propTypes2.default.func
};

ContentError.defaultProps = {
  title: 'An error occurred'
};

exports.default = ContentError;
//# sourceMappingURL=index.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(1005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wraps any component and overlays a file input.
 */
var FileButton = function (_React$Component) {
  (0, _inherits3.default)(FileButton, _React$Component);

  function FileButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FileButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FileButton.__proto__ || (0, _getPrototypeOf2.default)(FileButton)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var handler = _this.props.onChange;
      if (handler) handler(e.target.files);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FileButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['children']);

      return _react2.default.createElement(
        'div',
        { className: 'FileButton' },
        children,
        _react2.default.createElement('input', (0, _extends3.default)({
          multiple: false,
          value: ''
        }, props, {
          type: 'file',
          onChange: this.onChange,
          className: 'FileButton__input'
        }))
      );
    }
  }]);
  return FileButton;
}(_react2.default.Component);

exports.default = FileButton;


FileButton.propTypes = {
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.element
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemTitle = exports.ListItemSegment = exports.ListItem = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Flex = __webpack_require__(38);

__webpack_require__(1011);

var _prefix = __webpack_require__(77);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('ListItem--');

/**
 * A list item that looks decent in widgets.
 *
 * @param  {Boolean} options.pad
 * Adds some padding around the entire item
 *
 * @param  {Boolean} options.clickable
 * Adds some styling that indicates that the item is clickable.
 */
var ListItem = function ListItem(_ref) {
  var className = _ref.className,
      border = _ref.border,
      pad = _ref.pad,
      children = _ref.children,
      clickable = _ref.clickable,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'border', 'pad', 'children', 'clickable']);
  return _react2.default.createElement(
    _Flex.FlexContainer,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('ListItem', modifiers({ pad: pad, clickable: clickable, border: border }), className)
    }, props),
    children
  );
};

exports.ListItem = ListItem;
ListItem.propTypes = {
  clickable: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  pad: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

/**
 * A segment inside a ListItem - a segment is a flex item that goes from left to right.
 * Additional props are passed to the underlying FlexItem - e.g. `stretch`
 *
 * @param  {Boolean} options.pad
 * Adds padding around this segment. Values are the same as if the list item itself was padded.
 */
var ListItemSegment = function ListItemSegment(_ref2) {
  var className = _ref2.className,
      pad = _ref2.pad,
      children = _ref2.children,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['className', 'pad', 'children']);
  return _react2.default.createElement(
    _Flex.FlexItem,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('ListItemSegment', { 'ListItemSegment--pad': pad }, className)
    }, props),
    children
  );
};

exports.ListItemSegment = ListItemSegment;
ListItemSegment.propTypes = {
  pad: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

/**
 * A preformatted ListItem title.
 */
var ListItemTitle = exports.ListItemTitle = function ListItemTitle(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('ListItemTitle', className) },
    children
  );
};

ListItemTitle.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (window.analytics);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvbWlzYy9hbmFseXRpY3MuanMiXSwibmFtZXMiOlsid2luZG93IiwiYW5hbHl0aWNzIl0sIm1hcHBpbmdzIjoiQUFBQSxlQUFlQSxPQUFPQyxTQUF0QiIsImZpbGUiOiJhbmFseXRpY3MuanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB3aW5kb3cuYW5hbHl0aWNzXG4iXX0=

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(269);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(159)
  , TAG = __webpack_require__(44)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(91)
  , call        = __webpack_require__(449)
  , isArrayIter = __webpack_require__(447)
  , anObject    = __webpack_require__(81)
  , toLength    = __webpack_require__(207)
  , getIterFn   = __webpack_require__(293)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(81)
  , dPs         = __webpack_require__(902)
  , enumBugKeys = __webpack_require__(279)
  , IE_PROTO    = __webpack_require__(287)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(278)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(445).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(289)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 208 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/img/taxfyle-icon-256px.png";

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(13);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__(42);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _class2, _temp, _initialiseProps;

var _mobx = __webpack_require__(7);

var _promiseDefer = __webpack_require__(1422);

var _promiseDefer2 = _interopRequireDefault(_promiseDefer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Creates a confirmation request.
 */
var confirmationRequest = function confirmationRequest(opts) {
  return {
    deferred: (0, _promiseDefer2.default)(),
    options: opts || {}
  };
};

var ConfirmDialogState = (_class = (_temp = _class2 = function ConfirmDialogState(opts) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ConfirmDialogState);

  _initialiseProps.call(this);

  _mobx.extras.allowStateChanges(true, function () {
    (0, _assign2.default)(_this, opts);
  });
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  _initDefineProp(this, 'isOpened', _descriptor, this);

  this.no = function () {
    _this2._resolve(false);
  };

  this.yes = function () {
    _this2._resolve(true);
  };

  this.hide = (0, _mobx.action)(function () {
    _this2._resolve(false);
    _this2.isOpened = false;
  });
  this._resolve = (0, _mobx.action)(function (value) {
    if (!_this2.confirmationRequest) return;

    // Basically, sometimes we don't want to close the confirmation
    // dialog after getting confirmation.
    // In some cases we reuse the dialog with disabled buttons to
    // show progress updates.
    if (!_this2.confirmationRequest.options.manage) {
      _this2.isOpened = false;
    }

    _this2.confirmationRequest.deferred.resolve(value);
  });
  this.show = (0, _mobx.action)(function (opts) {
    if (_this2.confirmationRequest) {
      _this2.confirmationRequest.deferred.resolve(false);
    }

    _this2.confirmationRequest = confirmationRequest(opts);
    _this2.isOpened = true;
    return _this2.confirmationRequest.deferred.promise;
  });
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isOpened', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
exports.default = ConfirmDialogState;
//# sourceMappingURL=ConfirmDialogState.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfirmDialogState = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(90);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _ConfirmDialogState = __webpack_require__(250);

Object.defineProperty(exports, 'ConfirmDialogState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConfirmDialogState).default;
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(8);

var _Modal = __webpack_require__(153);

var _Modal2 = _interopRequireDefault(_Modal);

var _Dialog = __webpack_require__(152);

var _ConfirmDialogState2 = _interopRequireDefault(_ConfirmDialogState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDialog = (0, _mobxReact.observer)(_class = function (_React$Component) {
  (0, _inherits3.default)(ConfirmDialog, _React$Component);

  function ConfirmDialog() {
    (0, _classCallCheck3.default)(this, ConfirmDialog);
    return (0, _possibleConstructorReturn3.default)(this, (ConfirmDialog.__proto__ || (0, _getPrototypeOf2.default)(ConfirmDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfirmDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          state = _props.state,
          title = _props.title,
          yes = _props.yes,
          no = _props.no,
          danger = _props.danger,
          disabled = _props.disabled,
          children = _props.children;

      var yesButtonProps = (0, _defineProperty3.default)({}, danger ? 'danger' : 'primary', true);
      return _react2.default.createElement(
        _Modal2.default,
        { isOpened: state.isOpened, onRequestClose: state.no },
        _react2.default.createElement(
          _Dialog.Dialog,
          null,
          title && _react2.default.createElement(
            _Dialog.DialogTitle,
            null,
            title
          ),
          _react2.default.createElement(
            _Dialog.DialogContent,
            null,
            children
          ),
          _react2.default.createElement(
            _Dialog.DialogFooter,
            null,
            _react2.default.createElement(
              _Dialog.DialogButton,
              { onClick: state.no, disabled: disabled },
              no
            ),
            _react2.default.createElement(
              _Dialog.DialogButton,
              (0, _extends3.default)({}, yesButtonProps, { onClick: state.yes, disabled: disabled }),
              yes
            )
          )
        )
      );
    }
  }]);
  return ConfirmDialog;
}(_react2.default.Component)) || _class;

exports.default = ConfirmDialog;


ConfirmDialog.propTypes = {
  state: _propTypes2.default.instanceOf(_ConfirmDialogState2.default),
  title: _propTypes2.default.string,
  yes: _propTypes2.default.string,
  no: _propTypes2.default.string,
  danger: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

ConfirmDialog.defaultProps = {
  yes: 'Ok',
  no: 'Cancel',
  title: 'Confirm',
  danger: false,
  disabled: false
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlashMessageTypes = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(9);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty = __webpack_require__(13);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__(42);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _desc2, _value2, _class3, _descriptor13;

var _mobx = __webpack_require__(7);

var _isString = __webpack_require__(323);

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

// ID used for React key.
var _idCounter = 1;

var DEFAULT_DISMISS_TIME = 3000;

var FlashMessageTypes = exports.FlashMessageTypes = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error'
};

/**
 * A single flash message with a fluent API.
 */
var FlashMessage = (_class =

/**
 * Constructor sets the initial stuff.
 * If autoDismiss is set, the message with dismiss after
 * the specified amount of milliseconds.
 *
 * @param {object} opts
 * Will be set on the instance.
 */
function FlashMessage(opts) {
  (0, _classCallCheck3.default)(this, FlashMessage);

  _initDefineProp(this, 'message', _descriptor, this);

  _initDefineProp(this, 'isShowing', _descriptor2, this);

  _initDefineProp(this, 'inProgress', _descriptor3, this);

  _initDefineProp(this, 'type', _descriptor4, this);

  _initDefineProp(this, 'show', _descriptor5, this);

  _initDefineProp(this, 'dismiss', _descriptor6, this);

  _initDefineProp(this, 'clearDismissTimer', _descriptor7, this);

  _initDefineProp(this, 'autoDismiss', _descriptor8, this);

  _initDefineProp(this, 'set', _descriptor9, this);

  _initDefineProp(this, 'progress', _descriptor10, this);

  _initDefineProp(this, 'done', _descriptor11, this);

  _initDefineProp(this, 'failed', _descriptor12, this);

  opts = (0, _extends3.default)({}, (0, _isString2.default)(opts) ? { message: opts } : opts, {
    id: _idCounter++
  });

  var _opts = opts,
      autoDismiss = _opts.autoDismiss,
      other = (0, _objectWithoutProperties3.default)(_opts, ['autoDismiss']);

  this.set(other);
  if (autoDismiss && !opts.inProgress) {
    this.autoDismiss(autoDismiss);
  }
}

/**
 * Shows the message again (if it was dismissed before).
 */


/**
 * Dismisses the message.
 */


/**
 * Clears the dismiss timeout.
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Sets up the message to auto dismiss.
 *
 * @param  {Number} ms
 * How long till it is dismissed?
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Sets the given opts directly on the instance.
 *
 * @param {object} opts
 * Options to set.
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Marks this message as being an in-progress type.
 *
 * @param  {string} message
 * Optional message to set.
 *
 * @return {FlashMessage}
 * This instance.
 */


/**
 * Marks the message as done (sets inProgress to false).
 * Basically like `set`, but with an automatic inProgress = false.
 *
 * @param  {object}   opts
 * Additional things to set.
 *
 * @return {FlashMessage}
 * The instance.
 */


/**
 * Marks the message as done (sets inProgress to false).
 * Basically like `set`, but with an automatic inProgress = false.
 *
 * @param  {object}   opts
 * Additional things to set.
 *
 * @return {FlashMessage}
 * The instance.
 */
, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'message', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'inProgress', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return FlashMessageTypes.DEFAULT;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'show', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function () {
      _this.isShowing = true;
      return _this;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'dismiss', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.isShowing = false;
      return _this2;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'clearDismissTimer', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function () {
      clearTimeout(_this3._timeout);
      return _this3;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'autoDismiss', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DISMISS_TIME;

      _this4.clearDismissTimer();
      _this4._timeout = setTimeout(function () {
        _this4.dismiss();
      }, ms);
      return _this4;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'set', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (opts) {
      (0, _assign2.default)(_this5, opts);
      return _this5;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'progress', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (message) {
      _this6.set({
        inProgress: true,
        message: message || _this6.message
      });
      return _this6;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'done', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = { message: opts };
      }

      _this7.set((0, _extends3.default)({}, opts, {
        inProgress: false,
        type: FlashMessageTypes.SUCCESS
      }));
      return _this7;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'failed', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = { message: opts };
      }

      _this8.set((0, _extends3.default)({}, opts, {
        inProgress: false,
        type: FlashMessageTypes.ERROR
      }));
      return _this8;
    };
  }
})), _class);

/**
 * The Flash Message store.
 */

var FlashMessageStore = (_class3 = function () {
  function FlashMessageStore() {
    (0, _classCallCheck3.default)(this, FlashMessageStore);

    _initDefineProp(this, 'flashes', _descriptor13, this);
  }

  (0, _createClass3.default)(FlashMessageStore, [{
    key: 'create',
    value: function create(opts) {
      var message = new FlashMessage(opts);
      this.flashes.push(message);
      return message;
    }

    /**
     * Clears the flashes.
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.flashes.replace([]);
      return this;
    }
  }, {
    key: 'showingFlashes',


    /**
     * Computes the flashes to show.
     */
    get: function get() {
      return this.flashes.filter(function (x) {
        return x.isShowing;
      }).reverse();
    }

    /**
     * Creates and adds a new flash message.
     */

  }]);
  return FlashMessageStore;
}(), (_descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'flashes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'showingFlashes', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'showingFlashes'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'create', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'create'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'clear', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'clear'), _class3.prototype)), _class3);
exports.default = FlashMessageStore;
//# sourceMappingURL=FlashMessageStore.js.map

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_truncate__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_truncate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_truncate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Avatar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_RadialProgress__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_RadialProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_RadialProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_FileTypeIcon__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_FileTypeIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_FileTypeIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_sass__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_sass__);















var Document = function Document(_ref) {
  var document = _ref.document,
      canChangeCategory = _ref.canChangeCategory;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_components_ShadowBox___default.a,
    { className: 'document', level: 2 },
    document.editor.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DocumentEditMode, { document: document, canChangeCategory: canChangeCategory }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DocumentDisplayMode, { document: document, onDownloadClick: function onDownloadClick() {
        return document.download();
      } })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(Document));

var DocumentDisplayMode = function DocumentDisplayMode(_ref2) {
  var document = _ref2.document,
      onDownloadClick = _ref2.onDownloadClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'document-display-mode' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
        { stretch: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
            { stretch: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'title is-5 is-semibold is-marginless' },
              __WEBPACK_IMPORTED_MODULE_2_lodash_truncate___default()(document.label || document.fileName, 20),
              document.friendlyType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'category' },
                '\xA0 (',
                document.friendlyType,
                ')'
              )
            )
          ),
          !document.isNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
            { className: 'top-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'button is-icon-only is-faded', onClick: function onClick(e) {
                  return document.editor.startEditing();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Icon___default.a, { material: true, name: 'edit', small: true })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
          { className: 'document-meta-container' },
          document.uploadedBy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Avatar___default.a, { size: 20, url: document.uploadedBy.avatar, fallback: document.uploadedBy.avatarFallback })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
            { stretch: true, className: 'document-meta' },
            document.uploadedBy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'uploader' },
              document.uploadedBy.name,
              '\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'date' },
              document.dateUpdated.format('ll')
            )
          )
        ),
        document.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'document-description' },
          document.description
        ),
        !document.isNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'actions' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              className: 'unstyled download-button',
              onClick: onDownloadClick,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_FileTypeIcon___default.a, {
                  height: '48',
                  primaryColor: _iconType(document.fileType).color,
                  strokeColor: '#ccc',
                  type: _iconType(document.fileType).type,
                  label: document.fileType,
                  animate: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
                { stretch: true, className: 'file-meta' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h5',
                  { className: 'file-name' },
                  document.fileName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'file-description' },
                  'Download'
                )
              )
            )
          )
        )
      ),
      document.isNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_RadialProgress___default.a, {
          size: 50,
          progress: document.uploadProgress || 0
        })
      )
    )
  );
};

DocumentDisplayMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(DocumentDisplayMode);

var DocumentEditMode = function DocumentEditMode(_ref3) {
  var document = _ref3.document,
      canChangeCategory = _ref3.canChangeCategory;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'document-edit-mode' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Form__["Form"],
      { onSubmit: function onSubmit() {
          return document.editor.save();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'editor-area' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'columns' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Form__["Input"], {
              label: 'File name',
              model: document.editor,
              disabled: document.editor.disabled,
              field: 'label'
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'columns' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Form__["Input"], {
              label: 'Notes',
              model: document.editor,
              disabled: document.editor.disabled,
              field: 'description'
            })
          )
        ),
        canChangeCategory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'columns' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_components_Form__["Select"],
              {
                label: 'Category',
                model: document.editor,
                disabled: document.editor.disabled,
                field: 'category'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: '' },
                'Select...'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: 'PERSONAL' },
                'Personal'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: 'BUSINESS' },
                'Business'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'columns' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_components_Form__["Select"],
              {
                label: 'Document type',
                model: document.editor,
                disabled: document.editor.disabled,
                field: 'type'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: '' },
                'Select...'
              ),
              __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(document.editor.availableDocumentTypes, function (text, type) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'option',
                  { key: type, value: type },
                  text
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_components_Form__["Select"],
              {
                label: 'Year',
                model: document.editor,
                disabled: document.editor.disabled,
                field: 'year'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: '' },
                'Select year...'
              ),
              _years.map(function (year) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'option',
                  { key: year, value: year },
                  year
                );
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'editor-actions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'button is-save',
            disabled: document.editor.disabled
          },
          document.isNew ? 'Upload' : 'Save'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'button is-cancel',
            disabled: document.editor.disabled,
            onClick: function onClick() {
              return document.editor.cancelEditing();
            }
          },
          'Cancel'
        )
      )
    )
  );
};

DocumentEditMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["observer"])(DocumentEditMode);

var _years = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, 6).map(function (i) {
  return (new Date().getFullYear() - i).toString();
});
var _fileTypes = [{
  expr: /(xlsx?|numbers)/i,
  color: '#70c79a',
  type: 'table'
}, {
  expr: /(png|jpe?g|tiff|gif)/i,
  color: '#40a0f4',
  type: 'image'
}, {
  expr: /(js|cs|java|md|c|py|ts)/i,
  color: '#999',
  type: 'code'
}, {
  expr: /(pptx?|key)/i,
  color: '#FF5252',
  type: 'slides'
}, {
  expr: /.*/,
  color: '#FF5252',
  type: 'text'
}];

var _iconType = function _iconType(fileType) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(_fileTypes, function (opts) {
    return fileType.match(opts.expr);
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storageSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

// In Private Mode on iOS, setting items in the storage fails.
// We wrap it to make sure we can make it at least not crash.
var storage = localStorage;
var _supported = true;
try {
  storage.setItem('supported', 'true');
  storage.removeItem('supported');
} catch (err) {
  var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
  _supported = false;
  storage = {
    getItem: function getItem(item) {
      var r = map.get(item);
      return r === undefined ? null : r;
    },
    setItem: function setItem(item, value) {
      return map.set(item, value === undefined || value === null ? value : value.toString());
    },
    removeItem: function removeItem(item) {
      return map.delete(item);
    }
  };
}

var storageSupported = function storageSupported() {
  return _supported;
};
/* harmony default export */ __webpack_exports__["b"] = (storage);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = omitUndefined;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pickBy__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pickBy__);


/**
 * Returns a new object with all undefined values removed.
 */
function omitUndefined(obj) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_pickBy___default()(obj, function (value) {
    return value !== undefined;
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvdXRpbHMvb2JqZWN0VXRpbC5qcyJdLCJuYW1lcyI6WyJwaWNrQnkiLCJvbWl0VW5kZWZpbmVkIiwib2JqIiwidmFsdWUiLCJ1bmRlZmluZWQiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU9BLE1BQVAsTUFBbUIsZUFBbkI7O0FBRUE7OztBQUdBLE9BQU8sU0FBU0MsYUFBVCxDQUF3QkMsR0FBeEIsRUFBNkI7QUFDbEMsU0FBT0YsT0FBT0UsR0FBUCxFQUFZLFVBQUNDLEtBQUQ7QUFBQSxXQUFXQSxVQUFVQyxTQUFyQjtBQUFBLEdBQVosQ0FBUDtBQUNEIiwiZmlsZSI6Im9iamVjdFV0aWwuanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgcGlja0J5IGZyb20gJ2xvZGFzaC9waWNrQnknXG5cbi8qKlxuICogUmV0dXJucyBhIG5ldyBvYmplY3Qgd2l0aCBhbGwgdW5kZWZpbmVkIHZhbHVlcyByZW1vdmVkLlxuICovXG5leHBvcnQgZnVuY3Rpb24gb21pdFVuZGVmaW5lZCAob2JqKSB7XG4gIHJldHVybiBwaWNrQnkob2JqLCAodmFsdWUpID0+IHZhbHVlICE9PSB1bmRlZmluZWQpXG59XG4iXX0=

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(871), __esModule: true };

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(884), __esModule: true };

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(842);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(428);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93)
  , document = __webpack_require__(54).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(159);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(204)
  , $export        = __webpack_require__(59)
  , redefine       = __webpack_require__(455)
  , hide           = __webpack_require__(92)
  , has            = __webpack_require__(107)
  , Iterators      = __webpack_require__(129)
  , $iterCreate    = __webpack_require__(898)
  , setToStringTag = __webpack_require__(161)
  , getPrototypeOf = __webpack_require__(453)
  , ITERATOR       = __webpack_require__(44)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(208)('meta')
  , isObject = __webpack_require__(93)
  , has      = __webpack_require__(107)
  , setDesc  = __webpack_require__(60).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(106)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(206)
  , createDesc     = __webpack_require__(160)
  , toIObject      = __webpack_require__(94)
  , toPrimitive    = __webpack_require__(290)
  , has            = __webpack_require__(107)
  , IE8_DOM_DEFINE = __webpack_require__(446)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(59)
  , core    = __webpack_require__(30)
  , fails   = __webpack_require__(106);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(92);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(288)('keys')
  , uid    = __webpack_require__(208);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(54)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(93);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(54)
  , core           = __webpack_require__(30)
  , LIBRARY        = __webpack_require__(204)
  , wksExt         = __webpack_require__(292)
  , defineProperty = __webpack_require__(60).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(44);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(201)
  , ITERATOR  = __webpack_require__(44)('iterator')
  , Iterators = __webpack_require__(129);
module.exports = __webpack_require__(30).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 294 */
/***/ (function(module, exports) {



/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(115),
    isArray = __webpack_require__(35),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 324 */,
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1316);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 326 */,
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(326);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = __webpack_require__(77);

var _prefix2 = _interopRequireDefault(_prefix);

__webpack_require__(998);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('checkbutton--');

var CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      role = _ref.role;
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('checkbutton', modifiers({ checked: checked })),
      role: role,
      'aria-checked': checked,
      disabled: disabled
    }, !disabled && onChange && {
      onClick: function onClick() {
        return onChange(!checked);
      }
    }),
    children
  );
};

CheckButton.propTypes = {
  children: _propTypes2.default.node,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  role: _propTypes2.default.string
};

CheckButton.defaultProps = {
  role: 'checkbox' // accessibility purposes
};

exports.default = CheckButton;
//# sourceMappingURL=index.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Circle component.
 */
var Circle = function Circle(_ref) {
  var size = _ref.size,
      filled = _ref.filled,
      props = (0, _objectWithoutProperties3.default)(_ref, ['size', 'filled']);
  return _react2.default.createElement(_Icon2.default, (0, _extends3.default)({ name: 'circle' + (!filled ? '-thin' : ''), size: size }, props));
};

Circle.propTypes = {
  size: _propTypes2.default.number,
  filled: _propTypes2.default.bool
};

Circle.defaultProps = {
  size: 24,
  filled: false
};

exports.default = Circle;
//# sourceMappingURL=index.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageDocument = exports.MessageBubble = exports.Message = exports.Conversation = exports.MessageGroup = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Message = __webpack_require__(614);

Object.defineProperty(exports, 'Message', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Message).default;
  }
});
Object.defineProperty(exports, 'MessageBubble', {
  enumerable: true,
  get: function get() {
    return _Message.MessageBubble;
  }
});

var _MessageDocument = __webpack_require__(615);

Object.defineProperty(exports, 'MessageDocument', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageDocument).default;
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A message group.
 *
 * @param  {Boolean} options.mine
 */
var MessageGroup = exports.MessageGroup = function MessageGroup(_ref) {
  var mine = _ref.mine,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('MessageGroup')
    },
    children
  );
};

MessageGroup.propTypes = {
  mine: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

/**
 * Conversation component.
 */

var Conversation = exports.Conversation = function (_React$Component) {
  (0, _inherits3.default)(Conversation, _React$Component);

  function Conversation() {
    (0, _classCallCheck3.default)(this, Conversation);
    return (0, _possibleConstructorReturn3.default)(this, (Conversation.__proto__ || (0, _getPrototypeOf2.default)(Conversation)).apply(this, arguments));
  }

  (0, _createClass3.default)(Conversation, [{
    key: 'render',
    value: function render() {
      // const adminStyle = {
      //   backgroundColor: '#40c4ea'
      // };
      // const theirAvatar = 'https://scontent.xx.fbcdn.net/hprofile-xpl1/v/t1.0-1/p50x50/12033054_10153170208302816_4236135416063891193_n.jpg?oh=be70b28cc8be91ef4e2764c7ad635318&oe=575DA0A5';
      // const adminAvatar = 'https://media.licdn.com/mpr/mpr/shrinknp_200_200/AAEAAQAAAAAAAAPxAAAAJDQxODgzMTVjLTBkNTItNGI5Mi05N2E5LWUzMDY0ZDUyMTg0ZA.jpg';
      return _react2.default.createElement(
        'div',
        { className: 'Conversation' },
        this.props.children
      );
    }
  }]);
  return Conversation;
}(_react2.default.Component);

Conversation.propTypes = {
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(1004);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple error label to be used on white surfaces.
 */
var ErrorLabel = function ErrorLabel(_ref) {
  var children = _ref.children;
  return children ? _react2.default.createElement(
    'div',
    { className: 'ErrorLabel' },
    _react2.default.createElement(_Icon2.default, { name: 'exclamation' }),
    children
  ) : null;
};

ErrorLabel.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ErrorLabel;
//# sourceMappingURL=index.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _chromath = __webpack_require__(369);

var _chromath2 = _interopRequireDefault(_chromath);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(1006);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileTypeIcon = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(FileTypeIcon, _React$Component);

  function FileTypeIcon() {
    (0, _classCallCheck3.default)(this, FileTypeIcon);
    return (0, _possibleConstructorReturn3.default)(this, (FileTypeIcon.__proto__ || (0, _getPrototypeOf2.default)(FileTypeIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(FileTypeIcon, [{
    key: 'render',
    value: function render() {
      // Sizes
      var width = this.props.width || this.props.height * 0.75;
      var height = this.props.height || this.props.width * 1.33;
      var fontSize = height * 0.19;

      // Colors
      var primaryColorLight = new _chromath2.default(this.props.primaryColor).tint(0.8).toHexString();
      var primaryColorMid = new _chromath2.default(this.props.primaryColor).tint(0.4).toHexString();
      var primaryColorDark = new _chromath2.default(this.props.primaryColor).shade(0.2).toHexString();
      var bgColorDark = new _chromath2.default(this.props.bgColor).shade(0.2).toHexString();

      // ClassNames
      var reacticonClassName = (0, _classnames2.default)('reacticon_' + this.props.type, {
        'reacticon': true,
        'is-animated': this.props.animate
      });

      var progressClassName = (0, _classnames2.default)({
        'reacticon__progress': true,
        'is-processing': this.props.isProcessing
      });

      // Styles
      var reacticonStyle = { color: bgColorDark, fontSize: fontSize };
      var progressStyle = { backgroundColor: bgColorDark };
      var progressFillStyle = { backgroundColor: this.props.primaryColor, width: this.props.progress };

      return _react2.default.createElement(
        'div',
        { className: reacticonClassName, style: reacticonStyle },
        _react2.default.createElement(
          'svg',
          { version: '1.1',
            width: width + 'px',
            height: height + 'px',
            viewBox: '0 0 30 40' },
          this.renderGraphic(primaryColorLight, primaryColorMid, primaryColorDark, bgColorDark)
        ),
        this.props.progress || this.props.isProcessing ? _react2.default.createElement(
          'div',
          { className: progressClassName, style: progressStyle },
          _react2.default.createElement('div', { className: 'reacticon__progress__fill', style: progressFillStyle })
        ) : this.props.label ? _react2.default.createElement(
          'span',
          { className: 'reacticon__label' },
          this.props.label
        ) : null
      );
    }
  }, {
    key: 'renderGraphic',
    value: function renderGraphic(primaryColorLight, primaryColorMid, primaryColorDark, bgColorDark) {
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement(
          'g',
          { className: 'reacticon__file' },
          _react2.default.createElement(
            'g',
            { className: 'reacticon__file__background' },
            _react2.default.createElement('path', { fill: this.props.bgColor,
              d: 'M28,40H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h18l10,10v28C30,39.1,29.1,40,28,40z',
              stroke: this.props.strokeColor,
              strokeWidth: '1',
              strokeLinecap: 'rounded' })
          ),
          _react2.default.createElement(
            'g',
            { className: 'reacticon__file__flap' },
            _react2.default.createElement('path', { fill: bgColorDark, d: 'M30,10h-8c-1.1,0-2-0.9-2-2V0L30,10z' })
          )
        ),
        this.props.type === 'text' ? _react2.default.createElement(
          'g',
          { className: 'reacticon__type' },
          _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { fill: this.props.primaryColor, className: 'reacticon__text_row-1', d: 'M23.5,13h-10c-0.3,0-0.5,0.2-0.5,0.5v1c0,0.3,0.2,0.5,0.5,0.5h10c0.3,0,0.5-0.2,0.5-0.5v-1C24,13.2,23.8,13,23.5,13z' }),
            _react2.default.createElement('path', { fill: this.props.primaryColor, className: 'reacticon__text_row-2', d: 'M23.5,17h-10c-0.3,0-0.5,0.2-0.5,0.5v1c0,0.3,0.2,0.5,0.5,0.5h10c0.3,0,0.5-0.2,0.5-0.5v-1C24,17.2,23.8,17,23.5,17z' }),
            _react2.default.createElement('path', { fill: this.props.primaryColor, className: 'reacticon__text_row-3', d: 'M16.5,25h-10C6.2,25,6,25.2,6,25.5v1C6,26.8,6.2,27,6.5,27h10c0.3,0,0.5-0.2,0.5-0.5v-1C17,25.2,16.8,25,16.5,25z' }),
            _react2.default.createElement('path', { fill: this.props.primaryColor, className: 'reacticon__text_row-4', d: 'M23.5,21h-17C6.2,21,6,21.2,6,21.5v1C6,22.8,6.2,23,6.5,23h17c0.3,0,0.5-0.2,0.5-0.5v-1C24,21.2,23.8,21,23.5,21z' })
          ),
          _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { fill: primaryColorLight, className: 'reacticon__image_bg', d: 'M7,19h4c0.6,0,1-0.4,1-1v-4c0-0.6-0.4-1-1-1H7c-0.6,0-1,0.4-1,1v4C6,18.6,6.4,19,7,19z' }),
            _react2.default.createElement('path', { fill: primaryColorMid, className: 'reacticon__image_rear-mtn', d: 'M6.5,18.9l2.2-2.2L8.1,16c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2L6,17.1V18C6,18.4,6.2,18.7,6.5,18.9z' }),
            _react2.default.createElement('path', { fill: this.props.primaryColor, className: 'reacticon__image_front-mtn', d: 'M11.2,15.4c-0.2-0.2-0.4-0.2-0.6-0.2s-0.4,0.1-0.6,0.2l-3.5,3.5C6.7,18.9,6.8,19,7,19h4c0,0,0,0,0.1,0c0.5,0,0.9-0.5,0.9-1v-1.8L11.2,15.4z' }),
            _react2.default.createElement('path', { fill: primaryColorMid, className: 'reacticon__image_sun', d: 'M6.5,14.5c0.6,0,1-0.4,1-1c0-0.2-0.1-0.4-0.1-0.5H7c-0.5,0-1,0.4-1,1v0.4C6.1,14.4,6.3,14.5,6.5,14.5z' })
          )
        ) : null,
        this.props.type === 'table' ? _react2.default.createElement(
          'g',
          { className: 'reacticon__type' },
          _react2.default.createElement('path', { fill: primaryColorDark, className: 'reacticon__table_row-7', d: 'M24,15v-1c0-0.6-0.4-1-1-1H7c-0.6,0-1,0.4-1,1v1H24z' }),
          _react2.default.createElement('rect', { fill: primaryColorLight, className: 'reacticon__table_row-6', x: '6', y: '15', width: '18', height: '2' }),
          _react2.default.createElement('rect', { fill: primaryColorMid, className: 'reacticon__table_row-5', x: '6', y: '17', width: '18', height: '2' }),
          _react2.default.createElement('rect', { fill: primaryColorLight, className: 'reacticon__table_row-4', x: '6', y: '19', width: '18', height: '2' }),
          _react2.default.createElement('rect', { fill: primaryColorMid, className: 'reacticon__table_row-3', x: '6', y: '21', width: '18', height: '2' }),
          _react2.default.createElement('rect', { fill: primaryColorLight, className: 'reacticon__table_row-2', x: '6', y: '23', width: '18', height: '2' }),
          _react2.default.createElement('path', { fill: primaryColorMid, className: 'reacticon__table_row-1', d: 'M23,27H7c-0.6,0-1-0.4-1-1v-1h18v1C24,26.6,23.6,27,23,27z' })
        ) : null,
        this.props.type === 'image' ? _react2.default.createElement(
          'g',
          { className: 'reacticon__type' },
          _react2.default.createElement('path', { fill: primaryColorLight, className: 'reacticon__image_bg', d: 'M23,13H7c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V14C24,13.4,23.6,13,23,13L23,13z' }),
          _react2.default.createElement('path', { fill: primaryColorDark, className: 'reacticon__image_rear-mtn', d: 'M7.1,27l15.3,0l-7.5-7.5c-0.3-0.3-0.8-0.5-1.2-0.5c-0.4,0-0.9,0.2-1.2,0.5L6,25.9V26C6,26.6,6.5,27,7.1,27z' }),
          _react2.default.createElement('path', { fill: this.props.primaryColor, className: 'reacticon__image_front-mtn', d: 'M24,19l-1.1-1c-0.4-0.4-1-0.6-1.5-0.6c-0.5,0-1.1,0.2-1.5,0.6l-9.1,9H23c0.6,0,1-0.4,1-1V19z' }),
          _react2.default.createElement('path', { fill: primaryColorMid, className: 'reacticon__image_sun', d: 'M7,13c-0.6,0-1,0.4-1,1v2.2c0.3,0.2,0.7,0.3,1.2,0.3c1.3,0,2.3-1,2.3-2.3c0-0.4-0.1-0.8-0.3-1.2H7z' })
        ) : null,
        this.props.type === 'code' ? _react2.default.createElement(
          'g',
          { className: 'reacticon__type' },
          _react2.default.createElement('path', { fill: primaryColorDark, className: 'reacticon__code_sidebar', d: 'M9,26V14v-1H7c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1h2V26z' }),
          _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { fill: primaryColorLight, className: 'reacticon__code_row-7', d: 'M24,15H9v-2h14c0.6,0,1,0.4,1,1V15z' }),
            _react2.default.createElement('rect', { fill: primaryColorMid, className: 'reacticon__code_row-6', x: '9', y: '15', width: '15', height: '2' }),
            _react2.default.createElement('rect', { fill: primaryColorLight, className: 'reacticon__code_row-5', x: '9', y: '17', width: '15', height: '2' }),
            _react2.default.createElement('rect', { fill: primaryColorMid, className: 'reacticon__code_row-5', x: '9', y: '19', width: '15', height: '2' }),
            _react2.default.createElement('rect', { fill: primaryColorLight, className: 'reacticon__code_row-3', x: '9', y: '21', width: '15', height: '2' }),
            _react2.default.createElement('rect', { fill: primaryColorMid, className: 'reacticon__code_row-2', x: '9', y: '23', width: '15', height: '2' }),
            _react2.default.createElement('path', { fill: primaryColorLight, className: 'reacticon__code_row-1', d: 'M23,27H9v-2h15v1C24,26.6,23.6,27,23,27z' })
          ),
          _react2.default.createElement(
            'g',
            { className: 'reacticon__code_numbers' },
            _react2.default.createElement('path', { fill: this.props.bgColor, d: 'M8.1,15.9v0.3H7v-0.3h0.4V15H7v-0.2c0.2,0,0.3-0.1,0.4-0.1h0.3v1.3H8.1z' }),
            _react2.default.createElement('path', { fill: this.props.bgColor, d: 'M6.9,19c0.5-0.4,0.8-0.7,0.8-0.9c0-0.2-0.1-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2l-0.2-0.2c0.2-0.2,0.3-0.3,0.6-0.3c0.3,0,0.6,0.2,0.6,0.5c0,0.3-0.3,0.6-0.6,0.8c0.1,0,0.2,0,0.3,0h0.4v0.3H6.9V19z' }),
            _react2.default.createElement('path', { fill: this.props.bgColor, d: 'M7,21.8C7.1,21.9,7.3,22,7.4,22c0.2,0,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.5-0.2v-0.3c0.3,0,0.4-0.1,0.4-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1l-0.2-0.2c0.2-0.1,0.3-0.2,0.5-0.2c0.3,0,0.6,0.2,0.6,0.4c0,0.2-0.1,0.3-0.3,0.4v0c0.2,0.1,0.4,0.2,0.4,0.4c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.1-0.6-0.2L7,21.8z' }),
            _react2.default.createElement('path', { fill: this.props.bgColor, d: 'M8.1,24.9H7.9v0.4H7.6v-0.4H6.8v-0.3l0.7-1h0.4v0.9h0.2V24.9z M7.6,24.6v-0.3c0-0.1,0-0.2,0-0.3h0c-0.1,0.1-0.1,0.2-0.2,0.3l-0.2,0.3H7.6z' })
          )
        ) : null,
        this.props.type === 'slides' ? _react2.default.createElement(
          'g',
          { className: 'reacticon__type' },
          _react2.default.createElement('path', { fill: primaryColorDark, className: 'reacticon__slides_bg', d: 'M23,13H7c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V14C24,13.4,23.6,13,23,13L23,13z' }),
          _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { fill: primaryColorMid, className: 'reacticon__slides_pie', d: 'M14.9,16.1c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4h-4.4V16.1z' }),
            _react2.default.createElement('path', { fill: primaryColorLight, className: 'reacticon__slides_slice', d: 'M16.1,15v4.4h4.4C20.5,17,18.5,15,16.1,15z' })
          )
        ) : null
      );
    }
  }]);
  return FileTypeIcon;
}(_react2.default.Component), _class.propTypes = {
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['text', 'table', 'image', 'code', 'slides']).isRequired,
  label: _propTypes2.default.string,
  bgColor: _propTypes2.default.string,
  primaryColor: _propTypes2.default.string,
  strokeColor: _propTypes2.default.string,
  animate: _propTypes2.default.bool,
  progress: _propTypes2.default.string,
  isProcessing: _propTypes2.default.bool
}, _class.defaultProps = {
  primaryColor: '#0074d9',
  bgColor: '#fff'
}, _temp);
exports.default = FileTypeIcon;
//# sourceMappingURL=index.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__(149);

__webpack_require__(1017);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadialProgress = function RadialProgress(_ref) {
  var size = _ref.size,
      progress = _ref.progress,
      thickness = _ref.thickness,
      stroke = _ref.stroke,
      ringStroke = _ref.ringStroke,
      roundedLine = _ref.roundedLine;
  return _react2.default.createElement(
    'div',
    { className: 'RadialProgress' },
    _react2.default.createElement(
      'svg',
      { width: size + thickness * 2, height: size + thickness * 2, className: 'RadialProgress__svg' },
      _react2.default.createElement('circle', {
        className: 'RadialProgress__circle',
        cx: size / 2 + thickness,
        cy: size / 2 + thickness,
        r: size / 2,
        stroke: ringStroke,
        strokeWidth: thickness
      }),
      _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: {
            progress: 0
          },
          style: {
            progress: (0, _reactMotion.spring)(progress)
          }
        },
        function (value) {
          return _react2.default.createElement('path', {
            className: 'RadialProgress__path',
            strokeWidth: thickness,
            stroke: stroke,
            strokeLinecap: roundedLine ? 'round' : 'none',
            strokeDasharray: _progressToDasharray(value.progress, size),
            d: _path(size, thickness)
          });
        }
      )
    )
  );
};

RadialProgress.defaultProps = {
  size: 80,
  progress: 0,
  thickness: 5,
  stroke: '#40a0f4',
  ringStroke: '#eaeaea'
};

RadialProgress.propTypes = {
  size: _propTypes2.default.number,
  progress: _propTypes2.default.number,
  thickness: _propTypes2.default.number,
  stroke: _propTypes2.default.string,
  ringStroke: _propTypes2.default.string,
  roundedLine: _propTypes2.default.bool
};

exports.default = RadialProgress;

/**
 * Generates a path based on size and stroke width.
 */

function _path(size, strokeWidth) {
  var half = size / 2;
  return '\n    M' + (half + strokeWidth) + ' ' + strokeWidth + '\n    a ' + half + ' ' + half + ' 0 0 1 0 ' + size + '\n    a ' + half + ' ' + half + ' 0 0 1 0 -' + size + '\n  ';
}

/**
 * Calculates the correct dasharray to emulate the progress
 * effect.
 *
 * Explanation (for myself when I forget):
 * The trick is to set the length of each dash to
 * whatever % of the circumference we're at, and at the
 * same time make sure the gap between each stroke is far
 * enough so only a single one is displayed at any time.
 */
function _progressToDasharray(progress, size) {
  var circumference = size * Math.PI; // mmmm, could go for some pie
  // Length of the stroke
  var length = progress / 100 * circumference;
  // The gap which will make sure only a single "dash" is drawn.
  var gap = circumference - length;
  return length + ',' + gap;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SENDING = exports.SENDING = 'SENDING';
var SENT = exports.SENT = 'SENT';
var DELIVERED = exports.DELIVERED = 'DELIVERED';
var READ = exports.READ = 'READ';
//# sourceMappingURL=MessageReceiptState.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(245);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FlexCenter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Flex__);





function FlexCenter(_ref) {
  var children = _ref.children,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['children']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_Flex__["FlexContainer"],
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ direction: 'column' }, props),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components_Flex__["FlexItem"],
      null,
      children
    )
  );
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9GbGV4Q2VudGVyL2luZGV4LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIkZsZXhDb250YWluZXIiLCJGbGV4SXRlbSIsIkZsZXhDZW50ZXIiLCJjaGlsZHJlbiIsInByb3BzIl0sIm1hcHBpbmdzIjoiOztBQUFBLE9BQU9BLEtBQVAsTUFBa0IsT0FBbEI7QUFDQSxTQUFTQyxhQUFULEVBQXdCQyxRQUF4QixRQUF3QyxpQkFBeEM7O0FBRUEsZUFBZSxTQUFTQyxVQUFULE9BQTZDO0FBQUEsTUFBdEJDLFFBQXNCLFFBQXRCQSxRQUFzQjtBQUFBLE1BQVRDLEtBQVM7O0FBQzFELFNBQ0U7QUFBQyxpQkFBRDtBQUFBLGVBQWUsV0FBVSxRQUF6QixJQUFzQ0EsS0FBdEM7QUFDRTtBQUFDLGNBQUQ7QUFBQTtBQUNHRDtBQURIO0FBREYsR0FERjtBQU9EIiwiZmlsZSI6ImluZGV4LmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IEZsZXhDb250YWluZXIsIEZsZXhJdGVtIH0gZnJvbSAnY29tcG9uZW50cy9GbGV4J1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBGbGV4Q2VudGVyICh7IGNoaWxkcmVuLCAuLi5wcm9wcyB9KSB7XG4gIHJldHVybiAoXG4gICAgPEZsZXhDb250YWluZXIgZGlyZWN0aW9uPVwiY29sdW1uXCIgey4uLnByb3BzfT5cbiAgICAgIDxGbGV4SXRlbT5cbiAgICAgICAge2NoaWxkcmVufVxuICAgICAgPC9GbGV4SXRlbT5cbiAgICA8L0ZsZXhDb250YWluZXI+XG4gIClcbn1cbiJdfQ==

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuovoProviderState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_domain_LinkedAccount__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_validx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_validx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_validx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_misc_QuovoAPI__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MultiFactorAuth_MultiFactorAuthState__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_misc_brokerLogos__ = __webpack_require__(423);









var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _desc2, _value2, _class3, _descriptor14, _descriptor15, _descriptor16, _descriptor17;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Hello! If you've been tasked to make changes to this module, please know that the reason
 * for all the complexity is Quovo APIs tendency to suck hard, and I feel sorry for you.
 *
 * The code paths may be hard to trace, so here's a safety pig:
 *                          _
 *  _._ _..._ .-',     _.._(`))
 * '-. `     '  /-._.-'    ',/
 *     )         \            '.
 *    / _    _    |             \
 * |  a    a    /              |
 * \   .-.                     ;
 *    '-('' ).-'       ,'       ;
 *       '-;           |      .'
 *          \           \    /
 *          | 7  .__  _.-\   \
 *          | |  |  ``/  /`  /
 *         /,_|  |   /,_/   /
 *            /,_/      '`-'
 */









// Good luck adventurer. You're gonna need it.
var QuovoProviderState = (_class = function () {
  function QuovoProviderState(_ref) {
    var rootStore = _ref.rootStore,
        addAccount = _ref.addAccount;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, QuovoProviderState);

    _initDefineProp(this, 'selectedBrokerage', _descriptor, this);

    _initDefineProp(this, 'brokerages', _descriptor2, this);

    _initDefineProp(this, 'searchText', _descriptor3, this);

    _initDefineProp(this, 'account', _descriptor4, this);

    _initDefineProp(this, 'authenticating', _descriptor5, this);

    _initDefineProp(this, 'fetchingBrokerages', _descriptor6, this);

    _initDefineProp(this, 'syncing', _descriptor7, this);

    _initDefineProp(this, 'syncProgress', _descriptor8, this);

    _initDefineProp(this, 'error', _descriptor9, this);

    _initDefineProp(this, 'username', _descriptor10, this);

    _initDefineProp(this, 'password', _descriptor11, this);

    _initDefineProp(this, 'validation', _descriptor12, this);

    _initDefineProp(this, 'multiFactorAuthState', _descriptor13, this);

    this.rootStore = rootStore;
    this.addAccount = addAccount;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(QuovoProviderState, [{
    key: 'linkAccount',
    value: function linkAccount() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a(function (resolve) {
        _this.reset();
        _this.fetchBrokerages();
        _this.done = resolve;
      });
    }
  }, {
    key: 'updateAccount',
    value: function updateAccount(account) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Resets the dialog state.
                  _this2.done = resolve;
                  _this2.reset();
                  _this2.setAccount(account);
                  _context.next = 5;
                  return _this2.fetchBrokerages();

                case 5:
                  _this2.selectBrokerage(_this2.brokerages.find(function (b) {
                    return b.id === account.brokerageId;
                  }));
                  _this2.sync();

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'fetchBrokerages',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var brokerages;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this3.fetchingBrokerages = true;
                });
                // Don't worry, this is cached.
                _context2.next = 3;
                return this.quovoAPI.getBrokerages();

              case 3:
                brokerages = _context2.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this3.brokerages.replace(brokerages.map(function (b) {
                    return new Brokerage(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, b, { logo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_misc_brokerLogos__["a" /* getLogo */])(b.id) }));
                  }));
                  _this3.fetchingBrokerages = false;
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchBrokerages() {
        return _ref3.apply(this, arguments);
      }

      return fetchBrokerages;
    }()
  }, {
    key: 'selectBrokerage',
    value: function selectBrokerage(brokerage) {
      this.selectedBrokerage = brokerage;
    }
  }, {
    key: 'setSearchText',
    value: function setSearchText(newText) {
      this.searchText = newText;
    }
  }, {
    key: 'setAccount',
    value: function setAccount(account) {
      this.account = account;
    }
  }, {
    key: 'authenticate',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, _result, linkedAccount;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setError('');

                if (this.validate()) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:
                _context3.prev = 3;

                // Shows the syncing screen.
                this.setSyncing(true);

                if (!this.account) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 8;
                return this.quovoAPI.updateAccount(this.account.id, this.username, this.password);

              case 8:
                result = _context3.sent;

                this.account.set(result.account, { parse: true });
                _context3.next = 18;
                break;

              case 12:
                _context3.next = 14;
                return this.quovoAPI.createAccount(this.selectedBrokerage.id, this.username, this.password);

              case 14:
                _result = _context3.sent;
                linkedAccount = new __WEBPACK_IMPORTED_MODULE_10_domain_LinkedAccount__["a" /* QuovoLinkedAccount */](_result.account, { parse: true });

                this.addAccount(linkedAccount);
                this.setAccount(linkedAccount);

              case 18:
                _context3.next = 20;
                return this.sync({ initSync: true });

              case 20:
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3['catch'](3);

                this.setSyncing(false);
                this.setError(_context3.t0);
                console.warn('Error while logging in to institution with Quovo:', _context3.t0);

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 22]]);
      }));

      function authenticate() {
        return _ref4.apply(this, arguments);
      }

      return authenticate;
    }()
  }, {
    key: 'close',
    value: function close() {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.done) {
        this.done(result);
      }
    }

    /**
     * This function is the belly of the beast that is Quovo authentication.
     * Basically, it (optionally) creates a new sync request and short-polls for changes to
     * it. When it's time to collect answers, the syncing loop stops and waits for
     * answers to be submitted.
     *
     * The MultiFactorAuthState is responsible for collecting and submitting answers, and
     * after that the syncing loop starts once more. If the sync status is still 'question' or `has_realtime`
     * is still true, MultiFactorAuthState basically attempts to show the challenges again, but
     * when all the challenges are answered, it short-circuits and attempts to sync again.
     * This might happen a few times until the sync status changes.
     *
     * I am really sorry... - that Quovo's API sucks.
     */

  }, {
    key: 'sync',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this4 = this;

        var syncOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _syncOpts$initSync, initSync, account, doSync;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _syncOpts$initSync = syncOpts.initSync, initSync = _syncOpts$initSync === undefined ? false : _syncOpts$initSync;
                account = this.account;

                this.setSyncing(true);

                // Called recursively.

                doSync = function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
                    var sync;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this4.quovoAPI.getSyncProgress(account.id).then(function (data) {
                              return data.sync;
                            });

                          case 2:
                            sync = _context4.sent;

                            if (!(sync.status === null)) {
                              _context4.next = 7;
                              break;
                            }

                            _context4.next = 6;
                            return _this4.initSync();

                          case 6:
                            sync = _context4.sent;

                          case 7:

                            account.set({ status: sync.status });

                            // Prompt MFA Questions.
                            // This check must come before checking for 'syncing'
                            // because Quovo thought it would be fucking smart
                            // to set status=syncing when has_realtime is true, even
                            // though it should be status=questions. Fucking retards.

                            if (!(sync.status === 'questions' || sync.has_realtime)) {
                              _context4.next = 11;
                              break;
                            }

                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                              if (sync.has_realtime) {
                                _this4.answerRealtimeMFA();
                              } else {
                                _this4.answerMFA();
                              }
                            });
                            return _context4.abrupt('return');

                          case 11:
                            if (!(sync.status === 'syncing')) {
                              _context4.next = 16;
                              break;
                            }

                            // Want to show a different indicator when authenticating.
                            if (sync.progress.state !== 'authenticating') {
                              _this4.setSyncProgress(sync.progress.percent * 100);
                            }

                            // Keep polling.
                            _context4.next = 15;
                            return __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a.delay(800);

                          case 15:
                            return _context4.abrupt('return', doSync());

                          case 16:
                            if (!(sync.status === 'config')) {
                              _context4.next = 19;
                              break;
                            }

                            // So I think after resolving the issue they need to login again.
                            _this4.setError(sync.config_instructions);
                            return _context4.abrupt('return');

                          case 19:
                            if (!(sync.status === 'no portfolio')) {
                              _context4.next = 22;
                              break;
                            }

                            _this4.setError('There were no Portfolios found within the account.');
                            return _context4.abrupt('return');

                          case 22:

                            if (sync.status === 'postponed') {
                              // Basically we don't know if its good because
                              // Quovo will attempt to sync later, so we just
                              // go all female and tell them it's fine even though it isn't.
                              _this4.setSyncProgress(100);
                              // Give the user a few seconds to read the message.
                              setTimeout(function () {
                                _this4.close(account);
                              }, 5000);
                            }

                            if (!(sync.status === 'good')) {
                              _context4.next = 27;
                              break;
                            }

                            _this4.setSyncProgress(100);
                            // Give the user a few seconds to celebrate.
                            setTimeout(function () {
                              _this4.close(account);
                            }, 2500);
                            return _context4.abrupt('return');

                          case 27:

                            // This basically means the username/password is wrong.
                            if (sync.status === 'login') {
                              _this4.setError('Username and/or password were invalid.');
                            }

                          case 28:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4);
                  }));

                  return function doSync() {
                    return _ref6.apply(this, arguments);
                  };
                }();

                _context5.prev = 4;

                if (!initSync) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return this.initSync();

              case 8:
                _context5.next = 10;
                return doSync();

              case 10:
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](4);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this4.setSyncing(false);
                  _this4.setError(_context5.t0);
                });
                console.warn('Error while syncing Quovo account', _context5.t0);

              case 16:
                _context5.prev = 16;

                this.setSyncing(false);
                return _context5.finish(16);

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 12, 16, 19]]);
      }));

      function sync() {
        return _ref5.apply(this, arguments);
      }

      return sync;
    }()

    /**
     * Requests a new sync for the account.
     */

  }, {
    key: 'initSync',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var sync;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.quovoAPI.sync(this.account.id).then(function (d) {
                  return d.sync;
                });

              case 2:
                sync = _context6.sent;

                this.account.set({ status: sync.status });
                return _context6.abrupt('return', sync);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function initSync() {
        return _ref7.apply(this, arguments);
      }

      return initSync;
    }()

    /**
     * Resets the state of the dialog.
     * This should bring the dialog in such a state as if it was
     * just created.
     *
     * The reason we don't just reinstantiate is that sometimes we may
     * want to preserve state (e.g. fetched brokerages - Like Tupac, some things will never change)
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.error = null;
      this.selectedBrokerage = null;
      this.account = null;
      this.fetchingBrokerages = false;
      this.syncing = false;
      this.syncProgress = 0;
    }
  }, {
    key: 'setSyncing',
    value: function setSyncing(syncing) {
      this.syncing = syncing;
    }
  }, {
    key: 'setSyncProgress',
    value: function setSyncProgress(progress) {
      this.syncProgress = progress;
    }
  }, {
    key: 'setError',
    value: function setError(err) {
      // Express yo self
      this.error = typeof err === 'string' ? err : err.response ? err.response.status < 500 ? err.response.data.message : 'An server error occurred while syncing. Please try again later' : err.message;
    }
  }, {
    key: 'validate',
    value: function validate() {
      return this.validation.reset().validate(this, {
        username: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_validx__["required"])('Username is required')],
        password: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_validx__["required"])('Password is required')]
      }).isValid;
    }
  }, {
    key: 'answerRealtimeMFA',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.displayMFA();

              case 2:
                _context7.next = 4;
                return this.sync({ initSync: false });

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function answerRealtimeMFA() {
        return _ref8.apply(this, arguments);
      }

      return answerRealtimeMFA;
    }()
  }, {
    key: 'answerMFA',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.displayMFA();

              case 2:
                _context8.next = 4;
                return this.sync({ initSync: true });

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function answerMFA() {
        return _ref9.apply(this, arguments);
      }

      return answerMFA;
    }()
  }, {
    key: 'displayMFA',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9(opts) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])('create MFA state', function () {
                  _this5.multiFactorAuthState = new __WEBPACK_IMPORTED_MODULE_13__MultiFactorAuth_MultiFactorAuthState__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                    provider: _this5
                  }, opts));
                });
                _context9.next = 3;
                return this.multiFactorAuthState.answerChallenge();

              case 3:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])('nullify MFA state', function () {
                  _this5.multiFactorAuthState = null;
                });

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function displayMFA(_x4) {
        return _ref10.apply(this, arguments);
      }

      return displayMFA;
    }()
  }, {
    key: 'quovoAPI',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_12_misc_QuovoAPI__["a" /* default */].create(this.rootStore.authStore.token);
    }
  }, {
    key: 'filteredBrokerages',
    get: function get() {
      var _this6 = this;

      if (!this.searchText) {
        return this.brokerages;
      }

      return this.brokerages.filter(function (b) {
        return b.name.toLowerCase().indexOf(_this6.searchText.toLowerCase()) > -1;
      });
    }
  }]);

  return QuovoProviderState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selectedBrokerage', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'brokerages', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'searchText', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'account', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'authenticating', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'fetchingBrokerages', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'syncing', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'syncProgress', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'error', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'username', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'password', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'validation', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_validx__["validationContext"])();
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'multiFactorAuthState', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'quovoAPI', [__WEBPACK_IMPORTED_MODULE_9_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'quovoAPI'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'filteredBrokerages', [__WEBPACK_IMPORTED_MODULE_9_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'filteredBrokerages'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectBrokerage', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectBrokerage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSearchText', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setSearchText'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setAccount', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAccount'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'authenticate', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'authenticate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'reset'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSyncing', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setSyncing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSyncProgress', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setSyncProgress'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setError', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validate', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'validate'), _class.prototype)), _class);

var Brokerage = (_class3 =
// Label to use for username
function Brokerage(attrs) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Brokerage);

  _initDefineProp(this, 'name', _descriptor14, this);

  _initDefineProp(this, 'notes', _descriptor15, this);

  _initDefineProp(this, 'username', _descriptor16, this);

  _initDefineProp(this, 'password', _descriptor17, this);

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this, attrs);
}
// Label to use for password
, (_descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'name', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class3.prototype, 'notes', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class3.prototype, 'username', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class3.prototype, 'password', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
})), _class3);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_sass__);





var WorkingIndicator = function WorkingIndicator(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_components_Flex__["FlexContainer"],
    { className: 'working-indicator', direction: 'column' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_components_Flex__["FlexItem"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'title is-5 is-semibold' },
        children
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_components_Flex__["FlexItem"],
      { className: 'has-spacing-top' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner___default.a, {
        size: 48,
        color: '#2395F3'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (WorkingIndicator);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL1dvcmtpbmdJbmRpY2F0b3IvaW5kZXguanN4Il0sIm5hbWVzIjpbIlJlYWN0IiwiRmxleENvbnRhaW5lciIsIkZsZXhJdGVtIiwiUHJvZ3Jlc3NTcGlubmVyIiwiV29ya2luZ0luZGljYXRvciIsImNoaWxkcmVuIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsU0FBU0MsYUFBVCxFQUF3QkMsUUFBeEIsUUFBd0MsaUJBQXhDO0FBQ0EsT0FBT0MsZUFBUCxNQUE0Qiw0QkFBNUI7QUFDQSxPQUFPLGVBQVA7O0FBRUEsSUFBTUMsbUJBQW1CLFNBQW5CQSxnQkFBbUI7QUFBQSxNQUFHQyxRQUFILFFBQUdBLFFBQUg7QUFBQSxTQUN2QjtBQUFDLGlCQUFEO0FBQUEsTUFBZSxXQUFVLG1CQUF6QixFQUE2QyxXQUFVLFFBQXZEO0FBQ0U7QUFBQyxjQUFEO0FBQUE7QUFDRTtBQUFBO0FBQUEsVUFBSSxXQUFVLHdCQUFkO0FBQXdDQTtBQUF4QztBQURGLEtBREY7QUFJRTtBQUFDLGNBQUQ7QUFBQSxRQUFVLFdBQVUsaUJBQXBCO0FBQ0UsMEJBQUMsZUFBRDtBQUNFLGNBQU0sRUFEUjtBQUVFLGVBQU07QUFGUjtBQURGO0FBSkYsR0FEdUI7QUFBQSxDQUF6Qjs7QUFjQSxlQUFlRCxnQkFBZiIsImZpbGUiOiJpbmRleC5qc3giLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBGbGV4Q29udGFpbmVyLCBGbGV4SXRlbSB9IGZyb20gJ2NvbXBvbmVudHMvRmxleCdcbmltcG9ydCBQcm9ncmVzc1NwaW5uZXIgZnJvbSAnY29tcG9uZW50cy9Qcm9ncmVzc1NwaW5uZXInXG5pbXBvcnQgJy4vc3R5bGVzLnNhc3MnXG5cbmNvbnN0IFdvcmtpbmdJbmRpY2F0b3IgPSAoeyBjaGlsZHJlbiB9KSA9PiAoXG4gIDxGbGV4Q29udGFpbmVyIGNsYXNzTmFtZT1cIndvcmtpbmctaW5kaWNhdG9yXCIgZGlyZWN0aW9uPVwiY29sdW1uXCI+XG4gICAgPEZsZXhJdGVtPlxuICAgICAgPGg0IGNsYXNzTmFtZT1cInRpdGxlIGlzLTUgaXMtc2VtaWJvbGRcIj57Y2hpbGRyZW59PC9oND5cbiAgICA8L0ZsZXhJdGVtPlxuICAgIDxGbGV4SXRlbSBjbGFzc05hbWU9XCJoYXMtc3BhY2luZy10b3BcIj5cbiAgICAgIDxQcm9ncmVzc1NwaW5uZXJcbiAgICAgICAgc2l6ZT17NDh9XG4gICAgICAgIGNvbG9yPVwiIzIzOTVGM1wiXG4gICAgICAvPlxuICAgIDwvRmxleEl0ZW0+XG4gIDwvRmxleENvbnRhaW5lcj5cbilcblxuZXhwb3J0IGRlZmF1bHQgV29ya2luZ0luZGljYXRvclxuIl19

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ListItem__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_LinkAccountDialog__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_RemoveLinkedAccountDialog__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_sass__);











var LinkedAccountsManager = function LinkedAccountsManager(_ref) {
  var manager = _ref.manager;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'linked-accounts-manager' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_Flex__["FlexContainer"],
      { direction: 'column' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components_Flex__["FlexItem"],
        { className: 'button-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'button is-rounded-outline', onClick: function onClick() {
              return manager.showDialog();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Icon___default.a, { material: true, name: 'account balance' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Link Account'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components_Flex__["FlexItem"],
        { className: 'linked-accounts' },
        manager.linkedAccounts.length === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmptyState, null) : manager.linkedAccounts.map(function (account) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkedAccount, {
            key: account.id,
            account: account,
            onDeleteClick: function onDeleteClick() {
              return manager.removeAccount(account);
            },
            onFixIssuesClick: function onFixIssuesClick() {
              return manager.fixIssues(account);
            },
            removeLinkedAccountDialog: manager.removeLinkedAccountDialog
          });
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_LinkAccountDialog__["a" /* default */], { dialog: manager.linkAccountDialog }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_RemoveLinkedAccountDialog__["a" /* default */], { dialog: manager.removeLinkedAccountDialog, account: manager.accountToRemove })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(LinkedAccountsManager));

var EmptyState = function EmptyState() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'content has-text-centered is-medium intro' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Link your financial institutions and Taxfyle will connect your tax documents for you.'
    )
  );
};

var LinkedAccount = function LinkedAccount(_ref2) {
  var account = _ref2.account,
      removeLinkedAccountDialog = _ref2.removeLinkedAccountDialog,
      onDeleteClick = _ref2.onDeleteClick,
      onFixIssuesClick = _ref2.onFixIssuesClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'linked-account' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_ShadowBox___default.a,
      { level: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_components_ListItem__["ListItem"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_ListItem__["ListItemSegment"],
          { pad: true, stretch: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components_ListItem__["ListItemTitle"],
            null,
            account.logo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: account.logo, alt: account.institution, className: 'institution-logo' }) : account.institution
          )
        ),
        account.syncing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_ListItem__["ListItemSegment"],
          { pad: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ProgressSpinner___default.a, { color: '#2395F3' })
        ),
        account.needsUserInteraction && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_ListItem__["ListItemSegment"],
          { pad: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'button is-danger', onClick: onFixIssuesClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'icon' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Icon___default.a, { material: true, name: 'error outline' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Fix Issues'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_ListItem__["ListItemSegment"],
          { pad: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'button is-icon-only', onClick: function onClick() {
                return onDeleteClick();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Icon___default.a, { material: true, name: 'delete' })
          )
        )
      )
    )
  );
};

LinkedAccount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(LinkedAccount);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_sass__);






var PaddedBlock = function PaddedBlock(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['children', 'className']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('padded-block', className) }, props),
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PaddedBlock);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9QYWRkZWRCbG9jay9pbmRleC5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJjeCIsIlBhZGRlZEJsb2NrIiwiY2hpbGRyZW4iLCJjbGFzc05hbWUiLCJwcm9wcyJdLCJtYXBwaW5ncyI6Ijs7QUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsT0FBT0MsRUFBUCxNQUFlLFlBQWY7QUFDQSxPQUFPLGVBQVA7O0FBRUEsSUFBTUMsY0FBYyxTQUFkQSxXQUFjO0FBQUEsTUFBR0MsUUFBSCxRQUFHQSxRQUFIO0FBQUEsTUFBYUMsU0FBYixRQUFhQSxTQUFiO0FBQUEsTUFBMkJDLEtBQTNCOztBQUFBLFNBQ2xCO0FBQUE7QUFBQSxlQUFLLFdBQVdKLEdBQUcsY0FBSCxFQUFtQkcsU0FBbkIsQ0FBaEIsSUFBbURDLEtBQW5EO0FBQ0dGO0FBREgsR0FEa0I7QUFBQSxDQUFwQjs7QUFNQSxlQUFlRCxXQUFmIiwiZmlsZSI6ImluZGV4LmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJ1xuaW1wb3J0ICcuL3N0eWxlcy5zYXNzJ1xuXG5jb25zdCBQYWRkZWRCbG9jayA9ICh7IGNoaWxkcmVuLCBjbGFzc05hbWUsIC4uLnByb3BzIH0pID0+IChcbiAgPGRpdiBjbGFzc05hbWU9e2N4KCdwYWRkZWQtYmxvY2snLCBjbGFzc05hbWUpfSB7Li4ucHJvcHN9PlxuICAgIHtjaGlsZHJlbn1cbiAgPC9kaXY+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IFBhZGRlZEJsb2NrXG4iXX0=

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ListItem__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ContentLoading__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ContentLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_ContentLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_patternMatchUtil__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_patternMatchUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_utils_patternMatchUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_sass__);












var CardItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(function CardItem(_ref) {
  var card = _ref.card,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      onDeleteCardClick = _ref.onDeleteCardClick;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItem"],
    {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('card-item', disabled && 'payment-methods--item-disabled'),
      onClick: !disabled && onClick,
      clickable: !disabled,
      border: true
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItemSegment"],
      { pad: true, stretch: true },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'card-item__primary-info' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          card.brand
        ),
        ' ending in ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          card.last4
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'card-item__secondary-info' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'card-item__expires' },
          'Expires ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            card.exp_month,
            '/',
            card.exp_year
          )
        ),
        '\xA0 \u2022 \xA0',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('card-item__cvc', 'card-item__cvc--' + card.cvc_check) },
          'CVC check ',
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_patternMatchUtil__["match"])(card.cvc_check, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            pass: 'passed',
            fail: 'failed',
            unavailable: 'unavailable',
            unchecked: 'unchecked'
          }, __WEBPACK_IMPORTED_MODULE_8_utils_patternMatchUtil__["match"].DEFAULT, 'unavailable'))
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItemSegment"],
      { pad: true },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_components_Flex__["FlexContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components_Flex__["FlexItem"],
          null,
          card.isDefaultSource && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'card-item__default' },
            'Current Payment Method'
          )
        ),
        onDeleteCardClick && !disabled && !card.isDefaultSource && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components_Flex__["FlexItem"],
          null,
          '\xA0',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { className: 'button is-icon-only', onClick: function onClick(e) {
                return e.stopPropagation() || onDeleteCardClick();
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Icon___default.a, { material: true, name: 'delete' })
          )
        )
      )
    )
  );
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(function PaymentMethods(_ref2) {
  var loading = _ref2.loading,
      busy = _ref2.busy,
      cards = _ref2.cards,
      onAddClick = _ref2.onAddClick,
      onCardClick = _ref2.onCardClick,
      onDeleteCardClick = _ref2.onDeleteCardClick;

  if (loading) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ContentLoading___default.a, { small: true });
  }
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'payment-methods' },
    cards.map(function (card) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CardItem, {
        disabled: busy,
        key: card.id,
        card: card,
        onClick: function onClick() {
          return onCardClick(card);
        },
        onDeleteCardClick: onDeleteCardClick && cards.length > 1 && function () {
          return onDeleteCardClick(card);
        }
      });
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItem"],
      {
        clickable: !busy,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('payment-methods__add', busy && 'payment-methods--item-disabled'),
        onClick: !busy && onAddClick,
        border: true
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItemSegment"],
        { stretch: true, pad: true, className: 'payment-methods__add-inner' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Icon___default.a, { material: true, name: 'credit card' }),
        '\xA0 Add Payment Method'
      )
    )
  );
}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Avatar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_FileButton__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_FileButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_FileButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_sass__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_sass__);










/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function ProfileEditor(_ref) {
  var profileEditorStore = _ref.profileEditorStore;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'profile-editor' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'avatar-box' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_components_FileButton___default.a,
        { onChange: function onChange(files) {
            return profileEditorStore.uploadPicture(files[0]);
          }, accept: '.png,.jpg,.jpeg' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Avatar___default.a, {
          size: 128,
          className: 'profile-editor-avatar',
          url: profileEditorStore.picture
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default.a,
      { className: 'profile-editor-box' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content intro' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Tell us a little about yourself.'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components_Form__["Form"],
        { onSubmit: function onSubmit() {
            return profileEditorStore.save();
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'columns' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Form__["Input"], { field: 'firstName', model: profileEditorStore, label: 'First name', disabled: profileEditorStore.save.pending }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Form__["Input"], { field: 'lastName', model: profileEditorStore, label: 'Last name', disabled: profileEditorStore.save.pending }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Form__["Input"], { field: 'email', model: profileEditorStore, label: 'Email address', disabled: profileEditorStore.save.pending || !profileEditorStore.canSetEmail })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'columns' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column has-text-centered' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('button is-awesome', profileEditorStore.save.pending && 'is-loading'), disabled: profileEditorStore.save.pending },
              'Save'
            )
          )
        )
      )
    )
  );
}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Amendment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_uniqueId__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_objectUtil__ = __webpack_require__(268);







var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var Amendment = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Amendment, _Model);

  function Amendment(attrs, opts) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Amendment);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Amendment.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Amendment)).apply(this, arguments));

    _this.cid = __WEBPACK_IMPORTED_MODULE_9_lodash_uniqueId___default()('amendment-');

    _initDefineProp(_this, 'id', _descriptor, _this);

    _initDefineProp(_this, 'dateCreated', _descriptor2, _this);

    _initDefineProp(_this, 'description', _descriptor3, _this);

    _initDefineProp(_this, 'customerAmount', _descriptor4, _this);

    _this.job = opts.job;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Amendment, [{
    key: 'parse',
    value: function parse(json) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils_objectUtil__["a" /* omitUndefined */])({
        id: json.date_created,
        dateCreated: __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_created),
        description: json.description,
        customerAmount: json.customer_amount
      });
    }
  }]);

  return Amendment;
}(__WEBPACK_IMPORTED_MODULE_6_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'dateCreated', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'description', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'customerAmount', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
})), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuovoLinkedAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PlaidLinkedAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_misc_brokerLogos__ = __webpack_require__(423);










var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _desc2, _value2, _class3, _descriptor4, _descriptor5, _desc3, _value3, _class5, _descriptor6;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var LinkedAccount = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(LinkedAccount, _Model);

  function LinkedAccount() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, LinkedAccount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LinkedAccount.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(LinkedAccount)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'id', _descriptor, _this), _initDefineProp(_this, 'provider', _descriptor2, _this), _initDefineProp(_this, 'institution', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }
  // Can be 'plaid' or 'quovo'


  return LinkedAccount;
}(__WEBPACK_IMPORTED_MODULE_11_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'provider', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'institution', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
})), _class);



var QUOVO_STATUS_NEEDS_USER_INTERACTION = ['login', 'questions', 'config'];

var QuovoLinkedAccount = (_class3 = function (_LinkedAccount) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(QuovoLinkedAccount, _LinkedAccount);

  function QuovoLinkedAccount() {
    var _ref2;

    var _temp2, _this2, _ret2;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, QuovoLinkedAccount);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = QuovoLinkedAccount.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(QuovoLinkedAccount)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, 'status', _descriptor4, _this2), _initDefineProp(_this2, 'brokerageId', _descriptor5, _this2), _temp2), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret2);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(QuovoLinkedAccount, [{
    key: 'parse',
    value: function parse(json) {
      var brokerage_name = json.brokerage_name,
          brokerage = json.brokerage,
          rest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(json, ['brokerage_name', 'brokerage']);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, {
        provider: 'quovo',
        brokerageId: brokerage,
        institution: brokerage_name
      });
    }
  }, {
    key: 'syncing',
    get: function get() {
      return this.status === 'syncing';
    }
  }, {
    key: 'needsUserInteraction',
    get: function get() {
      if (!this.status) {
        return true;
      }

      return __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(QUOVO_STATUS_NEEDS_USER_INTERACTION, this.status);
    }
  }, {
    key: 'logo',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_misc_brokerLogos__["a" /* getLogo */])(this.brokerageId);
    }
  }]);

  return QuovoLinkedAccount;
}(LinkedAccount), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'status', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'brokerageId', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, 'syncing', [__WEBPACK_IMPORTED_MODULE_9_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'syncing'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'needsUserInteraction', [__WEBPACK_IMPORTED_MODULE_9_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'needsUserInteraction'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'logo', [__WEBPACK_IMPORTED_MODULE_9_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'logo'), _class3.prototype)), _class3);

var PlaidLinkedAccount = (_class5 = function (_LinkedAccount2) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(PlaidLinkedAccount, _LinkedAccount2);

  function PlaidLinkedAccount() {
    var _ref3;

    var _temp3, _this3, _ret3;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, PlaidLinkedAccount);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref3 = PlaidLinkedAccount.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(PlaidLinkedAccount)).call.apply(_ref3, [this].concat(args))), _this3), _initDefineProp(_this3, 'publicToken', _descriptor6, _this3), _temp3), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this3, _ret3);
  }

  return PlaidLinkedAccount;
}(LinkedAccount), (_descriptor6 = _applyDecoratedDescriptor(_class5.prototype, 'publicToken', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: null
})), _class5);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_auth0Util__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_auth0Util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_utils_auth0Util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_last__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_dummyImageUtil__ = __webpack_require__(840);










var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







/* eslint-disable camelcase */
var User = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(User, _Model);

  function User() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, User);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = User.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(User)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'name', _descriptor, _this), _initDefineProp(_this, 'picture', _descriptor2, _this), _initDefineProp(_this, 'email', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(User, [{
    key: 'parse',
    value: function parse(json) {
      var user_id = json.user_id,
          _json$app_metadata = json.app_metadata,
          app_metadata = _json$app_metadata === undefined ? {} : _json$app_metadata,
          email = json.email,
          _json$user_metadata = json.user_metadata,
          user_metadata = _json$user_metadata === undefined ? {} : _json$user_metadata,
          rest = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(json, ['user_id', 'app_metadata', 'email', 'user_metadata']);

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rest, {
        id: user_id,
        name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils_auth0Util__["extractProfileName"])(json) || this.name,
        given_name: json.given_name || json.first_name,
        family_name: json.family_name || json.last_name,
        email: user_metadata.email_address || this.user_metadata && this.user_metadata.email_address || email || this.email,
        app_metadata: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.app_metadata, app_metadata),
        user_metadata: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.user_metadata, user_metadata)
      });
    }
  }, {
    key: 'firstName',
    get: function get() {
      if (this.user_metadata.given_name) {
        return this.user_metadata.given_name;
      }

      if (this.given_name) {
        return this.given_name;
      }

      if (this.name === this.email) {
        return '';
      }

      return this.name ? this.name.split(' ')[0] : '';
    }
  }, {
    key: 'lastName',
    get: function get() {
      if (this.user_metadata.family_name) {
        return this.user_metadata.family_name;
      }

      if (this.family_name) {
        return this.family_name;
      }

      if (this.name === this.email) {
        return '';
      }

      return this.name ? __WEBPACK_IMPORTED_MODULE_12_lodash_last___default()(this.name.split(' ')) : '';
    }
  }, {
    key: 'displayName',
    get: function get() {
      return ((this.firstName || '') + ' ' + (this.lastName || '')).trim() || this.name;
    }
  }, {
    key: 'avatar',
    get: function get() {
      return this.user_metadata.picture || this.picture || this.avatarFallback;
    }
  }, {
    key: 'avatarFallback',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils_dummyImageUtil__["a" /* generateAvatarFallback */])(this.displayName || this.email);
    }
  }]);

  return User;
}(__WEBPACK_IMPORTED_MODULE_9_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'name', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'picture', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'email', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'firstName', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'firstName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'lastName', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'lastName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'displayName', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'displayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'avatar', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'avatar'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'avatarFallback', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'avatarFallback'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuovoAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_memoize__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_memoize__);







var QuovoAPI = function () {
  function QuovoAPI(token) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, QuovoAPI);

    this.client = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
      headers: {
        authorization: 'Bearer ' + token
      }
    });

    this.getBrokerages = __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default()(this.getBrokerages.bind(this));
    this.getBrokerage = __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default()(this.getBrokerage.bind(this));
    this.ensureUser = __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default()(this.ensureUser.bind(this));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(QuovoAPI, [{
    key: 'ensureUser',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                return _context.abrupt('return', this.client.post('/quovo/ensureuser').then(function (r) {
                  return r.data;
                }));

              case 4:
                _context.prev = 4;
                _context.t0 = _context['catch'](0);

                this.ensureUser.cache.clear();
                throw _context.t0;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 4]]);
      }));

      function ensureUser() {
        return _ref.apply(this, arguments);
      }

      return ensureUser;
    }()
  }, {
    key: 'getBrokerages',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.client.get('/quovo/brokerages');

              case 3:
                _ref3 = _context2.sent;
                data = _ref3.data;
                return _context2.abrupt('return', data.brokerages);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                this.getBrokerages.cache.clear();
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getBrokerages() {
        return _ref2.apply(this, arguments);
      }

      return getBrokerages;
    }()
  }, {
    key: 'getBrokerage',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var _ref5, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.client.get('/quovo/brokerages/' + id);

              case 3:
                _ref5 = _context3.sent;
                data = _ref5.data;
                return _context3.abrupt('return', data.brokerage);

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                this.getBrokerage.cache.clear();
                throw _context3.t0;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function getBrokerage(_x) {
        return _ref4.apply(this, arguments);
      }

      return getBrokerage;
    }()
  }, {
    key: 'getSyncProgress',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(accountId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.ensureUser();

              case 2:
                return _context4.abrupt('return', this.client.get('/quovo/sync', { params: { account: accountId } }).then(function (r) {
                  return r.data;
                }));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getSyncProgress(_x2) {
        return _ref6.apply(this, arguments);
      }

      return getSyncProgress;
    }()
  }, {
    key: 'getAccount',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.ensureUser();

              case 2:
                return _context5.abrupt('return', this.client.get('/quovo/accounts/' + id).then(function (resp) {
                  return resp.data;
                }));

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAccount(_x3) {
        return _ref7.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: 'getAccounts',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.ensureUser();

              case 2:
                user = _context6.sent;
                return _context6.abrupt('return', this.client.get('/quovo/users/' + user.id + '/accounts').then(function (resp) {
                  return resp.data;
                }));

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAccounts() {
        return _ref8.apply(this, arguments);
      }

      return getAccounts;
    }()
  }, {
    key: 'sync',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(accountId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.ensureUser();

              case 2:
                return _context7.abrupt('return', this.client.post('/quovo/sync', { account: accountId }).then(function (r) {
                  return r.data;
                }));

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sync(_x4) {
        return _ref9.apply(this, arguments);
      }

      return sync;
    }()
  }, {
    key: 'deleteAccount',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(accountId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.ensureUser();

              case 2:
                return _context8.abrupt('return', this.client.delete('/quovo/accounts/' + accountId).then(function (resp) {
                  return resp.data;
                }));

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteAccount(_x5) {
        return _ref10.apply(this, arguments);
      }

      return deleteAccount;
    }()
  }, {
    key: 'createAccount',
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(brokerageId, username, password) {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.ensureUser();

              case 2:
                user = _context9.sent;
                return _context9.abrupt('return', this.client.post('/quovo/accounts', {
                  user: user.id,
                  brokerage: brokerageId,
                  username: username,
                  password: password
                }).then(function (r) {
                  return r.data;
                }));

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createAccount(_x6, _x7, _x8) {
        return _ref11.apply(this, arguments);
      }

      return createAccount;
    }()
  }, {
    key: 'updateAccount',
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(id, username, password) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.ensureUser();

              case 2:
                return _context10.abrupt('return', this.client.put('/quovo/accounts/' + id, { username: username, password: password }).then(function (r) {
                  return r.data;
                }));

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateAccount(_x9, _x10, _x11) {
        return _ref12.apply(this, arguments);
      }

      return updateAccount;
    }()
  }, {
    key: 'getChallenges',
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(accountId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.ensureUser();

              case 2:
                return _context11.abrupt('return', this.client.get('/quovo/accounts/' + accountId + '/challenges').then(function (r) {
                  return r.data;
                }));

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getChallenges(_x12) {
        return _ref13.apply(this, arguments);
      }

      return getChallenges;
    }()
  }, {
    key: 'answerChallenge',
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(_ref15) {
        var challengeId = _ref15.challengeId,
            answer = _ref15.answer,
            question = _ref15.question;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.ensureUser();

              case 2:
                return _context12.abrupt('return', this.client.put('/quovo/challenges/' + challengeId, { question: question, answer: answer }).then(function (r) {
                  return r.data;
                }));

              case 3:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function answerChallenge(_x13) {
        return _ref14.apply(this, arguments);
      }

      return answerChallenge;
    }()

    /**
     * Use this to create an instance from a token.
     * Ensures that cacheable things are cached.
     */

  }], [{
    key: 'create',
    value: function create(token) {
      return _create(token);
    }
  }]);

  return QuovoAPI;
}();




var _create = __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default()(function createQuovoAPI(token) {
  return new QuovoAPI(token);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLogo;
var logos = {
  1: 'etrade',
  21556: 'fidelity',
  3: 'td',
  4: 'capone',
  5: 'scottrade',
  6: 'schwab', // haha, sounds funny
  12: 'chase',
  22: 'merrill',
  34: 'bofa',
  1350: 'amex'
  // 23: 'fidelitynetbenefits'
};

function getLogo(id) {
  var name = logos[id];
  if (!name) {
    return null;
  }

  return __webpack_require__(1593)("./" + name + '.png');
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvbWlzYy9icm9rZXJMb2dvcy5qcyJdLCJuYW1lcyI6WyJsb2dvcyIsImdldExvZ28iLCJpZCIsIm5hbWUiLCJyZXF1aXJlIl0sIm1hcHBpbmdzIjoiQUFBQSxJQUFNQSxRQUFRO0FBQ1osS0FBRyxRQURTO0FBRVosU0FBTyxVQUZLO0FBR1osS0FBRyxJQUhTO0FBSVosS0FBRyxRQUpTO0FBS1osS0FBRyxXQUxTO0FBTVosS0FBRyxRQU5TLEVBTUM7QUFDYixNQUFJLE9BUFE7QUFRWixNQUFJLFNBUlE7QUFTWixNQUFJLE1BVFE7QUFVWixRQUFNO0FBQ047QUFYWSxDQUFkOztBQWNBLE9BQU8sU0FBU0MsT0FBVCxDQUFrQkMsRUFBbEIsRUFBc0I7QUFDM0IsTUFBTUMsT0FBT0gsTUFBTUUsRUFBTixDQUFiO0FBQ0EsTUFBSSxDQUFDQyxJQUFMLEVBQVc7QUFDVCxXQUFPLElBQVA7QUFDRDs7QUFFRCxTQUFPQywrQkFBNkJELElBQTdCLFVBQVA7QUFDRCIsImZpbGUiOiJicm9rZXJMb2dvcy5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IGxvZ29zID0ge1xuICAxOiAnZXRyYWRlJyxcbiAgMjE1NTY6ICdmaWRlbGl0eScsXG4gIDM6ICd0ZCcsXG4gIDQ6ICdjYXBvbmUnLFxuICA1OiAnc2NvdHRyYWRlJyxcbiAgNjogJ3NjaHdhYicsIC8vIGhhaGEsIHNvdW5kcyBmdW5ueVxuICAxMjogJ2NoYXNlJyxcbiAgMjI6ICdtZXJyaWxsJyxcbiAgMzQ6ICdib2ZhJyxcbiAgMTM1MDogJ2FtZXgnXG4gIC8vIDIzOiAnZmlkZWxpdHluZXRiZW5lZml0cydcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldExvZ28gKGlkKSB7XG4gIGNvbnN0IG5hbWUgPSBsb2dvc1tpZF1cbiAgaWYgKCFuYW1lKSB7XG4gICAgcmV0dXJuIG51bGxcbiAgfVxuXG4gIHJldHVybiByZXF1aXJlKGBhc3NldHMvYmFuay1sb2dvcy8ke25hbWV9LnBuZ2ApXG59XG4iXX0=

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaymentMethodPicker", function() { return PaymentMethodPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FeeBreakdown", function() { return FeeBreakdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_PaymentMethods__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_formatCurrency__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_formatCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_utils_formatCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_prefix__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_utils_prefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_sass__);












var FeeBreakdown = function FeeBreakdown(_ref) {
  var step = _ref.step;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default.a,
    { className: 'breakdown-box', level: 2 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'breakdown-header' },
      step.breakdownTitle
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'order-lines' },
      step.orderLinesDisplay.map(function (orderLine) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderLine, {
          name: orderLine.product,
          calculating: orderLine.isDiscount && step.calculatingDiscount,
          price: orderLine.price,
          wrapPrice: orderLine.isDiscount,
          boldPrice: orderLine.bold,
          dashed: orderLine.dashed,
          key: orderLine.product
        });
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderLine, { name: 'Total', price: step.orderTotal, total: true, boldPrice: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderLine, { name: 'Amount Due Now', price: step.amountDueNow, boldName: true, boldPrice: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'coupon-container' },
      step.couponsUsed.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'coupons-used' },
        step.couponsUsed.map(function (c) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: c, className: 'coupon tag' },
            c
          );
        })
      ),
      step.showingCouponField ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_components_Form__["Form"],
        { onSubmit: function onSubmit() {
            return step.applyCoupon();
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'control has-addons' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            type: 'text',
            className: 'input coupon-field',
            placeholder: 'Enter coupon code',
            value: step.couponCode,
            disabled: step.applyCoupon.pending,
            onChange: function onChange(e) {
              return step.setCouponCode(e.target.value);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('button is-info', step.applyCoupon.pending && 'is-loading'),
              disabled: step.applyCoupon.pending || step.calculatePrice.pending || step.submitJob.pending || step.saveCard.pending
            },
            'Apply'
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'coupon-button', onClick: function onClick() {
            return step.toggleCouponField();
          }, disabled: step.submitJob.pending },
        step.couponsUsed.length === 0 ? 'I have a coupon!' : 'I have another coupon!'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        className: 'button pay-button',
        onClick: function onClick() {
          return step.pay();
        },
        disabled: step.calculatePrice.pending || step.submitJob.pending || step.saveCard.pending
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'icon' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Icon___default.a, { material: true, name: 'credit card' }),
        '\xA0'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Secure Checkout'
      )
    )
  );
};

FeeBreakdown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(FeeBreakdown);

var orderLineModifiers = __WEBPACK_IMPORTED_MODULE_9_utils_prefix___default()('order-line--');

var OrderLine = function OrderLine(_ref2) {
  var calculating = _ref2.calculating,
      name = _ref2.name,
      price = _ref2.price,
      wrapPrice = _ref2.wrapPrice,
      boldName = _ref2.boldName,
      total = _ref2.total,
      boldPrice = _ref2.boldPrice,
      dashed = _ref2.dashed;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('order-line', orderLineModifiers({ total: total, boldPrice: boldPrice, boldName: boldName, dashed: dashed })) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'line-name' },
      name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'line-price' },
      calculating ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_ProgressSpinner___default.a, { blue: true }) : typeof price === 'string' ? price : wrapPrice ? '(' + __WEBPACK_IMPORTED_MODULE_8_utils_formatCurrency___default()(price) + ')' : __WEBPACK_IMPORTED_MODULE_8_utils_formatCurrency___default()(price)
    )
  );
};

OrderLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(OrderLine);

var PaymentMethodPicker = function PaymentMethodPicker(_ref3) {
  var step = _ref3.step;
  var billingStore = step.wizard.rootStore.billingStore;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default.a,
    { className: 'breakdown-box', level: 2 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'breakdown-header flex' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'breakdown-header__filler' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'button is-icon-only', onClick: function onClick(e) {
              return e.preventDefault() || step.showFeeBreakdown();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Icon___default.a, { material: true, name: 'arrow back' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'breakdown-header__text' },
        'Select Payment Method'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'breakdown-header__filler' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_PaymentMethods__["a" /* default */], {
      loading: step.fetchPaymentMethods.pending,
      cards: billingStore.cards,
      busy: billingStore.busy || step.selectPaymentMethod.pending,
      onAddClick: function onAddClick() {
        return billingStore.showAddCardCheckout();
      },
      onDeleteCardClick: function onDeleteCardClick(card) {
        return billingStore.deletePaymentMethod(card);
      },
      onCardClick: function onCardClick(card) {
        return step.selectPaymentMethod(card);
      }
    })
  );
};

PaymentMethodPicker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(PaymentMethodPicker);


//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc2NyZWVucy9Qcm9qZWN0V2l6YXJkL1N0ZXBzL0ZlZUJyZWFrZG93bi9Cb3hlcy9pbmRleC5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJvYnNlcnZlciIsImN4IiwiU2hhZG93Qm94IiwiSWNvbiIsIlBheW1lbnRNZXRob2RzIiwiUHJvZ3Jlc3NTcGlubmVyIiwiRm9ybSIsImZvcm1hdEN1cnJlbmN5IiwicHJlZml4IiwiRmVlQnJlYWtkb3duIiwic3RlcCIsImJyZWFrZG93blRpdGxlIiwib3JkZXJMaW5lc0Rpc3BsYXkiLCJtYXAiLCJvcmRlckxpbmUiLCJwcm9kdWN0IiwiaXNEaXNjb3VudCIsImNhbGN1bGF0aW5nRGlzY291bnQiLCJwcmljZSIsImJvbGQiLCJkYXNoZWQiLCJvcmRlclRvdGFsIiwiYW1vdW50RHVlTm93IiwiY291cG9uc1VzZWQiLCJsZW5ndGgiLCJjIiwic2hvd2luZ0NvdXBvbkZpZWxkIiwiYXBwbHlDb3Vwb24iLCJjb3Vwb25Db2RlIiwicGVuZGluZyIsInNldENvdXBvbkNvZGUiLCJlIiwidGFyZ2V0IiwidmFsdWUiLCJjYWxjdWxhdGVQcmljZSIsInN1Ym1pdEpvYiIsInNhdmVDYXJkIiwidG9nZ2xlQ291cG9uRmllbGQiLCJwYXkiLCJvcmRlckxpbmVNb2RpZmllcnMiLCJPcmRlckxpbmUiLCJjYWxjdWxhdGluZyIsIm5hbWUiLCJ3cmFwUHJpY2UiLCJib2xkTmFtZSIsInRvdGFsIiwiYm9sZFByaWNlIiwiUGF5bWVudE1ldGhvZFBpY2tlciIsImJpbGxpbmdTdG9yZSIsIndpemFyZCIsInJvb3RTdG9yZSIsInByZXZlbnREZWZhdWx0Iiwic2hvd0ZlZUJyZWFrZG93biIsImZldGNoUGF5bWVudE1ldGhvZHMiLCJjYXJkcyIsImJ1c3kiLCJzZWxlY3RQYXltZW50TWV0aG9kIiwic2hvd0FkZENhcmRDaGVja291dCIsImRlbGV0ZVBheW1lbnRNZXRob2QiLCJjYXJkIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsU0FBU0MsUUFBVCxRQUF5QixZQUF6QjtBQUNBLE9BQU9DLEVBQVAsTUFBZSxZQUFmO0FBQ0EsT0FBT0MsU0FBUCxNQUFzQixzQkFBdEI7QUFDQSxPQUFPQyxJQUFQLE1BQWlCLGlCQUFqQjtBQUNBLE9BQU9DLGNBQVAsTUFBMkIsMkJBQTNCO0FBQ0EsT0FBT0MsZUFBUCxNQUE0Qiw0QkFBNUI7QUFDQSxTQUFTQyxJQUFULFFBQXFCLGlCQUFyQjtBQUNBLE9BQU9DLGNBQVAsTUFBMkIsc0JBQTNCO0FBQ0EsT0FBT0MsTUFBUCxNQUFtQixjQUFuQjtBQUNBLE9BQU8sZUFBUDs7QUFFQSxJQUFJQyxlQUFlO0FBQUEsTUFBR0MsSUFBSCxRQUFHQSxJQUFIO0FBQUEsU0FDakI7QUFBQyxhQUFEO0FBQUEsTUFBVyxXQUFVLGVBQXJCLEVBQXFDLE9BQU8sQ0FBNUM7QUFDRTtBQUFBO0FBQUEsUUFBSyxXQUFVLGtCQUFmO0FBQ0dBLFdBQUtDO0FBRFIsS0FERjtBQUlFO0FBQUE7QUFBQSxRQUFLLFdBQVUsYUFBZjtBQUNHRCxXQUFLRSxpQkFBTCxDQUF1QkMsR0FBdkIsQ0FBMkIsVUFBQ0MsU0FBRDtBQUFBLGVBQzFCLG9CQUFDLFNBQUQ7QUFDRSxnQkFBTUEsVUFBVUMsT0FEbEI7QUFFRSx1QkFBYUQsVUFBVUUsVUFBVixJQUF3Qk4sS0FBS08sbUJBRjVDO0FBR0UsaUJBQU9ILFVBQVVJLEtBSG5CO0FBSUUscUJBQVdKLFVBQVVFLFVBSnZCO0FBS0UscUJBQVdGLFVBQVVLLElBTHZCO0FBTUUsa0JBQVFMLFVBQVVNLE1BTnBCO0FBT0UsZUFBS04sVUFBVUM7QUFQakIsVUFEMEI7QUFBQSxPQUEzQixDQURIO0FBWUUsMEJBQUMsU0FBRCxJQUFXLE1BQUssT0FBaEIsRUFBd0IsT0FBT0wsS0FBS1csVUFBcEMsRUFBZ0QsV0FBaEQsRUFBc0QsZUFBdEQsR0FaRjtBQWFFLDBCQUFDLFNBQUQsSUFBVyxNQUFLLGdCQUFoQixFQUFpQyxPQUFPWCxLQUFLWSxZQUE3QyxFQUEyRCxjQUEzRCxFQUFvRSxlQUFwRTtBQWJGLEtBSkY7QUFtQkU7QUFBQTtBQUFBLFFBQUssV0FBVSxrQkFBZjtBQUNHWixXQUFLYSxXQUFMLENBQWlCQyxNQUFqQixHQUEwQixDQUExQixJQUNDO0FBQUE7QUFBQSxVQUFLLFdBQVUsY0FBZjtBQUNHZCxhQUFLYSxXQUFMLENBQWlCVixHQUFqQixDQUFxQixVQUFDWSxDQUFEO0FBQUEsaUJBQ3BCO0FBQUE7QUFBQSxjQUFNLEtBQUtBLENBQVgsRUFBYyxXQUFVLFlBQXhCO0FBQXNDQTtBQUF0QyxXQURvQjtBQUFBLFNBQXJCO0FBREgsT0FGSjtBQVNHZixXQUFLZ0Isa0JBQUwsR0FFRztBQUFDLFlBQUQ7QUFBQSxVQUFNLFVBQVU7QUFBQSxtQkFBTWhCLEtBQUtpQixXQUFMLEVBQU47QUFBQSxXQUFoQjtBQUNFO0FBQUE7QUFBQSxZQUFHLFdBQVUsb0JBQWI7QUFDRTtBQUNFLGtCQUFLLE1BRFA7QUFFRSx1QkFBVSxvQkFGWjtBQUdFLHlCQUFZLG1CQUhkO0FBSUUsbUJBQU9qQixLQUFLa0IsVUFKZDtBQUtFLHNCQUFVbEIsS0FBS2lCLFdBQUwsQ0FBaUJFLE9BTDdCO0FBTUUsc0JBQVU7QUFBQSxxQkFBS25CLEtBQUtvQixhQUFMLENBQW1CQyxFQUFFQyxNQUFGLENBQVNDLEtBQTVCLENBQUw7QUFBQTtBQU5aLFlBREY7QUFTRTtBQUFBO0FBQUE7QUFDRSxvQkFBSyxRQURQO0FBRUUseUJBQVdoQyxHQUFHLGdCQUFILEVBQXFCUyxLQUFLaUIsV0FBTCxDQUFpQkUsT0FBakIsSUFBNEIsWUFBakQsQ0FGYjtBQUdFLHdCQUFVbkIsS0FBS2lCLFdBQUwsQ0FBaUJFLE9BQWpCLElBQTRCbkIsS0FBS3dCLGNBQUwsQ0FBb0JMLE9BQWhELElBQTJEbkIsS0FBS3lCLFNBQUwsQ0FBZU4sT0FBMUUsSUFBcUZuQixLQUFLMEIsUUFBTCxDQUFjUDtBQUgvRztBQUFBO0FBQUE7QUFURjtBQURGLE9BRkgsR0F1Qkc7QUFBQTtBQUFBLFVBQVEsV0FBVSxlQUFsQixFQUFrQyxTQUFTO0FBQUEsbUJBQU1uQixLQUFLMkIsaUJBQUwsRUFBTjtBQUFBLFdBQTNDLEVBQTJFLFVBQVUzQixLQUFLeUIsU0FBTCxDQUFlTixPQUFwRztBQUNHbkIsYUFBS2EsV0FBTCxDQUFpQkMsTUFBakIsS0FBNEIsQ0FBNUIsR0FBZ0Msa0JBQWhDLEdBQXFEO0FBRHhEO0FBaENOLEtBbkJGO0FBeURFO0FBQUE7QUFBQTtBQUNFLG1CQUFVLG1CQURaO0FBRUUsaUJBQVM7QUFBQSxpQkFBTWQsS0FBSzRCLEdBQUwsRUFBTjtBQUFBLFNBRlg7QUFHRSxrQkFBVTVCLEtBQUt3QixjQUFMLENBQW9CTCxPQUFwQixJQUErQm5CLEtBQUt5QixTQUFMLENBQWVOLE9BQTlDLElBQXlEbkIsS0FBSzBCLFFBQUwsQ0FBY1A7QUFIbkY7QUFLRTtBQUFBO0FBQUEsVUFBTSxXQUFVLE1BQWhCO0FBQ0UsNEJBQUMsSUFBRCxJQUFNLGNBQU4sRUFBZSxNQUFLLGFBQXBCLEdBREY7QUFBQTtBQUFBLE9BTEY7QUFRRTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBUkY7QUF6REYsR0FEaUI7QUFBQSxDQUFuQjs7QUF5RUFwQixlQUFlVCxTQUFTUyxZQUFULENBQWY7O0FBRUEsSUFBTThCLHFCQUFxQi9CLE9BQU8sY0FBUCxDQUEzQjs7QUFFQSxJQUFJZ0MsWUFBWTtBQUFBLE1BQUdDLFdBQUgsU0FBR0EsV0FBSDtBQUFBLE1BQWdCQyxJQUFoQixTQUFnQkEsSUFBaEI7QUFBQSxNQUFzQnhCLEtBQXRCLFNBQXNCQSxLQUF0QjtBQUFBLE1BQTZCeUIsU0FBN0IsU0FBNkJBLFNBQTdCO0FBQUEsTUFBd0NDLFFBQXhDLFNBQXdDQSxRQUF4QztBQUFBLE1BQWtEQyxLQUFsRCxTQUFrREEsS0FBbEQ7QUFBQSxNQUF5REMsU0FBekQsU0FBeURBLFNBQXpEO0FBQUEsTUFBb0UxQixNQUFwRSxTQUFvRUEsTUFBcEU7QUFBQSxTQUNkO0FBQUE7QUFBQSxNQUFLLFdBQVduQixHQUFHLFlBQUgsRUFBaUJzQyxtQkFBbUIsRUFBRU0sWUFBRixFQUFTQyxvQkFBVCxFQUFvQkYsa0JBQXBCLEVBQThCeEIsY0FBOUIsRUFBbkIsQ0FBakIsQ0FBaEI7QUFDRTtBQUFBO0FBQUEsUUFBSyxXQUFVLFdBQWY7QUFBNEJzQjtBQUE1QixLQURGO0FBRUU7QUFBQTtBQUFBLFFBQUssV0FBVSxZQUFmO0FBQ0dELG9CQUNHLG9CQUFDLGVBQUQsSUFBaUIsVUFBakIsR0FESCxHQUVHLE9BQU92QixLQUFQLEtBQWlCLFFBQWpCLEdBQ0VBLEtBREYsR0FFRXlCLGtCQUNNcEMsZUFBZVcsS0FBZixDQUROLFNBRUVYLGVBQWVXLEtBQWY7QUFQVjtBQUZGLEdBRGM7QUFBQSxDQUFoQjs7QUFnQkFzQixZQUFZeEMsU0FBU3dDLFNBQVQsQ0FBWjs7QUFFQSxJQUFJTyxzQkFBc0Isb0NBQWM7QUFBQSxNQUFYckMsSUFBVyxTQUFYQSxJQUFXO0FBQUEsTUFDOUJzQyxZQUQ4QixHQUNidEMsS0FBS3VDLE1BQUwsQ0FBWUMsU0FEQyxDQUM5QkYsWUFEOEI7O0FBRXRDLFNBQ0U7QUFBQyxhQUFEO0FBQUEsTUFBVyxXQUFVLGVBQXJCLEVBQXFDLE9BQU8sQ0FBNUM7QUFDRTtBQUFBO0FBQUEsUUFBSyxXQUFVLHVCQUFmO0FBQ0U7QUFBQTtBQUFBLFVBQUssV0FBVSwwQkFBZjtBQUNFO0FBQUE7QUFBQSxZQUFHLFdBQVUscUJBQWIsRUFBbUMsU0FBUyxpQkFBQ2pCLENBQUQ7QUFBQSxxQkFBT0EsRUFBRW9CLGNBQUYsTUFBc0J6QyxLQUFLMEMsZ0JBQUwsRUFBN0I7QUFBQSxhQUE1QztBQUNFLDhCQUFDLElBQUQsSUFBTSxjQUFOLEVBQWUsTUFBSyxZQUFwQjtBQURGO0FBREYsT0FERjtBQU1FO0FBQUE7QUFBQSxVQUFLLFdBQVUsd0JBQWY7QUFBQTtBQUFBLE9BTkY7QUFTRSxtQ0FBSyxXQUFVLDBCQUFmO0FBVEYsS0FERjtBQVlFLHdCQUFDLGNBQUQ7QUFDRSxlQUFTMUMsS0FBSzJDLG1CQUFMLENBQXlCeEIsT0FEcEM7QUFFRSxhQUFPbUIsYUFBYU0sS0FGdEI7QUFHRSxZQUFNTixhQUFhTyxJQUFiLElBQXFCN0MsS0FBSzhDLG1CQUFMLENBQXlCM0IsT0FIdEQ7QUFJRSxrQkFBWTtBQUFBLGVBQU1tQixhQUFhUyxtQkFBYixFQUFOO0FBQUEsT0FKZDtBQUtFLHlCQUFtQjtBQUFBLGVBQVFULGFBQWFVLG1CQUFiLENBQWlDQyxJQUFqQyxDQUFSO0FBQUEsT0FMckI7QUFNRSxtQkFBYTtBQUFBLGVBQVFqRCxLQUFLOEMsbUJBQUwsQ0FBeUJHLElBQXpCLENBQVI7QUFBQTtBQU5mO0FBWkYsR0FERjtBQXVCRCxDQXpCRDs7QUEyQkFaLHNCQUFzQi9DLFNBQVMrQyxtQkFBVCxDQUF0Qjs7QUFFQSxTQUFTQSxtQkFBVCxFQUE4QnRDLFlBQTlCIiwiZmlsZSI6ImluZGV4LmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCdcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJ1xuaW1wb3J0IFNoYWRvd0JveCBmcm9tICdjb21wb25lbnRzL1NoYWRvd0JveCdcbmltcG9ydCBJY29uIGZyb20gJ2NvbXBvbmVudHMvSWNvbidcbmltcG9ydCBQYXltZW50TWV0aG9kcyBmcm9tICdjb21wb25lbnRzL1BheW1lbnRNZXRob2RzJ1xuaW1wb3J0IFByb2dyZXNzU3Bpbm5lciBmcm9tICdjb21wb25lbnRzL1Byb2dyZXNzU3Bpbm5lcidcbmltcG9ydCB7IEZvcm0gfSBmcm9tICdjb21wb25lbnRzL0Zvcm0nXG5pbXBvcnQgZm9ybWF0Q3VycmVuY3kgZnJvbSAndXRpbHMvZm9ybWF0Q3VycmVuY3knXG5pbXBvcnQgcHJlZml4IGZyb20gJ3V0aWxzL3ByZWZpeCdcbmltcG9ydCAnLi9zdHlsZXMuc2FzcydcblxubGV0IEZlZUJyZWFrZG93biA9ICh7IHN0ZXAgfSkgPT4gKFxuICA8U2hhZG93Qm94IGNsYXNzTmFtZT1cImJyZWFrZG93bi1ib3hcIiBsZXZlbD17Mn0+XG4gICAgPGRpdiBjbGFzc05hbWU9XCJicmVha2Rvd24taGVhZGVyXCI+XG4gICAgICB7c3RlcC5icmVha2Rvd25UaXRsZX1cbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGNsYXNzTmFtZT1cIm9yZGVyLWxpbmVzXCI+XG4gICAgICB7c3RlcC5vcmRlckxpbmVzRGlzcGxheS5tYXAoKG9yZGVyTGluZSkgPT5cbiAgICAgICAgPE9yZGVyTGluZVxuICAgICAgICAgIG5hbWU9e29yZGVyTGluZS5wcm9kdWN0fVxuICAgICAgICAgIGNhbGN1bGF0aW5nPXtvcmRlckxpbmUuaXNEaXNjb3VudCAmJiBzdGVwLmNhbGN1bGF0aW5nRGlzY291bnR9XG4gICAgICAgICAgcHJpY2U9e29yZGVyTGluZS5wcmljZX1cbiAgICAgICAgICB3cmFwUHJpY2U9e29yZGVyTGluZS5pc0Rpc2NvdW50fVxuICAgICAgICAgIGJvbGRQcmljZT17b3JkZXJMaW5lLmJvbGR9XG4gICAgICAgICAgZGFzaGVkPXtvcmRlckxpbmUuZGFzaGVkfVxuICAgICAgICAgIGtleT17b3JkZXJMaW5lLnByb2R1Y3R9XG4gICAgICAgIC8+XG4gICAgICApfVxuICAgICAgPE9yZGVyTGluZSBuYW1lPVwiVG90YWxcIiBwcmljZT17c3RlcC5vcmRlclRvdGFsfSB0b3RhbCBib2xkUHJpY2UgLz5cbiAgICAgIDxPcmRlckxpbmUgbmFtZT1cIkFtb3VudCBEdWUgTm93XCIgcHJpY2U9e3N0ZXAuYW1vdW50RHVlTm93fSBib2xkTmFtZSBib2xkUHJpY2UgLz5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGNsYXNzTmFtZT1cImNvdXBvbi1jb250YWluZXJcIj5cbiAgICAgIHtzdGVwLmNvdXBvbnNVc2VkLmxlbmd0aCA+IDAgJiZcbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb3Vwb25zLXVzZWRcIj5cbiAgICAgICAgICB7c3RlcC5jb3Vwb25zVXNlZC5tYXAoKGMpID0+XG4gICAgICAgICAgICA8c3BhbiBrZXk9e2N9IGNsYXNzTmFtZT1cImNvdXBvbiB0YWdcIj57Y308L3NwYW4+XG4gICAgICAgICAgKX1cbiAgICAgICAgPC9kaXY+XG4gICAgICB9XG5cbiAgICAgIHtzdGVwLnNob3dpbmdDb3Vwb25GaWVsZFxuICAgICAgICA/IChcbiAgICAgICAgICA8Rm9ybSBvblN1Ym1pdD17KCkgPT4gc3RlcC5hcHBseUNvdXBvbigpfT5cbiAgICAgICAgICAgIDxwIGNsYXNzTmFtZT1cImNvbnRyb2wgaGFzLWFkZG9uc1wiPlxuICAgICAgICAgICAgICA8aW5wdXRcbiAgICAgICAgICAgICAgICB0eXBlPVwidGV4dFwiXG4gICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwiaW5wdXQgY291cG9uLWZpZWxkXCJcbiAgICAgICAgICAgICAgICBwbGFjZWhvbGRlcj1cIkVudGVyIGNvdXBvbiBjb2RlXCJcbiAgICAgICAgICAgICAgICB2YWx1ZT17c3RlcC5jb3Vwb25Db2RlfVxuICAgICAgICAgICAgICAgIGRpc2FibGVkPXtzdGVwLmFwcGx5Q291cG9uLnBlbmRpbmd9XG4gICAgICAgICAgICAgICAgb25DaGFuZ2U9e2UgPT4gc3RlcC5zZXRDb3Vwb25Db2RlKGUudGFyZ2V0LnZhbHVlKX1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgPGJ1dHRvblxuICAgICAgICAgICAgICAgIHR5cGU9XCJzdWJtaXRcIlxuICAgICAgICAgICAgICAgIGNsYXNzTmFtZT17Y3goJ2J1dHRvbiBpcy1pbmZvJywgc3RlcC5hcHBseUNvdXBvbi5wZW5kaW5nICYmICdpcy1sb2FkaW5nJyl9XG4gICAgICAgICAgICAgICAgZGlzYWJsZWQ9e3N0ZXAuYXBwbHlDb3Vwb24ucGVuZGluZyB8fCBzdGVwLmNhbGN1bGF0ZVByaWNlLnBlbmRpbmcgfHwgc3RlcC5zdWJtaXRKb2IucGVuZGluZyB8fCBzdGVwLnNhdmVDYXJkLnBlbmRpbmd9XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICBBcHBseVxuICAgICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICAgIDwvcD5cbiAgICAgICAgICA8L0Zvcm0+XG4gICAgICAgIClcbiAgICAgICAgOiAoXG4gICAgICAgICAgPGJ1dHRvbiBjbGFzc05hbWU9XCJjb3Vwb24tYnV0dG9uXCIgb25DbGljaz17KCkgPT4gc3RlcC50b2dnbGVDb3Vwb25GaWVsZCgpfSBkaXNhYmxlZD17c3RlcC5zdWJtaXRKb2IucGVuZGluZ30+XG4gICAgICAgICAgICB7c3RlcC5jb3Vwb25zVXNlZC5sZW5ndGggPT09IDAgPyAnSSBoYXZlIGEgY291cG9uIScgOiAnSSBoYXZlIGFub3RoZXIgY291cG9uISd9XG4gICAgICAgICAgPC9idXR0b24+XG4gICAgICAgIClcbiAgICAgIH1cbiAgICA8L2Rpdj5cbiAgICA8YVxuICAgICAgY2xhc3NOYW1lPVwiYnV0dG9uIHBheS1idXR0b25cIlxuICAgICAgb25DbGljaz17KCkgPT4gc3RlcC5wYXkoKX1cbiAgICAgIGRpc2FibGVkPXtzdGVwLmNhbGN1bGF0ZVByaWNlLnBlbmRpbmcgfHwgc3RlcC5zdWJtaXRKb2IucGVuZGluZyB8fCBzdGVwLnNhdmVDYXJkLnBlbmRpbmd9XG4gICAgPlxuICAgICAgPHNwYW4gY2xhc3NOYW1lPVwiaWNvblwiPlxuICAgICAgICA8SWNvbiBtYXRlcmlhbCBuYW1lPVwiY3JlZGl0IGNhcmRcIiAvPiZuYnNwO1xuICAgICAgPC9zcGFuPlxuICAgICAgPHNwYW4+XG4gICAgICAgIFNlY3VyZSBDaGVja291dFxuICAgICAgPC9zcGFuPlxuICAgIDwvYT5cbiAgPC9TaGFkb3dCb3g+XG4pXG5cbkZlZUJyZWFrZG93biA9IG9ic2VydmVyKEZlZUJyZWFrZG93bilcblxuY29uc3Qgb3JkZXJMaW5lTW9kaWZpZXJzID0gcHJlZml4KCdvcmRlci1saW5lLS0nKVxuXG5sZXQgT3JkZXJMaW5lID0gKHsgY2FsY3VsYXRpbmcsIG5hbWUsIHByaWNlLCB3cmFwUHJpY2UsIGJvbGROYW1lLCB0b3RhbCwgYm9sZFByaWNlLCBkYXNoZWQgfSkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT17Y3goJ29yZGVyLWxpbmUnLCBvcmRlckxpbmVNb2RpZmllcnMoeyB0b3RhbCwgYm9sZFByaWNlLCBib2xkTmFtZSwgZGFzaGVkIH0pKX0+XG4gICAgPGRpdiBjbGFzc05hbWU9XCJsaW5lLW5hbWVcIj57bmFtZX08L2Rpdj5cbiAgICA8ZGl2IGNsYXNzTmFtZT1cImxpbmUtcHJpY2VcIj5cbiAgICAgIHtjYWxjdWxhdGluZ1xuICAgICAgICA/IDxQcm9ncmVzc1NwaW5uZXIgYmx1ZSAvPlxuICAgICAgICA6IHR5cGVvZiBwcmljZSA9PT0gJ3N0cmluZydcbiAgICAgICAgICA/IHByaWNlXG4gICAgICAgICAgOiB3cmFwUHJpY2VcbiAgICAgICAgICAgID8gYCgke2Zvcm1hdEN1cnJlbmN5KHByaWNlKX0pYFxuICAgICAgICAgICAgOiBmb3JtYXRDdXJyZW5jeShwcmljZSlcbiAgICAgIH1cbiAgICA8L2Rpdj5cbiAgPC9kaXY+XG4pXG5cbk9yZGVyTGluZSA9IG9ic2VydmVyKE9yZGVyTGluZSlcblxubGV0IFBheW1lbnRNZXRob2RQaWNrZXIgPSAoeyBzdGVwIH0pID0+IHtcbiAgY29uc3QgeyBiaWxsaW5nU3RvcmUgfSA9IHN0ZXAud2l6YXJkLnJvb3RTdG9yZVxuICByZXR1cm4gKFxuICAgIDxTaGFkb3dCb3ggY2xhc3NOYW1lPVwiYnJlYWtkb3duLWJveFwiIGxldmVsPXsyfT5cbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiYnJlYWtkb3duLWhlYWRlciBmbGV4XCI+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiYnJlYWtkb3duLWhlYWRlcl9fZmlsbGVyXCI+XG4gICAgICAgICAgPGEgY2xhc3NOYW1lPVwiYnV0dG9uIGlzLWljb24tb25seVwiIG9uQ2xpY2s9eyhlKSA9PiBlLnByZXZlbnREZWZhdWx0KCkgfHwgc3RlcC5zaG93RmVlQnJlYWtkb3duKCl9PlxuICAgICAgICAgICAgPEljb24gbWF0ZXJpYWwgbmFtZT1cImFycm93IGJhY2tcIiAvPlxuICAgICAgICAgIDwvYT5cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiYnJlYWtkb3duLWhlYWRlcl9fdGV4dFwiPlxuICAgICAgICAgIFNlbGVjdCBQYXltZW50IE1ldGhvZFxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJicmVha2Rvd24taGVhZGVyX19maWxsZXJcIj48L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgICAgPFBheW1lbnRNZXRob2RzXG4gICAgICAgIGxvYWRpbmc9e3N0ZXAuZmV0Y2hQYXltZW50TWV0aG9kcy5wZW5kaW5nfVxuICAgICAgICBjYXJkcz17YmlsbGluZ1N0b3JlLmNhcmRzfVxuICAgICAgICBidXN5PXtiaWxsaW5nU3RvcmUuYnVzeSB8fCBzdGVwLnNlbGVjdFBheW1lbnRNZXRob2QucGVuZGluZ31cbiAgICAgICAgb25BZGRDbGljaz17KCkgPT4gYmlsbGluZ1N0b3JlLnNob3dBZGRDYXJkQ2hlY2tvdXQoKX1cbiAgICAgICAgb25EZWxldGVDYXJkQ2xpY2s9e2NhcmQgPT4gYmlsbGluZ1N0b3JlLmRlbGV0ZVBheW1lbnRNZXRob2QoY2FyZCl9XG4gICAgICAgIG9uQ2FyZENsaWNrPXtjYXJkID0+IHN0ZXAuc2VsZWN0UGF5bWVudE1ldGhvZChjYXJkKX1cbiAgICAgIC8+XG4gICAgPC9TaGFkb3dCb3g+XG4gIClcbn1cblxuUGF5bWVudE1ldGhvZFBpY2tlciA9IG9ic2VydmVyKFBheW1lbnRNZXRob2RQaWNrZXIpXG5cbmV4cG9ydCB7IFBheW1lbnRNZXRob2RQaWNrZXIsIEZlZUJyZWFrZG93biB9XG4iXX0=

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = retryOnNetworkFailure;
/* harmony export (immutable) */ __webpack_exports__["b"] = extractMessageFromError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);




/**
 * Retries the given function when a network error is thrown.
 */
function retryOnNetworkFailure(fn) {
  var _this = this;

  var retryCount = 0;
  var maxRetryCount = 5;
  var backoffTime = 300;
  var doneRetryingFn = void 0;
  var onFirstRetry = void 0;
  var valFromFirstRetry = void 0;
  var recoveredFn = void 0;
  var promise = __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.try(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var run, lastError, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            run = function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return fn();

                      case 3:
                        _context.t0 = _context.sent;
                        return _context.abrupt('return', {
                          result: _context.t0
                        });

                      case 7:
                        _context.prev = 7;
                        _context.t1 = _context['catch'](0);

                        if (!(_context.t1.message === 'Network Error' || _context.t1.message === 'Network Failure')) {
                          _context.next = 11;
                          break;
                        }

                        return _context.abrupt('return', {
                          error: _context.t1
                        });

                      case 11:
                        throw _context.t1;

                      case 12:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this, [[0, 7]]);
              }));

              return function run() {
                return _ref2.apply(this, arguments);
              };
            }();

            lastError = void 0;

          case 2:
            if (!(retryCount < maxRetryCount)) {
              _context2.next = 22;
              break;
            }

            _context2.next = 5;
            return run();

          case 5:
            result = _context2.sent;

            if (!result.error) {
              _context2.next = 16;
              break;
            }

            lastError = result.error;
            retryCount++;

            if (!(retryCount === 1 && onFirstRetry)) {
              _context2.next = 13;
              break;
            }

            _context2.next = 12;
            return onFirstRetry(lastError);

          case 12:
            valFromFirstRetry = _context2.sent;

          case 13:
            _context2.next = 15;
            return __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.delay(retryCount * backoffTime);

          case 15:
            return _context2.abrupt('continue', 2);

          case 16:
            if (!(retryCount > 0 && recoveredFn)) {
              _context2.next = 19;
              break;
            }

            _context2.next = 19;
            return recoveredFn(valFromFirstRetry);

          case 19:
            return _context2.abrupt('return', result.result);

          case 22:
            if (!doneRetryingFn) {
              _context2.next = 24;
              break;
            }

            return _context2.abrupt('return', doneRetryingFn(lastError, valFromFirstRetry));

          case 24:
            throw lastError;

          case 25:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  })));

  promise.retry = function (times) {
    maxRetryCount = times;
    return promise;
  };

  promise.firstRetry = function (fn) {
    onFirstRetry = fn;
    return promise;
  };

  promise.doneRetrying = function (fn) {
    doneRetryingFn = fn;
    return promise;
  };

  promise.backoffTime = function (time) {
    backoffTime = time;
    return promise;
  };

  promise.recovered = function (fn) {
    recoveredFn = fn;
    return promise;
  };

  return promise;
}

function extractMessageFromError(err) {
  if (err.response) {
    return err.response.data ? err.response.data.message : err.message;
  }

  return err.message;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_misc_env__ = __webpack_require__(157);



/**
 * We're lazy-evaling because we're loading Stripe asynchronously.
 */
function checkout(opts) {
  return window.StripeCheckout.configure(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, opts, {
    key: __WEBPACK_IMPORTED_MODULE_1_misc_env__["a" /* default */].STRIPE_PK,
    image: __webpack_require__(217),
    locale: 'auto',
    billingAddress: true,
    zipCode: true
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvdXRpbHMvc3RyaXBlLmpzIl0sIm5hbWVzIjpbImVudiIsImNoZWNrb3V0Iiwib3B0cyIsIndpbmRvdyIsIlN0cmlwZUNoZWNrb3V0IiwiY29uZmlndXJlIiwia2V5IiwiU1RSSVBFX1BLIiwiaW1hZ2UiLCJyZXF1aXJlIiwibG9jYWxlIiwiYmlsbGluZ0FkZHJlc3MiLCJ6aXBDb2RlIl0sIm1hcHBpbmdzIjoiO0FBQUEsT0FBT0EsR0FBUCxNQUFnQixVQUFoQjs7QUFFQTs7O0FBR0EsT0FBTyxTQUFTQyxRQUFULENBQW1CQyxJQUFuQixFQUF5QjtBQUM5QixTQUFPQyxPQUFPQyxjQUFQLENBQXNCQyxTQUF0QixjQUNGSCxJQURFO0FBRUxJLFNBQUtOLElBQUlPLFNBRko7QUFHTEMsV0FBT0MsUUFBUSxtQ0FBUixDQUhGO0FBSUxDLFlBQVEsTUFKSDtBQUtMQyxvQkFBZ0IsSUFMWDtBQU1MQyxhQUFTO0FBTkosS0FBUDtBQVFEIiwiZmlsZSI6InN0cmlwZS5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBlbnYgZnJvbSAnbWlzYy9lbnYnXG5cbi8qKlxuICogV2UncmUgbGF6eS1ldmFsaW5nIGJlY2F1c2Ugd2UncmUgbG9hZGluZyBTdHJpcGUgYXN5bmNocm9ub3VzbHkuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBjaGVja291dCAob3B0cykge1xuICByZXR1cm4gd2luZG93LlN0cmlwZUNoZWNrb3V0LmNvbmZpZ3VyZSh7XG4gICAgLi4ub3B0cyxcbiAgICBrZXk6IGVudi5TVFJJUEVfUEssXG4gICAgaW1hZ2U6IHJlcXVpcmUoJ2Fzc2V0cy9pbWcvdGF4ZnlsZS1pY29uLTI1NnB4LnBuZycpLFxuICAgIGxvY2FsZTogJ2F1dG8nLFxuICAgIGJpbGxpbmdBZGRyZXNzOiB0cnVlLFxuICAgIHppcENvZGU6IHRydWVcbiAgfSlcbn1cbiJdfQ==

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackUrlConversion;
function trackUrlConversion() {
  if (true) {
    window.goog_report_conversion();
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvdXRpbHMvdHJhY2tVcmxDb252ZXJzaW9uLmpzIl0sIm5hbWVzIjpbInRyYWNrVXJsQ29udmVyc2lvbiIsInByb2Nlc3MiLCJlbnYiLCJOT0RFX0VOViIsIndpbmRvdyIsImdvb2dfcmVwb3J0X2NvbnZlcnNpb24iXSwibWFwcGluZ3MiOiJBQUFBLGVBQWUsU0FBU0Esa0JBQVQsR0FBK0I7QUFDNUMsTUFBSUMsUUFBUUMsR0FBUixDQUFZQyxRQUFaLEtBQXlCLFlBQTdCLEVBQTJDO0FBQ3pDQyxXQUFPQyxzQkFBUDtBQUNEO0FBQ0YiLCJmaWxlIjoidHJhY2tVcmxDb252ZXJzaW9uLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdHJhY2tVcmxDb252ZXJzaW9uICgpIHtcbiAgaWYgKHByb2Nlc3MuZW52Lk5PREVfRU5WID09PSAncHJvZHVjdGlvbicpIHtcbiAgICB3aW5kb3cuZ29vZ19yZXBvcnRfY29udmVyc2lvbigpXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(872), __esModule: true };

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(875), __esModule: true };

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(881), __esModule: true };

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(846);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(270);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(54).document && document.documentElement;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(70) && !__webpack_require__(106)(function(){
  return Object.defineProperty(__webpack_require__(278)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(129)
  , ITERATOR   = __webpack_require__(44)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(159);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(81);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(44)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(454)
  , hiddenKeys = __webpack_require__(279).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(107)
  , toObject    = __webpack_require__(131)
  , IE_PROTO    = __webpack_require__(287)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(107)
  , toIObject    = __webpack_require__(94)
  , arrayIndexOf = __webpack_require__(888)(false)
  , IE_PROTO     = __webpack_require__(287)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(92);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(54)
  , core        = __webpack_require__(30)
  , dP          = __webpack_require__(60)
  , DESCRIPTORS = __webpack_require__(70)
  , SPECIES     = __webpack_require__(44)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(91)
  , invoke             = __webpack_require__(897)
  , html               = __webpack_require__(445)
  , cel                = __webpack_require__(278)
  , global             = __webpack_require__(54)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(159)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  (function(root, factory) {
    if (true) {
      return !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return factory();
      }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
      return module.exports = factory();
    } else {
      return root.ifvisible = factory();
    }
  })(this, function() {
    var addEvent, customEvent, doc, fireEvent, hidden, idleStartedTime, idleTime, ie, ifvisible, init, initialized, status, trackIdleStatus, visibilityChange;
    ifvisible = {};
    doc = document;
    initialized = false;
    status = "active";
    idleTime = 60000;
    idleStartedTime = false;
    customEvent = (function() {
      var S4, addCustomEvent, cgid, fireCustomEvent, guid, listeners, removeCustomEvent;
      S4 = function() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      };
      guid = function() {
        return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
      };
      listeners = {};
      cgid = '__ceGUID';
      addCustomEvent = function(obj, event, callback) {
        obj[cgid] = undefined;
        if (!obj[cgid]) {
          obj[cgid] = "ifvisible.object.event.identifier";
        }
        if (!listeners[obj[cgid]]) {
          listeners[obj[cgid]] = {};
        }
        if (!listeners[obj[cgid]][event]) {
          listeners[obj[cgid]][event] = [];
        }
        return listeners[obj[cgid]][event].push(callback);
      };
      fireCustomEvent = function(obj, event, memo) {
        var ev, j, len, ref, results;
        if (obj[cgid] && listeners[obj[cgid]] && listeners[obj[cgid]][event]) {
          ref = listeners[obj[cgid]][event];
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            ev = ref[j];
            results.push(ev(memo || {}));
          }
          return results;
        }
      };
      removeCustomEvent = function(obj, event, callback) {
        var cl, i, j, len, ref;
        if (callback) {
          if (obj[cgid] && listeners[obj[cgid]] && listeners[obj[cgid]][event]) {
            ref = listeners[obj[cgid]][event];
            for (i = j = 0, len = ref.length; j < len; i = ++j) {
              cl = ref[i];
              if (cl === callback) {
                listeners[obj[cgid]][event].splice(i, 1);
                return cl;
              }
            }
          }
        } else {
          if (obj[cgid] && listeners[obj[cgid]] && listeners[obj[cgid]][event]) {
            return delete listeners[obj[cgid]][event];
          }
        }
      };
      return {
        add: addCustomEvent,
        remove: removeCustomEvent,
        fire: fireCustomEvent
      };
    })();
    addEvent = (function() {
      var setListener;
      setListener = false;
      return function(el, ev, fn) {
        if (!setListener) {
          if (el.addEventListener) {
            setListener = function(el, ev, fn) {
              return el.addEventListener(ev, fn, false);
            };
          } else if (el.attachEvent) {
            setListener = function(el, ev, fn) {
              return el.attachEvent('on' + ev, fn, false);
            };
          } else {
            setListener = function(el, ev, fn) {
              return el['on' + ev] = fn;
            };
          }
        }
        return setListener(el, ev, fn);
      };
    })();
    fireEvent = function(element, event) {
      var evt;
      if (doc.createEventObject) {
        return element.fireEvent('on' + event, evt);
      } else {
        evt = doc.createEvent('HTMLEvents');
        evt.initEvent(event, true, true);
        return !element.dispatchEvent(evt);
      }
    };
    ie = (function() {
      var all, check, div, undef, v;
      undef = void 0;
      v = 3;
      div = doc.createElement("div");
      all = div.getElementsByTagName("i");
      check = function() {
        return (div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->", all[0]);
      };
      while (check()) {
        continue;
      }
      if (v > 4) {
        return v;
      } else {
        return undef;
      }
    })();
    hidden = false;
    visibilityChange = void 0;
    if (typeof doc.hidden !== "undefined") {
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof doc.mozHidden !== "undefined") {
      hidden = "mozHidden";
      visibilityChange = "mozvisibilitychange";
    } else if (typeof doc.msHidden !== "undefined") {
      hidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof doc.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }
    trackIdleStatus = function() {
      var timer, wakeUp;
      timer = false;
      wakeUp = function() {
        clearTimeout(timer);
        if (status !== "active") {
          ifvisible.wakeup();
        }
        idleStartedTime = +(new Date());
        return timer = setTimeout(function() {
          if (status === "active") {
            return ifvisible.idle();
          }
        }, idleTime);
      };
      wakeUp();
      addEvent(doc, "mousemove", wakeUp);
      addEvent(doc, "keyup", wakeUp);
      addEvent(doc, "touchstart", wakeUp);
      addEvent(window, "scroll", wakeUp);
      ifvisible.focus(wakeUp);
      return ifvisible.wakeup(wakeUp);
    };
    init = function() {
      var blur;
      if (initialized) {
        return true;
      }
      if (hidden === false) {
        blur = "blur";
        if (ie < 9) {
          blur = "focusout";
        }
        addEvent(window, blur, function() {
          return ifvisible.blur();
        });
        addEvent(window, "focus", function() {
          return ifvisible.focus();
        });
      } else {
        addEvent(doc, visibilityChange, function() {
          if (doc[hidden]) {
            return ifvisible.blur();
          } else {
            return ifvisible.focus();
          }
        }, false);
      }
      initialized = true;
      return trackIdleStatus();
    };
    ifvisible = {
      setIdleDuration: function(seconds) {
        return idleTime = seconds * 1000;
      },
      getIdleDuration: function() {
        return idleTime;
      },
      getIdleInfo: function() {
        var now, res;
        now = +(new Date());
        res = {};
        if (status === "idle") {
          res.isIdle = true;
          res.idleFor = now - idleStartedTime;
          res.timeLeft = 0;
          res.timeLeftPer = 100;
        } else {
          res.isIdle = false;
          res.idleFor = now - idleStartedTime;
          res.timeLeft = (idleStartedTime + idleTime) - now;
          res.timeLeftPer = (100 - (res.timeLeft * 100 / idleTime)).toFixed(2);
        }
        return res;
      },
      focus: function(callback) {
        if (typeof callback === "function") {
          this.on("focus", callback);
        } else {
          status = "active";
          customEvent.fire(this, "focus");
          customEvent.fire(this, "wakeup");
          customEvent.fire(this, "statusChanged", {
            status: status
          });
        }
        return this;
      },
      blur: function(callback) {
        if (typeof callback === "function") {
          this.on("blur", callback);
        } else {
          status = "hidden";
          customEvent.fire(this, "blur");
          customEvent.fire(this, "idle");
          customEvent.fire(this, "statusChanged", {
            status: status
          });
        }
        return this;
      },
      idle: function(callback) {
        if (typeof callback === "function") {
          this.on("idle", callback);
        } else {
          status = "idle";
          customEvent.fire(this, "idle");
          customEvent.fire(this, "statusChanged", {
            status: status
          });
        }
        return this;
      },
      wakeup: function(callback) {
        if (typeof callback === "function") {
          this.on("wakeup", callback);
        } else {
          status = "active";
          customEvent.fire(this, "wakeup");
          customEvent.fire(this, "statusChanged", {
            status: status
          });
        }
        return this;
      },
      on: function(name, callback) {
        init();
        customEvent.add(this, name, callback);
        return this;
      },
      off: function(name, callback) {
        init();
        customEvent.remove(this, name, callback);
        return this;
      },
      onEvery: function(seconds, callback) {
        var paused, t;
        init();
        paused = false;
        if (callback) {
          t = setInterval(function() {
            if (status === "active" && paused === false) {
              return callback();
            }
          }, seconds * 1000);
        }
        return {
          stop: function() {
            return clearInterval(t);
          },
          pause: function() {
            return paused = true;
          },
          resume: function() {
            return paused = false;
          },
          code: t,
          callback: callback
        };
      },
      now: function(check) {
        init();
        return status === (check || "active");
      }
    };
    return ifvisible;
  });

}).call(this);

//# sourceMappingURL=ifvisible.js.map


/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABcCAMAAAAs0dmdAAAAM1BMVEUAAADHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMzHyMykqArYAAAAEHRSTlMAv0CAEO/PII/fYFAwr59w+WYzhgAAAcdJREFUeF7t2Q2O4yAMhmHb/BNIff/Trhq06mojTMwQzUiT9wBPUtQvVVv4lnJldclYkLPIU7lNZj3PJsKVp3PCUZQGeNTV4Nh343FhAmXt9FLfPa5sQF3gdwOXQF+S3djOXx/Krt2dLzDtyq10N1NRV3yFoUuJZ4pWdjNP5q3kbjydl9zE8+W+224XN9JlXNtu140HC+qI39mui+316PNt9D13n30moOwWx+xhvQuWCJa7rZVuiaitvqzozn+eOyO7YXpku+h6ns4IbuYvFLpum4rLFlSFeLivvstzG2vbrAMXJp81+GPcx31c2nFcDFqXFF8eNK7ha2Wl+7roksJVfGHb9bsoNK78ml08Ll0J4J73L8JNe9uUrrnJDe6e5xkEc6Xw7ELhPjtO9+yY+JYd52NcfumO32grL92x/Qt4+NeF8sUdE7dcgLW7aPeLFha7pSLGArDabXXcxzX4XzVcdJ3kbnwKr7n76TBHOx679hXTYdSem89sGrvILaaeC/HElrF7+u1k0fvhwy512+lVgtUuBPqgq3chu48b9K4ZuOnz74MmcsP/745Ql+cjYY/W8XQVhLY5c3x6m5tj0YKcNWlCzRL5B/MEqCKyo5n2AAAAAElFTkSuQmCC"

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/img/avatar-placeholder.png";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/devices.png";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/logo-blue.png";

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/ornament-left.png";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/ornament-right.png";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/step1.png";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/step2.png";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/step3.png";

/***/ }),
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(1297);

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

module.exports = arraySample;


/***/ }),
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(508),
    baseSample = __webpack_require__(1300),
    isArray = __webpack_require__(35);

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

module.exports = sample;


/***/ }),
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1306),
    keys = __webpack_require__(172);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var withSideEffect = __webpack_require__(592);
var PropTypes = __webpack_require__(3);

function reducePropsToState(propsList) {
  return propsList.map(function(props) {
    return props.className;
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }).join(' ');
}

function handleStateChangeOnClient(stringClassNames) {
  document.body.className = stringClassNames || '';
}

function DocumentTitle(props){
  if (props.children) {
    return React.Children.only(props.children);
  } else {
    return null;
  }
}

DocumentTitle.displayName = 'DocumentTitle';
DocumentTitle.propTypes = {
  className: PropTypes.string.isRequired
};

module.exports = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(DocumentTitle);


/***/ }),
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_favicon_ico__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shell_AppRouter__ = __webpack_require__(814);







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shell_AppRouter__["a" /* default */], null), document.getElementById('app-container'));

if ('ActiveXObject' in window) {
  document.body.classList.add('browser-ie');
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvaW5kZXguanMiXSwibmFtZXMiOlsiUmVhY3QiLCJyZW5kZXIiLCJBcHBSb3V0ZXIiLCJkb2N1bWVudCIsImdldEVsZW1lbnRCeUlkIiwid2luZG93IiwiYm9keSIsImNsYXNzTGlzdCIsImFkZCJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxhQUFQO0FBQ0EsT0FBTyxNQUFQO0FBQ0EsT0FBTywyQkFBUDtBQUNBLE9BQU9BLEtBQVAsTUFBa0IsT0FBbEI7QUFDQSxTQUFTQyxNQUFULFFBQXVCLFdBQXZCO0FBQ0EsT0FBT0MsU0FBUCxNQUFzQixtQkFBdEI7O0FBRUFELE9BQ0Usb0JBQUMsU0FBRCxPQURGLEVBRUVFLFNBQVNDLGNBQVQsQ0FBd0IsZUFBeEIsQ0FGRjs7QUFLQSxJQUFJLG1CQUFtQkMsTUFBdkIsRUFBK0I7QUFDN0JGLFdBQVNHLElBQVQsQ0FBY0MsU0FBZCxDQUF3QkMsR0FBeEIsQ0FBNEIsWUFBNUI7QUFDRCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAnZmF2aWNvbi5pY28nXG5pbXBvcnQgJ2ludGwnXG5pbXBvcnQgJ2ludGwvbG9jYWxlLWRhdGEvanNvbnAvZW4nXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyByZW5kZXIgfSBmcm9tICdyZWFjdC1kb20nXG5pbXBvcnQgQXBwUm91dGVyIGZyb20gJy4vc2hlbGwvQXBwUm91dGVyJ1xuXG5yZW5kZXIoXG4gIDxBcHBSb3V0ZXIgLz4sXG4gIGRvY3VtZW50LmdldEVsZW1lbnRCeUlkKCdhcHAtY29udGFpbmVyJylcbilcblxuaWYgKCdBY3RpdmVYT2JqZWN0JyBpbiB3aW5kb3cpIHtcbiAgZG9jdW1lbnQuYm9keS5jbGFzc0xpc3QuYWRkKCdicm93c2VyLWllJylcbn1cbiJdfQ==

/***/ }),
/* 610 */,
/* 611 */,
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AwesomeLoader;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _loader = __webpack_require__(1148);

var _loader2 = _interopRequireDefault(_loader);

var _loader3 = __webpack_require__(1149);

var _loader4 = _interopRequireDefault(_loader3);

var _loader5 = __webpack_require__(1150);

var _loader6 = _interopRequireDefault(_loader5);

__webpack_require__(997);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  1: _loader2.default,
  2: _loader4.default,
  3: _loader6.default
};

/**
 * Displays a super-awesome loading indicator.
 *
 * @param {Number} size
 * A value from 1 to 3 that determines what size the loader should be.
 */
function AwesomeLoader(_ref) {
  var size = _ref.size,
      withMargin = _ref.withMargin,
      noContainer = _ref.noContainer;

  var img = _react2.default.createElement('img', { src: sizeMap[size], alt: 'Loading...' });
  return noContainer ? img : _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('AwesomeLoader', withMargin && 'AwesomeLoader--with-margin') },
    img
  );
}

AwesomeLoader.propTypes = {
  // Size from 1 to 3.
  size: _propTypes2.default.number,
  // Should we add some margin?
  withMargin: _propTypes2.default.bool,
  // Don't render in a container, just give us the image
  noContainer: _propTypes2.default.bool
};

AwesomeLoader.defaultProps = {
  size: 1,
  withMargin: true,
  noContainer: false
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentSink = exports.ComponentSinkRenderer = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(9);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _class, _class2, _desc, _value, _class3;

exports.makeSink = makeSink;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(8);

var _mobx = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * Creates a sink and a renderer for a given component.
 */
function makeSink(InnerComponent) {
  var sink = _mobx.observable.shallowBox();
  var Sink = function Sink(props) {
    return _react2.default.createElement(ComponentSink, (0, _extends3.default)({ sink: sink }, props));
  };
  var Renderer = function Renderer(rendererProps) {
    return _react2.default.createElement(
      ComponentSinkRenderer,
      (0, _extends3.default)({}, rendererProps, { sink: sink }),
      function (props) {
        return _react2.default.createElement(InnerComponent, props);
      }
    );
  };

  return {
    Sink: Sink,
    Renderer: Renderer
  };
}

/**
 * Renders a single sink.
 */

var ComponentSinkRenderer = exports.ComponentSinkRenderer = (0, _mobxReact.observer)(_class = function (_React$Component) {
  (0, _inherits3.default)(ComponentSinkRenderer, _React$Component);

  function ComponentSinkRenderer() {
    (0, _classCallCheck3.default)(this, ComponentSinkRenderer);
    return (0, _possibleConstructorReturn3.default)(this, (ComponentSinkRenderer.__proto__ || (0, _getPrototypeOf2.default)(ComponentSinkRenderer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComponentSinkRenderer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          sink = _props.sink,
          props = (0, _objectWithoutProperties3.default)(_props, ['children', 'sink']);

      var sinkValue = sink.get();
      if (!sinkValue) {
        return null;
      }

      return children((0, _extends3.default)({}, props, sinkValue.props));
    }
  }]);
  return ComponentSinkRenderer;
}(_react2.default.Component)) || _class;

ComponentSinkRenderer.propTypes = {
  children: _propTypes2.default.func.isRequired,
  sink: _propTypes2.default.any.isRequired
};

/**
 * Stuffs data into a sink so it'll be rendered.
 */

var ComponentSink = exports.ComponentSink = (0, _mobxReact.observer)(_class2 = (_class3 = function (_React$Component2) {
  (0, _inherits3.default)(ComponentSink, _React$Component2);

  function ComponentSink() {
    (0, _classCallCheck3.default)(this, ComponentSink);
    return (0, _possibleConstructorReturn3.default)(this, (ComponentSink.__proto__ || (0, _getPrototypeOf2.default)(ComponentSink)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComponentSink, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateSink(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSink();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.updateSink(nextProps);
    }
  }, {
    key: 'updateSink',
    value: function updateSink(nextProps) {
      var sink = nextProps.sink,
          props = (0, _objectWithoutProperties3.default)(nextProps, ['sink']);

      sink.set({
        props: props
      });
    }
  }, {
    key: 'removeSink',
    value: function removeSink() {
      this.props.sink.set(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ComponentSink;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class3.prototype, 'updateSink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'updateSink'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'removeSink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'removeSink'), _class3.prototype)), _class3)) || _class2;

ComponentSink.propTypes = {
  sink: _propTypes2.default.any.isRequired
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBubble = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(47);

var _moment2 = _interopRequireDefault(_moment);

var _arrayUtil = __webpack_require__(154);

var _MessageReceiptState = __webpack_require__(384);

var _noop = __webpack_require__(535);

var _noop2 = _interopRequireDefault(_noop);

var _ProgressSpinner = __webpack_require__(52);

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

var _Avatar = __webpack_require__(100);

var _Avatar2 = _interopRequireDefault(_Avatar);

__webpack_require__(467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY = [];

/**
 * Message component.
 *
 * @param  {ReactElement} options.children
 * The message
 *
 * @param  {Boolean} options.mine
 * Was this message from "me"?
 *
 * @param {string} className
 * Additional class name to add.
 *
 * @param  {Boolean} options.animateEntrance
 * Should we animate the message when it mounts?
 *
 * @param  {string} options.name
 * Sender name - should only be used by "theirs".
 *
 * @param  {string} options.avatar
 * URL of the avatar to display, if any. Should also only be used for "theirs".
 *
 * @param  {string[]} options.seenBy
 * Array of picture URL's. Usually only used on the last message that was seen.
 *
 * @param {*} options.sentAt
 * Anything that can be parsed as a moment. If falsy, won't be displayed.
 *
 * @param {"SENDING" | "SENT" | "DELIVERED" | undefined} options.receiptState
 * When set, displays the correct indicator.
 *
 * @param  {object} options.style
 * A style object being applied on the bubble.
 *
 * @param {Function} onClick
 * The click handler for clicking on a bubble.
 */
var Message = function Message(_ref) {
  var children = _ref.children,
      className = _ref.className,
      animateEntrance = _ref.animateEntrance,
      mine = _ref.mine,
      name = _ref.name,
      avatar = _ref.avatar,
      seenBy = _ref.seenBy,
      sentAt = _ref.sentAt,
      receiptState = _ref.receiptState,
      style = _ref.style,
      onClick = _ref.onClick;

  seenBy = seenBy ? (0, _arrayUtil.toArray)(seenBy) : EMPTY;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('Message', {
        'Message--mine': mine,
        'Message--theirs': !mine,
        'Message--animate-entrance': animateEntrance
      }, className)
    },
    _react2.default.createElement(
      'div',
      { className: 'Message__gutter Message__gutter--left' },
      avatar && _react2.default.createElement(_Avatar2.default, { url: avatar, className: 'Message__sender-avatar' }),
      name && _react2.default.createElement(
        'div',
        { className: 'Message__sender-name' },
        name
      )
    ),
    _react2.default.createElement(
      'div',
      { onClick: onClick, className: 'Message__bubble-container' },
      _react2.default.createElement(
        'div',
        null,
        children,
        sentAt && _react2.default.createElement(
          'div',
          { className: 'Message__sent-timestamp' },
          'sent ',
          (0, _moment2.default)(sentAt).format('L LT')
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'Message__gutter Message__gutter--right' },
      !!mine && seenBy.length === 0 && _react2.default.createElement(ReceiptState, { receiptState: receiptState }),
      seenBy.map(function (s) {
        return _react2.default.createElement(_Avatar2.default, {
          className: 'Message__seen-by-avatar',
          key: s,
          url: s
        });
      })
    )
  );
};

Message.defaultProps = {
  onClick: _noop2.default
};

Message.propTypes = {
  children: _propTypes2.default.node,
  mine: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  avatar: _propTypes2.default.string,
  animateEntrance: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  seenBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  sentAt: _propTypes2.default.any,
  receiptState: _propTypes2.default.string,
  style: _propTypes2.default.object,
  onClick: _propTypes2.default.any
};

exports.default = Message;

/**
 * Indicates the status of the message.
 */

var ReceiptState = function ReceiptState(_ref2) {
  var receiptState = _ref2.receiptState;

  var sending = receiptState === _MessageReceiptState.SENDING;
  if (sending) {
    return _react2.default.createElement(_ProgressSpinner2.default, { blue: true, size: 12, thickness: 2 });
  }

  var sent = receiptState === _MessageReceiptState.SENT;
  var delivered = receiptState === _MessageReceiptState.DELIVERED;
  if (!sent && !delivered) {
    return false;
  }

  var icon = delivered ? 'check circle' : 'send';
  var title = delivered ? 'delivered' : 'sent';
  var color = delivered ? '#2395F3' : '#bbb';
  return _react2.default.createElement(_Icon2.default, { material: true, size: 12, name: icon, color: color, title: title });
};

ReceiptState.propTypes = {
  receiptState: _propTypes2.default.string
};

var MessageBubble = exports.MessageBubble = function MessageBubble(_ref3) {
  var style = _ref3.style,
      children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: 'Message__bubble', style: style },
    _react2.default.createElement(
      'div',
      { className: 'Message__content' },
      children
    )
  );
};

MessageBubble.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
};
//# sourceMappingURL=Message.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileTypeIcon = __webpack_require__(382);

var _FileTypeIcon2 = _interopRequireDefault(_FileTypeIcon);

var _fileTypeUtil = __webpack_require__(637);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageDocument = function MessageDocument(_ref) {
  var title = _ref.title,
      fileName = _ref.fileName,
      subtitle = _ref.subtitle,
      children = _ref.children,
      onClick = _ref.onClick;

  var iconProps = fileName && (0, _fileTypeUtil.iconType)(fileName);
  return _react2.default.createElement(
    'div',
    { className: 'MessageDocument', role: 'button', onClick: onClick },
    !children && _react2.default.createElement(
      'div',
      { className: 'MessageDocument__iconContainer' },
      _react2.default.createElement(_FileTypeIcon2.default, (0, _extends3.default)({ width: '48' }, iconProps)),
      title && _react2.default.createElement(
        'div',
        { className: 'MessageDocument__fileName' },
        fileName
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'MessageDocument__text' },
      _react2.default.createElement(
        'p',
        { className: 'MessageDocument__title' },
        title || fileName
      ),
      subtitle && _react2.default.createElement(
        'p',
        { className: 'MessageDocument__subtitle' },
        subtitle
      )
    )
  );
};

MessageDocument.propTypes = {
  title: _propTypes2.default.node,
  fileName: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.node,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.any
};

exports.default = MessageDocument;
//# sourceMappingURL=MessageDocument.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownItemIcon = exports.DropdownItem = exports.DropdownItemContainer = exports.Dropdown = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getOwnPropertyDescriptor = __webpack_require__(9);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = __webpack_require__(184);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _autobindDecorator = __webpack_require__(57);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bodyClick = __webpack_require__(629);

var _bodyClick2 = _interopRequireDefault(_bodyClick);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

var _Link = __webpack_require__(64);

var _Link2 = _interopRequireDefault(_Link);

__webpack_require__(1003);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * How long does it take a dropdown to animate?
 * That sounds like a lightbulb joke, hah!
 * @type {Number}
 */
var TRANSITION_DURATION = 200;

/**
 * The dropdown component itself. It needs a button
 * which will be wrapped so the dropdown can be displayed relative to it.
 *
 * When `isOpen` is undefined, the component is uncontrolled and manages
 * it's own state. If not, then it's controlled.
 */
var Dropdown = exports.Dropdown = (_dec = (0, _bodyClick2.default)(), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * Initial state.
   */


  (0, _createClass3.default)(Dropdown, [{
    key: 'onButtonClick',


    /**
     * When the button is clicked (that is, when the wrapping span is clicked),
     * if controlled, trigger the callback. If not, toggles internal `isOpen` state.
     */
    value: function onButtonClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.isControlled()) {
        this.toggleDropdown();
      } else {
        if (this.props.onButtonClick) {
          this.props.onButtonClick();
        }
      }
    }

    /**
     * Determines if this dropdown is controlled.
     */

  }, {
    key: 'isControlled',
    value: function isControlled() {
      return this.props.isOpen !== undefined;
    }

    /**
     * If configured, dismisses the dropdown.
     */

  }, {
    key: 'onBodyClick',
    value: function onBodyClick(e) {
      if (this.refs.togglerButton) {
        var domNode = this.refs.togglerButton;
        if (domNode && domNode.contains(e.target)) {
          return;
        }
      }

      if (this.isControlled()) {
        if (this.props.onRequestClose && this.props.isOpen) {
          this.props.onRequestClose();
        }
        return;
      }

      if (this.state.isOpen && this.props.autoDismiss) {
        this.toggleDropdown();
      }
    }

    /**
     * Toggles the internal `isOpen` state.
     */

  }, {
    key: 'toggleDropdown',
    value: function toggleDropdown() {
      this.setState({ isOpen: !this.state.isOpen });
    }

    /**
     * Renders the dropdown.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          button = _props.button,
          children = _props.children,
          position = _props.position,
          isOpen = _props.isOpen;

      var dropdownIsOpen = !this.isControlled() ? this.state.isOpen : isOpen;
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Dropdown') },
        button && _react2.default.createElement(
          'span',
          { onClick: this.onButtonClick, ref: 'togglerButton' },
          button
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'DropdownAnimation',
            transitionEnterTimeout: TRANSITION_DURATION,
            transitionLeaveTimeout: TRANSITION_DURATION
          },
          dropdownIsOpen && _react2.default.createElement(
            'ul',
            { className: (0, _classnames2.default)('DropdownContent', position) },
            children
          )
        )
      );
    }
  }]);
  return Dropdown;
}(_react.Component), (_applyDecoratedDescriptor(_class2.prototype, 'onButtonClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onButtonClick'), _class2.prototype)), _class2)) || _class);


Dropdown.defaultProps = {
  position: 'left',
  autoDismiss: true
};

Dropdown.propTypes = {
  position: _propTypes2.default.string,
  button: _propTypes2.default.node,
  isOpen: _propTypes2.default.bool,
  autoDismiss: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onButtonClick: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func
};

/**
 * Used by `DropdownItem`.
 */
var DropdownItemContainer = exports.DropdownItemContainer = function DropdownItemContainer(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'li',
    { className: 'DropdownItemContainer' },
    children
  );
};

DropdownItemContainer.propTypes = {
  children: _propTypes2.default.node.isRequired
};

/**
 * A regular dropdown item.
 */
var DropdownItem = function DropdownItem(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      active = _ref3.active,
      other = (0, _objectWithoutProperties3.default)(_ref3, ['children', 'className', 'active']);
  return _react2.default.createElement(
    DropdownItemContainer,
    null,
    _react2.default.createElement(
      _Link2.default,
      (0, _extends3.default)({ className: (0, _classnames2.default)('DropdownItem', className, active && 'is-active') }, other),
      children
    )
  );
};

exports.DropdownItem = DropdownItem;
DropdownItem.propTypes = {
  className: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

/**
 * A dropdown item icon. Nice.
 */
var DropdownItemIcon = exports.DropdownItemIcon = function DropdownItemIcon(_ref4) {
  var name = _ref4.name,
      material = _ref4.material,
      children = _ref4.children;
  return _react2.default.createElement(
    'span',
    { className: 'DropdownItemIcon' },
    name && _react2.default.createElement(_Icon2.default, { name: name, className: 'DropDownItemIcon__icon', material: material }),
    children
  );
};

DropdownItemIcon.propTypes = {
  name: _propTypes2.default.string,
  material: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlashMessage = exports.FlashMessageStore = undefined;

var _defineProperty2 = __webpack_require__(90);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ICONS;
// noinspection JSDuplicatedDeclaration


var _FlashMessageStore = __webpack_require__(252);

Object.defineProperty(exports, 'FlashMessageStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FlashMessageStore).default;
  }
});
Object.defineProperty(exports, 'FlashMessage', {
  enumerable: true,
  get: function get() {
    return _FlashMessageStore.FlashMessage;
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = __webpack_require__(184);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _mobxReact = __webpack_require__(8);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

var _ProgressSpinner = __webpack_require__(52);

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

var _FlashMessageStore2 = _interopRequireDefault(_FlashMessageStore);

__webpack_require__(1007);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_DURATION = 300;

var ICONS = (_ICONS = {}, (0, _defineProperty3.default)(_ICONS, _FlashMessageStore.FlashMessageTypes.SUCCESS, 'check'), (0, _defineProperty3.default)(_ICONS, _FlashMessageStore.FlashMessageTypes.ERROR, 'exclamation-triangle'), _ICONS);

/**
 * A single item.
 */
var FlashMessageItem = (0, _mobxReact.observer)(function FlashMessageItem(_ref) {
  var flash = _ref.flash;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('FlashMessage', 'FlashMessage--' + flash.type) },
    _react2.default.createElement(
      'div',
      { className: 'FlashMessage__inner' },
      flash.type && ICONS[flash.type] && _react2.default.createElement(
        'div',
        { className: 'FlashMessage__type-container' },
        _react2.default.createElement(_Icon2.default, { name: ICONS[flash.type] })
      ),
      flash.inProgress && _react2.default.createElement(
        'div',
        { className: 'FlashMessage__progress-container' },
        _react2.default.createElement(_ProgressSpinner2.default, null)
      ),
      _react2.default.createElement(
        'div',
        { className: 'FlashMessage__message-content' },
        flash.message
      ),
      _react2.default.createElement(
        'div',
        { className: 'FlashMessage__actions' },
        _react2.default.createElement(
          'button',
          { onClick: function onClick() {
              return flash.dismiss();
            } },
          'Dismiss'
        )
      )
    )
  );
});

/**
 * Flash messages container
 *
 * @param  {FlashMessageStore} options.store
 */
var FlashMessages = function FlashMessages(_ref2) {
  var store = _ref2.store,
      position = _ref2.position;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('FlashMessages', 'FlashMessages--' + position) },
    _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      {
        transitionName: 'anim',
        transitionEnterTimeout: ANIMATION_DURATION,
        transitionLeaveTimeout: ANIMATION_DURATION
      },
      store.showingFlashes.map(function (f) {
        return _react2.default.createElement(FlashMessageItem, { flash: f, key: f.id });
      })
    )
  );
};

FlashMessages.propTypes = {
  store: _propTypes2.default.instanceOf(_FlashMessageStore2.default),
  position: _propTypes2.default.oneOf(['bottomRight', 'bottomLeft', 'topRight', 'topLeft'])
};

FlashMessages.defaultProps = {
  position: 'bottomRight'
};

exports.default = (0, _mobxReact.observer)(FlashMessages);
//# sourceMappingURL=index.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(64);

var _Link2 = _interopRequireDefault(_Link);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = __webpack_require__(77);

var _prefix2 = _interopRequireDefault(_prefix);

__webpack_require__(1009);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = (0, _prefix2.default)('FloatingActionButton--');

var FloatingActionButton = function FloatingActionButton(_ref) {
  var pull = _ref.pull,
      small = _ref.small,
      large = _ref.large,
      className = _ref.className,
      icon = _ref.icon,
      props = (0, _objectWithoutProperties3.default)(_ref, ['pull', 'small', 'large', 'className', 'icon']);
  return _react2.default.createElement(
    _Link2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('unstyled FloatingActionButton', classes({ pull: pull, small: small, large: large }), className)
    }, props),
    icon
  );
};

var bool = _propTypes2.default.bool,
    element = _propTypes2.default.element,
    string = _propTypes2.default.string;


FloatingActionButton.propTypes = {
  pull: bool,
  small: bool,
  large: bool,
  icon: element,
  className: string
};

exports.default = FloatingActionButton;
//# sourceMappingURL=index.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageComposer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__(535);

var _noop2 = _interopRequireDefault(_noop);

var _reactAutosizeTextarea = __webpack_require__(249);

var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(1012);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageComposer = exports.MessageComposer = function MessageComposer(_ref) {
  var value = _ref.value,
      border = _ref.border,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      onSend = _ref.onSend;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('message-composer', disabled && 'is-disabled', border && 'has-border') },
    _react2.default.createElement(_reactAutosizeTextarea2.default, {
      className: 'composer-input',
      disabled: disabled
      // Have to use style here because the library adds it itself.
      , style: { resize: 'none' },
      placeholder: 'Write your message here..',
      value: value,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.charCode === 13 && !e.shiftKey) {
          onSend();
          setTimeout(function () {
            return _onChange('');
          }, 0);
        }
      }
    }),
    _react2.default.createElement(
      'div',
      { className: 'actions' },
      _react2.default.createElement(
        'button',
        {
          className: 'button is-icon-only',
          disabled: !value || !value.trim() || disabled,
          onClick: onSend,
          title: 'Send message'
        },
        _react2.default.createElement(_Icon2.default, { material: true, name: 'send', className: 'send-icon' })
      )
    )
  );
};

MessageComposer.propTypes = {
  value: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onSend: _propTypes2.default.func
};

MessageComposer.defaultProps = {
  onChange: _noop2.default,
  onSend: _noop2.default
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(13);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(7);

var _mobxReact = __webpack_require__(8);

var _ProgressSpinner = __webpack_require__(52);

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

__webpack_require__(1013);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TOP_THRESH = 800;
var BOTTOM_THRESH = 50;

var MessageScrollView = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(MessageScrollView, _Component);

  function MessageScrollView() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MessageScrollView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MessageScrollView.__proto__ || (0, _getPrototypeOf2.default)(MessageScrollView)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'shouldScrollBottom', _descriptor, _this), _this.scroll = function () {
      _this.checkScroll();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MessageScrollView, [{
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.root.scrollTop = this.root.scrollHeight;
    }
  }, {
    key: 'checkScroll',
    value: function checkScroll() {
      var _this2 = this;

      var node = this.root;
      var scrollTop = node.scrollTop,
          offsetHeight = node.offsetHeight,
          scrollHeight = node.scrollHeight;

      var shouldScrollBottom = offsetHeight === scrollHeight || scrollTop + offsetHeight > scrollHeight - BOTTOM_THRESH;
      if (this.props.onLoadMore) {
        if (scrollTop < TOP_THRESH) {
          if (this._shouldNotifyLoadMore) {
            this._shouldNotifyLoadMore = false;
            this.props.onLoadMore();
          }
        } else {
          this._shouldNotifyLoadMore = true;
        }
      }
      (0, _mobx.runInAction)(function () {
        _this2.shouldScrollBottom = shouldScrollBottom;
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToBottom();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      // Record scroll position and children count.
      this._scrollPos = this.root.scrollTop;
      this._scrollHeight = this.root.scrollHeight;
      // if the next props says we have more messages,
      // we need to save the scroll position so we can
      // restore it after adding more messages.
      this._shouldSetScroll = this.props.messageCount < nextProps.messageCount;
      this.checkScroll();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var node = this.root;
      if (this.shouldScrollBottom) {
        this.scrollToBottom();
      } else if (this._shouldSetScroll) {
        var heightDiff = node.scrollHeight - this._scrollHeight;
        node.scrollTop = heightDiff + this._scrollPos;
        this._shouldSetScroll = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          isLoadingMore = _props.isLoadingMore,
          scrollToBottom = _props.scrollToBottom;

      return _react2.default.createElement(
        'div',
        { className: 'message-scroll-view' },
        isLoadingMore && _react2.default.createElement(
          'div',
          { className: 'loading-more animated fadeIn is-faster' },
          _react2.default.createElement(
            'div',
            { className: 'spinner-block' },
            _react2.default.createElement(_ProgressSpinner2.default, { color: '#fff' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-block' },
            'Loading older messages...'
          )
        ),
        _react2.default.createElement(
          'div',
          { ref: function ref(x) {
              _this3.root = x;
            }, className: 'inner', onScroll: this.scroll },
          children
        ),
        !this.shouldScrollBottom && _react2.default.createElement(
          'div',
          { className: 'floating-actions animated fadeIn is-faster' },
          _react2.default.createElement(
            'button',
            { className: 'scroll-to-bottom', onClick: function onClick() {
                return _this3.scrollToBottom();
              } },
            scrollToBottom || 'Scroll to bottom'
          )
        )
      );
    }
  }]);
  return MessageScrollView;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'shouldScrollBottom', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
})), _class2)) || _class;

exports.default = MessageScrollView;


MessageScrollView.propTypes = {
  children: _propTypes2.default.node,
  isLoadingMore: _propTypes2.default.bool,
  scrollToBottom: _propTypes2.default.any,
  messageCount: _propTypes2.default.number.isRequired,
  onLoadMore: _propTypes2.default.func
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(1015);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generic component to indicate that there is no data.
 *
 * @param  {ReactElement} props.children
 *
 * @param  {String} props.icon
 * The icon to display.
 *
 * @param  {Number} props.iconSize
 * How big should the icon be?
 */
var NoData = function NoData(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      theme = _ref.theme,
      iconSize = _ref.iconSize;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('NoData', theme && 'NoData--theme-' + theme, className) },
    _react2.default.createElement(
      'div',
      null,
      typeof icon === 'string' ? _react2.default.createElement(_Icon2.default, { name: icon, size: iconSize }) : icon // in case it's an Icon element

    ),
    _react2.default.createElement(
      'div',
      { className: 'NoData__content' },
      children || 'Nothing to display.. yet!'
    )
  );
};

NoData.defaultProps = {
  icon: 'flag-checkered',
  iconSize: 64
};

NoData.propTypes = {
  children: _propTypes2.default.node,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  iconSize: _propTypes2.default.number,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.string
};

exports.default = NoData;
//# sourceMappingURL=index.js.map

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = __webpack_require__(21);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _range = __webpack_require__(325);

var _range2 = _interopRequireDefault(_range);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(29);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(1018);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ratings snap to 0.5
var SNAP = 0.5;

// Rounds a rating to the nearest snap point.
var roundToNearest = function roundToNearest(rating) {
  return Math.round(rating / SNAP) * SNAP;
};

/**
 * A single star.
 */
var Star = function Star(_ref) {
  var filled = _ref.filled,
      size = _ref.size,
      half = _ref.half,
      other = (0, _objectWithoutProperties3.default)(_ref, ['filled', 'size', 'half']);

  var icon = 'star';
  if (half) {
    icon += '-half-o';
  } else if (!filled) {
    icon += '-o';
  }

  return _react2.default.createElement(
    'span',
    other,
    _react2.default.createElement(_Icon2.default, { name: icon, size: size, className: 'Rating__star' })
  );
};

Star.propTypes = {
  filled: _propTypes2.default.bool,
  half: _propTypes2.default.bool,
  size: _propTypes2.default.number
};

/**
 * Rating component. Nice!
 */

var Rating = function (_Component) {
  (0, _inherits3.default)(Rating, _Component);

  function Rating() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Rating);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Rating.__proto__ || (0, _getPrototypeOf2.default)(Rating)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { hoveredRating: null }, _this.mouseEnter = function (ratingNumber) {
      if (_this.props.readonly) return;
      _this.setState({ hoveredRating: ratingNumber });
    }, _this.mouseLeave = function () {
      if (_this.props.readonly) return;
      _this.setState({ hoveredRating: null });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * Initially we are not hovering.
   */


  /**
   * Used to track the rating we are hovering on.
   *
   * @param  {Number} ratingNumber
   * The rating we are hovering on.
   */


  /**
   * Used to reset the hover state.
   */


  (0, _createClass3.default)(Rating, [{
    key: 'render',


    /**
     * Duh.
     */
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          rating = _props.rating,
          maxRating = _props.maxRating,
          onRatingClick = _props.onRatingClick,
          readonly = _props.readonly,
          starSize = _props.starSize,
          style = _props.style,
          color = _props.color,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'rating', 'maxRating', 'onRatingClick', 'readonly', 'starSize', 'style', 'color']);
      // When hovering, the rating displayed is that under the cursor.

      var usedRating = roundToNearest(this.state.hoveredRating === null || readonly ? rating : this.state.hoveredRating);

      // We ceil the rating so we know if it's a whole number or not when iterating.
      var ratingCeil = Math.ceil(usedRating);

      // Util to create props for each star.
      var createProps = function createProps(i) {
        return {
          // Click event will only trigger if not readonly.
          onClick: function onClick(e) {
            return !readonly && onRatingClick && onRatingClick(e, i);
          },
          // Used to set hover state.
          onMouseEnter: function onMouseEnter() {
            return _this2.mouseEnter(i);
          },
          // Used to reset hover state.
          onMouseLeave: _this2.mouseLeave,
          // Size of the star
          size: starSize,
          className: 'star',
          key: i
        };
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: (0, _classnames2.default)('Rating', readonly && 'Rating--readonly', className),
          style: (0, _extends3.default)({
            color: color
          }, style)
        }, rest),
        (0, _range2.default)(1, ratingCeil + 1).map(function (i) {
          return _react2.default.createElement(Star, (0, _extends3.default)({}, createProps(i), {
            filled: true
            // It'll be half a star when the rating we have is less than the ceil of it.
            , half: i === ratingCeil && ratingCeil > usedRating
          }));
        }),
        (0, _range2.default)(ratingCeil + 1, maxRating + 1).map(function (i) {
          return _react2.default.createElement(Star, createProps(i));
        })
      );
    }
  }]);
  return Rating;
}(_react.Component);

exports.default = Rating;


Rating.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  starSize: _propTypes2.default.number,
  maxRating: _propTypes2.default.number,
  rating: _propTypes2.default.number.isRequired,
  onRatingClick: _propTypes2.default.func,
  readonly: _propTypes2.default.bool
};

Rating.defaultProps = {
  color: '#FFEB3B',
  starSize: 24,
  maxRating: 5,
  rating: 0,
  readonly: false
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(8);

__webpack_require__(1019);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReloadWarning = function ReloadWarning(_ref) {
  var authStore = _ref.authStore;

  if (!authStore.shouldShowReloadWarning) {
    return null;
  }
  var seconds = authStore.secondsUntilTokenExpires;
  return _react2.default.createElement(
    'div',
    { className: 'reload-warning animated fadeInDown' },
    _react2.default.createElement(
      'div',
      { className: 'inner' },
      _react2.default.createElement(
        'div',
        { className: 'text' },
        'As a security precaution, your session will expire in ',
        _react2.default.createElement(
          'strong',
          null,
          seconds,
          ' seconds'
        ),
        ', and you will have to log in again. Finish what you\'re doing and click the button below to reload.'
      ),
      _react2.default.createElement(
        'a',
        { className: 'button is-reload-button', onClick: function onClick() {
            return authStore.logout();
          } },
        'Reload now'
      )
    )
  );
};

ReloadWarning.propTypes = {
  authStore: _propTypes2.default.shape({
    shouldShowReloadWarning: _propTypes2.default.bool,
    secondsUntilTokenExpires: _propTypes2.default.number,
    logout: _propTypes2.default.func
  })
};

exports.default = (0, _mobxReact.observer)(ReloadWarning);
//# sourceMappingURL=index.js.map

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(50);

var _scrollparent = __webpack_require__(1558);

var _scrollparent2 = _interopRequireDefault(_scrollparent);

var _domUtil = __webpack_require__(636);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollMonitor = function (_React$Component) {
  (0, _inherits3.default)(ScrollMonitor, _React$Component);

  function ScrollMonitor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ScrollMonitor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollMonitor.__proto__ || (0, _getPrototypeOf2.default)(ScrollMonitor)).call.apply(_ref, [this].concat(args))), _this), _this.checkViewport = function () {
      if (!_this.node) {
        return;
      }

      if (_this.props.enterViewport && (0, _domUtil.inView)(_this.node)) {
        if (!_this._didNotify) {
          _this._didNotify = true;
          _this.props.enterViewport();
        }
      } else {
        _this._didNotify = false;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ScrollMonitor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var node = this.node = (0, _reactDom.findDOMNode)(this);
      var parent = this.scrollingParent = (0, _scrollparent2.default)(node);
      if (parent) {
        parent.addEventListener('scroll', this.checkViewport);
      }
      setTimeout(function () {
        _this2.checkViewport();
      }, 30);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkViewport();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scrollingParent) {
        this.scrollingParent.removeEventListener('scroll', this.checkViewport);
      }

      delete this.node;
      delete this.scrollingParent;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ScrollMonitor;
}(_react2.default.Component);

exports.default = ScrollMonitor;


ScrollMonitor.propTypes = {
  enterViewport: _propTypes2.default.func,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timeline = exports.TimelineEvent = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(47);

var _moment2 = _interopRequireDefault(_moment);

var _Circle = __webpack_require__(379);

var _Circle2 = _interopRequireDefault(_Circle);

__webpack_require__(1021);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimelineEvent = exports.TimelineEvent = function TimelineEvent(_ref) {
  var date = _ref.date,
      children = _ref.children,
      completed = _ref.completed;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('TimelineEvent', completed && 'TimelineEvent--completed') },
    _react2.default.createElement(
      'div',
      { className: 'TimelineEvent__line-container' },
      _react2.default.createElement('div', { className: 'TimelineEvent__line' }),
      _react2.default.createElement(_Circle2.default, { filled: true, size: 18, className: 'TimelineEvent__circle' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'TimelineEvent__text' },
      _react2.default.createElement(
        'div',
        { className: 'TimelineEvent__date' },
        (0, _moment2.default)(date).format('L')
      ),
      children
    )
  );
};

TimelineEvent.propTypes = {
  date: _propTypes2.default.any.isRequired,
  children: _propTypes2.default.node,
  completed: _propTypes2.default.bool
};

var Timeline = exports.Timeline = function Timeline(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'div',
    { className: 'Timeline' },
    children
  );
};

Timeline.propTypes = {
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defineProperty4 = __webpack_require__(90);

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(8);

var _mobx = __webpack_require__(7);

var _Conversation = __webpack_require__(380);

var _ScrollMonitor = __webpack_require__(624);

var _ScrollMonitor2 = _interopRequireDefault(_ScrollMonitor);

var _patternMatchUtil = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Message container.
 */
var MessageContainer = (0, _mobxReact.observer)(_class = (_class2 = function (_React$Component) {
  (0, _inherits3.default)(MessageContainer, _React$Component);

  function MessageContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MessageContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MessageContainer.__proto__ || (0, _getPrototypeOf2.default)(MessageContainer)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showDetails', _descriptor, _this), _initDefineProp(_this, 'toggleDetails', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MessageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          message = _props.message,
          seenBy = _props.seenBy,
          group = _props.group,
          otherName = _props.otherName,
          onEnterViewport = _props.onEnterViewport,
          onDocumentClick = _props.onDocumentClick;

      var isLast = group.lastMessage.message === message;
      var messageElement = _react2.default.createElement(
        _Conversation.Message,
        {
          mine: group.mine,
          avatar: !group.mine && isLast ? message.sender.avatar : '',
          name: !group.mine && isLast ? otherName : '',
          seenBy: seenBy,
          receiptState: message.receiptState,
          onClick: message.type !== 'document' && this.toggleDetails,
          sentAt: this.showDetails && message.sentAt
        },
        (0, _patternMatchUtil.match)(message.type, (0, _defineProperty5.default)({
          text: function text() {
            return _react2.default.createElement(
              _Conversation.MessageBubble,
              null,
              message.text
            );
          },
          document: function document() {
            return _react2.default.createElement(_Conversation.MessageDocument, {
              fileName: message.document.fileName,
              title: message.document.label,
              subtitle: message.document.description,
              onClick: onDocumentClick
            });
          }
        }, _patternMatchUtil.match.DEFAULT, function () {
          return _react2.default.createElement(
            _Conversation.MessageBubble,
            null,
            '[Unknown message type "',
            message.type,
            '"]'
          );
        }))
      );
      return !onEnterViewport ? messageElement : _react2.default.createElement(
        _ScrollMonitor2.default,
        {
          enterViewport: function enterViewport() {
            return onEnterViewport();
          }
        },
        messageElement
      );
    }
  }]);
  return MessageContainer;
}(_react2.default.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'toggleDetails', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.showDetails = !_this2.showDetails;
    };
  }
})), _class2)) || _class;

MessageContainer.propTypes = {
  message: _propTypes2.default.any,
  group: _propTypes2.default.any,
  onEnterViewport: _propTypes2.default.func,
  onDocumentClick: _propTypes2.default.func,
  otherName: _propTypes2.default.string,
  seenBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};

exports.default = MessageContainer;
//# sourceMappingURL=MessageContainer.js.map

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = __webpack_require__(9);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(7);

var _mobxReact = __webpack_require__(8);

var _conversationUtil = __webpack_require__(635);

var _Conversation = __webpack_require__(380);

var _MessageScrollView = __webpack_require__(620);

var _MessageScrollView2 = _interopRequireDefault(_MessageScrollView);

var _MessageContainer = __webpack_require__(626);

var _MessageContainer2 = _interopRequireDefault(_MessageContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * Conversation container responsible for displaying
 * a flat list of messages in a.. less flat way.
 */
var ConversationContainer = (0, _mobxReact.observer)(_class = (_class2 = function (_React$Component) {
  (0, _inherits3.default)(ConversationContainer, _React$Component);

  function ConversationContainer() {
    (0, _classCallCheck3.default)(this, ConversationContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ConversationContainer.__proto__ || (0, _getPrototypeOf2.default)(ConversationContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConversationContainer, [{
    key: 'renderMessageGroups',
    value: function renderMessageGroups(messageGroups) {
      var _props = this.props,
          onMarkAsRead = _props.onMarkAsRead,
          otherName = _props.otherName,
          _onDocumentClick = _props.onDocumentClick;

      return messageGroups.map(function (group, i) {
        return _react2.default.createElement(
          _Conversation.MessageGroup,
          { mine: group.mine, key: i },
          group.messages.map(function (message) {
            // `message` is a plain mapped object, not the actual instance,
            // which is added as a property.
            var actualMessage = message.message;
            return _react2.default.createElement(_MessageContainer2.default, (0, _extends3.default)({
              key: actualMessage.id,
              otherName: otherName,
              message: actualMessage,
              seenBy: message.seenBy,
              group: group,
              onDocumentClick: function onDocumentClick() {
                return _onDocumentClick(actualMessage);
              }
            }, !actualMessage.isRead && {
              onEnterViewport: function onEnterViewport() {
                return onMarkAsRead(actualMessage);
              }
            }));
          })
        );
      });
    }

    /**
     * Does the render thing.
     */

  }, {
    key: 'render',
    value: function render() {
      var messageGroups = this.messageGroups;

      return _react2.default.createElement(
        _MessageScrollView2.default,
        {
          onLoadMore: this.props.onLoadMore,
          isLoadingMore: this.props.isLoadingMore,
          messageCount: this.props.messages.length,
          scrollToBottom: unreadMessagesFormatter({ count: this.props.unreadMessagesCount })
        },
        _react2.default.createElement(
          _Conversation.Conversation,
          null,
          messageGroups.length === 0 ? this.props.noMessages || false : this.renderMessageGroups(messageGroups)
        )
      );
    }
  }, {
    key: 'messageGroups',
    get: function get() {
      // We are expecting the messages to be in order.
      var messages = this.props.messages;
      var me = this.props.me;
      return (0, _conversationUtil.createMessageGroups)(messages, me);
    }
  }]);
  return ConversationContainer;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class2.prototype, 'messageGroups', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'messageGroups'), _class2.prototype)), _class2)) || _class;

ConversationContainer.propTypes = {
  messages: _propTypes2.default.any,
  me: _propTypes2.default.any,
  onMarkAsRead: _propTypes2.default.func,
  onLoadMore: _propTypes2.default.func,
  isLoadingMore: _propTypes2.default.bool,
  noMessages: _propTypes2.default.element,
  unreadMessagesCount: _propTypes2.default.number,
  otherName: _propTypes2.default.string,
  onDocumentClick: _propTypes2.default.any
};

exports.default = ConversationContainer;

/**
 * Simple message formatter.
 */

function unreadMessagesFormatter(_ref) {
  var count = _ref.count;

  if (!count) {
    return 'Scroll to bottom';
  }

  if (count === 1) {
    return '1 unread message';
  }

  return count + ' unread messages';
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crudStore = exports.preferSuper = exports.inlineEditorHost = exports.destroyable = exports.inlineEditor = exports.field = exports.editor = undefined;

var _defineProperty = __webpack_require__(13);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(196);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getOwnPropertyDescriptor = __webpack_require__(9);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__(42);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(19);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(847);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _symbol = __webpack_require__(270);

var _symbol2 = _interopRequireDefault(_symbol);

var _mobx = __webpack_require__(7);

var _validx = __webpack_require__(99);

var _ConfirmDialogState = __webpack_require__(250);

var _ConfirmDialogState2 = _interopRequireDefault(_ConfirmDialogState);

var _pick = __webpack_require__(537);

var _pick2 = _interopRequireDefault(_pick);

var _forEach = __webpack_require__(1378);

var _forEach2 = _interopRequireDefault(_forEach);

var _uniqueId = __webpack_require__(327);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _assert = __webpack_require__(385);

var _assert2 = _interopRequireDefault(_assert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
} /**
   * This module is for easily making simple model editors
   * with strong conventions and plenty of hooks for customization.
   */


/**
 * IMPORTANT!!!!!!!
 * The ordering of decorators matter! See `src/stores/ui/BenefitsScreenStore` for example usage.
 */

/**
 * Symbol for privatizing the fields discovered when
 * decorating properties.
 * @type {[type]}
 */
var FIELDS = (0, _symbol2.default)('FIELDS');

/**
 * Inherits the decorated viewmodel class and adds common editor functionality
 * to it. It also prescribes a constructor that takes a `Model` instance
 * as the first argument, or null/undefined when editing a new model.
 *
 * The `field` decorator is used to mark a field for mapping to/from a model.
 *
 * The decorated class must implement the following interface:
 * - save(mapped: Object) => Promise<Boolean>
 */
var editor = exports.editor = function editor() {
  return function (target) {
    var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

    var _fields = target.prototype[FIELDS] || [];

    /**
     * A class that inherits the class being decorated. This
     * means that the returned class is the actual class being
     * used, and therefore decides when to call into the decorated class.
     */
    return _class = function (_target) {
      (0, _inherits3.default)(Editor, _target);

      /**
       *
       * @param  {Model|object} model
       * If not specified, generates a unique ID and marks it as new.
       */
      function Editor(model) {
        var _ref;

        (0, _classCallCheck3.default)(this, Editor);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).call.apply(_ref, [this, model].concat(rest)));

        _initDefineProp(_this, 'disabled', _descriptor, _this);

        _initDefineProp(_this, 'editing', _descriptor2, _this);

        _initDefineProp(_this, 'validation', _descriptor3, _this);

        if (!model) {
          _this.isNew = true;
          _this.id = (0, _uniqueId2.default)();
        } else {
          _this.isNew = false;
          _this.model = model;
          _this.id = model.id;
        }
        return _this;
      }

      /**
       * If not editing an existing model, maps fields from the
       * model onto the viewmodel - the fields to map are those
       * which have the `field` decorator.
       *
       * To override what gets mapped, implement `mapFromModel(mapped: Object) => Object`
       *
       * @chainable
       */


      (0, _createClass3.default)(Editor, [{
        key: 'startEditing',
        value: function startEditing() {
          this.editing = true;
          if (this.isNew) return this;

          var mapped = (0, _pick2.default)(this.model, _fields);
          if (this.mapFromModel) {
            mapped = this.mapFromModel(mapped);
          }

          this.set(mapped);
          if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'startEditing', this)) {
            (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'startEditing', this).apply(this, arguments);
          }
          return this;
        }

        /**
         * Cancels editing by setting the `editing` to false and resetting validation state.
         */

      }, {
        key: 'cancelEditing',
        value: function cancelEditing() {
          this.editing = false;
          this.validation.reset();
          if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'cancelEditing', this)) {
            return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'cancelEditing', this).call(this);
          }
        }

        /**
         * Validates the object (calls the `validate()` method if it exists),
         * maps fields from the viewmodel into an object, passing them along
         * to `save(mapped: Object) => Promise<any>` on the decorated class.
         *
         * If the `save` method returns an explicit `false`, it is implied that saving did not succeed.
         * Of course, it it throws an exception that's not good either.
         *
         * To override what gets mapped, implement `mapToModel(mapped: Object) => Object`.
         * The return value is passed to `save`. Note that is does not actually mutate the model.
         *
         * `save` *must* be implemented! The resolved promise determines if
         * saving happened or not. If it did, stops editing.
         *
         * @return {Promise<Boolean>}
         */

      }, {
        key: 'save',
        value: function () {
          var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var _this2 = this;

            var mapped, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    (0, _assert2.default)((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'save', this), target.name + ' must implement a \'save\' method');

                    _context.next = 3;
                    return this.validate();

                  case 3:
                    if (this.validation.isValid) {
                      _context.next = 5;
                      break;
                    }

                    return _context.abrupt('return', false);

                  case 5:
                    mapped = (0, _pick2.default)(this, _fields);


                    if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'mapToModel', this)) {
                      mapped = (0, _mobx.runInAction)('editor.mapToModel', function () {
                        return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'mapToModel', _this2).call(_this2, mapped);
                      });
                    }

                    this.set({ disabled: true });
                    _context.prev = 8;
                    _context.next = 11;
                    return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'save', this).call(this, mapped);

                  case 11:
                    result = _context.sent;

                    if (!(result !== false)) {
                      _context.next = 15;
                      break;
                    }

                    this.set({ editing: false });
                    return _context.abrupt('return', true);

                  case 15:
                    return _context.abrupt('return', false);

                  case 16:
                    _context.prev = 16;

                    this.set({ disabled: false });
                    return _context.finish(16);

                  case 19:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this, [[8,, 16, 19]]);
          }));

          function save() {
            return _ref2.apply(this, arguments);
          }

          return save;
        }()

        /**
         * Shortcut for shallow-assigning an object's properties to this instance.
         *
         * @param {Object} obj
         * @chainable
         */

      }, {
        key: 'set',
        value: function set(obj) {
          (0, _assign2.default)(this, obj);
          return this;
        }

        /**
         * Validates `validationRules` if they exist on the instance, and calls `validate`
         * on the decorated class (if it exists).
         *
         * In order to register validation errors, the `validate` method must mutate the `validation` context.
         *
         * @return {Promise}
         */

      }, {
        key: 'validate',
        value: function () {
          var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (this.validationRules) {
                      this.validation.reset().validate(this, this.validationRules);
                    }

                    if (!(0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'validate', this)) {
                      _context2.next = 4;
                      break;
                    }

                    _context2.next = 4;
                    return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'validate', this).call(this);

                  case 4:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function validate() {
            return _ref3.apply(this, arguments);
          }

          return validate;
        }()

        /**
         * Calls `destroy` on the decorated class while safely maintaining `disabled` state.
         *
         * @return {Promise}
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    (0, _assert2.default)((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'destroy', this), 'attempted to call \'destroy\' on ' + target.name + ' but it does not implement it.');

                    this.set({ disabled: true });
                    _context3.prev = 2;
                    _context3.next = 5;
                    return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'destroy', this).call(this);

                  case 5:
                    return _context3.abrupt('return', _context3.sent);

                  case 6:
                    _context3.prev = 6;

                    this.set({ disabled: false });
                    return _context3.finish(6);

                  case 9:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, this, [[2,, 6, 9]]);
          }));

          function destroy() {
            return _ref4.apply(this, arguments);
          }

          return destroy;
        }()

        /**
         * Clears the fields. If the decorated class implements and returns
         * `false`, will do nothing.
         *
         * @chainable
         */

      }, {
        key: 'clear',
        value: function clear() {
          var _this3 = this;

          if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'clear', this)) {
            if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'clear', this).call(this) === false) {
              return;
            }
          }

          (0, _mobx.runInAction)(function () {
            (0, _forEach2.default)(_fields, function (field) {
              _this3[field] = null;
            });
          });

          return this;
        }
      }]);
      return Editor;
    }(target), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return false;
      }
    }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'editing', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return false;
      }
    }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'validation', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return (0, _validx.validationContext)();
      }
    }), _applyDecoratedDescriptor(_class.prototype, 'startEditing', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'startEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancelEditing', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancelEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'set', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'set'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clear', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clear'), _class.prototype)), _class;
  };
};

/**
 * Property decorator for fields that `editor` should use for its magical mapping.
 */
var field = exports.field = function field(target, name, descriptor) {
  target[FIELDS] = target[FIELDS] || [];
  target[FIELDS].push(name);
  return (0, _mobx.observable)(target, name, descriptor);
};

/**
 * Derives the decorated class and adds functionality for use with a
 * store decorated with `inlineEditorHost`. Makes the class implement all
 * the things needed for `editor`, passing the calls to the store that owns
 * the instance.
 */
var inlineEditor = exports.inlineEditor = function inlineEditor() {
  return function (target) {
    return function (_target2) {
      (0, _inherits3.default)(InlineEditor, _target2);

      /**
       *
       * @param  {Model|object} model
       * The model to manage, or nothing if a new instance.
       *
       * @param  {Object} opts.parentStore
       * A reference to the parent store, used to for callbacks.
       */
      function InlineEditor(model, opts) {
        (0, _classCallCheck3.default)(this, InlineEditor);

        var _this4 = (0, _possibleConstructorReturn3.default)(this, (InlineEditor.__proto__ || (0, _getPrototypeOf2.default)(InlineEditor)).apply(this, arguments));

        _this4.options = opts;
        (0, _assert2.default)(opts, 'inline editor constructed without options - it needs an options object with a parentStore');
        (0, _assert2.default)(opts.parentStore, 'inline editor constructed without options.parentStore');
        if (!model) {
          _this4.startEditing();
        }
        return _this4;
      }

      /**
       * Marshals the saving to the parent store.
       */


      (0, _createClass3.default)(InlineEditor, [{
        key: 'save',
        value: function save() {
          var _options$parentStore;

          return (_options$parentStore = this.options.parentStore).saveItem.apply(_options$parentStore, [this].concat(Array.prototype.slice.call(arguments)));
        }

        /**
         * Calls `cancelEditing` on the editor, and calls the parent store
         * so it can do additional stuff (like removing new instances).
         */

      }, {
        key: 'cancelEditing',
        value: function cancelEditing() {
          var _options$parentStore2;

          if ((0, _get3.default)(InlineEditor.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditor.prototype), 'cancelEditing', this)) {
            (0, _get3.default)(InlineEditor.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditor.prototype), 'cancelEditing', this).apply(this, arguments);
          }

          (_options$parentStore2 = this.options.parentStore).cancelEditing.apply(_options$parentStore2, [this].concat(Array.prototype.slice.call(arguments)));
        }

        /**
         * If the parent store supports it, calls `destroy`.
         * While not required, destroying stuff is common.
         *
         * This should only be called for existing models, not new ones that
         * have not been saved yet.
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!this.options.parentStore.destroy) {
                      _context4.next = 2;
                      break;
                    }

                    return _context4.abrupt('return', this.options.parentStore.destroy(this));

                  case 2:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          function destroy() {
            return _ref5.apply(this, arguments);
          }

          return destroy;
        }()
      }]);
      return InlineEditor;
    }(target);
  };
};

/**
 * Marks a viewmodel as destroyable, giving it a `ConfirmDialogState`
 * as `confirmDestruction` that is shown before calling `destroy` on the
 * decorated class.
 */
var destroyable = exports.destroyable = function destroyable() {
  return function (target) {
    return function (_target3) {
      (0, _inherits3.default)(Destroyable, _target3);

      /**
       * Adds a `confirmDestruction` field for use with the corresponding React component.
       */
      function Destroyable() {
        (0, _classCallCheck3.default)(this, Destroyable);

        var _this5 = (0, _possibleConstructorReturn3.default)(this, (Destroyable.__proto__ || (0, _getPrototypeOf2.default)(Destroyable)).apply(this, arguments));

        _this5.confirmDestruction = new _ConfirmDialogState2.default();
        return _this5;
      }

      /**
       * Waits for confirmation before calling the decorated class' `destroy` method.
       * @return {Promise}
       */


      (0, _createClass3.default)(Destroyable, [{
        key: 'destroy',
        value: function () {
          var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    (0, _assert2.default)((0, _get3.default)(Destroyable.prototype.__proto__ || (0, _getPrototypeOf2.default)(Destroyable.prototype), 'destroy', this), target.name + ' needs to implement \'destroy\'.');
                    _context5.next = 3;
                    return this.confirmDestruction.show();

                  case 3:
                    if (_context5.sent) {
                      _context5.next = 5;
                      break;
                    }

                    return _context5.abrupt('return');

                  case 5:
                    if (!(0, _get3.default)(Destroyable.prototype.__proto__ || (0, _getPrototypeOf2.default)(Destroyable.prototype), 'destroy', this)) {
                      _context5.next = 7;
                      break;
                    }

                    return _context5.abrupt('return', (0, _get3.default)(Destroyable.prototype.__proto__ || (0, _getPrototypeOf2.default)(Destroyable.prototype), 'destroy', this).call(this));

                  case 7:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));

          function destroy() {
            return _ref6.apply(this, arguments);
          }

          return destroy;
        }()
      }]);
      return Destroyable;
    }(target);
  };
};

/**
 * Derives a store, giving it functionality to act as an inline editor host
 * with a lot of boilerplate taken care of:
 * - Managing existing and new items
 * - Transforming models to viewmodels
 * - calling create or update based on new/existing state
 * - start/stop editing
 * - destroying models (when implemented)
 *
 * The decorated class must implement:
 * - ViewModel: ViewModelClass | () => ViewModelClass
 * - getItems() => Model[]
 * - create(data: Object) => Promise<Boolean>
 * - update(id: any, data: Object) => Promise<Boolean>
 *
 * Optional:
 * - destroy(item: ViewModel) => Promise
 */
var inlineEditorHost = exports.inlineEditorHost = function inlineEditorHost() {
  return function (target) {
    var _desc2, _value2, _class3, _descriptor4;

    return _class3 = function (_target4) {
      (0, _inherits3.default)(InlineEditorHost, _target4);

      function InlineEditorHost() {
        var _ref7;

        var _temp, _this6, _ret;

        (0, _classCallCheck3.default)(this, InlineEditorHost);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _ret = (_temp = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref7 = InlineEditorHost.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost)).call.apply(_ref7, [this].concat(args))), _this6), _this6.transformer = (0, _mobx.createTransformer)(_this6.createViewModel.bind(_this6)), _initDefineProp(_this6, 'newItems', _descriptor4, _this6), _temp), (0, _possibleConstructorReturn3.default)(_this6, _ret);
      }
      /**
       * MobX magic used to map models to viewmodels reactively.
       */


      /**
       * Tracks new items
       * @type {ObservableArray}
       */


      (0, _createClass3.default)(InlineEditorHost, [{
        key: 'newItem',


        /**
         * Creates a new instance of `ViewModel` with no model.
         *
         * @return {ViewModel}
         */
        value: function newItem() {
          var vm = this.createViewModel();
          this.newItems.unshift(vm);
          return vm;
        }

        /**
         * Invokes `ViewModel` with the given model and
         * the options for the `inlineEditor` constructor.
         *
         * @param  {Model?} model
         * @return {ViewModel}
         */

      }, {
        key: 'createViewModel',
        value: function createViewModel(model) {
          var _this7 = this;

          var ViewModel = this.ViewModel;
          // ViewModels set internal state upon creation,
          // so we allow that here.
          return _mobx.extras.allowStateChanges(true, function () {
            return new ViewModel(model, {
              parentStore: _this7
            });
          });
        }

        /**
         * Callback from the `inlineEditor`, calls `create` or `update`.
         *
         * @param  {ViewModel} item
         * @param  {Object} props
         * @return {Promise<Boolean>}
         */

      }, {
        key: 'saveItem',
        value: function () {
          var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(item, props) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    if (!item.isNew) {
                      _context6.next = 8;
                      break;
                    }

                    _context6.next = 3;
                    return this.create(props);

                  case 3:
                    _context6.t0 = _context6.sent;

                    if (!(_context6.t0 === false)) {
                      _context6.next = 6;
                      break;
                    }

                    return _context6.abrupt('return', false);

                  case 6:

                    this.newItems.remove(item);
                    return _context6.abrupt('return', true);

                  case 8:
                    _context6.next = 10;
                    return this.update(item.id, props);

                  case 10:
                    _context6.t1 = _context6.sent;

                    if (!(_context6.t1 === false)) {
                      _context6.next = 13;
                      break;
                    }

                    return _context6.abrupt('return', false);

                  case 13:
                    return _context6.abrupt('return', true);

                  case 14:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));

          function saveItem(_x, _x2) {
            return _ref8.apply(this, arguments);
          }

          return saveItem;
        }()

        /**
         * Called from the `inlineEditor`, calls `cancelEditing` on the decorated class
         * if it exists. If that call returns an explicit false, will not remove the viewmodel
         * from the `newItems` array.
         *
         * @param  {ViewModel} item
         * @return {Promise}
         */

      }, {
        key: 'cancelEditing',
        value: function () {
          var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(item) {
            var result;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!(0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'cancelEditing', this)) {
                      _context7.next = 6;
                      break;
                    }

                    _context7.next = 3;
                    return (0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'cancelEditing', this).call(this, item);

                  case 3:
                    result = _context7.sent;

                    if (!(result === false)) {
                      _context7.next = 6;
                      break;
                    }

                    return _context7.abrupt('return');

                  case 6:

                    this.newItems.remove(item);

                  case 7:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));

          function cancelEditing(_x3) {
            return _ref9.apply(this, arguments);
          }

          return cancelEditing;
        }()

        /**
         * Called by the `inlineEditor`, calls `destroy` if it exists on
         * the decorated class.
         *
         * @param  {ViewModel} item
         * @return {Promise}
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(item) {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    if (!(0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'destroy', this)) {
                      _context8.next = 6;
                      break;
                    }

                    _context8.next = 3;
                    return (0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'destroy', this).call(this, item);

                  case 3:
                    _context8.t0 = _context8.sent;

                    if (!(_context8.t0 === false)) {
                      _context8.next = 6;
                      break;
                    }

                    return _context8.abrupt('return');

                  case 6:

                    // Just in case..
                    this.newItems.remove(item);

                  case 7:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));

          function destroy(_x4) {
            return _ref10.apply(this, arguments);
          }

          return destroy;
        }()
      }, {
        key: 'items',


        /**
         * Combines new items with items from
         * @return {[type]} [description]
         */
        get: function get() {
          return [].concat((0, _toConsumableArray3.default)(this.newItems.slice()), (0, _toConsumableArray3.default)(this.getItems().map(this.transformer)));
        }
      }]);
      return InlineEditorHost;
    }(target), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'newItems', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return [];
      }
    }), _applyDecoratedDescriptor(_class3.prototype, 'items', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'items'), _class3.prototype)), _class3;
  };
};

/**
 * Utility decorator used to call the super method if it exists.
 */
var preferSuper = exports.preferSuper = function preferSuper(target, name, descriptor) {
  var oldValue = descriptor.value;
  var proto = (0, _getPrototypeOf2.default)(target);
  descriptor.value = function patched() {
    if (proto[name]) {
      return proto[name].apply(proto, arguments);
    }

    return oldValue.apply(this, arguments);
  };
};

/**
 * A very conventional CRUD store. Stack this on below
 *   @inlineEditorHost()
 *
 * Set `modelStore` to an instance of a store with the following methods:
 * - create(data: Object) => Promise
 * - update(id: any, data: Object) => Promise
 * - destroy update(id: any) => Promise
 */
var crudStore = exports.crudStore = function crudStore(opts) {
  return function (target) {
    var _desc3, _value3, _class5;

    opts = (0, _extends3.default)({
      itemsProp: 'items'
    }, opts);

    return _class5 = function (_target5) {
      (0, _inherits3.default)(CrudStore, _target5);

      function CrudStore() {
        (0, _classCallCheck3.default)(this, CrudStore);
        return (0, _possibleConstructorReturn3.default)(this, (CrudStore.__proto__ || (0, _getPrototypeOf2.default)(CrudStore)).apply(this, arguments));
      }

      (0, _createClass3.default)(CrudStore, [{
        key: 'getItems',
        value: function getItems() {
          this._assertModelStore();
          var items = this.modelStore[opts.itemsProp];
          (0, _assert2.default)(items, 'Model store\'s "' + opts.itemsProp + '" returned nothing useful');
          return items;
        }

        /**
         * Delegates the create call to the model store.
         */

      }, {
        key: 'create',
        value: function create(data) {
          this._assertModelStore();
          return this.modelStore.create(data);
        }

        /**
         * Delegates the update call to the model store.
         */

      }, {
        key: 'update',
        value: function update(id, data) {
          this._assertModelStore();
          return this.modelStore.update(id, data);
        }

        /**
         * Delegates the destroy call to the model store, except it
         * will pass it the model instead of the viewmodel.
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(vm) {
            var result;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    this._assertModelStore();
                    _context9.next = 3;
                    return this.modelStore.destroy(vm.model);

                  case 3:
                    result = _context9.sent;
                    return _context9.abrupt('return', result);

                  case 5:
                  case 'end':
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          }));

          function destroy(_x5) {
            return _ref11.apply(this, arguments);
          }

          return destroy;
        }()

        /**
         * Asserts that we have a model store before attempting to invoke anything on it.
         */

      }, {
        key: '_assertModelStore',
        value: function _assertModelStore() {
          (0, _assert2.default)(this.modelStore, 'modelStore has not been set on this instance of a crudStore.');
        }
      }]);
      return CrudStore;
    }(target), (_applyDecoratedDescriptor(_class5.prototype, 'getItems', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'getItems'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'create', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'create'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'update', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'update'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'destroy', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'destroy'), _class5.prototype)), _class5;
  };
};
//# sourceMappingURL=editor.js.map

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = makeBodyClick;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wraps a component and gives it the ability to handle clicks on any element,
 * including itself and it's children.
 */
function makeBodyClick() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'onBodyClick';

  function decorator(Component) {
    var newName = 'Wrapped' + (Component.name || Component.displayName);

    var Wrapped = function (_React$Component) {
      (0, _inherits3.default)(Wrapped, _React$Component);

      function Wrapped() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Wrapped);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Wrapped.__proto__ || (0, _getPrototypeOf2.default)(Wrapped)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
          _this.__wrappedComponent[method](e);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(Wrapped, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.__wrappedComponent = this.refs.wrappedComponent;
          document.addEventListener('click', this.handleClick, true);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          document.removeEventListener('click', this.handleClick, true);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, { ref: 'wrappedComponent' }));
        }
      }]);
      return Wrapped;
    }(_react2.default.Component);

    Wrapped.displayName = newName;
    return Wrapped;
  }

  return decorator;
}
//# sourceMappingURL=bodyClick.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = scrollPositionDecorator;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollPositionDecorator(Wrapped) {
  return function (_React$Component) {
    (0, _inherits3.default)(ScrollPosition, _React$Component);

    function ScrollPosition() {
      (0, _classCallCheck3.default)(this, ScrollPosition);

      var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollPosition.__proto__ || (0, _getPrototypeOf2.default)(ScrollPosition)).apply(this, arguments));

      _this.state = {
        windowScrollX: 0,
        windowScrollY: 0
      };

      _this.updateScrollState = _this.updateScrollState.bind(_this);
      return _this;
    }

    (0, _createClass3.default)(ScrollPosition, [{
      key: 'updateScrollState',
      value: function updateScrollState() {
        this.setState({
          windowScrollX: window.scrollX,
          windowScrollY: window.scrollY
        });
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.updateScrollState();
        window.addEventListener('scroll', this.updateScrollState);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('scroll', this.updateScrollState);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Wrapped, (0, _extends3.default)({}, this.props, { windowScrollX: this.state.windowScrollX, windowScrollY: this.state.windowScrollY }));
      }
    }]);
    return ScrollPosition;
  }(_react2.default.Component);
}
//# sourceMappingURL=scrollPosition.js.map

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PERSONAL = exports.PERSONAL = {
  'PHOTO_ID': 'Photo ID',
  'TAX_RETURN': 'Tax Return',
  'SIGNATURE_PAGE': 'Signature Page',
  'W-2': 'W-2',
  'INTEREST_INCOME': 'Interest Income',
  'ALIMONY': 'Alimony',
  'RENTAL_PROPERTY': 'Rental Property',
  'SOCIAL_SECURITY_BENEFITS': 'Social Security Benefits',
  'UNEMPLOYMENT': 'Unemployment',
  'INVESTMENTS': 'Investments',
  'MISC_INCOME': 'Misc Income',
  'HEALTH_CARE': 'Health Care',
  'HOME_MORTGAGE_INTEREST': 'Home Mortgage Interest',
  'MEDICAL': 'Medical',
  'STUDENT_LOANS': 'Student Loans',
  'FOREIGN': 'Foreign',
  'OTHER': 'Other'
};

var BUSINESS = exports.BUSINESS = {
  'PHOTO_ID': 'Photo ID',
  'TAX_RETURN': 'Tax Return',
  'SIGNATURE_PAGE': 'Signature Page',
  'TRIAL_BALANCE': 'Trial Balance',
  'PROFIT_AND_LOSS_STMT': 'Profit and Loss Stmt',
  'REVENUE': 'Revenue',
  'EXPENSES': 'Expenses',
  'EQUITY': 'Equity',
  'BANK_STATEMENTS': 'Bank Statements',
  'CREDIT_CARD_STATEMENTS': 'Credit Card Statements',
  'INVENTORY': 'Inventory',
  'FIXED_ASSETS': 'Fixed Assets',
  'PAYROLL': 'Payroll',
  'FOREIGN': 'Foreign',
  'OTHER': 'Other'
};
//# sourceMappingURL=DocumentTypes.js.map

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = encryptedLocalStorage;

var _sjcl = __webpack_require__(375);

var _sjcl2 = _interopRequireDefault(_sjcl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function encryptedLocalStorage(password) {
  var encrypt = function encrypt(data) {
    return data ? _sjcl2.default.encrypt(password, data.toString()) : null;
  };
  var decrypt = function decrypt(data) {
    return data ? _sjcl2.default.decrypt(password, data) : null;
  };

  return {
    getItem: function getItem(key) {
      return decrypt(window.localStorage.getItem(key));
    },
    setItem: function setItem(key, value) {
      window.localStorage.setItem(key, encrypt(value));
    },
    removeItem: function removeItem(key) {
      window.localStorage.removeItem(key);
    }
  };
}
//# sourceMappingURL=encryptedLocalStorage.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(196);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.createNotifier = createNotifier;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple, explicit eventing system.
 *
 * @returns {registerHandler}
 */
function createNotifier() {
  var registrations = [];

  function registerHandler(fn) {
    registrations = [].concat((0, _toConsumableArray3.default)(registrations), [fn]);
    return function unregisterHandler() {
      registrations = registrations.filter(function (x) {
        return x !== fn;
      });
    };
  }

  function notify() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    registrations.forEach(function (fn) {
      return fn.apply(undefined, args);
    });
  }

  registerHandler.notify = notify;
  return registerHandler;
}
//# sourceMappingURL=notifier.js.map

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractProfileName = extractProfileName;
/**
 * Utility to extract a profile's name.. Why the fuck is this even needed?
 *
 * @param  {object} authProfile
 * @return {string}
 */
function extractProfileName(authProfile) {
  var name = authProfile.name;
  var userMeta = authProfile.user_metadata || {};
  if (userMeta && userMeta.given_name) {
    name = userMeta.given_name + ' ' + (userMeta.family_name || authProfile.family_name);
  }

  if (authProfile.given_name) {
    name = (userMeta.given_name || authProfile.given_name) + ' ' + (userMeta.family_name || authProfile.family_name);
  }

  return name;
}
//# sourceMappingURL=auth0Util.js.map

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(428);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(429);

var _map2 = _interopRequireDefault(_map);

exports.createMessageGroups = createMessageGroups;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a message group.
 */
var createGroup = function createGroup(mine) {
  return {
    mine: mine,
    messages: []
  };
};

/**
 * Creates messages groups from a flat list of messages.
 *
 * @param  {Message[]} messages
 * List of messages.
 *
 * @param  {User} me
 * The user acting as the "me" of the conversation.
 *
 * @return {object[]}
 * Message groups.
 */
function createMessageGroups(messages, me) {
  var groups = [];

  // Skip work when there's no work to be done.
  if (!messages || messages.length === 0) {
    return groups;
  }

  var currentGroup = void 0,
      previousMessage = void 0;

  // Used to keep track of the message that a user had last seen.
  var seenByMap = new _map2.default();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var message = _step.value;

      var mine = message.sender === me;
      if (!currentGroup) {
        currentGroup = createGroup(mine);
        groups.push(currentGroup);
      }

      // Based on this message's sender and the previous one,
      // determines if we need to end the current group and start
      // a new one.
      if (previousMessage && previousMessage.message.sender !== message.sender) {
        currentGroup.lastMessage = previousMessage;
        currentGroup = createGroup(mine);
        groups.push(currentGroup);
      }

      // We need to attach extra shit on the message, which we
      // don't want on the original model.
      var newMessage = {
        message: message,
        // "seen by" is kinda misleading. This array will contain avatar URL's that
        // should be displayed next to the message - that means the message
        // above it has been seen, but it won't have the avatars set,
        // because only the message that was last seen by a user will appear.
        seenBy: []
      };

      currentGroup.messages.push(newMessage);
      previousMessage = newMessage;

      message.recipientStatus.filter(function (rs) {
        return rs.status === 'read' && !!rs.recipient;
      }).forEach(function (rs) {
        return seenByMap.set(rs.recipient, newMessage);
      });
    };

    for (var _iterator = (0, _getIterator3.default)(messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  currentGroup.lastMessage = previousMessage;

  // We now have the messages that recipients have last seen.
  // We attach that to each corresponding message.
  seenByMap.forEach(function (message, recipient) {
    return message.seenBy.push(recipient.avatar || recipient.picture || recipient.avatarFallback);
  });

  return groups;
}
//# sourceMappingURL=conversationUtil.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inView = inView;
/**
 * Determines if an element is visible in the viewport.
 *
 * @param element
 * @param percentX
 * @param percentY
 * @returns {boolean}
 */
function inView(element, percentX, percentY) {
  var tolerance = 0.01; // needed because the rects returned by getBoundingClientRect provide the position up to 10 decimals
  if (percentX == null) {
    percentX = 100;
  }
  if (percentY == null) {
    percentY = 100;
  }

  var elementRect = element.getBoundingClientRect();
  var parentRects = [];

  while (element.parentElement != null) {
    parentRects.push(element.parentElement.getBoundingClientRect());
    element = element.parentElement;
  }

  return parentRects.every(function (parentRect) {
    var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
    var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);
    var visiblePercentageX = visiblePixelX / elementRect.width * 100;
    var visiblePercentageY = visiblePixelY / elementRect.height * 100;
    return visiblePercentageX + tolerance > percentX && visiblePercentageY + tolerance > percentY;
  });
}
//# sourceMappingURL=domUtil.js.map

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconType = undefined;

var _find = __webpack_require__(320);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileTypes = [{
  expr: /(xlsx?|numbers)/i,
  color: '#70c79a',
  type: 'table'
}, {
  expr: /(png|jpe?g|tiff|gif)/i,
  color: '#40a0f4',
  type: 'image'
}, {
  expr: /(js|cs|java|md|c|py|ts)/i,
  color: '#999',
  type: 'code'
}, {
  expr: /(pptx?|key)/i,
  color: '#FF5252',
  type: 'slides'
}, {
  expr: /.*/,
  color: '#FF5252',
  type: 'text'
}];

var iconType = exports.iconType = function iconType(fileType) {
  return (0, _find2.default)(fileTypes, function (opts) {
    return fileType.match(opts.expr);
  });
};
//# sourceMappingURL=fileTypeUtil.js.map

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(19);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(43);

var _promise2 = _interopRequireDefault(_promise);

exports.default = makeLayerGetter;

var _layerWebsdk = __webpack_require__(183);

var _layerWebsdk2 = _interopRequireDefault(_layerWebsdk);

var _axios = __webpack_require__(182);

var _axios2 = _interopRequireDefault(_axios);

var _memoize = __webpack_require__(138);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeLayerGetter(_ref) {
  var _this = this;

  var authStore = _ref.authStore,
      auth0ClientId = _ref.auth0ClientId,
      appId = _ref.appId,
      delegationEndpoint = _ref.delegationEndpoint;

  function getDelegationToken(token, nonce) {
    return _axios2.default.post(delegationEndpoint, {
      client_id: auth0ClientId,
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      id_token: token,
      target: auth0ClientId,
      api_type: 'layer',
      nonce: nonce,
      scope: 'openid'
    }).then(function (r) {
      return r.data.id_token;
    });
  }

  var layerGetter = (0, _memoize2.default)(function () {
    return new _promise2.default(function (resolve) {
      var client = new _layerWebsdk2.default.Client({
        appId: appId,
        isTrustedDevice: true
      });

      client.on('challenge', function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(evt) {
          var delegationToken;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return getDelegationToken(authStore.token, evt.nonce);

                case 2:
                  delegationToken = _context.sent;

                  evt.callback(delegationToken);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());

      client.on('ready', function () {
        resolve(client);
      });

      authStore.onLogin(function () {
        // Layer does session management - how nice
        client.connect(authStore.user.id);
      });
    });
  });

  authStore.onLogout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
    var existing;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return layerGetter.cache.get(undefined);

          case 2:
            existing = _context2.sent;

            if (existing) {
              existing.logout();
              existing.destroy();
            }

            layerGetter.cache.clear();

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  })));

  return layerGetter;
}
//# sourceMappingURL=layerUtil.js.map

/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Dialog__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Dialog__);






var ChangeEmailDialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(function ChangeEmailDialog(_ref) {
  var store = _ref.store;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_components_Modal___default.a,
    { isOpened: store.showing, onRequestClose: store.close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["Dialog"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_components_Form__["Form"],
        { onSubmit: store.save },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogTitle"],
          null,
          'Change email'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogContent"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Form__["Input"], {
            label: 'New email address',
            field: 'email',
            disabled: store.save.pending,
            placeholder: 'Please enter your new email address',
            model: store
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogFooter"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogButton"],
            { disabled: store.save.pending, type: 'button', onClick: store.close },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogButton"],
            { disabled: store.save.pending, primary: true },
            'Save'
          )
        )
      )
    )
  );
});

/* harmony default export */ __webpack_exports__["a"] = (ChangeEmailDialog);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_sass__);






var FloatingBadge = function FloatingBadge(_ref) {
  var children = _ref.children,
      className = _ref.className,
      animated = _ref.animated,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['children', 'className', 'animated']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('floating-badge', className, animated && 'floating-badge--animated') }, props),
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (FloatingBadge);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9GbG9hdGluZ0JhZGdlL2luZGV4LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsImN4IiwiRmxvYXRpbmdCYWRnZSIsImNoaWxkcmVuIiwiY2xhc3NOYW1lIiwiYW5pbWF0ZWQiLCJwcm9wcyJdLCJtYXBwaW5ncyI6Ijs7QUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsT0FBT0MsRUFBUCxNQUFlLFlBQWY7QUFDQSxPQUFPLGVBQVA7O0FBRUEsSUFBTUMsZ0JBQWdCLFNBQWhCQSxhQUFnQjtBQUFBLE1BQUdDLFFBQUgsUUFBR0EsUUFBSDtBQUFBLE1BQWFDLFNBQWIsUUFBYUEsU0FBYjtBQUFBLE1BQXdCQyxRQUF4QixRQUF3QkEsUUFBeEI7QUFBQSxNQUFxQ0MsS0FBckM7O0FBQUEsU0FDcEI7QUFBQTtBQUFBLGVBQUssV0FBV0wsR0FBRyxnQkFBSCxFQUFxQkcsU0FBckIsRUFBZ0NDLFlBQVksMEJBQTVDLENBQWhCLElBQTZGQyxLQUE3RjtBQUNHSDtBQURILEdBRG9CO0FBQUEsQ0FBdEI7O0FBTUEsZUFBZUQsYUFBZiIsImZpbGUiOiJpbmRleC5qc3giLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgY3ggZnJvbSAnY2xhc3NuYW1lcydcbmltcG9ydCAnLi9zdHlsZXMuc2FzcydcblxuY29uc3QgRmxvYXRpbmdCYWRnZSA9ICh7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGFuaW1hdGVkLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxkaXYgY2xhc3NOYW1lPXtjeCgnZmxvYXRpbmctYmFkZ2UnLCBjbGFzc05hbWUsIGFuaW1hdGVkICYmICdmbG9hdGluZy1iYWRnZS0tYW5pbWF0ZWQnKX0gey4uLnByb3BzfT5cbiAgICB7Y2hpbGRyZW59XG4gIDwvZGl2PlxuKVxuXG5leHBvcnQgZGVmYXVsdCBGbG9hdGluZ0JhZGdlXG4iXX0=

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sass__);




var SocialIcon = function SocialIcon(_ref) {
  var icon = _ref.icon,
      url = _ref.url;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: url, className: 'social-icon', target: '_blank', rel: 'noopener noreferrer' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('fa', 'fa-' + icon) })
  );
};

var Footer = function Footer() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'footer',
    { className: 'page-footer' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'columns' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'column is-narrow logo-column' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(1206), className: 'logo' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'column links' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://taxfyle.com/partners', target: '_blank', rel: 'noopener noreferrer' },
          'Partners'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://intercom.help/taxfyle', target: '_blank', rel: 'noopener noreferrer' },
          'FAQ'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://taxfyle.com/policies/terms', target: '_blank', rel: 'noopener noreferrer' },
          'Terms of Use'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://taxfyle.com/policies/privacy', target: '_blank', rel: 'noopener noreferrer' },
          'Privacy Policy'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'column is-narrow links' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIcon, { icon: 'facebook', url: 'https://facebook.com/Taxfyle' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIcon, { icon: 'twitter', url: 'https://twitter.com/Taxfyle' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIcon, { icon: 'instagram', url: 'https://instragram.com/Taxfyle' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIcon, { icon: 'youtube', url: 'https://www.youtube.com/channel/UChipeQJrmT2-qqZCnSidjuw' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'column is-narrow' },
        'Copyright \xA9 Tickmark, Inc ',
        new Date().getFullYear()
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Footer);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ListItem__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_patternMatchUtil__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_patternMatchUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_utils_patternMatchUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_formatCurrency__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_formatCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_utils_formatCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Avatar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_sass__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_sass__);










/* eslint-disable react/display-name */

var EventReason = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(function EventReason(_ref) {
  var event = _ref.event;

  if (event.reason) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'event-reason' },
      event.reason
    );
  }

  if (event.eventType === 'AMENDED') {
    return event.amendment.description.trim() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'event-reason' },
      event.amendment.description
    );
  }

  return null;
});

var Price = function Price(_ref2) {
  var value = _ref2.value,
      includeSymbol = _ref2.includeSymbol;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('event-price', value < 0 ? 'is-negative' : 'is-positive') },
    value > 0 && includeSymbol ? '+' : '',
    __WEBPACK_IMPORTED_MODULE_6_utils_formatCurrency___default()(value)
  );
};

var EventDescription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(function EventDescription(_ref3) {
  var event = _ref3.event;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_patternMatchUtil__["match"])(event.eventType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    AMENDED: function AMENDED() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Amendment created',
        event.previousQuote.providerCutAmount !== event.newQuote.providerCutAmount && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'event-description__details' },
          '\xA0 \u2014 \xA0',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Price, { value: event.newQuote.providerCutAmount - event.previousQuote.providerCutAmount })
        )
      );
    },
    UNCLAIMED: function UNCLAIMED() {
      return event.rebound ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Transmitted back to the pool'
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Transmitted to the pool'
      );
    },
    REOPENED: function REOPENED() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Reopened'
      );
    },
    TRANSFERRED: function TRANSFERRED() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Transferred from ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          event.previousProvider.displayName
        ),
        ' to ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          event.newProvider.displayName
        )
      );
    },
    CLAIMED: function CLAIMED() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Picked up'
      );
    },
    UPDATED: function UPDATED() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Updated',
        event.previousQuote.total !== event.newQuote.total && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'event-description__details' },
          '\xA0 \u2014 \xA0',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Price, { value: event.newQuote.total - event.previousQuote.total })
        )
      );
    },
    CLOSED: function CLOSED() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-description' },
        'Closed by ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          null,
          event.triggeredBy.displayName
        )
      );
    }
  }, __WEBPACK_IMPORTED_MODULE_5_utils_patternMatchUtil__["match"].DEFAULT, function () {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'event-description' },
      event.description
    );
  }));
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(function JobEvent(_ref4) {
  var event = _ref4.event;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItem"],
    { className: 'job-event', border: true },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_ListItem__["ListItemSegment"],
      { pad: true, stretch: true },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'event__created' },
        event.dateCreated.format('L LT')
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EventDescription, { event: event }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'event-triggered-by', title: event.triggeredBy.detailedDisplayName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Avatar___default.a, {
          url: event.triggeredBy.avatar,
          fallback: event.triggeredBy.avatarFallback,
          size: 16
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'event-triggered-by__name' },
          event.triggeredBy.displayName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EventReason, { event: event })
    )
  );
}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sample__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_body_classname__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_body_classname___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_body_classname__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_sass__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_sass__);








var _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var IOS_APP = 'https://itunes.apple.com/us/app/taxfyle-personal-and-business-tax-return-filing/id1058033104';
var ANDROID_APP = 'https://play.google.com/store/apps/details?id=com.taxfyle.TaxfyleMobile';

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"])(function LandingPage(_ref) {
  var onSignupClick = _ref.onSignupClick,
      onLoginClick = _ref.onLoginClick,
      partnerLogo = _ref.partnerLogo,
      hideLogin = _ref.hideLogin,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? 'Welcome to Taxfyle' : _ref$title,
      callToActionLink = _ref.callToActionLink,
      additionalCtaParagraph = _ref.additionalCtaParagraph,
      hideAppLinks = _ref.hideAppLinks;

  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: 'landing-page' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_helmet___default.a, { title: title }),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_body_classname___default.a, { className: 'landing-page-body' }),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'header',
      { className: 'landing-header' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'nav',
          { className: 'nav' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'nav-left' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'a',
              { className: 'nav-item is-brand', href: '#hello' },
              __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { className: 'landing-header-logo', src: __webpack_require__(482), alt: 'Taxfyle' }),
              partnerLogo && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'span',
                { className: 'plus' },
                ' + '
              ),
              partnerLogo && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { className: 'landing-header-logo partner-logo', src: partnerLogo })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'nav-center is-hidden-mobile' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'a',
              { href: '#why-taxfyle', className: 'nav-item has-hover' },
              'Why Taxfyle?'
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'a',
              { href: '#how-it-works', className: 'nav-item has-hover' },
              'How It Works'
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'a',
              { href: 'https://intercom.help/taxfyle', target: '_blank', rel: 'noopener noreferrer', className: 'nav-item has-hover' },
              'FAQ'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'nav-right' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'span',
              { className: 'nav-item' },
              __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'a',
                { href: callToActionLink, onClick: !callToActionLink && onSignupClick, className: 'button is-cta is-header-button' },
                'Try now'
              )
            ),
            !hideLogin && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'a',
              { onClick: onLoginClick, className: 'nav-item has-hover' },
              'Sign in'
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'section',
      { className: 'landing-hero container', id: 'hello' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'landing-hero-content' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'hero-primary-block' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'h1',
            { className: 'hero-title' },
            'Have your taxes done for you.'
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'strong',
              null,
              'Taxfyle'
            ),
            ' connects you with a tax expert who does your taxes, so you won\'t have to.'
          ),
          additionalCtaParagraph
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'hero-cta-section' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            {
              href: callToActionLink,
              className: 'button is-cta is-hero-cta',
              onClick: !callToActionLink && onSignupClick
            },
            'Try now'
          )
        ),
        !hideAppLinks && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'hero-app-section' },
          'Get the app on ',
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: IOS_APP, target: '_blank', rel: 'noopener noreferrer' },
            'iOS'
          ),
          ', ',
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: ANDROID_APP, target: '_blank', rel: 'noopener noreferrer' },
            'Android'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'landing-hero-img' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(481) })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'section',
      { className: 'section' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'h2',
        { className: 'section-title', id: 'why-taxfyle' },
        'Why Taxfyle?'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'section-content' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          null,
          'We\'re faster, cheaper, and easier than everyone else - our customers love us for it. \uD83D\uDE0D'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'has-spacing-top--less' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ReviewBox, null)
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(PressImages, null),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(AppleBestApp, null)
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'section',
      { className: 'section' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'h2 section-title', id: 'how-it-works' },
        'How It Works'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'section-content' },
        'The hardest part is figuring out what to do with all that free time. \uD83D\uDE0E'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'steps' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'step' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-info' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-title' },
              'Step 1'
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-text' },
              'Answer a few simple questions. \uD83E\uDD14'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-image' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(486) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'step' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-info push-down' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-title' },
              'Step 2'
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-text' },
              'Review and submit your order. \uD83D\uDC40'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-image' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(487) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'step' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-info' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-title' },
              'Step 3'
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-text' },
              'Upload your tax documents & say hello to your Tax Pro \u2014 they\'ll make sure you get that fat refund you deserve. \uD83D\uDCB0'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-image' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(488) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'step' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-info' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-title' },
              'Step 4'
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'step-text' },
              'Review & sign your return - done! \u2705'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'step-image' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'span',
              { className: 'step-emoji' },
              '\uD83C\uDF89 \uD83C\uDF8A'
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'section',
      { className: 'section' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'h2',
        { className: 'section-title' },
        'Get your free quote!'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'section-content' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          null,
          'Sign up & answer a few questions to get a free quote - no strings attached. It only takes a minute.'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'section-cta-container' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'a',
          { className: 'button is-cta is-section-cta', href: callToActionLink, onClick: !callToActionLink && onSignupClick },
          'Try now'
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'section-cta-subtitle' },
          'You won\'t regret it. \uD83D\uDC4D'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'footer',
      { className: 'landing-footer container' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'footer-items' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'footer-logo' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(483), alt: 'Taxfyle' })
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'footer-links' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: 'https://taxfyle.com/partners', target: '_blank', rel: 'noopener noreferrer' },
            'Partners'
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: 'https://intercom.help/taxfyle', target: '_blank', rel: 'noopener noreferrer' },
            'FAQ'
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: 'https://taxfyle.com/policies/terms', target: '_blank', rel: 'noopener noreferrer' },
            'Terms of Use'
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: 'https://taxfyle.com/policies/privacy', target: '_blank', rel: 'noopener noreferrer' },
            'Privacy Policy'
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'a',
            { href: 'https://taxfyle.com/apply', target: '_blank', rel: 'noopener noreferrer' },
            'Pro Apply'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'footer-socialmedia' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SocialIcon, { icon: 'facebook', link: 'https://facebook.com/Taxfyle' }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SocialIcon, { icon: 'twitter', link: 'https://twitter.com/Taxfyle' }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SocialIcon, { icon: 'instagram', link: 'https://instragram.com/Taxfyle' }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SocialIcon, { icon: 'youtube', link: 'https://www.youtube.com/channel/UChipeQJrmT2-qqZCnSidjuw' })
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'footer-copyright' },
          'Copyright \xA9 Tickmark, Inc ',
          new Date().getFullYear()
        )
      )
    )
  );
}));

var AppleBestApp = function AppleBestApp() {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: 'apple-best-app' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'ornament' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(484) })
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'text' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'p',
        { className: 'best-app-title' },
        '2017 #1 Tax Time App'
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'p',
        { className: 'best-app-subtitle' },
        '- Apple'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'ornament' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(485) })
    )
  );
};

var testimonials = [{ quote: 'Kurt F. was great to work with and we will be using Taxfyle again for our 2017 taxes.', username: 'Matthew S' }, { quote: 'Fantastic service and he saved me $1000! Thanks so much. ', username: 'Mayuka K' }, { quote: 'The experience was quick and easy!  I\'ll do it again next year! John was great!', username: 'Terri M' }, { quote: 'Freddie was fantastic! He was extremely responsive. He thoroughly answered all of my many questions. This process was made so much easier. Thank you Freddie and the taxfyle team for putting my mind at ease! I no longer have to worry if I\'m doing my taxes correctly. What an amazing app.', username: 'Haley A' }, { quote: 'Gilbert was super helpful and did a great job of explaining everything clearly, thank you!', username: 'Jennifer A' }, { quote: 'To the point advice, and directions. Very responsive and courteous. Definitely would recommend him.', username: 'Ruben A' }, { quote: 'Joe knows what he\'s doing, very efficient service and overall experience! I will be coming back for future returns.', username: 'Jason T' }, { quote: 'Thank you for the great turnaround time!', username: 'Vastal P' }, { quote: 'This was my first time filing for a business. Stewart was excellent with knowledge and wonderful with patience as he helped guide me through. Thank you very much Taxfyle.', username: 'Gordon R' }];

var ReviewBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"])(_class = (_class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ReviewBox, _React$Component);

  function ReviewBox() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ReviewBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = ReviewBox.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ReviewBox)).call.apply(_ref2, [this].concat(args))), _this), _initDefineProp(_this, 'review', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ReviewBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var index = testimonials.indexOf(__WEBPACK_IMPORTED_MODULE_9_lodash_sample___default()(testimonials));
      this.setReview(index);
    }
  }, {
    key: 'setReview',
    value: function setReview(index) {
      this.review = testimonials[index];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'review-container' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'review-box' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'blockquote',
            { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()('review-text', 'review-size-' + this.size) },
            this.review.quote,
            '\xA0\u2013 ',
            this.review.username
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'pager' },
            testimonials.map(function (r, i) {
              return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a', {
                className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()('pager-item', _this2.review === r && 'is-current'),
                key: i,
                onClick: function onClick(e) {
                  return e.preventDefault() || _this2.setReview(i);
                }
              });
            })
          )
        )
      );
    }
  }]);

  return ReviewBox;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'review', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'setReview', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setReview'), _class2.prototype)), _class2)) || _class;

var PressImages = function PressImages() {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: 'press-images' },
    ['logo-forbes', 'logo-businessinsider', 'logo-macworld', 'logo-venturebeat', 'logo-yahoo'].map(function (p) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'press-logo', key: p },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: __webpack_require__(1594)("./" + p + '.png'), alt: p })
      );
    })
  );
};

var SocialIcon = function SocialIcon(_ref3) {
  var link = _ref3.link,
      icon = _ref3.icon;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'a',
    { className: 'social-icon', href: link, target: '_blank', rel: 'noopener noreferrer' },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'fa fa-' + icon })
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkAccountDialogState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QuovoProvider_ProviderState__ = __webpack_require__(413);







var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var LinkAccountDialogState = __WEBPACK_IMPORTED_MODULE_8_autobind_decorator___default()(_class = (_class2 = function () {
  function LinkAccountDialogState(_ref) {
    var _this = this;

    var rootStore = _ref.rootStore;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, LinkAccountDialogState);

    _initDefineProp(this, 'showing', _descriptor, this);

    _initDefineProp(this, 'provider', _descriptor2, this);

    _initDefineProp(this, 'quovoProvider', _descriptor3, this);

    this.rootStore = rootStore;

    // Each provider decides when it is time to add an account,
    // so we pass them a function to invoke when the time is right.
    var addAccount = function addAccount(account) {
      return _this.rootStore.linkedAccountStore.addAccount(account);
    };
    this.quovoProvider = new __WEBPACK_IMPORTED_MODULE_9__QuovoProvider_ProviderState__["a" /* default */]({ rootStore: this.rootStore, addAccount: addAccount });
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(LinkAccountDialogState, [{
    key: 'linkNewAccount',
    value: function linkNewAccount() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_6_bluebird___default.a(function (resolve) {
        if (_this2.done) {
          _this2.done(false);
        }
        _this2.done = resolve;
        _this2.reset();
      });
    }
  }, {
    key: 'updateAccount',
    value: function updateAccount(account) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_6_bluebird___default.a(function (resolve) {
        if (_this3.done) {
          _this3.done(false);
        }

        _this3.done = resolve;
        _this3.reset();
        _this3.showProvider(_this3[account.provider + 'Provider'], account);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.showing = true;
      this.showProvider(this.quovoProvider);
    }
  }, {
    key: 'close',
    value: function close() {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.provider) {
        this.provider.close();
      }

      this.showing = false;
      this.done(result);
    }
  }, {
    key: 'showProvider',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(provider, accountToUpdate) {
        var _this4 = this;

        var account;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.provider = provider;

                _context.next = 3;
                return accountToUpdate ? this.provider.updateAccount(accountToUpdate).then(function () {
                  return accountToUpdate;
                }) : this.provider.linkAccount();

              case 3:
                account = _context.sent;

                if (account) {
                  _context.next = 7;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mobx__["runInAction"])(function () {
                  _this4.provider = null;
                });
                return _context.abrupt('return');

              case 7:

                this.close(account);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function showProvider(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return showProvider;
    }()
  }]);

  return LinkAccountDialogState;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showing', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'provider', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'quovoProvider', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'close'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showProvider', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showProvider'), _class2.prototype)), _class2)) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ErrorLabel__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ErrorLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_ErrorLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_sass__);







var BrokerLogin = function BrokerLogin(_ref) {
  var provider = _ref.provider;

  var brokerage = provider.selectedBrokerage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'brokerage-login' },
    !provider.account &&
    // Only show the back button when we haven't created an account yet.
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { className: 'button is-icon-only', onClick: function onClick() {
          return provider.reset();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Icon___default.a, { material: true, name: 'arrow back' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'brokerage-name' },
      brokerage.logo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: brokerage.logo, alt: brokerage.name, className: 'brokerage-logo' }) : brokerage.name
    ),
    brokerage.notes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'brokerage-notes' },
      brokerage.notes
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_Form__["Form"],
      { onSubmit: function onSubmit() {
          return provider.authenticate();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Form__["Input"], {
        placeholder: brokerage.username || 'Username',
        field: 'username',
        model: provider
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Form__["Input"], {
        placeholder: brokerage.password || 'Password',
        field: 'password',
        type: 'password',
        model: provider
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'button is-action' },
        'Log in'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'has-spacing-top--less' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components_ErrorLabel___default.a,
        null,
        provider.error
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(BrokerLogin));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_NoData__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_NoData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_NoData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_sass__);





var BrokerPicker = function BrokerPicker(_ref) {
  var provider = _ref.provider;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'broker-picker' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'top-bar' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'searchfield-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'search',
          className: 'searchfield',
          placeholder: 'Type here to search for your institution',
          value: provider.searchText,
          onChange: function onChange(e) {
            return provider.setSearchText(e.target.value);
          }
        })
      )
    ),
    provider.filteredBrokerages.length === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_NoData___default.a,
      { icon: 'search', theme: 'blue' },
      'No brokerages matched your filter.'
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'brokerages' },
      provider.filteredBrokerages.map(function (brokerage) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Brokerage, {
          key: brokerage.id,
          brokerage: brokerage,
          onClick: function onClick() {
            return provider.selectBrokerage(brokerage);
          }
        });
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(BrokerPicker));

var Brokerage = function Brokerage(_ref2) {
  var brokerage = _ref2.brokerage,
      onClick = _ref2.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'brokerage' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { className: 'brokerage-button', onClick: onClick },
      brokerage.logo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: brokerage.logo, className: 'brokerage-logo', alt: brokerage.name }) : brokerage.name
    )
  );
};

Brokerage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(Brokerage);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RadialProgress__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RadialProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_RadialProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_sass__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_sass__);








var BrokerSyncingStatus = function BrokerSyncingStatus(_ref) {
  var provider = _ref.provider;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_components_Flex__["FlexContainer"],
    { className: 'syncing', direction: 'column' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_components_Flex__["FlexItem"],
      { className: 'has-text-centered' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'title is-5 is-semibold' },
        provider.syncProgress === 100 ? provider.account.status === 'postponed' ? 'Almost done!' : 'Awesome!' : 'Syncing your account, please wait'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content' },
        provider.syncProgress === 100 ? provider.account.status === 'postponed' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Brokerage is unavailable at the moment, we will try again at the end of the day.'
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Your account has been synced!'
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'This may take a minute, hold tight!'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_components_Flex__["FlexItem"],
      { className: 'has-spacing-top' },
      provider.syncProgress === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner___default.a, {
        size: 48,
        color: '#70c79a'
      }) : provider.syncProgress === 100 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'animated zoomIn' },
        provider.account.status === 'postponed' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Icon___default.a, { large: true, material: true, name: 'check', color: '#FFB300' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Icon___default.a, { large: true, material: true, name: 'check', color: '#70c79a' })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RadialProgress___default.a, {
        progress: provider.syncProgress
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(BrokerSyncingStatus));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoicesChallenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);






var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var ChoicesChallenge = (_class = function () {
  function ChoicesChallenge(_ref) {
    var challenge = _ref.challenge;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ChoicesChallenge);

    _initDefineProp(this, 'selectedValue', _descriptor, this);

    _initDefineProp(this, 'choices', _descriptor2, this);

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this, challenge);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ChoicesChallenge, [{
    key: 'setAnswer',
    value: function setAnswer(answer) {
      this.selectedValue = answer;
    }
  }, {
    key: 'answer',
    get: function get() {
      var _this = this;

      // The answer must be the index of the selected value
      var choice = this.choices.find(function (x) {
        return x.value === _this.selectedValue;
      });
      if (!choice) {
        return null;
      }

      return this.choices.indexOf(choice);
    }
  }]);

  return ChoicesChallenge;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selectedValue', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'choices', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setAnswer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAnswer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'answer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'answer'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CheckList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_CheckList__);




var ChoicesChallengeView = function ChoicesChallengeView(_ref) {
  var challenge = _ref.challenge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'choices-challenge' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_CheckList__["CheckList"],
      null,
      challenge.choices.map(function (choice) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_CheckList__["CheckListItem"],
          {
            small: true,
            key: choice.value,
            onChange: function onChange(checked) {
              return checked && challenge.setAnswer(choice.value);
            },
            checked: challenge.selectedValue === choice.value
          },
          choice.value
        );
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(ChoicesChallengeView));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageChallenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);






var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var ImageChallenge = (_class = function () {
  function ImageChallenge(_ref) {
    var challenge = _ref.challenge;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ImageChallenge);

    _initDefineProp(this, 'answer', _descriptor, this);

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this, challenge);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ImageChallenge, [{
    key: 'setAnswer',
    value: function setAnswer(answer) {
      this.answer = answer;
    }
  }]);

  return ImageChallenge;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'answer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setAnswer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAnswer'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9JbWFnZUNoYWxsZW5nZS9DaGFsbGVuZ2UuanMiXSwibmFtZXMiOlsib2JzZXJ2YWJsZSIsImFjdGlvbiIsIkltYWdlQ2hhbGxlbmdlIiwiY2hhbGxlbmdlIiwiYW5zd2VyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsVUFBVCxFQUFxQkMsTUFBckIsUUFBbUMsTUFBbkM7O0lBRXFCQyxjO0FBR25CLGdDQUE0QjtBQUFBLFFBQWJDLFNBQWEsUUFBYkEsU0FBYTs7QUFBQTs7QUFBQTs7QUFDMUIsbUJBQWMsSUFBZCxFQUFvQkEsU0FBcEI7QUFDRDs7Ozs4QkFFa0JDLE0sRUFBUTtBQUN6QixXQUFLQSxNQUFMLEdBQWNBLE1BQWQ7QUFDRDs7OzsyRUFSQUosVTs7O1dBQW9CLEU7OzhEQU1wQkMsTTtTQVBrQkMsYyIsImZpbGUiOiJDaGFsbGVuZ2UuanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBvYnNlcnZhYmxlLCBhY3Rpb24gfSBmcm9tICdtb2J4J1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBJbWFnZUNoYWxsZW5nZSB7XG4gIEBvYnNlcnZhYmxlIGFuc3dlciA9ICcnXG5cbiAgY29uc3RydWN0b3IgKHsgY2hhbGxlbmdlIH0pIHtcbiAgICBPYmplY3QuYXNzaWduKHRoaXMsIGNoYWxsZW5nZSlcbiAgfVxuXG4gIEBhY3Rpb24gc2V0QW5zd2VyIChhbnN3ZXIpIHtcbiAgICB0aGlzLmFuc3dlciA9IGFuc3dlclxuICB9XG59XG4iXX0=

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sass__);




var ImageChallengeView = function ImageChallengeView(_ref) {
  var challenge = _ref.challenge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'image-challenge' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'image-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: challenge.image.source, alt: 'Image' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      className: 'input',
      placeholder: 'Write your answer here',
      value: challenge.answer,
      onChange: function onChange(e) {
        return challenge.setAnswer(e.target.value);
      }
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(ImageChallengeView));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9JbWFnZUNoYWxsZW5nZS9WaWV3LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIm9ic2VydmVyIiwiSW1hZ2VDaGFsbGVuZ2VWaWV3IiwiY2hhbGxlbmdlIiwiaW1hZ2UiLCJzb3VyY2UiLCJhbnN3ZXIiLCJzZXRBbnN3ZXIiLCJlIiwidGFyZ2V0IiwidmFsdWUiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU9BLEtBQVAsTUFBa0IsT0FBbEI7QUFDQSxTQUFTQyxRQUFULFFBQXlCLFlBQXpCO0FBQ0EsT0FBTyxlQUFQOztBQUVBLElBQU1DLHFCQUFxQixTQUFyQkEsa0JBQXFCO0FBQUEsTUFBR0MsU0FBSCxRQUFHQSxTQUFIO0FBQUEsU0FDekI7QUFBQTtBQUFBLE1BQUssV0FBVSxpQkFBZjtBQUNFO0FBQUE7QUFBQSxRQUFLLFdBQVUsaUJBQWY7QUFDRSxtQ0FBSyxLQUFLQSxVQUFVQyxLQUFWLENBQWdCQyxNQUExQixFQUFrQyxLQUFJLE9BQXRDO0FBREYsS0FERjtBQUlFO0FBQ0UsWUFBSyxNQURQO0FBRUUsaUJBQVUsT0FGWjtBQUdFLG1CQUFZLHdCQUhkO0FBSUUsYUFBT0YsVUFBVUcsTUFKbkI7QUFLRSxnQkFBVTtBQUFBLGVBQUtILFVBQVVJLFNBQVYsQ0FBb0JDLEVBQUVDLE1BQUYsQ0FBU0MsS0FBN0IsQ0FBTDtBQUFBO0FBTFo7QUFKRixHQUR5QjtBQUFBLENBQTNCOztBQWVBLGVBQWVULFNBQVNDLGtCQUFULENBQWYiLCJmaWxlIjoiVmlldy5qc3giLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnXG5pbXBvcnQgJy4vc3R5bGVzLnNhc3MnXG5cbmNvbnN0IEltYWdlQ2hhbGxlbmdlVmlldyA9ICh7IGNoYWxsZW5nZSB9KSA9PiAoXG4gIDxkaXYgY2xhc3NOYW1lPVwiaW1hZ2UtY2hhbGxlbmdlXCI+XG4gICAgPGRpdiBjbGFzc05hbWU9XCJpbWFnZS1jb250YWluZXJcIj5cbiAgICAgIDxpbWcgc3JjPXtjaGFsbGVuZ2UuaW1hZ2Uuc291cmNlfSBhbHQ9XCJJbWFnZVwiIC8+XG4gICAgPC9kaXY+XG4gICAgPGlucHV0XG4gICAgICB0eXBlPVwidGV4dFwiXG4gICAgICBjbGFzc05hbWU9XCJpbnB1dFwiXG4gICAgICBwbGFjZWhvbGRlcj1cIldyaXRlIHlvdXIgYW5zd2VyIGhlcmVcIlxuICAgICAgdmFsdWU9e2NoYWxsZW5nZS5hbnN3ZXJ9XG4gICAgICBvbkNoYW5nZT17ZSA9PiBjaGFsbGVuZ2Uuc2V0QW5zd2VyKGUudGFyZ2V0LnZhbHVlKX1cbiAgICAvPlxuICA8L2Rpdj5cbilcblxuZXhwb3J0IGRlZmF1bHQgb2JzZXJ2ZXIoSW1hZ2VDaGFsbGVuZ2VWaWV3KVxuIl19

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageChoicesChallenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);








var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var ImageChoicesChallenge = (_class = function () {
  function ImageChoicesChallenge(_ref) {
    var challenge = _ref.challenge;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ImageChoicesChallenge);

    _initDefineProp(this, 'selectedChoice', _descriptor, this);

    _initDefineProp(this, 'choices', _descriptor2, this);

    var image_choices = challenge.image_choices,
        rest = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default()(challenge, ['image_choices']);

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      choices: image_choices
    }, rest));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ImageChoicesChallenge, [{
    key: 'setAnswer',
    value: function setAnswer(answer) {
      this.selectedChoice = answer;
    }
  }, {
    key: 'answer',
    get: function get() {
      // The answer must be the index of the selected value
      var choice = this.selectedChoice;
      if (!choice) {
        return null;
      }

      return this.choices.indexOf(choice);
    }
  }]);

  return ImageChoicesChallenge;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selectedChoice', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'choices', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setAnswer', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAnswer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'answer', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'answer'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9JbWFnZUNob2ljZXNDaGFsbGVuZ2UvQ2hhbGxlbmdlLmpzIl0sIm5hbWVzIjpbIm9ic2VydmFibGUiLCJhY3Rpb24iLCJjb21wdXRlZCIsIkltYWdlQ2hvaWNlc0NoYWxsZW5nZSIsImNoYWxsZW5nZSIsImltYWdlX2Nob2ljZXMiLCJyZXN0IiwiY2hvaWNlcyIsImFuc3dlciIsInNlbGVjdGVkQ2hvaWNlIiwiY2hvaWNlIiwiaW5kZXhPZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsVUFBVCxFQUFxQkMsTUFBckIsRUFBNkJDLFFBQTdCLFFBQTZDLE1BQTdDOztJQUVxQkMscUI7QUFJbkIsdUNBQTRCO0FBQUEsUUFBYkMsU0FBYSxRQUFiQSxTQUFhOztBQUFBOztBQUFBOztBQUFBOztBQUFBLFFBQ2xCQyxhQURrQixHQUNTRCxTQURULENBQ2xCQyxhQURrQjtBQUFBLFFBQ0FDLElBREEsNEJBQ1NGLFNBRFQ7O0FBRTFCLG1CQUFjLElBQWQ7QUFDRUcsZUFBU0Y7QUFEWCxPQUVLQyxJQUZMO0FBSUQ7Ozs7OEJBRWtCRSxNLEVBQVE7QUFDekIsV0FBS0MsY0FBTCxHQUFzQkQsTUFBdEI7QUFDRDs7O3dCQUV1QjtBQUN0QjtBQUNBLFVBQU1FLFNBQVMsS0FBS0QsY0FBcEI7QUFDQSxVQUFJLENBQUNDLE1BQUwsRUFBYTtBQUNYLGVBQU8sSUFBUDtBQUNEOztBQUVELGFBQU8sS0FBS0gsT0FBTCxDQUFhSSxPQUFiLENBQXFCRCxNQUFyQixDQUFQO0FBQ0Q7Ozs7bUZBdkJBVixVOzs7V0FBNEIsSTs7MkVBQzVCQSxVOzs7V0FBcUIsRTs7OERBVXJCQyxNLDhJQUlBQyxRO1NBaEJrQkMscUIiLCJmaWxlIjoiQ2hhbGxlbmdlLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgb2JzZXJ2YWJsZSwgYWN0aW9uLCBjb21wdXRlZCB9IGZyb20gJ21vYngnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEltYWdlQ2hvaWNlc0NoYWxsZW5nZSB7XG4gIEBvYnNlcnZhYmxlIHNlbGVjdGVkQ2hvaWNlID0gbnVsbFxuICBAb2JzZXJ2YWJsZSBjaG9pY2VzID0gW11cblxuICBjb25zdHJ1Y3RvciAoeyBjaGFsbGVuZ2UgfSkge1xuICAgIGNvbnN0IHsgaW1hZ2VfY2hvaWNlcywgLi4ucmVzdCB9ID0gY2hhbGxlbmdlXG4gICAgT2JqZWN0LmFzc2lnbih0aGlzLCB7XG4gICAgICBjaG9pY2VzOiBpbWFnZV9jaG9pY2VzLFxuICAgICAgLi4ucmVzdFxuICAgIH0pXG4gIH1cblxuICBAYWN0aW9uIHNldEFuc3dlciAoYW5zd2VyKSB7XG4gICAgdGhpcy5zZWxlY3RlZENob2ljZSA9IGFuc3dlclxuICB9XG5cbiAgQGNvbXB1dGVkIGdldCBhbnN3ZXIgKCkge1xuICAgIC8vIFRoZSBhbnN3ZXIgbXVzdCBiZSB0aGUgaW5kZXggb2YgdGhlIHNlbGVjdGVkIHZhbHVlXG4gICAgY29uc3QgY2hvaWNlID0gdGhpcy5zZWxlY3RlZENob2ljZVxuICAgIGlmICghY2hvaWNlKSB7XG4gICAgICByZXR1cm4gbnVsbFxuICAgIH1cblxuICAgIHJldHVybiB0aGlzLmNob2ljZXMuaW5kZXhPZihjaG9pY2UpXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_sass__);





var ImageChoicesChallengeView = function ImageChoicesChallengeView(_ref) {
  var challenge = _ref.challenge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'image-choices-challenge' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'images' },
      challenge.choices.map(function (image) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageChoice, {
          key: image.source,
          source: image.source,
          selected: image === challenge.selectedChoice,
          onClick: function onClick() {
            return challenge.setAnswer(image);
          }
        });
      })
    )
  );
};

var ImageChoice = function ImageChoice(_ref2) {
  var selected = _ref2.selected,
      source = _ref2.source,
      onClick = _ref2.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'image-choice' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('image-button', selected && 'is-selected'),
        'aria-checked': selected,
        'aria-role': 'checkbox',
        onClick: onClick,
        type: 'button'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: source, alt: 'Image' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(ImageChoicesChallengeView));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiFactorAuthState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QuestionChallenge_Challenge__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChoicesChallenge_Challenge__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ImageChoicesChallenge_Challenge__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ImageChallenge_Challenge__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PrerealtimeChallenge_Challenge__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RealtimeChallenge_Challenge__ = __webpack_require__(753);








var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}









var CHALLENGE_CLASS_MAP = {
  question: __WEBPACK_IMPORTED_MODULE_8__QuestionChallenge_Challenge__["a" /* default */],
  choices: __WEBPACK_IMPORTED_MODULE_9__ChoicesChallenge_Challenge__["a" /* default */],
  image_choices: __WEBPACK_IMPORTED_MODULE_10__ImageChoicesChallenge_Challenge__["a" /* default */],
  image: __WEBPACK_IMPORTED_MODULE_11__ImageChallenge_Challenge__["a" /* default */],
  prerealtime: __WEBPACK_IMPORTED_MODULE_12__PrerealtimeChallenge_Challenge__["a" /* default */],
  realtime: __WEBPACK_IMPORTED_MODULE_13__RealtimeChallenge_Challenge__["a" /* default */]
};

var MultiFactorAuthState = (_class = function () {
  function MultiFactorAuthState(_ref) {
    var provider = _ref.provider;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, MultiFactorAuthState);

    _initDefineProp(this, 'challenge', _descriptor, this);

    _initDefineProp(this, 'submitting', _descriptor2, this);

    this.provider = provider;
    this.account = provider.account;
    this.quovoAPI = provider.quovoAPI;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(MultiFactorAuthState, [{
    key: 'answerChallenge',
    value: function answerChallenge() {
      var _this = this;

      // I actually love this trick despite its.. well, dirtiness I suppose.
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.done = resolve;
        _this.fetchChallenges();
      });
    }
  }, {
    key: 'fetchChallenges',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var challenges, challengeToAnswer;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.quovoAPI.getChallenges(this.account.id).then(function (r) {
                  return r.challenges;
                });

              case 2:
                challenges = _context.sent;

                // Dummy challenge for image_choices (Quovo has no test brokerage with these), fuckers..
                // const challenges = [{
                //   id: 1,
                //   image_choices: [{
                //     source: 'https://d13yacurqjgara.cloudfront.net/users/942421/screenshots/2970032/011_1x.png'
                //   }, {
                //     source: 'https://d13yacurqjgara.cloudfront.net/users/942421/screenshots/2969038/010_1x.png'
                //   }, {
                //     source: 'https://d13yacurqjgara.cloudfront.net/users/310724/screenshots/2687157/800x600_1x.jpg'
                //   }],
                //   should_answer: true,
                //   type: 'image_choices',
                //   question: 'Which image do you think has the most swag?'
                // }]
                challengeToAnswer = challenges.find(function (c) {
                  return c.should_answer;
                });

                if (challengeToAnswer) {
                  _context.next = 7;
                  break;
                }

                // This can happen if we have answered the challenge but not created a new sync yet,
                // OR if we are still waiting for the sync status to change.
                this.done();
                return _context.abrupt('return');

              case 7:

                this.setChallenge(challengeToAnswer);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchChallenges() {
        return _ref2.apply(this, arguments);
      }

      return fetchChallenges;
    }()
  }, {
    key: 'setChallenge',
    value: function setChallenge(challenge) {
      var Challenge = CHALLENGE_CLASS_MAP[challenge.type];
      this.challenge = new Challenge({ challenge: challenge });
    }
  }, {
    key: 'submitAnswer',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setSubmitting(true);
                _context2.prev = 1;
                _context2.next = 4;
                return this.quovoAPI.answerChallenge({
                  challengeId: this.challenge.id,
                  answer: this.challenge.answer,
                  question: this.challenge.question
                });

              case 4:
                this.done();

              case 5:
                _context2.prev = 5;

                this.setSubmitting(false);
                return _context2.finish(5);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 5, 8]]);
      }));

      function submitAnswer() {
        return _ref3.apply(this, arguments);
      }

      return submitAnswer;
    }()
  }, {
    key: 'setSubmitting',
    value: function setSubmitting(submitting) {
      this.submitting = submitting;
    }
  }]);

  return MultiFactorAuthState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'challenge', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'submitting', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'setChallenge', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setChallenge'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSubmitting', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setSubmitting'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrerealtimeChallenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);






var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var PrerealtimeChallenge = (_class = function () {
  function PrerealtimeChallenge(_ref) {
    var challenge = _ref.challenge;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PrerealtimeChallenge);

    _initDefineProp(this, 'selectedChoice', _descriptor, this);

    _initDefineProp(this, 'choices', _descriptor2, this);

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this, challenge);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PrerealtimeChallenge, [{
    key: 'setAnswer',
    value: function setAnswer(choice) {
      this.selectedChoice = choice;
    }
  }, {
    key: 'answer',
    get: function get() {
      return this.choices.indexOf(this.selectedChoice);
    }
  }]);

  return PrerealtimeChallenge;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selectedChoice', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'choices', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setAnswer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAnswer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'answer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'answer'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9QcmVyZWFsdGltZUNoYWxsZW5nZS9DaGFsbGVuZ2UuanMiXSwibmFtZXMiOlsib2JzZXJ2YWJsZSIsImFjdGlvbiIsImNvbXB1dGVkIiwiUHJlcmVhbHRpbWVDaGFsbGVuZ2UiLCJjaGFsbGVuZ2UiLCJjaG9pY2UiLCJzZWxlY3RlZENob2ljZSIsImNob2ljZXMiLCJpbmRleE9mIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsVUFBVCxFQUFxQkMsTUFBckIsRUFBNkJDLFFBQTdCLFFBQTZDLE1BQTdDOztJQUVxQkMsb0I7QUFJbkIsc0NBQTRCO0FBQUEsUUFBYkMsU0FBYSxRQUFiQSxTQUFhOztBQUFBOztBQUFBOztBQUFBOztBQUMxQixtQkFBYyxJQUFkLEVBQW9CQSxTQUFwQjtBQUNEOzs7OzhCQUVrQkMsTSxFQUFRO0FBQ3pCLFdBQUtDLGNBQUwsR0FBc0JELE1BQXRCO0FBQ0Q7Ozt3QkFFdUI7QUFDdEIsYUFBTyxLQUFLRSxPQUFMLENBQWFDLE9BQWIsQ0FBcUIsS0FBS0YsY0FBMUIsQ0FBUDtBQUNEOzs7O21GQWJBTixVOzs7V0FBNEIsSTs7MkVBQzVCQSxVOzs7V0FBcUIsRTs7OERBTXJCQyxNLDhJQUlBQyxRO1NBWmtCQyxvQiIsImZpbGUiOiJDaGFsbGVuZ2UuanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBvYnNlcnZhYmxlLCBhY3Rpb24sIGNvbXB1dGVkIH0gZnJvbSAnbW9ieCdcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgUHJlcmVhbHRpbWVDaGFsbGVuZ2Uge1xuICBAb2JzZXJ2YWJsZSBzZWxlY3RlZENob2ljZSA9IG51bGxcbiAgQG9ic2VydmFibGUgY2hvaWNlcyA9IFtdXG5cbiAgY29uc3RydWN0b3IgKHsgY2hhbGxlbmdlIH0pIHtcbiAgICBPYmplY3QuYXNzaWduKHRoaXMsIGNoYWxsZW5nZSlcbiAgfVxuXG4gIEBhY3Rpb24gc2V0QW5zd2VyIChjaG9pY2UpIHtcbiAgICB0aGlzLnNlbGVjdGVkQ2hvaWNlID0gY2hvaWNlXG4gIH1cblxuICBAY29tcHV0ZWQgZ2V0IGFuc3dlciAoKSB7XG4gICAgcmV0dXJuIHRoaXMuY2hvaWNlcy5pbmRleE9mKHRoaXMuc2VsZWN0ZWRDaG9pY2UpXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CheckList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_CheckList__);




var PrerealtimeChallengeView = function PrerealtimeChallengeView(_ref) {
  var challenge = _ref.challenge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'prerealtime-challenge' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_CheckList__["CheckList"],
      null,
      challenge.choices.map(function (choice) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_CheckList__["CheckListItem"],
          {
            small: true,
            key: choice.category + choice.value,
            onChange: function onChange(checked) {
              return checked && challenge.setAnswer(choice);
            },
            checked: challenge.selectedChoice === choice
          },
          choice.value,
          ' (',
          choice.category,
          ')'
        );
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(PrerealtimeChallengeView));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionChallenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);






var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var QuestionChallenge = (_class = function () {
  function QuestionChallenge(_ref) {
    var challenge = _ref.challenge;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, QuestionChallenge);

    _initDefineProp(this, 'answer', _descriptor, this);

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this, challenge);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(QuestionChallenge, [{
    key: 'setAnswer',
    value: function setAnswer(answer) {
      this.answer = answer;
    }
  }]);

  return QuestionChallenge;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'answer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setAnswer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAnswer'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9RdWVzdGlvbkNoYWxsZW5nZS9DaGFsbGVuZ2UuanMiXSwibmFtZXMiOlsib2JzZXJ2YWJsZSIsImFjdGlvbiIsIlF1ZXN0aW9uQ2hhbGxlbmdlIiwiY2hhbGxlbmdlIiwiYW5zd2VyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsVUFBVCxFQUFxQkMsTUFBckIsUUFBbUMsTUFBbkM7O0lBRXFCQyxpQjtBQUduQixtQ0FBNEI7QUFBQSxRQUFiQyxTQUFhLFFBQWJBLFNBQWE7O0FBQUE7O0FBQUE7O0FBQzFCLG1CQUFjLElBQWQsRUFBb0JBLFNBQXBCO0FBQ0Q7Ozs7OEJBRWtCQyxNLEVBQVE7QUFDekIsV0FBS0EsTUFBTCxHQUFjQSxNQUFkO0FBQ0Q7Ozs7MkVBUkFKLFU7OztXQUFvQixFOzs4REFNcEJDLE07U0FQa0JDLGlCIiwiZmlsZSI6IkNoYWxsZW5nZS5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IG9ic2VydmFibGUsIGFjdGlvbiB9IGZyb20gJ21vYngnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFF1ZXN0aW9uQ2hhbGxlbmdlIHtcbiAgQG9ic2VydmFibGUgYW5zd2VyID0gJydcblxuICBjb25zdHJ1Y3RvciAoeyBjaGFsbGVuZ2UgfSkge1xuICAgIE9iamVjdC5hc3NpZ24odGhpcywgY2hhbGxlbmdlKVxuICB9XG5cbiAgQGFjdGlvbiBzZXRBbnN3ZXIgKGFuc3dlcikge1xuICAgIHRoaXMuYW5zd2VyID0gYW5zd2VyXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);



var QuestionChallengeView = function QuestionChallengeView(_ref) {
  var challenge = _ref.challenge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'question-challenge' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      className: 'input',
      placeholder: 'Write your answer here',
      value: challenge.answer,
      onChange: function onChange(e) {
        return challenge.setAnswer(e.target.value);
      }
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(QuestionChallengeView));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9RdWVzdGlvbkNoYWxsZW5nZS9WaWV3LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIm9ic2VydmVyIiwiUXVlc3Rpb25DaGFsbGVuZ2VWaWV3IiwiY2hhbGxlbmdlIiwiYW5zd2VyIiwic2V0QW5zd2VyIiwiZSIsInRhcmdldCIsInZhbHVlIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsU0FBU0MsUUFBVCxRQUF5QixZQUF6Qjs7QUFFQSxJQUFNQyx3QkFBd0IsU0FBeEJBLHFCQUF3QjtBQUFBLE1BQUdDLFNBQUgsUUFBR0EsU0FBSDtBQUFBLFNBQzVCO0FBQUE7QUFBQSxNQUFLLFdBQVUsb0JBQWY7QUFDRTtBQUNFLFlBQUssTUFEUDtBQUVFLGlCQUFVLE9BRlo7QUFHRSxtQkFBWSx3QkFIZDtBQUlFLGFBQU9BLFVBQVVDLE1BSm5CO0FBS0UsZ0JBQVU7QUFBQSxlQUFLRCxVQUFVRSxTQUFWLENBQW9CQyxFQUFFQyxNQUFGLENBQVNDLEtBQTdCLENBQUw7QUFBQTtBQUxaO0FBREYsR0FENEI7QUFBQSxDQUE5Qjs7QUFZQSxlQUFlUCxTQUFTQyxxQkFBVCxDQUFmIiwiZmlsZSI6IlZpZXcuanN4Iiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHsgb2JzZXJ2ZXIgfSBmcm9tICdtb2J4LXJlYWN0J1xuXG5jb25zdCBRdWVzdGlvbkNoYWxsZW5nZVZpZXcgPSAoeyBjaGFsbGVuZ2UgfSkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT1cInF1ZXN0aW9uLWNoYWxsZW5nZVwiPlxuICAgIDxpbnB1dFxuICAgICAgdHlwZT1cInRleHRcIlxuICAgICAgY2xhc3NOYW1lPVwiaW5wdXRcIlxuICAgICAgcGxhY2Vob2xkZXI9XCJXcml0ZSB5b3VyIGFuc3dlciBoZXJlXCJcbiAgICAgIHZhbHVlPXtjaGFsbGVuZ2UuYW5zd2VyfVxuICAgICAgb25DaGFuZ2U9e2UgPT4gY2hhbGxlbmdlLnNldEFuc3dlcihlLnRhcmdldC52YWx1ZSl9XG4gICAgLz5cbiAgPC9kaXY+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IG9ic2VydmVyKFF1ZXN0aW9uQ2hhbGxlbmdlVmlldylcbiJdfQ==

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RealtimeChallenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);






var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var RealtimeChallenge = (_class = function () {
  function RealtimeChallenge(_ref) {
    var challenge = _ref.challenge;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RealtimeChallenge);

    _initDefineProp(this, 'answer', _descriptor, this);

    _initDefineProp(this, 'image', _descriptor2, this);

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this, challenge);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RealtimeChallenge, [{
    key: 'setAnswer',
    value: function setAnswer(answer) {
      this.answer = answer;
    }
  }]);

  return RealtimeChallenge;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'answer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'image', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setAnswer', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setAnswer'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9SZWFsdGltZUNoYWxsZW5nZS9DaGFsbGVuZ2UuanMiXSwibmFtZXMiOlsib2JzZXJ2YWJsZSIsImFjdGlvbiIsIlJlYWx0aW1lQ2hhbGxlbmdlIiwiY2hhbGxlbmdlIiwiYW5zd2VyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsVUFBVCxFQUFxQkMsTUFBckIsUUFBbUMsTUFBbkM7O0lBRXFCQyxpQjtBQUluQixtQ0FBNEI7QUFBQSxRQUFiQyxTQUFhLFFBQWJBLFNBQWE7O0FBQUE7O0FBQUE7O0FBQUE7O0FBQzFCLG1CQUFjLElBQWQsRUFBb0JBLFNBQXBCO0FBQ0Q7Ozs7OEJBRWtCQyxNLEVBQVE7QUFDekIsV0FBS0EsTUFBTCxHQUFjQSxNQUFkO0FBQ0Q7Ozs7MkVBVEFKLFU7OztXQUFvQixFOzt5RUFDcEJBLFU7OztXQUFtQixJOzs4REFNbkJDLE07U0FSa0JDLGlCIiwiZmlsZSI6IkNoYWxsZW5nZS5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IG9ic2VydmFibGUsIGFjdGlvbiB9IGZyb20gJ21vYngnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFJlYWx0aW1lQ2hhbGxlbmdlIHtcbiAgQG9ic2VydmFibGUgYW5zd2VyID0gJydcbiAgQG9ic2VydmFibGUgaW1hZ2UgPSBudWxsXG5cbiAgY29uc3RydWN0b3IgKHsgY2hhbGxlbmdlIH0pIHtcbiAgICBPYmplY3QuYXNzaWduKHRoaXMsIGNoYWxsZW5nZSlcbiAgfVxuXG4gIEBhY3Rpb24gc2V0QW5zd2VyIChhbnN3ZXIpIHtcbiAgICB0aGlzLmFuc3dlciA9IGFuc3dlclxuICB9XG59XG4iXX0=

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sass__);




var RealtimeChallengeView = function RealtimeChallengeView(_ref) {
  var challenge = _ref.challenge;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'realtime-challenge' },
    challenge.image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'captcha-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: challenge.image.source, alt: 'Captcha' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      className: 'input',
      placeholder: 'Write your answer here',
      value: challenge.answer,
      onChange: function onChange(e) {
        return challenge.setAnswer(e.target.value);
      }
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(RealtimeChallengeView));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9MaW5rQWNjb3VudERpYWxvZy9RdW92b1Byb3ZpZGVyL011bHRpRmFjdG9yQXV0aC9SZWFsdGltZUNoYWxsZW5nZS9WaWV3LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIm9ic2VydmVyIiwiUmVhbHRpbWVDaGFsbGVuZ2VWaWV3IiwiY2hhbGxlbmdlIiwiaW1hZ2UiLCJzb3VyY2UiLCJhbnN3ZXIiLCJzZXRBbnN3ZXIiLCJlIiwidGFyZ2V0IiwidmFsdWUiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU9BLEtBQVAsTUFBa0IsT0FBbEI7QUFDQSxTQUFTQyxRQUFULFFBQXlCLFlBQXpCO0FBQ0EsT0FBTyxlQUFQOztBQUVBLElBQU1DLHdCQUF3QixTQUF4QkEscUJBQXdCO0FBQUEsTUFBR0MsU0FBSCxRQUFHQSxTQUFIO0FBQUEsU0FDNUI7QUFBQTtBQUFBLE1BQUssV0FBVSxvQkFBZjtBQUNHQSxjQUFVQyxLQUFWLElBQ0M7QUFBQTtBQUFBLFFBQUssV0FBVSxtQkFBZjtBQUNFLG1DQUFLLEtBQUtELFVBQVVDLEtBQVYsQ0FBZ0JDLE1BQTFCLEVBQWtDLEtBQUksU0FBdEM7QUFERixLQUZKO0FBT0U7QUFDRSxZQUFLLE1BRFA7QUFFRSxpQkFBVSxPQUZaO0FBR0UsbUJBQVksd0JBSGQ7QUFJRSxhQUFPRixVQUFVRyxNQUpuQjtBQUtFLGdCQUFVO0FBQUEsZUFBS0gsVUFBVUksU0FBVixDQUFvQkMsRUFBRUMsTUFBRixDQUFTQyxLQUE3QixDQUFMO0FBQUE7QUFMWjtBQVBGLEdBRDRCO0FBQUEsQ0FBOUI7O0FBa0JBLGVBQWVULFNBQVNDLHFCQUFULENBQWYiLCJmaWxlIjoiVmlldy5qc3giLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnXG5pbXBvcnQgJy4vc3R5bGVzLnNhc3MnXG5cbmNvbnN0IFJlYWx0aW1lQ2hhbGxlbmdlVmlldyA9ICh7IGNoYWxsZW5nZSB9KSA9PiAoXG4gIDxkaXYgY2xhc3NOYW1lPVwicmVhbHRpbWUtY2hhbGxlbmdlXCI+XG4gICAge2NoYWxsZW5nZS5pbWFnZSAmJlxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJjYXB0Y2hhLWNvbnRhaW5lclwiPlxuICAgICAgICA8aW1nIHNyYz17Y2hhbGxlbmdlLmltYWdlLnNvdXJjZX0gYWx0PVwiQ2FwdGNoYVwiIC8+XG4gICAgICA8L2Rpdj5cbiAgICB9XG5cbiAgICA8aW5wdXRcbiAgICAgIHR5cGU9XCJ0ZXh0XCJcbiAgICAgIGNsYXNzTmFtZT1cImlucHV0XCJcbiAgICAgIHBsYWNlaG9sZGVyPVwiV3JpdGUgeW91ciBhbnN3ZXIgaGVyZVwiXG4gICAgICB2YWx1ZT17Y2hhbGxlbmdlLmFuc3dlcn1cbiAgICAgIG9uQ2hhbmdlPXtlID0+IGNoYWxsZW5nZS5zZXRBbnN3ZXIoZS50YXJnZXQudmFsdWUpfVxuICAgIC8+XG4gIDwvZGl2PlxuKVxuXG5leHBvcnQgZGVmYXVsdCBvYnNlcnZlcihSZWFsdGltZUNoYWxsZW5nZVZpZXcpXG4iXX0=

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkingIndicator__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuestionChallenge_View__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChoicesChallenge_View__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImageChoicesChallenge_View__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ImageChallenge_View__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrerealtimeChallenge_View__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RealtimeChallenge_View__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_sass__);












var CHALLENGE_VIEWS = {
  question: __WEBPACK_IMPORTED_MODULE_4__QuestionChallenge_View__["a" /* default */],
  choices: __WEBPACK_IMPORTED_MODULE_5__ChoicesChallenge_View__["a" /* default */],
  image: __WEBPACK_IMPORTED_MODULE_7__ImageChallenge_View__["a" /* default */],
  image_choices: __WEBPACK_IMPORTED_MODULE_6__ImageChoicesChallenge_View__["a" /* default */],
  prerealtime: __WEBPACK_IMPORTED_MODULE_8__PrerealtimeChallenge_View__["a" /* default */],
  realtime: __WEBPACK_IMPORTED_MODULE_9__RealtimeChallenge_View__["a" /* default */]
};

var MultiFactorAuth = function MultiFactorAuth(_ref) {
  var state = _ref.state;
  return state.submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__WorkingIndicator__["a" /* default */],
    null,
    'Submitting answer..'
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'multi-factor-auth' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'question has-text-centered' },
      state.challenge.question
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_Form__["Form"],
      { onSubmit: function onSubmit() {
          return state.submitAnswer();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChallengeView, { challenge: state.challenge }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'actions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'button is-action' },
          'Answer'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(MultiFactorAuth));

var ChallengeView = function ChallengeView(_ref2) {
  var challenge = _ref2.challenge;

  var View = CHALLENGE_VIEWS[challenge.type];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View, { challenge: challenge });
};

ChallengeView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(ChallengeView);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrokerPicker__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrokerLogin__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrokerSyncingStatus__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MultiFactorAuth__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WorkingIndicator__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_sass__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_sass__);










var QuovoProvider = function QuovoProvider(_ref) {
  var provider = _ref.provider;

  // I know this isn't very functional, but it was the easiest way
  // to get the view swapping done without over-arching things.
  var View = __WEBPACK_IMPORTED_MODULE_2__BrokerPicker__["a" /* default */];
  if (provider.fetchingBrokerages) {
    View = LoadingBrokerages;
  } else {
    // When we have selected a brokerage,
    // show the broker login.
    if (provider.selectedBrokerage) {
      View = __WEBPACK_IMPORTED_MODULE_3__BrokerLogin__["a" /* default */];
    }

    if (provider.multiFactorAuthState) {
      // If there's a multi-factor auth challenge present,
      // show that.
      if (provider.multiFactorAuthState.challenge) {
        View = MultiFactorAuthView;
      } else {
        // Cheating to reuse the syncing view while loading challenges. Hehe.
        View = __WEBPACK_IMPORTED_MODULE_4__BrokerSyncingStatus__["a" /* default */];
      }
    }

    // If we're either syncing, or done syncing..
    if (provider.syncing || provider.syncProgress === 100) {
      View = __WEBPACK_IMPORTED_MODULE_4__BrokerSyncingStatus__["a" /* default */];
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'quovo-provider' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View, { provider: provider })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(QuovoProvider));

// Proxy this so rerendering does not trigger errors when we nullify the state.
var MultiFactorAuthView = function MultiFactorAuthView(_ref2) {
  var provider = _ref2.provider;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MultiFactorAuth__["a" /* default */], { state: provider.multiFactorAuthState });
};

var LoadingBrokerages = function LoadingBrokerages() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__WorkingIndicator__["a" /* default */],
    null,
    'Loading brokerages, please wait'
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Dialog__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuovoProvider_ProviderView__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__QuovoProvider_ProviderState__ = __webpack_require__(413);









var LinkAccountDialog = function LinkAccountDialog(_ref) {
  var dialog = _ref.dialog;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_components_Modal___default.a,
    { isOpened: dialog.showing, onRequestClose: function onRequestClose() {
        return dialog.close();
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components_Dialog__["Dialog"],
      { className: 'link-account-dialog' },
      dialog.provider === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountTypeStep, { dialog: dialog }),
      dialog.provider instanceof __WEBPACK_IMPORTED_MODULE_6__QuovoProvider_ProviderState__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__QuovoProvider_ProviderView__["a" /* default */], { provider: dialog.provider })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(LinkAccountDialog));

// Not used anymore, was from when we were using both
// Plaid and Quovo.
var AccountTypeStep = function AccountTypeStep(_ref2) {
  var dialog = _ref2.dialog;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'account-type-step' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h1',
      { className: 'title has-text-centered' },
      'What type of account are you linking?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'account-types' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountType, {
        name: 'Bank Account',
        description: 'By linking your bank account, you can pay via Direct Deposit which means no credit card fees. Woo!',
        onClick: function onClick() {
          return dialog.selectType('bank');
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountType, {
        name: 'Investment and/or 401K',
        description: 'Give your CPA access to quality tax records so you don\u2019t have to spend time scanning tons of documents.',
        onClick: function onClick() {
          return dialog.selectType('investment-401k');
        }
      })
    )
  );
};

var AccountType = function AccountType(_ref3) {
  var name = _ref3.name,
      description = _ref3.description,
      onClick = _ref3.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    { className: 'account-type', onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'name' },
      name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'description' },
      description
    )
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedAccountsManagerState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ConfirmDialog__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ConfirmDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_ConfirmDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_LinkAccountDialog_LinkAccountDialogState__ = __webpack_require__(738);







var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var LinkedAccountsManagerState = (_class = function () {
  function LinkedAccountsManagerState(_ref) {
    var rootStore = _ref.rootStore;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, LinkedAccountsManagerState);

    _initDefineProp(this, 'accountToRemove', _descriptor, this);

    _initDefineProp(this, 'linkAccountDialog', _descriptor2, this);

    _initDefineProp(this, 'removeLinkedAccountDialog', _descriptor3, this);

    this.rootStore = rootStore;
    this.linkAccountDialog = new __WEBPACK_IMPORTED_MODULE_8_components_LinkAccountDialog_LinkAccountDialogState__["a" /* default */]({ rootStore: this.rootStore });
    this.removeLinkedAccountDialog = new __WEBPACK_IMPORTED_MODULE_7_components_ConfirmDialog__["ConfirmDialogState"]();
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(LinkedAccountsManagerState, [{
    key: 'loadAccounts',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.linkedAccountStore.fetchLinkedAccounts();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadAccounts() {
        return _ref2.apply(this, arguments);
      }

      return loadAccounts;
    }()
  }, {
    key: 'showDialog',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.linkAccountDialog = new __WEBPACK_IMPORTED_MODULE_8_components_LinkAccountDialog_LinkAccountDialogState__["a" /* default */]({ rootStore: this.rootStore });
                _context2.next = 3;
                return this.linkAccountDialog.linkNewAccount();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function showDialog() {
        return _ref3.apply(this, arguments);
      }

      return showDialog;
    }()
  }, {
    key: 'removeAccount',
    value: function removeAccount(account) {
      var _this = this;

      this.accountToRemove = account;
      return this.removeLinkedAccountDialog.show().then(function (yes) {
        if (yes) {
          return _this.rootStore.linkedAccountStore.destroy(account);
        }
      });
    }
  }, {
    key: 'fixIssues',
    value: function fixIssues(account) {
      this.linkAccountDialog = new __WEBPACK_IMPORTED_MODULE_8_components_LinkAccountDialog_LinkAccountDialogState__["a" /* default */]({ rootStore: this.rootStore });
      this.linkAccountDialog.updateAccount(account);
    }
  }, {
    key: 'linkedAccounts',
    get: function get() {
      return this.rootStore.linkedAccountStore.linkedAccounts.map(function (x) {
        return x;
      });
    }
  }]);

  return LinkedAccountsManagerState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'accountToRemove', [__WEBPACK_IMPORTED_MODULE_6_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'linkAccountDialog', [__WEBPACK_IMPORTED_MODULE_6_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'removeLinkedAccountDialog', [__WEBPACK_IMPORTED_MODULE_6_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'linkedAccounts', [__WEBPACK_IMPORTED_MODULE_6_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'linkedAccounts'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showDialog', [__WEBPACK_IMPORTED_MODULE_6_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showDialog'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeAccount', [__WEBPACK_IMPORTED_MODULE_6_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'removeAccount'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fixIssues', [__WEBPACK_IMPORTED_MODULE_6_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fixIssues'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniTabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MiniTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_prefix__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_utils_prefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_sass__);







var tabModifiers = __WEBPACK_IMPORTED_MODULE_4_utils_prefix___default()('mini-tabs__tab--');

var MiniTabs = function MiniTabs(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['children', 'className']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('mini-tabs', className) }, rest),
    children
  );
};


var MiniTab = function MiniTab(_ref2) {
  var children = _ref2.children,
      active = _ref2.active,
      className = _ref2.className,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['children', 'active', 'className']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'a',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('mini-tabs__tab', tabModifiers({ active: active }), className) }, rest),
    children
  );
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9NaW5pVGFicy9pbmRleC5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJjeCIsInByZWZpeCIsInRhYk1vZGlmaWVycyIsIk1pbmlUYWJzIiwiY2hpbGRyZW4iLCJjbGFzc05hbWUiLCJyZXN0IiwiTWluaVRhYiIsImFjdGl2ZSJdLCJtYXBwaW5ncyI6Ijs7QUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCO0FBQ0EsT0FBT0MsRUFBUCxNQUFlLFlBQWY7QUFDQSxPQUFPQyxNQUFQLE1BQW1CLGNBQW5CO0FBQ0EsT0FBTyxlQUFQOztBQUVBLElBQU1DLGVBQWVELE9BQU8sa0JBQVAsQ0FBckI7O0FBRU8sSUFBTUUsV0FBVyxTQUFYQSxRQUFXO0FBQUEsTUFBR0MsUUFBSCxRQUFHQSxRQUFIO0FBQUEsTUFBYUMsU0FBYixRQUFhQSxTQUFiO0FBQUEsTUFBMkJDLElBQTNCOztBQUFBLFNBQ3RCO0FBQUE7QUFBQSxlQUFLLFdBQVdOLEdBQUcsV0FBSCxFQUFnQkssU0FBaEIsQ0FBaEIsSUFBZ0RDLElBQWhEO0FBQ0dGO0FBREgsR0FEc0I7QUFBQSxDQUFqQjs7O0FBTUEsSUFBTUcsVUFBVSxTQUFWQSxPQUFVO0FBQUEsTUFBR0gsUUFBSCxTQUFHQSxRQUFIO0FBQUEsTUFBYUksTUFBYixTQUFhQSxNQUFiO0FBQUEsTUFBcUJILFNBQXJCLFNBQXFCQSxTQUFyQjtBQUFBLE1BQW1DQyxJQUFuQzs7QUFBQSxTQUNyQjtBQUFBO0FBQUEsZUFBRyxXQUFXTixHQUFHLGdCQUFILEVBQXFCRSxhQUFhLEVBQUVNLGNBQUYsRUFBYixDQUFyQixFQUErQ0gsU0FBL0MsQ0FBZCxJQUE2RUMsSUFBN0U7QUFDR0Y7QUFESCxHQURxQjtBQUFBLENBQWhCIiwiZmlsZSI6ImluZGV4LmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJ1xuaW1wb3J0IHByZWZpeCBmcm9tICd1dGlscy9wcmVmaXgnXG5pbXBvcnQgJy4vc3R5bGVzLnNhc3MnXG5cbmNvbnN0IHRhYk1vZGlmaWVycyA9IHByZWZpeCgnbWluaS10YWJzX190YWItLScpXG5cbmV4cG9ydCBjb25zdCBNaW5pVGFicyA9ICh7IGNoaWxkcmVuLCBjbGFzc05hbWUsIC4uLnJlc3QgfSkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT17Y3goJ21pbmktdGFicycsIGNsYXNzTmFtZSl9IHsuLi5yZXN0fT5cbiAgICB7Y2hpbGRyZW59XG4gIDwvZGl2PlxuKVxuXG5leHBvcnQgY29uc3QgTWluaVRhYiA9ICh7IGNoaWxkcmVuLCBhY3RpdmUsIGNsYXNzTmFtZSwgLi4ucmVzdCB9KSA9PiAoXG4gIDxhIGNsYXNzTmFtZT17Y3goJ21pbmktdGFic19fdGFiJywgdGFiTW9kaWZpZXJzKHsgYWN0aXZlIH0pLCBjbGFzc05hbWUpfSB7Li4ucmVzdH0+XG4gICAge2NoaWxkcmVufVxuICA8L2E+XG4pXG4iXX0=

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ConfirmDialog__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ConfirmDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_ConfirmDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);




var RemoveLinkedAccountDialog = function RemoveLinkedAccountDialog(_ref) {
  var dialog = _ref.dialog,
      account = _ref.account;
  return account && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_components_ConfirmDialog___default.a,
    { state: dialog, title: 'Removed Linked Account' },
    'Are you sure you want to remove your ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'strong',
      null,
      account.institution
    ),
    ' account?'
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(RemoveLinkedAccountDialog));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9SZW1vdmVMaW5rZWRBY2NvdW50RGlhbG9nL2luZGV4LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIkNvbmZpcm1EaWFsb2ciLCJvYnNlcnZlciIsIlJlbW92ZUxpbmtlZEFjY291bnREaWFsb2ciLCJkaWFsb2ciLCJhY2NvdW50IiwiaW5zdGl0dXRpb24iXSwibWFwcGluZ3MiOiJBQUFBLE9BQU9BLEtBQVAsTUFBa0IsT0FBbEI7QUFDQSxPQUFPQyxhQUFQLE1BQTBCLDBCQUExQjtBQUNBLFNBQVNDLFFBQVQsUUFBeUIsWUFBekI7O0FBRUEsSUFBTUMsNEJBQTRCLFNBQTVCQSx5QkFBNEI7QUFBQSxNQUFHQyxNQUFILFFBQUdBLE1BQUg7QUFBQSxNQUFXQyxPQUFYLFFBQVdBLE9BQVg7QUFBQSxTQUNoQ0EsV0FDRTtBQUFDLGlCQUFEO0FBQUEsTUFBZSxPQUFPRCxNQUF0QixFQUE4QixPQUFNLHdCQUFwQztBQUFBO0FBQ3VDO0FBQUE7QUFBQTtBQUFTQyxjQUFRQztBQUFqQixLQUR2QztBQUFBO0FBQUEsR0FGOEI7QUFBQSxDQUFsQzs7QUFRQSxlQUFlSixTQUFTQyx5QkFBVCxDQUFmIiwiZmlsZSI6ImluZGV4LmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBDb25maXJtRGlhbG9nIGZyb20gJ2NvbXBvbmVudHMvQ29uZmlybURpYWxvZydcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCdcblxuY29uc3QgUmVtb3ZlTGlua2VkQWNjb3VudERpYWxvZyA9ICh7IGRpYWxvZywgYWNjb3VudCB9KSA9PiAoXG4gIGFjY291bnQgJiYgKFxuICAgIDxDb25maXJtRGlhbG9nIHN0YXRlPXtkaWFsb2d9IHRpdGxlPVwiUmVtb3ZlZCBMaW5rZWQgQWNjb3VudFwiPlxuICAgICAgQXJlIHlvdSBzdXJlIHlvdSB3YW50IHRvIHJlbW92ZSB5b3VyIDxzdHJvbmc+e2FjY291bnQuaW5zdGl0dXRpb259PC9zdHJvbmc+IGFjY291bnQ/XG4gICAgPC9Db25maXJtRGlhbG9nPlxuICApXG4pXG5cbmV4cG9ydCBkZWZhdWx0IG9ic2VydmVyKFJlbW92ZUxpbmtlZEFjY291bnREaWFsb2cpXG4iXX0=

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_sass__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_sass__);









var SLIDE_AMOUNT = 70;
var rmConfig = {
  stiffness: 240,
  damping: 24
};

var SlideTransition = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SlideTransition, _React$Component);

  function SlideTransition() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SlideTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SlideTransition.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SlideTransition)).call.apply(_ref, [this].concat(args))), _this), _this.willEnter = function () {
      return {
        opacity: 0,
        // Slides the correct way based on
        // whether we're going forwards or backwards
        x: _this.props.invert ? -SLIDE_AMOUNT : SLIDE_AMOUNT
      };
    }, _this.willLeave = function () {
      return {
        opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_motion__["spring"])(0),
        x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_motion__["spring"])(_this.props.invert ? SLIDE_AMOUNT : -SLIDE_AMOUNT, rmConfig)
      };
    }, _this.getStyles = function () {
      return {
        opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_motion__["spring"])(1),
        x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_motion__["spring"])(0, rmConfig)
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SlideTransition, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          Wrapper = _props.wrapper,
          transitionKey = _props.transitionKey;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_motion__["TransitionMotion"],
        {
          styles: [{
            key: transitionKey,
            style: this.getStyles(),
            data: children
          }],
          willEnter: this.willEnter,
          willLeave: this.willLeave
        },
        function (interpolated) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            null,
            interpolated.map(function (_ref2) {
              var key = _ref2.key,
                  style = _ref2.style,
                  data = _ref2.data;
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                Wrapper,
                {
                  key: key + '-transition',
                  className: 'slide-transition',
                  style: {
                    position: 'absolute',
                    width: '100%',
                    overflow: 'visible',
                    opacity: style.opacity,
                    transform: 'translateX(' + style.x + '%)'
                  }
                },
                data
              );
            })
          );
        }
      );
    }
  }]);

  return SlideTransition;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* unused harmony export TabItemLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_sass__);








var Tabs = function Tabs(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: 'tab-bar' },
    children
  );
};

var TabItemLink = function TabItemLink(_ref2) {
  var children = _ref2.children,
      active = _ref2.active,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['children', 'active']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_components_Link___default.a,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tab-item', { 'is-active': active }), activeClassName: 'is-active' }),
    children
  );
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9UYWJzL2luZGV4LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsImN4IiwiTGluayIsIlRhYnMiLCJjaGlsZHJlbiIsIlRhYkl0ZW1MaW5rIiwiYWN0aXZlIiwicHJvcHMiXSwibWFwcGluZ3MiOiI7O0FBQUEsT0FBT0EsS0FBUCxNQUFrQixPQUFsQjtBQUNBLE9BQU9DLEVBQVAsTUFBZSxZQUFmO0FBQ0EsT0FBT0MsSUFBUCxNQUFpQixpQkFBakI7O0FBRUEsT0FBTyxlQUFQOztBQUVBLE9BQU8sSUFBTUMsT0FBTyxTQUFQQSxJQUFPO0FBQUEsTUFBR0MsUUFBSCxRQUFHQSxRQUFIO0FBQUEsU0FDbEI7QUFBQTtBQUFBLE1BQUssV0FBVSxTQUFmO0FBQ0dBO0FBREgsR0FEa0I7QUFBQSxDQUFiOztBQU1BLElBQU1DLGNBQWMsU0FBZEEsV0FBYztBQUFBLE1BQUdELFFBQUgsU0FBR0EsUUFBSDtBQUFBLE1BQWFFLE1BQWIsU0FBYUEsTUFBYjtBQUFBLE1BQXdCQyxLQUF4Qjs7QUFBQSxTQUN6QjtBQUFDLFFBQUQ7QUFBQSxpQkFBVUEsS0FBVixJQUFpQixXQUFXTixHQUFHLFVBQUgsRUFBZSxFQUFFLGFBQWFLLE1BQWYsRUFBZixDQUE1QixFQUFxRSxpQkFBaUIsV0FBdEY7QUFDR0Y7QUFESCxHQUR5QjtBQUFBLENBQXBCIiwiZmlsZSI6ImluZGV4LmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJ1xuaW1wb3J0IExpbmsgZnJvbSAnY29tcG9uZW50cy9MaW5rJ1xuXG5pbXBvcnQgJy4vc3R5bGVzLnNhc3MnXG5cbmV4cG9ydCBjb25zdCBUYWJzID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT1cInRhYi1iYXJcIj5cbiAgICB7Y2hpbGRyZW59XG4gIDwvZGl2PlxuKVxuXG5leHBvcnQgY29uc3QgVGFiSXRlbUxpbmsgPSAoeyBjaGlsZHJlbiwgYWN0aXZlLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxMaW5rIHsuLi5wcm9wc30gY2xhc3NOYW1lPXtjeCgndGFiLWl0ZW0nLCB7ICdpcy1hY3RpdmUnOiBhY3RpdmUgfSl9IGFjdGl2ZUNsYXNzTmFtZT17J2lzLWFjdGl2ZSd9PlxuICAgIHtjaGlsZHJlbn1cbiAgPC9MaW5rPlxuKVxuIl19

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsDialogState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);






var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}



var TermsDialogState = (_class = function () {
  function TermsDialogState() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TermsDialogState);

    _initDefineProp(this, 'showing', _descriptor, this);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TermsDialogState, [{
    key: 'show',
    value: function show() {
      var _this = this;

      if (this.accepted) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
      }

      this.showing = true;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.resolve = resolve;
      });
    }
  }, {
    key: 'decline',
    value: function decline() {
      this.resolve(false);
      this.showing = false;
    }
  }, {
    key: 'accept',
    value: function accept() {
      this.accepted = true;
      this.resolve(true);
      this.showing = false;
    }
  }]);

  return TermsDialogState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'showing', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'show', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'show'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'decline', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'decline'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'accept', [__WEBPACK_IMPORTED_MODULE_5_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'accept'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9UZXJtc0RpYWxvZy9UZXJtc0RpYWxvZ1N0YXRlLmpzIl0sIm5hbWVzIjpbIm9ic2VydmFibGUiLCJhY3Rpb24iLCJUZXJtc0RpYWxvZ1N0YXRlIiwiYWNjZXB0ZWQiLCJyZXNvbHZlIiwic2hvd2luZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLFNBQVNBLFVBQVQsRUFBcUJDLE1BQXJCLFFBQW1DLE1BQW5DOztJQUVxQkMsZ0I7Ozs7Ozs7OzsyQkFHSDtBQUFBOztBQUNkLFVBQUksS0FBS0MsUUFBVCxFQUFtQjtBQUNqQixlQUFPLFNBQVFDLE9BQVIsQ0FBZ0IsSUFBaEIsQ0FBUDtBQUNEOztBQUVELFdBQUtDLE9BQUwsR0FBZSxJQUFmO0FBQ0EsYUFBTyxhQUFZLFVBQUNELE9BQUQsRUFBYTtBQUM5QixjQUFLQSxPQUFMLEdBQWVBLE9BQWY7QUFDRCxPQUZNLENBQVA7QUFHRDs7OzhCQUVrQjtBQUNqQixXQUFLQSxPQUFMLENBQWEsS0FBYjtBQUNBLFdBQUtDLE9BQUwsR0FBZSxLQUFmO0FBQ0Q7Ozs2QkFFaUI7QUFDaEIsV0FBS0YsUUFBTCxHQUFnQixJQUFoQjtBQUNBLFdBQUtDLE9BQUwsQ0FBYSxJQUFiO0FBQ0EsV0FBS0MsT0FBTCxHQUFlLEtBQWY7QUFDRDs7Ozs0RUF0QkFMLFU7OztXQUFxQixLOzt5REFFckJDLE0sMElBV0FBLE0sNElBS0FBLE07U0FuQmtCQyxnQiIsImZpbGUiOiJUZXJtc0RpYWxvZ1N0YXRlLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgb2JzZXJ2YWJsZSwgYWN0aW9uIH0gZnJvbSAnbW9ieCdcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVGVybXNEaWFsb2dTdGF0ZSB7XG4gIEBvYnNlcnZhYmxlIHNob3dpbmcgPSBmYWxzZVxuXG4gIEBhY3Rpb24gc2hvdyAoKSB7XG4gICAgaWYgKHRoaXMuYWNjZXB0ZWQpIHtcbiAgICAgIHJldHVybiBQcm9taXNlLnJlc29sdmUodHJ1ZSlcbiAgICB9XG5cbiAgICB0aGlzLnNob3dpbmcgPSB0cnVlXG4gICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlKSA9PiB7XG4gICAgICB0aGlzLnJlc29sdmUgPSByZXNvbHZlXG4gICAgfSlcbiAgfVxuXG4gIEBhY3Rpb24gZGVjbGluZSAoKSB7XG4gICAgdGhpcy5yZXNvbHZlKGZhbHNlKVxuICAgIHRoaXMuc2hvd2luZyA9IGZhbHNlXG4gIH1cblxuICBAYWN0aW9uIGFjY2VwdCAoKSB7XG4gICAgdGhpcy5hY2NlcHRlZCA9IHRydWVcbiAgICB0aGlzLnJlc29sdmUodHJ1ZSlcbiAgICB0aGlzLnNob3dpbmcgPSBmYWxzZVxuICB9XG59XG4iXX0=

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_misc_env__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modal__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Dialog__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_sass__);







var TermsDialog = function TermsDialog(_ref) {
  var state = _ref.state;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_Modal___default.a,
    { isOpened: state.showing, onRequestClose: function onRequestClose() {
        return state.decline();
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["Dialog"],
      { className: 'terms-dialog' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'iframe-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
          className: 'terms-frame',
          src: __WEBPACK_IMPORTED_MODULE_1_misc_env__["a" /* default */].TAXFYLE_TERMS_URL,
          frameBorder: '0',
          seamless: 'seamless'
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogFooter"],
        { className: 'terms-dialog__footer' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogButton"],
          { onClick: function onClick() {
              return state.accept();
            } },
          'Accept'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_Dialog__["DialogButton"],
          { danger: true, onClick: function onClick() {
              return state.decline();
            } },
          'Decline'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(TermsDialog));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9UZXJtc0RpYWxvZy9pbmRleC5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJlbnYiLCJvYnNlcnZlciIsIk1vZGFsIiwiRGlhbG9nIiwiRGlhbG9nQnV0dG9uIiwiRGlhbG9nRm9vdGVyIiwiVGVybXNEaWFsb2ciLCJzdGF0ZSIsInNob3dpbmciLCJkZWNsaW5lIiwiVEFYRllMRV9URVJNU19VUkwiLCJhY2NlcHQiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU9BLEtBQVAsTUFBa0IsT0FBbEI7QUFDQSxPQUFPQyxHQUFQLE1BQWdCLFVBQWhCO0FBQ0EsU0FBU0MsUUFBVCxRQUF5QixZQUF6QjtBQUNBLE9BQU9DLEtBQVAsTUFBa0Isa0JBQWxCO0FBQ0EsU0FBU0MsTUFBVCxFQUFpQkMsWUFBakIsRUFBK0JDLFlBQS9CLFFBQW1ELG1CQUFuRDtBQUNBLE9BQU8sZUFBUDs7QUFFQSxJQUFNQyxjQUFjLFNBQWRBLFdBQWMsT0FBZTtBQUFBLE1BQVpDLEtBQVksUUFBWkEsS0FBWTs7QUFDakMsU0FDRTtBQUFDLFNBQUQ7QUFBQSxNQUFPLFVBQVVBLE1BQU1DLE9BQXZCLEVBQWdDLGdCQUFnQjtBQUFBLGVBQU1ELE1BQU1FLE9BQU4sRUFBTjtBQUFBLE9BQWhEO0FBQ0U7QUFBQyxZQUFEO0FBQUEsUUFBUSxXQUFVLGNBQWxCO0FBQ0U7QUFBQTtBQUFBLFVBQUssV0FBVSxrQkFBZjtBQUNFO0FBQ0UscUJBQVUsYUFEWjtBQUVFLGVBQUtULElBQUlVLGlCQUZYO0FBR0UsdUJBQVksR0FIZDtBQUlFLG9CQUFTO0FBSlg7QUFERixPQURGO0FBU0U7QUFBQyxvQkFBRDtBQUFBLFVBQWMsV0FBVSxzQkFBeEI7QUFDRTtBQUFDLHNCQUFEO0FBQUEsWUFBYyxTQUFTO0FBQUEscUJBQU1ILE1BQU1JLE1BQU4sRUFBTjtBQUFBLGFBQXZCO0FBQUE7QUFBQSxTQURGO0FBRUU7QUFBQyxzQkFBRDtBQUFBLFlBQWMsWUFBZCxFQUFxQixTQUFTO0FBQUEscUJBQU1KLE1BQU1FLE9BQU4sRUFBTjtBQUFBLGFBQTlCO0FBQUE7QUFBQTtBQUZGO0FBVEY7QUFERixHQURGO0FBa0JELENBbkJEOztBQXFCQSxlQUFlUixTQUFTSyxXQUFULENBQWYiLCJmaWxlIjoiaW5kZXguanN4Iiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IGVudiBmcm9tICdtaXNjL2VudidcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCdcbmltcG9ydCBNb2RhbCBmcm9tICdjb21wb25lbnRzL01vZGFsJ1xuaW1wb3J0IHsgRGlhbG9nLCBEaWFsb2dCdXR0b24sIERpYWxvZ0Zvb3RlciB9IGZyb20gJ2NvbXBvbmVudHMvRGlhbG9nJ1xuaW1wb3J0ICcuL3N0eWxlcy5zYXNzJ1xuXG5jb25zdCBUZXJtc0RpYWxvZyA9ICh7IHN0YXRlIH0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8TW9kYWwgaXNPcGVuZWQ9e3N0YXRlLnNob3dpbmd9IG9uUmVxdWVzdENsb3NlPXsoKSA9PiBzdGF0ZS5kZWNsaW5lKCl9PlxuICAgICAgPERpYWxvZyBjbGFzc05hbWU9XCJ0ZXJtcy1kaWFsb2dcIj5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJpZnJhbWUtY29udGFpbmVyXCI+XG4gICAgICAgICAgPGlmcmFtZVxuICAgICAgICAgICAgY2xhc3NOYW1lPVwidGVybXMtZnJhbWVcIlxuICAgICAgICAgICAgc3JjPXtlbnYuVEFYRllMRV9URVJNU19VUkx9XG4gICAgICAgICAgICBmcmFtZUJvcmRlcj1cIjBcIlxuICAgICAgICAgICAgc2VhbWxlc3M9XCJzZWFtbGVzc1wiXG4gICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxEaWFsb2dGb290ZXIgY2xhc3NOYW1lPVwidGVybXMtZGlhbG9nX19mb290ZXJcIj5cbiAgICAgICAgICA8RGlhbG9nQnV0dG9uIG9uQ2xpY2s9eygpID0+IHN0YXRlLmFjY2VwdCgpfT5BY2NlcHQ8L0RpYWxvZ0J1dHRvbj5cbiAgICAgICAgICA8RGlhbG9nQnV0dG9uIGRhbmdlciBvbkNsaWNrPXsoKSA9PiBzdGF0ZS5kZWNsaW5lKCl9PkRlY2xpbmU8L0RpYWxvZ0J1dHRvbj5cbiAgICAgICAgPC9EaWFsb2dGb290ZXI+XG4gICAgICA8L0RpYWxvZz5cbiAgICA8L01vZGFsPlxuICApXG59XG5cbmV4cG9ydCBkZWZhdWx0IG9ic2VydmVyKFRlcm1zRGlhbG9nKVxuIl19

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_formatCurrency__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_formatCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_utils_formatCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_sass__);







var UserCoupon = function UserCoupon(_ref) {
  var coupon = _ref.userCoupon.coupon;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_ShadowBox___default.a,
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('user-coupon', coupon.expired && 'is-expired'), pad: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'coupon-info' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'friendly-name' },
        coupon.friendlyName || coupon.id
      ),
      coupon.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'description' },
        coupon.description
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'off-info' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'off-value' },
        coupon.offType.type === 'AMOUNT_OFF' ? __WEBPACK_IMPORTED_MODULE_4_utils_formatCurrency___default()(coupon.offType.amountOff) : coupon.offType.percentOff + '%',
        ' off'
      ),
      coupon.dateExpires && (coupon.expired ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'expired' },
        'Expired'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'expires' },
        'expires ',
        coupon.dateExpires.format('L LT')
      ))
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"])(UserCoupon));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hideIntercom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







/**
 * Hides Intercom.
 */
function hideIntercom(Target) {
  return function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(IntercomHider, _React$Component);

    function IntercomHider() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, IntercomHider);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IntercomHider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(IntercomHider)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(IntercomHider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.body.classList.add('hide-intercom');
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.body.classList.remove('hide-intercom');
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Target, this.props);
      }
    }]);

    return IntercomHider;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZGVjb3JhdG9ycy9oaWRlSW50ZXJjb20uanMiXSwibmFtZXMiOlsiUmVhY3QiLCJoaWRlSW50ZXJjb20iLCJUYXJnZXQiLCJkb2N1bWVudCIsImJvZHkiLCJjbGFzc0xpc3QiLCJhZGQiLCJyZW1vdmUiLCJwcm9wcyIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCOztBQUVBOzs7QUFHQSxlQUFlLFNBQVNDLFlBQVQsQ0FBdUJDLE1BQXZCLEVBQStCO0FBQzVDO0FBQUE7O0FBQUE7QUFBQTs7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQSwwQ0FDdUI7QUFDbkJDLGlCQUFTQyxJQUFULENBQWNDLFNBQWQsQ0FBd0JDLEdBQXhCLENBQTRCLGVBQTVCO0FBQ0Q7QUFISDtBQUFBO0FBQUEsNkNBSzBCO0FBQ3RCSCxpQkFBU0MsSUFBVCxDQUFjQyxTQUFkLENBQXdCRSxNQUF4QixDQUErQixlQUEvQjtBQUNEO0FBUEg7QUFBQTtBQUFBLCtCQVNZO0FBQ1IsZUFDRSxvQkFBQyxNQUFELEVBQVksS0FBS0MsS0FBakIsQ0FERjtBQUdEO0FBYkg7O0FBQUE7QUFBQSxJQUFtQ1IsTUFBTVMsU0FBekM7QUFlRCIsImZpbGUiOiJoaWRlSW50ZXJjb20uanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5cbi8qKlxuICogSGlkZXMgSW50ZXJjb20uXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGhpZGVJbnRlcmNvbSAoVGFyZ2V0KSB7XG4gIHJldHVybiBjbGFzcyBJbnRlcmNvbUhpZGVyIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgICBjb21wb25lbnREaWRNb3VudCAoKSB7XG4gICAgICBkb2N1bWVudC5ib2R5LmNsYXNzTGlzdC5hZGQoJ2hpZGUtaW50ZXJjb20nKVxuICAgIH1cblxuICAgIGNvbXBvbmVudFdpbGxVbm1vdW50ICgpIHtcbiAgICAgIGRvY3VtZW50LmJvZHkuY2xhc3NMaXN0LnJlbW92ZSgnaGlkZS1pbnRlcmNvbScpXG4gICAgfVxuXG4gICAgcmVuZGVyICgpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgIDxUYXJnZXQgey4uLnRoaXMucHJvcHN9IC8+XG4gICAgICApXG4gICAgfVxuICB9XG59XG4iXX0=

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx__);








var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Card = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Card, _Model);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Card.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Card)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'id', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Card, [{
    key: 'isDefaultSource',
    get: function get() {
      var record = this.rootStore.billingStore.customerRecord;
      if (!record) {
        return false;
      }

      return record.default_source === this.id;
    }
  }]);

  return Card;
}(__WEBPACK_IMPORTED_MODULE_7_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'isDefaultSource', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'isDefaultSource'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZG9tYWluL0NhcmQuanMiXSwibmFtZXMiOlsiTW9kZWwiLCJvYnNlcnZhYmxlIiwiY29tcHV0ZWQiLCJDYXJkIiwicmVjb3JkIiwicm9vdFN0b3JlIiwiYmlsbGluZ1N0b3JlIiwiY3VzdG9tZXJSZWNvcmQiLCJkZWZhdWx0X3NvdXJjZSIsImlkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxTQUFTQSxLQUFULFFBQXNCLE1BQXRCO0FBQ0EsU0FBU0MsVUFBVCxFQUFxQkMsUUFBckIsUUFBcUMsTUFBckM7O0lBRXFCQyxJOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O3dCQUdjO0FBQy9CLFVBQU1DLFNBQVMsS0FBS0MsU0FBTCxDQUFlQyxZQUFmLENBQTRCQyxjQUEzQztBQUNBLFVBQUksQ0FBQ0gsTUFBTCxFQUFhO0FBQ1gsZUFBTyxLQUFQO0FBQ0Q7O0FBRUQsYUFBT0EsT0FBT0ksY0FBUCxLQUEwQixLQUFLQyxFQUF0QztBQUNEOzs7O0VBVitCVCxLLHFFQUMvQkMsVTs7O29FQUVBQyxRO1NBSGtCQyxJIiwiZmlsZSI6IkNhcmQuanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBNb2RlbCB9IGZyb20gJ2xpYngnXG5pbXBvcnQgeyBvYnNlcnZhYmxlLCBjb21wdXRlZCB9IGZyb20gJ21vYngnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIENhcmQgZXh0ZW5kcyBNb2RlbCB7XG4gIEBvYnNlcnZhYmxlIGlkXG5cbiAgQGNvbXB1dGVkIGdldCBpc0RlZmF1bHRTb3VyY2UgKCkge1xuICAgIGNvbnN0IHJlY29yZCA9IHRoaXMucm9vdFN0b3JlLmJpbGxpbmdTdG9yZS5jdXN0b21lclJlY29yZFxuICAgIGlmICghcmVjb3JkKSB7XG4gICAgICByZXR1cm4gZmFsc2VcbiAgICB9XG5cbiAgICByZXR1cm4gcmVjb3JkLmRlZmF1bHRfc291cmNlID09PSB0aGlzLmlkXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Conversation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_libx__);






var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Conversation = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Conversation, _Model);

  // First time around we load 30 messages
  function Conversation() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Conversation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Conversation.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Conversation)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'hasMoreMessages', _descriptor, _this), _initDefineProp(_this, 'loadingMore', _descriptor2, _this), _initDefineProp(_this, 'paginationWindow', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return Conversation;
}(__WEBPACK_IMPORTED_MODULE_6_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'hasMoreMessages', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'loadingMore', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'paginationWindow', [__WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 30;
  }
})), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZG9tYWluL0NvbnZlcnNhdGlvbi5qcyJdLCJuYW1lcyI6WyJvYnNlcnZhYmxlIiwiTW9kZWwiLCJDb252ZXJzYXRpb24iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxTQUFTQSxVQUFULFFBQTJCLE1BQTNCO0FBQ0EsU0FBU0MsS0FBVCxRQUFzQixNQUF0Qjs7SUFFcUJDLFk7OztBQUdlOzs7Ozs7Ozs7Ozs7Ozs7O0VBSE1ELEssa0ZBQ3ZDRCxVOzs7V0FBNkIsSzs7K0VBQzdCQSxVOzs7V0FBeUIsSzs7b0ZBQ3pCQSxVOzs7V0FBOEIsRTs7O1NBSFpFLFkiLCJmaWxlIjoiQ29udmVyc2F0aW9uLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgb2JzZXJ2YWJsZSB9IGZyb20gJ21vYngnXG5pbXBvcnQgeyBNb2RlbCB9IGZyb20gJ2xpYngnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIENvbnZlcnNhdGlvbiBleHRlbmRzIE1vZGVsIHtcbiAgQG9ic2VydmFibGUgaGFzTW9yZU1lc3NhZ2VzID0gZmFsc2VcbiAgQG9ic2VydmFibGUgbG9hZGluZ01vcmUgPSBmYWxzZVxuICBAb2JzZXJ2YWJsZSBwYWdpbmF0aW9uV2luZG93ID0gMzAgLy8gRmlyc3QgdGltZSBhcm91bmQgd2UgbG9hZCAzMCBtZXNzYWdlc1xufVxuIl19

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Coupon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserCoupon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);









var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _desc2, _value2, _class3, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var Coupon = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Coupon, _Model);

  function Coupon() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Coupon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Coupon.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Coupon)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'id', _descriptor, _this), _initDefineProp(_this, 'friendlyName', _descriptor2, _this), _initDefineProp(_this, 'description', _descriptor3, _this), _initDefineProp(_this, 'couponType', _descriptor4, _this), _initDefineProp(_this, 'offType', _descriptor5, _this), _initDefineProp(_this, 'duration', _descriptor6, _this), _initDefineProp(_this, 'dateExpires', _descriptor7, _this), _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Coupon, [{
    key: 'parse',
    value: function parse(json) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, json, {
        dateExpires: json.dateExpires ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(json.dateExpires) : null
      });
    }
  }, {
    key: 'expired',
    get: function get() {
      return this.dateExpires && this.dateExpires.isBefore(__WEBPACK_IMPORTED_MODULE_9_moment___default()());
    }
  }]);

  return Coupon;
}(__WEBPACK_IMPORTED_MODULE_8_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'friendlyName', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'description', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'couponType', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'offType', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'duration', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'dateExpires', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'expired', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'expired'), _class.prototype)), _class);

var UserCoupon = (_class3 = function (_Model2) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(UserCoupon, _Model2);

  function UserCoupon() {
    var _ref2;

    var _temp2, _this2, _ret2;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UserCoupon);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = UserCoupon.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(UserCoupon)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, 'userId', _descriptor8, _this2), _initDefineProp(_this2, 'redeemed', _descriptor9, _this2), _initDefineProp(_this2, 'dateCreated', _descriptor10, _this2), _initDefineProp(_this2, 'dateRedeemed', _descriptor11, _this2), _temp2), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret2);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UserCoupon, [{
    key: 'parse',
    value: function parse(json) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, json, {
        dateCreated: __WEBPACK_IMPORTED_MODULE_9_moment___default()(json.dateCreated),
        dateRedeemed: json.dateRedeemed ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(json.dateRedeemed) : null,
        coupon: new Coupon(json.coupon, { rootStore: this.rootStore, parse: true })
      });
    }
  }]);

  return UserCoupon;
}(__WEBPACK_IMPORTED_MODULE_8_libx__["Model"]), (_descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'userId', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'redeemed', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'dateCreated', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()();
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'dateRedeemed', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class3);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_domain_User__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);







var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var CurrentUser = (_class = function (_User) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CurrentUser, _User);

  function CurrentUser() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CurrentUser);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CurrentUser.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CurrentUser)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CurrentUser, [{
    key: 'needsToUpdateProfile',
    get: function get() {
      return [this.firstName, this.lastName, this.email].some(function (field) {
        return !field;
      });
    }
  }]);

  return CurrentUser;
}(__WEBPACK_IMPORTED_MODULE_6_domain_User__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'needsToUpdateProfile', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'needsToUpdateProfile'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZG9tYWluL0N1cnJlbnRVc2VyLmpzIl0sIm5hbWVzIjpbIlVzZXIiLCJjb21wdXRlZCIsIkN1cnJlbnRVc2VyIiwiZmlyc3ROYW1lIiwibGFzdE5hbWUiLCJlbWFpbCIsInNvbWUiLCJmaWVsZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPQSxJQUFQLE1BQWlCLGFBQWpCO0FBQ0EsU0FBU0MsUUFBVCxRQUF5QixNQUF6Qjs7SUFFcUJDLFc7Ozs7Ozs7Ozs7O3dCQUNtQjtBQUNwQyxhQUFPLENBQ0wsS0FBS0MsU0FEQSxFQUVMLEtBQUtDLFFBRkEsRUFHTCxLQUFLQyxLQUhBLEVBSUxDLElBSkssQ0FJQTtBQUFBLGVBQVMsQ0FBQ0MsS0FBVjtBQUFBLE9BSkEsQ0FBUDtBQUtEOzs7O0VBUHNDUCxJLHlFQUN0Q0MsUTtTQURrQkMsVyIsImZpbGUiOiJDdXJyZW50VXNlci5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBVc2VyIGZyb20gJ2RvbWFpbi9Vc2VyJ1xuaW1wb3J0IHsgY29tcHV0ZWQgfSBmcm9tICdtb2J4J1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBDdXJyZW50VXNlciBleHRlbmRzIFVzZXIge1xuICBAY29tcHV0ZWQgZ2V0IG5lZWRzVG9VcGRhdGVQcm9maWxlICgpIHtcbiAgICByZXR1cm4gW1xuICAgICAgdGhpcy5maXJzdE5hbWUsXG4gICAgICB0aGlzLmxhc3ROYW1lLFxuICAgICAgdGhpcy5lbWFpbFxuICAgIF0uc29tZShmaWVsZCA9PiAhZmllbGQpXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Document; });
/* unused harmony export DocumentEditor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_path__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqueId__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_validx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_validx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_validx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_data_editor__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_data_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_data_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_misc_DocumentTypes__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_misc_DocumentTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_misc_DocumentTypes__);











var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _dec, _class3, _desc2, _value2, _class4, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var Document = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(Document, _Model);

  function Document() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Document);

    var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Document.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Document)).apply(this, arguments));

    _initDefineProp(_this, 'cid', _descriptor, _this);

    _initDefineProp(_this, 'label', _descriptor2, _this);

    _initDefineProp(_this, 'type', _descriptor3, _this);

    _initDefineProp(_this, 'description', _descriptor4, _this);

    _initDefineProp(_this, 'fileName', _descriptor5, _this);

    _initDefineProp(_this, 'dateUpdated', _descriptor6, _this);

    _initDefineProp(_this, 'uploadProgress', _descriptor7, _this);

    _initDefineProp(_this, 'fileObject', _descriptor8, _this);

    _initDefineProp(_this, 'year', _descriptor9, _this);

    _initDefineProp(_this, 'downloadLink', _descriptor10, _this);

    _initDefineProp(_this, 'jobId', _descriptor11, _this);

    _initDefineProp(_this, 'category', _descriptor12, _this);

    _this.editor = new DocumentEditor(_this, { rootStore: _this.rootStore });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Document, [{
    key: 'parse',
    value: function parse(json) {
      var meta = json.Metadata;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        id: json.Key,
        fileName: __WEBPACK_IMPORTED_MODULE_11_path___default.a.basename(json.Key),
        dateUpdated: json.LastModified ? __WEBPACK_IMPORTED_MODULE_13_moment___default()(json.LastModified) : this.dateUpdated
      }, meta && {
        label: meta.name,
        description: meta.notes,
        type: meta.type || 'OTHER',
        year: meta.year,
        jobId: meta.job,
        category: meta.category || 'PERSONAL',
        // need to store uploader ID in meta
        uploadedBy: meta.uploader ? this.rootStore.userStore.users.set({ user_id: meta.uploader }) : undefined
      });
    }
  }, {
    key: 'download',
    value: function download() {
      return this.rootStore.documentStore.download(this);
    }
  }, {
    key: 'fileType',
    get: function get() {
      if (!this.fileName) {
        return '';
      }

      return __WEBPACK_IMPORTED_MODULE_11_path___default.a.extname(this.fileName).substring(1);
    }
  }, {
    key: 'isNew',
    get: function get() {
      // It's a new document if there's a file object present.
      // (we remove this after uploading)
      return !!this.fileObject;
    }
  }, {
    key: 'friendlyType',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_17_misc_DocumentTypes__[this.category][this.type];
    }
  }]);

  return Document;
}(__WEBPACK_IMPORTED_MODULE_10_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'cid', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_uniqueId___default()('document-');
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'label', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'type', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'description', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'fileName', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'dateUpdated', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()();
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'uploadProgress', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'fileObject', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'year', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'downloadLink', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'jobId', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'category', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 'PERSONAL';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'fileType', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fileType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isNew', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'isNew'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'friendlyType', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'friendlyType'), _class.prototype)), _class);


var DocumentEditor = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_data_editor__["editor"])(), _dec(_class3 = (_class4 = function () {
  function DocumentEditor(model, opts) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, DocumentEditor);

    _initDefineProp(this, 'label', _descriptor13, this);

    _initDefineProp(this, 'description', _descriptor14, this);

    _initDefineProp(this, 'type', _descriptor15, this);

    _initDefineProp(this, 'year', _descriptor16, this);

    _initDefineProp(this, 'category', _descriptor17, this);

    this.validationRules = {
      label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('File name is required')],
      type: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('Type is required')],
      category: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('Category is required')],
      description: [function (_ref) {
        var value = _ref.value;
        return value ? value.length < 100 ? true : 'Description is too long' : true;
      }],
      year: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('Year is required')]
    };

    this.model = model;
    this.documentStore = opts.rootStore.documentStore;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["reaction"])(function () {
      return _this2.category;
    }, function () {
      if (!_this2.category || _this2.type in __WEBPACK_IMPORTED_MODULE_17_misc_DocumentTypes__[_this2.category] === false) {
        _this2.set({ type: '' });
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(DocumentEditor, [{
    key: 'save',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(mapped) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.documentStore.save(this.model, mapped);

              case 2:
                return _context.abrupt('return', true);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: 'cancelEditing',
    value: function cancelEditing() {
      if (this.model.isNew) {
        this.documentStore.removeStagedDocument(this.model);
      }
    }
  }, {
    key: 'availableDocumentTypes',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_17_misc_DocumentTypes__[this.category];
    }
  }]);

  return DocumentEditor;
}(), (_descriptor13 = _applyDecoratedDescriptor(_class4.prototype, 'label', [__WEBPACK_IMPORTED_MODULE_16_data_editor__["field"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class4.prototype, 'description', [__WEBPACK_IMPORTED_MODULE_16_data_editor__["field"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class4.prototype, 'type', [__WEBPACK_IMPORTED_MODULE_16_data_editor__["field"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class4.prototype, 'year', [__WEBPACK_IMPORTED_MODULE_16_data_editor__["field"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class4.prototype, 'category', [__WEBPACK_IMPORTED_MODULE_16_data_editor__["field"]], {
  enumerable: true,
  initializer: function initializer() {
    return 'PERSONAL';
  }
}), _applyDecoratedDescriptor(_class4.prototype, 'availableDocumentTypes', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class4.prototype, 'availableDocumentTypes'), _class4.prototype)), _class4)) || _class3);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JobEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_objectUtil__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Amendment__ = __webpack_require__(419);







var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}







var JobEvent = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(JobEvent, _Model);

  function JobEvent() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, JobEvent);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (JobEvent.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(JobEvent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(JobEvent, [{
    key: 'parse',
    value: function parse(json) {
      var _this2 = this;

      var user = function user(value) {
        return value ? _this2.rootStore.userStore.users.set(value) : null;
      };

      var quote = function quote(value) {
        return {
          adminFeeAmount: value.admin_fee_amount,
          couponAmount: value.coupon_amount,
          primaryAmount: value.primary_amount,
          providerCutAmount: value.provider_cut_amount,
          grossAmount: value.gross_amount,
          amendedAmount: value.amended_amount,
          total: value.total
        };
      };

      var previousProvider = user(json.previous_provider);
      var provider = user(json.provider);
      var newProvider = user(json.new_provider);
      var triggeredBy = user(json.triggered_by);

      // Refresh all these users.
      this.rootStore.userStore.refreshProfiles([previousProvider, provider, newProvider, triggeredBy].filter(function (x) {
        return x;
      }).map(function (x) {
        return x.id;
      }));

      if (json.snapshot && json.snapshot.date_modified) {
        // Update the in-memory job if we have one, but only if
        // the snapshot is newer than what we have.
        var job = this.rootStore.projectStore.projects.get(json.snapshot.id);
        if (!job || job.dateUpdated && __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.snapshot.date_modified).isAfter(job.dateUpdated)) {
          // Snapshot is newer than what we have; set it.
          this.rootStore.projectStore.projects.set(json.snapshot);
        }
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils_objectUtil__["a" /* omitUndefined */])({
        id: json.id,
        dateCreated: __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_created),
        jobId: json.job_id,
        amendment: json.amendment ? new __WEBPACK_IMPORTED_MODULE_10__Amendment__["a" /* default */](json.amendment, { parse: true, rootStore: this.rootStore, job: this.rootStore.projectStore.projects.set({ id: json.job_id }) }) : null,
        reason: json.reason,
        description: json.description,
        dateTransmitted: json.date_transmitted ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_transmitted) : null,
        dateAccepted: json.date_accepted ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_accepted) : null,
        dateReopened: json.date_reopened ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_reopened) : null,
        dateClosed: json.date_closed ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_closed) : null,
        previousProvider: previousProvider,
        provider: provider,
        newProvider: newProvider,
        triggeredBy: triggeredBy,
        eventVisibility: json.event_visibility,
        eventType: json.event_type,
        rebound: json.rebound,
        previousQuote: quote(json.previous_quote),
        newQuote: quote(json.new_quote)
      });
    }
  }, {
    key: 'job',
    get: function get() {
      return this.rootStore.projectStore.projects.get(this.jobId);
    }
  }]);

  return JobEvent;
}(__WEBPACK_IMPORTED_MODULE_7_libx__["Model"]), (_applyDecoratedDescriptor(_class.prototype, 'job', [__WEBPACK_IMPORTED_MODULE_6_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'job'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_layer_websdk__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_layer_websdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_layer_websdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);








var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}








var Message = (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Message, _Model);

  function Message() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Message);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Message.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Message)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'id', _descriptor, _this), _initDefineProp(_this, 'text', _descriptor2, _this), _initDefineProp(_this, 'sender', _descriptor3, _this), _initDefineProp(_this, 'sentAt', _descriptor4, _this), _initDefineProp(_this, 'allRecipientStatuses', _descriptor5, _this), _initDefineProp(_this, 'type', _descriptor6, _this), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Message, [{
    key: 'hasRecipientStatus',
    value: function hasRecipientStatus(status) {
      return this.recipientStatus.some(function (x) {
        return x.status === status;
      });
    }
  }, {
    key: 'parse',
    value: function parse(json, opts) {
      var createdHere = opts ? opts.createdHere : false;
      var id = json.id,
          parts = json.parts,
          conversationId = json.conversationId,
          sentAt = json.sentAt,
          recipientStatus = json.recipientStatus,
          sender = json.sender;

      var part = parts[0];
      var data = {
        id: id,
        createdHere: createdHere,
        conversationId: conversationId,
        type: 'text',
        sentAt: __WEBPACK_IMPORTED_MODULE_11_moment___default()(sentAt),
        allRecipientStatuses: this._mapRecipientStatus(recipientStatus),
        sender: this.rootStore.userStore.userByAuthId(sender.userId),
        text: part.body // lol sue me
      };

      if (part.mimeType === 'application/json') {
        var body = JSON.parse(part.body);
        data.type = body.type;
        if (data.type === 'document') {
          data.text = '';
          // Odds are the one we have in memory (if we do) is more up-to-date.
          var doc = this.rootStore.documentStore.documents.get(body.data.Key);
          data.document = doc || this.rootStore.documentStore.documents.set(body.data);
        }
      }
      return data;
    }
  }, {
    key: '_mapRecipientStatus',
    value: function _mapRecipientStatus(recipientStatus) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(recipientStatus, function (value, key) {
        var id = decodeURIComponent(key.replace('layer:///identities/', ''));
        return {
          status: value,
          recipient: _this2.rootStore.userStore.userByAuthId(id)
        };
      });
    }
  }, {
    key: 'receiptState',
    get: function get() {
      var receiptState = null;
      if (this.hasRecipientStatus(__WEBPACK_IMPORTED_MODULE_8_layer_websdk___default.a.Constants.RECEIPT_STATE.PENDING)) {
        receiptState = __WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState__["SENDING"];
      }

      if (this.hasRecipientStatus(__WEBPACK_IMPORTED_MODULE_8_layer_websdk___default.a.Constants.RECEIPT_STATE.SENT)) {
        receiptState = __WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState__["SENT"];
      }

      if (this.hasRecipientStatus(__WEBPACK_IMPORTED_MODULE_8_layer_websdk___default.a.Constants.RECEIPT_STATE.DELIVERED)) {
        receiptState = __WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState__["DELIVERED"];
      }

      if (this.hasRecipientStatus(__WEBPACK_IMPORTED_MODULE_8_layer_websdk___default.a.Constants.RECEIPT_STATE.READ)) {
        receiptState = __WEBPACK_IMPORTED_MODULE_10_consts_MessageReceiptState__["READ"];
      }

      return receiptState;
    }
  }, {
    key: 'isRead',
    get: function get() {
      return this.myRecipientStatus.status === 'read';
    }
  }, {
    key: 'recipientStatus',
    get: function get() {
      var _this3 = this;

      return this.allRecipientStatuses.filter(function (x) {
        return x !== _this3.myRecipientStatus;
      });
    }
  }, {
    key: 'myRecipientStatus',
    get: function get() {
      var _this4 = this;

      return this.allRecipientStatuses.find(function (x) {
        return x.recipient === _this4.rootStore.authStore.user;
      });
    }
  }]);

  return Message;
}(__WEBPACK_IMPORTED_MODULE_9_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'text', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'sender', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'sentAt', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return __WEBPACK_IMPORTED_MODULE_11_moment___default()();
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'allRecipientStatuses', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'type', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 'text';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'receiptState', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'receiptState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isRead', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'isRead'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'recipientStatus', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'recipientStatus'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'myRecipientStatus', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'myRecipientStatus'), _class.prototype)), _class);


/* harmony default export */ __webpack_exports__["a"] = (Message);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Project; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_identity__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Amendment__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__taxfyle_rules_engine__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__taxfyle_rules_engine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__taxfyle_rules_engine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_arrayUtil__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_arrayUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_utils_arrayUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_objectUtil__ = __webpack_require__(268);









var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var Project = (_dec = __WEBPACK_IMPORTED_MODULE_10_mobx__["observable"].ref, (_class = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Project, _Model);

  function Project() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Project);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Project.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Project)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'name', _descriptor, _this), _initDefineProp(_this, 'answers', _descriptor2, _this), _initDefineProp(_this, 'amendments', _descriptor3, _this), _initDefineProp(_this, 'unseenMessagesCount', _descriptor4, _this), _initDefineProp(_this, 'conversation', _descriptor5, _this), _initDefineProp(_this, 'provider', _descriptor6, _this), _initDefineProp(_this, 'partnerRating', _descriptor7, _this), _initDefineProp(_this, 'dateCompleted', _descriptor8, _this), _initDefineProp(_this, 'dateCreated', _descriptor9, _this), _initDefineProp(_this, 'dateUpdated', _descriptor10, _this), _initDefineProp(_this, 'dateReopened', _descriptor11, _this), _initDefineProp(_this, 'dateTransmitted', _descriptor12, _this), _initDefineProp(_this, 'conversationId', _descriptor13, _this), _initDefineProp(_this, 'legend', _descriptor14, _this), _initDefineProp(_this, 'status', _descriptor15, _this), _initDefineProp(_this, 'states', _descriptor16, _this), _initDefineProp(_this, 'years', _descriptor17, _this), _initDefineProp(_this, 'total', _descriptor18, _this), _initDefineProp(_this, 'paidAmount', _descriptor19, _this), _initDefineProp(_this, 'primaryAmount', _descriptor20, _this), _initDefineProp(_this, 'adminFeeAmount', _descriptor21, _this), _initDefineProp(_this, 'federalAmount', _descriptor22, _this), _initDefineProp(_this, 'stateAmount', _descriptor23, _this), _initDefineProp(_this, 'couponAmount', _descriptor24, _this), _initDefineProp(_this, 'amendedAmount', _descriptor25, _this), _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // this was not always present.
  // this was not always present.


  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Project, [{
    key: 'parse',
    value: function parse(json) {
      var _this2 = this;

      var provider = json.provider_user_id ? this.rootStore.userStore.users.set(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        user_id: json.provider_user_id
      }, !this.rootStore.userStore.users.get(json.provider_user_id) ? { given_name: json.provider_first, family_name: json.provider_last } : null)) : null;

      var conversation = json.layerConversation ? this.rootStore.messageStore.conversations.set({ id: json.layerConversation }) : null;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_objectUtil__["a" /* omitUndefined */])({
        id: json.id,
        name: json.description,
        providerId: json.provider_user_id,
        conversation: conversation,
        amendments: json.amendments ? json.amendments.map(function (x) {
          return new __WEBPACK_IMPORTED_MODULE_12__Amendment__["a" /* default */](x, { parse: true, rootStore: _this2.rootStore, job: _this2 });
        }) : undefined,
        legend: json.legend,
        answers: json.answers,
        states: json.coverage_states,
        status: json.status,
        years: json.years,
        total: json.total,
        adminFeeAmount: json.admin_fee_amount,
        paidAmount: json.paid_amount,
        primaryAmount: json.primary_amount,
        stateAmount: json.state_amount,
        federalAmount: json.federal_amount,
        couponAmount: json.coupon_amount,
        amendedAmount: json.amended_amount,
        // If we didn't get provider data (missing), just use the current provider.
        // If it was explicitly null, it means the provider has been removed, and so we null
        // the provider on the job.
        provider: provider || (json.provider_user_id === null ? null : this.provider),
        partnerRating: json.rating_submitted,
        customerRating: json.rating_received,
        conversationId: json.layerConversation,
        dateCreated: __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_created),
        dateUpdated: __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_modified),
        // Note: the reason for the logic below is that if the value
        // is falsy, it is most likely explicitly being set to null (which may be desired)
        dateCompleted: json.date_closed ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_closed) : json.date_closed,
        dateAccepted: json.date_accepted ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_accepted) : json.date_accepted,
        dateTransmitted: json.date_transmitted ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_transmitted) : json.date_transmitted,
        dateReopened: json.date_reopened ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(json.date_reopened) : json.date_reopened
      });
    }
  }, {
    key: 'completed',
    get: function get() {
      return this.status === 'CLOSED';
    }
  }, {
    key: 'projectType',
    get: function get() {
      return this.legend ? this.legend.id : null;
    }
  }, {
    key: 'documents',
    get: function get() {
      // const category = this.documentsCategory
      return this.rootStore.documentStore.allDocuments;
    }
  }, {
    key: 'unreadCount',
    get: function get() {
      return this.rootStore.messageStore.unreadIn(this.conversationId);
    }
  }, {
    key: 'events',
    get: function get() {
      var _this3 = this;

      return this.rootStore.eventStore.jobEvents.filter(function (x) {
        return x.jobId === _this3.id;
      }).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_utils_arrayUtil__["makeMomentSorter"])('desc', function (x) {
        return x.dateCreated;
      }));
    }
  }, {
    key: 'documentsCategory',
    get: function get() {
      return this.projectType === 'PERSONAL_TAX_RETURN' ? 'PERSONAL' : 'BUSINESS';
    }
  }, {
    key: 'questions',
    get: function get() {
      if (!this.legend) {
        return [];
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__taxfyle_rules_engine__["rulesEngine"])(this.legend).questions(this.answers || []);
    }
  }, {
    key: 'hasAnsweredAllQuestions',
    get: function get() {
      if (!this.legend) {
        return false;
      }

      var questions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__taxfyle_rules_engine__["rulesEngine"])(this.legend).questions(this.answers || []);
      return questions.filter(function (x) {
        return x.answer === undefined;
      }).length === 0;
    }
  }, {
    key: 'timeline',
    get: function get() {
      return [{
        date: this.dateCreated,
        text: 'Job created',
        type: 'pending'
      }, this.dateTransmitted && {
        date: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateTransmitted),
        text: 'Submitted',
        type: 'pending'
      }, this.dateAccepted && {
        date: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateAccepted),
        text: 'Job picked up by ' + this.provider.name,
        type: 'pending'
      }, !this.dateCompleted && this.dateReopened && {
        date: __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateReopened),
        text: 'Job reopened',
        type: 'pending'
      }, this.dateCompleted && {
        date: this.dateCompleted,
        text: 'Job completed',
        type: 'success'
      }].filter(__WEBPACK_IMPORTED_MODULE_11_lodash_identity___default.a);
    }
  }, {
    key: 'statusMessage',
    get: function get() {
      switch (this.status) {
        case 'UNDER_CONSTRUCTION':
          return 'Under Construction';
        case 'UNCLAIMED':
          return 'Submitted';
        case 'CLAIMED':
          return 'In Progress';
        case 'CLOSED':
          return 'Completed';
        default:
          return 'N/A';
      }
    }
  }, {
    key: 'relevantStatusDate',
    get: function get() {
      switch (this.status) {
        case 'UNDER_CONSTRUCTION':
          return this.dateCreated;
        case 'UNCLAIMED':
          return this.dateTransmitted;
        case 'CLAIMED':
          return this.dateAccepted;
        case 'CLOSED':
          return this.dateCompleted;
        default:
          return this.dateUpdated;
      }
    }
  }]);

  return Project;
}(__WEBPACK_IMPORTED_MODULE_9_libx__["Model"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'name', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'answers', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'amendments', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'unseenMessagesCount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'conversation', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'provider', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'partnerRating', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'dateCompleted', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'dateCreated', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'dateUpdated', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'dateReopened', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'dateTransmitted', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'conversationId', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'legend', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'status', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 'UNDER_CONSTRUCTION';
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'states', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'years', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'total', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'paidAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, 'primaryAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, 'adminFeeAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, 'federalAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, 'stateAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, 'couponAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, 'amendedAmount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'completed', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'completed'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'projectType', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'projectType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'documents', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'documents'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'unreadCount', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'unreadCount'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'events', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'events'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'documentsCategory', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'documentsCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'questions', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'questions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasAnsweredAllQuestions', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'hasAnsweredAllQuestions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'timeline', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'timeline'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'statusMessage', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'statusMessage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'relevantStatusDate', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'relevantStatusDate'), _class.prototype)), _class));

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  RESPONSIVENESS: 'Responsiveness',
  KNOWLEDGE: 'Knowledge',
  EFFICIENCY: 'Efficiency',
  PROFESSIONALISM: 'Professionalism',
  HELPFULNESS: 'Helpfulness'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvbWlzYy9SYXRpbmdDYXRlZ29yaWVzLmpzIl0sIm5hbWVzIjpbIlJFU1BPTlNJVkVORVNTIiwiS05PV0xFREdFIiwiRUZGSUNJRU5DWSIsIlBST0ZFU1NJT05BTElTTSIsIkhFTFBGVUxORVNTIl0sIm1hcHBpbmdzIjoiQUFBQSxlQUFlO0FBQ2JBLGtCQUFnQixnQkFESDtBQUViQyxhQUFXLFdBRkU7QUFHYkMsY0FBWSxZQUhDO0FBSWJDLG1CQUFpQixpQkFKSjtBQUtiQyxlQUFhO0FBTEEsQ0FBZiIsImZpbGUiOiJSYXRpbmdDYXRlZ29yaWVzLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBSRVNQT05TSVZFTkVTUzogJ1Jlc3BvbnNpdmVuZXNzJyxcbiAgS05PV0xFREdFOiAnS25vd2xlZGdlJyxcbiAgRUZGSUNJRU5DWTogJ0VmZmljaWVuY3knLFxuICBQUk9GRVNTSU9OQUxJU006ICdQcm9mZXNzaW9uYWxpc20nLFxuICBIRUxQRlVMTkVTUzogJ0hlbHBmdWxuZXNzJ1xufVxuIl19

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaxfyleAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pickBy__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_memoize__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_misc_env__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_feathers_socketio_client__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_feathers_socketio_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_feathers_socketio_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_socket_io_client__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_feathers_client__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_feathers_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_feathers_client__);










var _class;











var createFeathersClient = __WEBPACK_IMPORTED_MODULE_11_lodash_memoize___default()(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee(token) {
    var socket;
    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            socket = __WEBPACK_IMPORTED_MODULE_16_socket_io_client___default.a.connect(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].JOB_API, {
              query: 'token=' + token
            });
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_17_feathers_client___default()().configure(__WEBPACK_IMPORTED_MODULE_15_feathers_socketio_client___default()(socket)));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function createFeathersClient(_x) {
    return _ref.apply(this, arguments);
  }

  return createFeathersClient;
}());

var TaxfyleAPI = __WEBPACK_IMPORTED_MODULE_13_autobind_decorator___default()(_class = function () {
  function TaxfyleAPI(_ref2) {
    var authStore = _ref2.authStore;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, TaxfyleAPI);

    this.authStore = authStore;
    this.jobs = new JobsAPI(this);
    this.jobEvents = new JobEventsAPI(this);
    this.profiles = new ProfilesAPI(this);
    this.coupons = new CouponsAPI(this);
    this.cards = new CardsAPI(this);
    this.customers = new CustomersAPI(this);
    this.legends = new LegendsAPI(this);
    this.states = new StatesAPI(this);
    this.charges = new ChargesAPI(this);
    this.account = new AccountAPI(this);
    this.documents = new DocumentsAPI(this);
    this.sweep = new SweepAPI(this);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(TaxfyleAPI, [{
    key: 'client',
    value: function client(baseUrl) {
      return __WEBPACK_IMPORTED_MODULE_12_axios___default.a.create({
        baseURL: baseUrl ? baseUrl + '/' : '',
        headers: {
          Authorization: 'Bearer ' + this.authStore.token
        }
      });
    }
  }, {
    key: 'apiClient',
    get: function get() {
      return this.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].JOB_API);
    }
  }, {
    key: 'localClient',
    get: function get() {
      return this.client();
    }
  }]);

  return TaxfyleAPI;
}()) || _class;



var APIClient = function () {
  function APIClient(api) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, APIClient);

    this.api = api;
    this.api.authStore.onLogin(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return createFeathersClient(_this.api.authStore.token);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    })));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(APIClient, [{
    key: 'on',
    value: function on(eventName, handler) {
      var _this2 = this;

      this.api.authStore.onLogin(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var client;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return createFeathersClient(_this2.api.authStore.token);

              case 2:
                client = _context3.sent;

                client.service(_this2.service).on(eventName, handler);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      })));
    }
  }]);

  return APIClient;
}();

var JobsAPI = function (_APIClient) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(JobsAPI, _APIClient);

  function JobsAPI() {
    var _ref5;

    var _temp, _this3, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, JobsAPI);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref5 = JobsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(JobsAPI)).call.apply(_ref5, [this].concat(args))), _this3), _this3.service = 'jobs', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this3, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(JobsAPI, [{
    key: 'get',
    value: function get(id) {
      return this.api.apiClient.get('/jobs/' + id).then(_data);
    }
  }, {
    key: 'find',
    value: function find() {
      var params = { $limit: 100 };
      return this.api.apiClient.get('/jobs', { params: params }).then(_data).then(function (x) {
        return x.data;
      });
    }
  }, {
    key: 'rate',
    value: function rate(jobId, params) {
      return this.api.apiClient.patch('/jobs/' + jobId, params).then(_data);
    }
  }, {
    key: 'create',
    value: function create(data) {
      return this.api.apiClient.post('/jobs', data).then(_data);
    }
  }, {
    key: 'patch',
    value: function patch(id, data) {
      return this.api.apiClient.patch('/jobs/' + id, data).then(_data);
    }
  }, {
    key: 'price',
    value: function price(id) {
      return this.api.apiClient.get('/job-price/' + id).then(_data);
    }
  }]);

  return JobsAPI;
}(APIClient);

var JobEventsAPI = function (_APIClient2) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(JobEventsAPI, _APIClient2);

  function JobEventsAPI() {
    var _ref6;

    var _temp2, _this4, _ret2;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, JobEventsAPI);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref6 = JobEventsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(JobEventsAPI)).call.apply(_ref6, [this].concat(args))), _this4), _this4.service = 'job-events', _temp2), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this4, _ret2);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(JobEventsAPI, [{
    key: 'find',
    value: function find(query) {
      return this.api.apiClient.get('/job-events', { params: query }).then(_data);
    }
  }]);

  return JobEventsAPI;
}(APIClient);

var ProfilesAPI = function (_APIClient3) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProfilesAPI, _APIClient3);

  function ProfilesAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ProfilesAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProfilesAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ProfilesAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ProfilesAPI, [{
    key: 'get',
    value: function get(id) {
      return this.api.localClient.get('/api/profile/' + id).then(_data);
    }
  }, {
    key: 'patch',
    value: function patch(id, data) {
      return this.api.localClient.patch('/api/profile/' + id, data).then(_data);
    }
  }, {
    key: 'uploadPicture',
    value: function uploadPicture(file) {
      var data = new FormData();
      data.append('file', file);
      return this.api.localClient.put('/api/profile/me/picture', data).then(_data);
    }
  }]);

  return ProfilesAPI;
}(APIClient);

var LegendsAPI = function (_APIClient4) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LegendsAPI, _APIClient4);

  function LegendsAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, LegendsAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LegendsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(LegendsAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(LegendsAPI, [{
    key: 'find',
    value: function find() {
      return this.client.get('/legends').then(_data);
    }
  }, {
    key: 'get',
    value: function get(id) {
      return this.client.get('/legends/' + id).then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].LEGEND_API);
    }
  }]);

  return LegendsAPI;
}(APIClient);

var StatesAPI = function (_APIClient5) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StatesAPI, _APIClient5);

  function StatesAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, StatesAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StatesAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(StatesAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(StatesAPI, [{
    key: 'find',
    value: function find() {
      return this.client.get('/states').then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].LEGEND_API);
    }
  }]);

  return StatesAPI;
}(APIClient);

var ChargesAPI = function (_APIClient6) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ChargesAPI, _APIClient6);

  function ChargesAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ChargesAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChargesAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ChargesAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ChargesAPI, [{
    key: 'create',
    value: function create(charge) {
      return this.client.post('/charges', charge).then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].STRIPE_API);
    }
  }]);

  return ChargesAPI;
}(APIClient);

var CardsAPI = function (_APIClient7) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CardsAPI, _APIClient7);

  function CardsAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, CardsAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CardsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CardsAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(CardsAPI, [{
    key: 'find',
    value: function find() {
      return this.client.get('/cards').then(_data).then(function (x) {
        return x.data;
      });
    }
  }, {
    key: 'create',
    value: function create(card) {
      return this.client.post('/cards', card).then(_data);
    }
  }, {
    key: 'destroy',
    value: function destroy(id) {
      return this.client.delete('/cards/' + id).then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].STRIPE_API);
    }
  }]);

  return CardsAPI;
}(APIClient);

// Stripe customers


var CustomersAPI = function (_APIClient8) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CustomersAPI, _APIClient8);

  function CustomersAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, CustomersAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CustomersAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CustomersAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(CustomersAPI, [{
    key: 'get',
    value: function get(id) {
      return this.client.get('/customers/' + id).then(_data);
    }
  }, {
    key: 'patch',
    value: function patch(id, data) {
      return this.client.patch('/customers/' + id, data).then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].STRIPE_API);
    }
  }]);

  return CustomersAPI;
}(APIClient);

var CouponsAPI = function (_APIClient9) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CouponsAPI, _APIClient9);

  function CouponsAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, CouponsAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CouponsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CouponsAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(CouponsAPI, [{
    key: 'getUserCoupons',
    value: function getUserCoupons() {
      return this.client.get('/api/users/me/coupons').then(_data);
    }
  }, {
    key: 'addCouponToUser',
    value: function addCouponToUser(code) {
      return this.client.post('/api/users/me/coupons', { couponId: code }).then(_data);
    }
  }, {
    key: 'calculateNewPrice',
    value: function calculateNewPrice(price) {
      return this.client.get('/api/users/me/calculation', { params: { originalPrice: price } }).then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].COUPON_API);
    }
  }]);

  return CouponsAPI;
}(APIClient);

var AccountAPI = function (_APIClient10) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AccountAPI, _APIClient10);

  function AccountAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, AccountAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccountAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AccountAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(AccountAPI, [{
    key: 'updateMeta',
    value: function updateMeta(meta) {
      meta = __WEBPACK_IMPORTED_MODULE_9_lodash_pickBy___default()(meta, function (x) {
        return x !== undefined;
      });
      return this.client.patch('/users/me/referrer', meta).then(_data);
    }
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].ACCOUNT_API);
    }
  }]);

  return AccountAPI;
}(APIClient);

var SweepAPI = function (_APIClient11) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SweepAPI, _APIClient11);

  function SweepAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, SweepAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SweepAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SweepAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(SweepAPI, [{
    key: 'create',
    value: function create(data) {
      return this.api.localClient.post('/api/sweep', data).then(_data);
    }
  }]);

  return SweepAPI;
}(APIClient);

var DocumentsAPI = function (_APIClient12) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DocumentsAPI, _APIClient12);

  function DocumentsAPI() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DocumentsAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumentsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DocumentsAPI)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DocumentsAPI, [{
    key: 'get',
    value: function get(id, params) {
      return this.client.get('/documents/' + encodeURIComponent(id), { params: params }).then(_data);
    }
  }, {
    key: 'find',
    value: function find(params) {
      return this.client.get('/documents', { params: params }).then(_data);
    }
  }, {
    key: 'patch',
    value: function patch(id, params) {
      var jobId = params.jobId,
          other = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(params, ['jobId']);

      return this.client.patch('/documents/' + encodeURIComponent(id), other, {
        headers: {
          'x-jobid': jobId
        }
      }).then(_data);
    }
  }, {
    key: 'upload',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4(opts) {
        var data, cfg, response;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                  progress: function progress() {},
                  file: null,
                  meta: {}
                }, opts);

                data = new window.FormData();

                data.append('file', opts.file);
                cfg = {
                  headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, opts.job && {
                    'x-jobid': opts.job
                  }, __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_pickBy___default()(opts.meta, function (v) {
                    return v !== undefined && v !== null;
                  }), function (value, key) {
                    return 'x-meta-' + key;
                  })),
                  onUploadProgress: function onUploadProgress(e) {
                    opts.progress({
                      percent: Math.ceil(e.loaded / e.total * 100),
                      loaded: e.loaded,
                      total: e.total
                    });
                  }
                };
                _context4.next = 6;
                return this.client.post('/documents', data, cfg);

              case 6:
                response = _context4.sent;
                return _context4.abrupt('return', response.data);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function upload(_x2) {
        return _ref7.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: 'client',
    get: function get() {
      return this.api.client(__WEBPACK_IMPORTED_MODULE_14_misc_env__["a" /* default */].DOCUMENTS_API);
    }
  }]);

  return DocumentsAPI;
}(APIClient);

function _data(response) {
  return response.data;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_PaymentMethods__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ContentLoading__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ContentLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_ContentLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ContentError__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ContentError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_ContentError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_sass__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_sass__);






var _dec, _class;













var BillingScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_decorators_intercomUpdate__["a" /* default */])({ screen: 'Billing' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BillingScreen, _React$Component);

  function BillingScreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BillingScreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BillingScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(BillingScreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BillingScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.billingScreenStore.activate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$rootStore = this.props.rootStore,
          billingStore = _props$rootStore.billingStore,
          billingScreenStore = _props$rootStore.billingScreenStore;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'billing-screen' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet___default.a, { title: 'Billing' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_components_Header__["b" /* HeaderTitle */],
            null,
            'Billing'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container has-spacing-top has-spacing-bottom' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column is-8 is-offset-2' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'has-text-centered' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'box-title' },
                  'Payment methods'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'box-description' },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'p',
                    null,
                    'Your current card will be used to bill you for the balance of your quote once your Tax Pro marks your job complete. The service fee is billed when you submit a job, but if you need to use a different card for the remaining portion of your quote, you can do that here.'
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'p',
                    null,
                    'Please note that at least one card must be on file at all times.'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column is-8 is-offset-2' },
              billingScreenStore.fetchCards.match({
                pending: function pending() {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_ContentLoading___default.a, null);
                },
                rejected: function rejected(err) {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ContentError___default.a, { error: err });
                },
                resolved: function resolved() {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_components_ShadowBox___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_PaymentMethods__["a" /* default */], {
                      loading: billingScreenStore.fetchCards.pending,
                      cards: billingStore.cards,
                      busy: billingStore.busy,
                      onAddClick: function onAddClick() {
                        return billingStore.showAddCardCheckout();
                      },
                      onDeleteCardClick: function onDeleteCardClick(card) {
                        return billingStore.deletePaymentMethod(card);
                      },
                      onCardClick: function onCardClick(card) {
                        return billingStore.changeDefaultMethod(card);
                      }
                    })
                  );
                }
              })
            )
          )
        )
      );
    }
  }]);

  return BillingScreen;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponsScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_FlexCenter__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_UserCoupon__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ErrorLabel__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ErrorLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_ErrorLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_sass__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_sass__);






var _dec, _class;














var CouponsScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_decorators_intercomUpdate__["a" /* default */])({ screen: 'Coupons' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CouponsScreen, _React$Component);

  function CouponsScreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CouponsScreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CouponsScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CouponsScreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CouponsScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.couponsScreenStore.activate();
    }
  }, {
    key: 'renderCoupons',
    value: function renderCoupons(coupons) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'coupons-list' },
        coupons.map(function (userCoupon) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_UserCoupon__["a" /* default */], { key: userCoupon.id, userCoupon: userCoupon });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.rootStore.couponsScreenStore;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'coupons-screen' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a, { title: 'Coupons' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_components_Header__["b" /* HeaderTitle */],
            null,
            'Coupons'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'has-vspacing' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'div',
              { className: 'columns' },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                { className: 'column is-8 is-offset-2' },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  'div',
                  { className: 'content' },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'p',
                    null,
                    'This is your coupon stash. Coupons go towards your next purchase.'
                  ),
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'p',
                    null,
                    'If you have a coupon, you may apply it here or at checkout.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_components_Form__["Form"],
                  { onSubmit: function onSubmit() {
                      return store.applyCoupon();
                    } },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'p',
                    { className: 'control has-addons' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
                      type: 'text',
                      disabled: store.processing,
                      className: 'input coupon-field',
                      placeholder: 'Enter your coupon code here',
                      value: store.couponCode,
                      onChange: function onChange(e) {
                        return store.setCouponCode(e.target.value);
                      }
                    }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('button is-info', store.processing && 'is-loading'), disabled: store.processing },
                      'Apply'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_14_components_ErrorLabel___default.a,
                    null,
                    store.errorMessage
                  )
                ),
                store.fetching ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12_components_FlexCenter__["a" /* default */],
                  { className: 'has-spacing-top' },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_ProgressSpinner___default.a, { blue: true })
                ) : this.renderCoupons(store.coupons)
              )
            )
          )
        )
      );
    }
  }]);

  return CouponsScreen;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentsScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_PaddedBlock__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_FlexCenter__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_FileButton__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_FileButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_FileButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Document__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Header__ = __webpack_require__(80);






var _dec, _class;













var DocumentsScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_decorators_intercomUpdate__["a" /* default */])({ screen: 'Documents' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DocumentsScreen, _React$Component);

  function DocumentsScreen() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DocumentsScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DocumentsScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DocumentsScreen)).call.apply(_ref, [this].concat(args))), _this), _this.renderLoader = function () {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components_FlexCenter__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_ProgressSpinner___default.a, { blue: true })
      );
    }, _this.renderNoDocuments = function () {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_components_PaddedBlock__["a" /* default */],
        { className: 'no-documents has-text-centered' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: __webpack_require__(479), alt: 'No Documents' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'content has-vspacing' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'p',
            null,
            'No documents have been uploaded yet.'
          )
        )
      );
    }, _this.renderDocuments = function (store) {
      return store.documents.map(function (document) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'has-spacing-bottom', key: document.cid },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Document__["a" /* default */], {
            onEditClick: function onEditClick() {
              return store.rootStore.documentStore.editDocument(document);
            },
            document: document,
            canChangeCategory: true
          })
        );
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumentsScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.documentsScreenStore.activate();
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.rootStore.documentsScreenStore;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'documents-screen' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a, { title: 'Documents' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_components_Header__["b" /* HeaderTitle */],
            null,
            'Documents'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'has-vspacing' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              'div',
              { className: 'columns' },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                { className: 'column is-6 is-offset-3' },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  'div',
                  { className: 'has-text-centered has-spacing-bottom' },
                  store.loading === false && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_components_FileButton___default.a,
                    { onChange: function onChange(files) {
                        return store.rootStore.documentStore.stageFiles('PERSONAL', files);
                      } },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      'a',
                      { className: 'button is-medium is-document-action' },
                      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'span',
                        { className: 'icon' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Icon___default.a, { material: true, name: 'cloud upload' })
                      ),
                      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'span',
                        null,
                        'Upload Document'
                      )
                    )
                  )
                ),
                store.loading ? this.renderLoader() : store.documents.length ? this.renderDocuments(store) : this.renderNoDocuments()
              )
            )
          )
        )
      );
    }
  }]);

  return DocumentsScreen;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedAccountsScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LinkedAccountsManager__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_decorators_intercomUpdate__ = __webpack_require__(69);






var _dec, _class;








var LinkedAccountsScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_decorators_intercomUpdate__["a" /* default */])({ screen: 'Linked Accounts' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LinkedAccountsScreen, _React$Component);

  function LinkedAccountsScreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LinkedAccountsScreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LinkedAccountsScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LinkedAccountsScreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LinkedAccountsScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.linkedAccountsManager.loadAccounts();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'linked-accounts-screen' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a, { title: 'Linked Accounts' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_components_Header__["b" /* HeaderTitle */],
            null,
            'Linked Accounts'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'has-vspacing' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_LinkedAccountsManager__["a" /* default */], {
            manager: this.props.rootStore.linkedAccountsManager
          })
        )
      );
    }
  }]);

  return LinkedAccountsScreen;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_LandingPage__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_trackUrlConversion__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_sass__);






var _class, _temp2;








var LoginScreen = (_temp2 = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LoginScreen, _React$Component);

  function LoginScreen() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoginScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LoginScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LoginScreen)).call.apply(_ref, [this].concat(args))), _this), _this.login = function () {
      return _this.props.rootStore.authStore.login().then(_this.afterAuthenticate);
    }, _this.signup = function () {
      return _this.props.rootStore.authStore.signup({ hideLogin: true }).then(_this.afterAuthenticate).then(__WEBPACK_IMPORTED_MODULE_8_utils_trackUrlConversion__["a" /* default */]);
    }, _this.afterAuthenticate = function (success) {
      if (!success) {
        return;
      }

      var location = _this.props.location;

      if (location.state && location.state.nextPathname) {
        _this.context.router.replace(location.state.nextPathname);
      } else {
        _this.context.router.replace('/');
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LoginScreen, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_LandingPage__["a" /* default */], {
        onSignupClick: this.signup,
        onLoginClick: this.login
      });
    }
  }]);

  return LoginScreen;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
}, _temp2);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ProfileEditor__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_decorators_intercomUpdate__ = __webpack_require__(69);






var _dec, _class;








var ProfileScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_decorators_intercomUpdate__["a" /* default */])({ screen: 'Profile' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProfileScreen, _React$Component);

  function ProfileScreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProfileScreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProfileScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProfileScreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ProfileScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.profileEditorStore.activate();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'profile-screen' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a, { title: 'Profile' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_components_Header__["b" /* HeaderTitle */],
            null,
            'Your Profile'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container has-spacing-top' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column is-8 is-offset-2' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_ProfileEditor__["a" /* default */], { profileEditorStore: this.props.rootStore.profileEditorStore })
            )
          )
        )
      );
    }
  }]);

  return ProfileScreen;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc2NyZWVucy9Qcm9maWxlL2luZGV4LmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIkhlbG1ldCIsIm9ic2VydmVyIiwiSGVhZGVyU2luayIsIkhlYWRlclRpdGxlIiwiUHJvZmlsZUVkaXRvciIsImludGVyY29tVXBkYXRlIiwiUHJvZmlsZVNjcmVlbiIsInNjcmVlbiIsInByb3BzIiwicm9vdFN0b3JlIiwicHJvZmlsZUVkaXRvclN0b3JlIiwiYWN0aXZhdGUiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUEsT0FBT0EsS0FBUCxNQUFrQixPQUFsQjtBQUNBLE9BQU9DLE1BQVAsTUFBbUIsY0FBbkI7QUFDQSxTQUFTQyxRQUFULFFBQXlCLFlBQXpCO0FBQ0EsU0FBU0MsVUFBVCxFQUFxQkMsV0FBckIsUUFBd0MsbUJBQXhDO0FBQ0EsT0FBT0MsYUFBUCxNQUEwQiwwQkFBMUI7QUFDQSxPQUFPQyxjQUFQLE1BQTJCLDJCQUEzQjs7SUFJcUJDLGEsV0FGcEJELGVBQWUsRUFBRUUsUUFBUSxTQUFWLEVBQWYsQyxnQkFDQU4sUTs7Ozs7Ozs7Ozs7eUNBRXVCO0FBQ3BCLFdBQUtPLEtBQUwsQ0FBV0MsU0FBWCxDQUFxQkMsa0JBQXJCLENBQXdDQyxRQUF4QztBQUNEOzs7NkJBRVM7QUFDUixhQUNFO0FBQUE7QUFBQSxVQUFLLFdBQVUsZ0JBQWY7QUFDRSw0QkFBQyxNQUFELElBQVEsT0FBTSxTQUFkLEdBREY7QUFFRTtBQUFDLG9CQUFEO0FBQUEsWUFBWSxXQUFaO0FBQ0U7QUFBQyx1QkFBRDtBQUFBO0FBQUE7QUFBQTtBQURGLFNBRkY7QUFRRTtBQUFBO0FBQUEsWUFBSyxXQUFVLDJCQUFmO0FBQ0U7QUFBQTtBQUFBLGNBQUssV0FBVSxTQUFmO0FBQ0U7QUFBQTtBQUFBLGdCQUFLLFdBQVUseUJBQWY7QUFDRSxrQ0FBQyxhQUFELElBQWUsb0JBQW9CLEtBQUtILEtBQUwsQ0FBV0MsU0FBWCxDQUFxQkMsa0JBQXhEO0FBREY7QUFERjtBQURGO0FBUkYsT0FERjtBQWtCRDs7OztFQXhCd0NYLE1BQU1hLFM7U0FBNUJOLGEiLCJmaWxlIjoiaW5kZXguanN4Iiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IEhlbG1ldCBmcm9tICdyZWFjdC1oZWxtZXQnXG5pbXBvcnQgeyBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnXG5pbXBvcnQgeyBIZWFkZXJTaW5rLCBIZWFkZXJUaXRsZSB9IGZyb20gJ2NvbXBvbmVudHMvSGVhZGVyJ1xuaW1wb3J0IFByb2ZpbGVFZGl0b3IgZnJvbSAnY29tcG9uZW50cy9Qcm9maWxlRWRpdG9yJ1xuaW1wb3J0IGludGVyY29tVXBkYXRlIGZyb20gJ2RlY29yYXRvcnMvaW50ZXJjb21VcGRhdGUnXG5cbkBpbnRlcmNvbVVwZGF0ZSh7IHNjcmVlbjogJ1Byb2ZpbGUnIH0pXG5Ab2JzZXJ2ZXJcbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFByb2ZpbGVTY3JlZW4gZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICBjb21wb25lbnRXaWxsTW91bnQgKCkge1xuICAgIHRoaXMucHJvcHMucm9vdFN0b3JlLnByb2ZpbGVFZGl0b3JTdG9yZS5hY3RpdmF0ZSgpXG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cInByb2ZpbGUtc2NyZWVuXCI+XG4gICAgICAgIDxIZWxtZXQgdGl0bGU9XCJQcm9maWxlXCIgLz5cbiAgICAgICAgPEhlYWRlclNpbmsgc21hbGw+XG4gICAgICAgICAgPEhlYWRlclRpdGxlPlxuICAgICAgICAgICAgWW91ciBQcm9maWxlXG4gICAgICAgICAgPC9IZWFkZXJUaXRsZT5cbiAgICAgICAgPC9IZWFkZXJTaW5rPlxuXG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY29udGFpbmVyIGhhcy1zcGFjaW5nLXRvcFwiPlxuICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY29sdW1uc1wiPlxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2x1bW4gaXMtOCBpcy1vZmZzZXQtMlwiPlxuICAgICAgICAgICAgICA8UHJvZmlsZUVkaXRvciBwcm9maWxlRWRpdG9yU3RvcmU9e3RoaXMucHJvcHMucm9vdFN0b3JlLnByb2ZpbGVFZGl0b3JTdG9yZX0gLz5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIClcbiAgfVxufVxuIl19

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ListItem__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_sass__);






var Amendments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function Amendments(_ref) {
  var amendments = _ref.amendments;

  if (amendments.length === 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'no-amendments' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-amendments__icon' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(1200) })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-amendments__title' },
        'Amendments'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-amendments__description' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'If you would like to request additional services, ask your Pro or contact support and we will hook you up!'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'For example...'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'Estimated payments'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'ITIN application'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'Incorporation'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            'Additional bookkeeping'
          )
        )
      )
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'amendments' },
    amendments.map(function (a) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Amendment, { amendment: a, key: a.id });
    })
  );
});

/* harmony default export */ __webpack_exports__["a"] = (Amendments);

var Amendment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function Amendment(_ref2) {
  var amendment = _ref2.amendment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_components_ListItem__["ListItem"],
    { className: 'amendment', border: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_ListItem__["ListItemSegment"],
      { pad: true, stretch: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'amendment__description' },
        amendment.description
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'amendment__date' },
        amendment.dateCreated.format('L LT')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_ListItem__["ListItemSegment"],
      { pad: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'amendment__price' },
        __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default()(amendment.customerAmount)
      )
    )
  );
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_JobEvent__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_sass__);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (_ref) {
  var events = _ref.events;

  if (events.length === 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'no-events' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-events__title' },
        'Events'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-events__description' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'The fact that you are seeing this message means your job was created prior the Event system.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Don\'t worry, this isn\'t a problem!'
        )
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'job-events' },
    events.map(function (e) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_JobEvent__["a" /* default */], { key: e.id, event: e });
    })
  );
}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_prefix__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_utils_prefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);







var infoLineModifiers = __WEBPACK_IMPORTED_MODULE_4_utils_prefix___default()('info-line--');

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function JobInfo(_ref) {
  var job = _ref.job;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'job-info' },
    job.years && job.years.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InfoLine,
      { title: 'Years' },
      job.years.join(', ')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InfoLine,
      { title: 'States' },
      job.states.join(', ')
    ),
    job.amendedAmount > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InfoLine,
      { title: 'Amended' },
      __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default()(job.amendedAmount)
    ),
    job.couponAmount > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InfoLine,
      { title: 'Coupon Discount', purple: true },
      '-',
      __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default()(job.couponAmount)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InfoLine,
      { title: 'Total' },
      __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default()(job.total)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InfoLine,
      { title: 'Paid so far' },
      __WEBPACK_IMPORTED_MODULE_3_utils_formatCurrency___default()(job.paidAmount)
    )
  );
}));

var InfoLine = function InfoLine(_ref2) {
  var title = _ref2.title,
      children = _ref2.children,
      purple = _ref2.purple;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('info-line', infoLineModifiers({ purple: purple })) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'info-line__title' },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'info-line__text' },
      children
    )
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_patternMatchUtil__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_patternMatchUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_utils_patternMatchUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MessageComposer__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MessageComposer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_MessageComposer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Timeline__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_FileButton__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_FileButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_FileButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_containers_ConversationContainer__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_containers_ConversationContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_containers_ConversationContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Avatar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_PaddedBlock__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_MiniTabs__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Document__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__JobInfo__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Amendments__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Events__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_assets_img_avatar_placeholder_png__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_assets_img_avatar_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_assets_img_avatar_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_sass__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__styles_sass__);







var _dec, _class;




























var ProjectDetails = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_decorators_intercomUpdate__["a" /* default */])({ screen: 'Project Details' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProjectDetails, _React$Component);

  function ProjectDetails() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ProjectDetails);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectDetails.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ProjectDetails)).apply(this, arguments));

    _this.store = _this.props.rootStore.projectDetailsStore;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ProjectDetails, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var id = this.props.params.id;
      this.store.activate(id);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.deactivate();
    }
  }, {
    key: 'renderLoader',
    value: function renderLoader() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexContainer"],
        {
          alignItems: 'center',
          justifyContent: 'center',
          className: 'is-h100'
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_ProgressSpinner___default.a, { blue: true })
        )
      );
    }
  }, {
    key: 'renderMilestones',
    value: function renderMilestones() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_components_Timeline__["Timeline"],
        null,
        _generateTimeline(this.store.project.timeline)
      );
    }
  }, {
    key: 'renderConversation',
    value: function renderConversation() {
      var _this2 = this;

      return this.store.messages.length === 0 ? this.renderConversationPlaceholder() : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_containers_ConversationContainer___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        messages: this.store.messages,
        unreadMessagesCount: this.store.unreadMessagesCount,
        otherName: 'Pro',
        onMarkAsRead: function onMarkAsRead(message) {
          return _this2.props.rootStore.messageStore.markAsRead(message);
        },
        onDocumentClick: function onDocumentClick(message) {
          return _this2.props.rootStore.documentStore.download(message.document);
        },
        me: this.props.rootStore.authStore.user
      }, this.store.conversation.hasMoreMessages && {
        isLoadingMore: this.store.conversation.loadingMore,
        onLoadMore: function onLoadMore() {
          return _this2.props.rootStore.messageStore.loadMore(_this2.store.project.conversationId);
        }
      }));
    }
  }, {
    key: 'renderConversationPlaceholder',
    value: function renderConversationPlaceholder() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          className: 'conversation-placeholder has-text-centered is-h100'
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_23_components_PaddedBlock__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_29_assets_img_avatar_placeholder_png___default.a })
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'h3',
          { className: 'title is-3 is-semibold' },
          'Hello!'
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'content has-hspacing' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'p',
            null,
            'A Pro will be with you shortly. While you wait, we suggest you upload whatever documents your Pro might need if you haven\'t done so already.'
          )
        )
      );
    }
  }, {
    key: 'renderComposer',
    value: function renderComposer() {
      if (this.store.project.completed) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_MessageComposer__["MessageComposer"], {
        value: this.store.composerText,
        onChange: this.store.changeComposerText,
        onSend: this.store.sendMessage,
        disabled: this.store.loadingMessages
      });
    }
  }, {
    key: 'renderNoDocuments',
    value: function renderNoDocuments() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_23_components_PaddedBlock__["a" /* default */],
        { className: 'no-documents has-text-centered' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: __webpack_require__(479), alt: 'No Documents' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'content has-vspacing' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'p',
            null,
            'No documents have been uploaded yet.'
          )
        )
      );
    }
  }, {
    key: 'renderDocuments',
    value: function renderDocuments() {
      var _this3 = this;

      var documents = this.store.project.documents;
      if (this.props.rootStore.documentStore.loading) {
        return this.renderLoader();
      }

      if (documents.length === 0) {
        return this.renderNoDocuments();
      }

      return this.store.project.documents.map(function (d) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: 'has-spacing-bottom', key: d.cid },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Document__["a" /* default */], { canChangeCategory: true, document: d, onEditClick: function onEditClick() {
              return _this3.store.editDocument(d);
            } })
        );
      });
    }
  }, {
    key: 'renderDetails',
    value: function renderDetails() {
      var _this4 = this;

      if (!this.store.project) {
        return null;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils_patternMatchUtil__["match"])(this.store.detailsTab, {
        INFO: function INFO() {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__JobInfo__["a" /* default */], { job: _this4.store.project });
        },
        AMENDMENTS: function AMENDMENTS() {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Amendments__["a" /* default */], { amendments: _this4.store.project.amendments });
        },
        EVENTS: function EVENTS() {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Events__["a" /* default */], { events: _this4.store.project.events });
        }
      });
    }
  }, {
    key: 'renderColumns',
    value: function renderColumns() {
      var _this5 = this;

      var project = this.store.project;
      var hasProvider = !!project.provider;

      var documentsColumn = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexContainer"],
        { alignItems: 'flex-start', direction: 'column', className: 'column documents-column is-narrow' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'documents-column-header is-column-header is-w100' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            SectionTitle,
            null,
            'Documents'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'documents-container is-scrollable is-w100', stretch: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            { className: 'documents-actions' },
            !this.props.rootStore.documentStore.loading && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16_components_FileButton___default.a,
              { onChange: function onChange(files) {
                  return _this5.store.stageFiles(files);
                } },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'a',
                { className: 'button is-medium is-document-action' },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  'span',
                  { className: 'icon' },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Icon___default.a, { material: true, name: 'cloud upload' })
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  'span',
                  null,
                  'Upload Document'
                )
              )
            )
          ),
          this.renderDocuments()
        )
      );

      var messagesColumn = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexContainer"],
        { alignItems: 'flex-start', direction: 'column', className: 'column messages-column' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'is-column-header is-w100' },
          !hasProvider && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            SectionTitle,
            null,
            'Messages'
          ),
          hasProvider && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexContainer"],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Avatar___default.a, { size: 28, url: project.provider.avatar, fallback: project.provider.avatarFallback })
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                SectionTitle,
                null,
                '\xA0',
                project.provider.displayName
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'is-scrollable is-w100 is-h100 messages-container', stretch: true },
          this.store.loadingMessages ? this.renderLoader() : this.renderConversation()
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'composer-container is-w100' },
          !this.store.loadingMessages && this.store.project.provider && this.renderComposer()
        )
      );

      var tab = function tab(tabName) {
        return {
          active: _this5.store.detailsTab === tabName,
          onClick: function onClick() {
            return _this5.store.changeDetailsTab(tabName);
          }
        };
      };
      var detailsColumn = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexContainer"],
        { alignItems: 'flex-start', direction: 'column', className: 'details-column column is-narrow' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'details-column-header is-column-header is-w100' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            SectionTitle,
            null,
            'Details'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'is-w100' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24_components_MiniTabs__["a" /* MiniTabs */],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_24_components_MiniTabs__["b" /* MiniTab */],
              tab('INFO'),
              'Info'
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_24_components_MiniTabs__["b" /* MiniTab */],
              tab('AMENDMENTS'),
              'Amendments'
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_24_components_MiniTabs__["b" /* MiniTab */],
              tab('EVENTS'),
              'Events'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_components_Flex__["FlexItem"],
          { className: 'details-container is-scrollable is-w100', stretch: true },
          this.renderDetails()
        )
      );

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('columns is-gapless details-columns') },
        documentsColumn,
        messagesColumn,
        detailsColumn
      );
    }
  }, {
    key: 'renderProjectDetails',
    value: function renderProjectDetails() {
      var project = this.store.project;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'project-details-screen animated fadeIn' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet___default.a, { title: project.name }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_components_Header__["b" /* HeaderTitle */],
            null,
            project.name
          )
        ),
        this.renderColumns()
      );
    }
  }, {
    key: 'renderNotFound',
    value: function renderNotFound() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'project-not-found has-spacing-top has-text-centered content' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'h1',
          { className: 'title is-1' },
          'Oh, bugger!'
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'p',
          null,
          'We couldn\'t find that project.'
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17_components_Link___default.a,
            { to: __WEBPACK_IMPORTED_MODULE_9_misc_links__["a" /* default */].projects() },
            'Go back to Projects overview'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.store.notFound) {
        return this.renderNotFound();
      }

      return !this.store.project ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { style: { height: '100vh' } },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet___default.a, { title: 'Taxfyle' }),
        this.renderLoader()
      ) : this.renderProjectDetails();
    }
  }]);

  return ProjectDetails;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component)) || _class) || _class);



var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
    'h1',
    { className: 'title is-4 is-semibold' },
    children
  );
};

var _generateTimeline = function _generateTimeline(timeline) {
  return timeline.map(function (milestone) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15_components_Timeline__["TimelineEvent"],
      {
        key: milestone.text,
        date: milestone.date,
        completed: true
      },
      milestone.text
    );
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StepTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var StepTitle = function StepTitle(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h3",
    { className: "step-title" },
    children
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc2NyZWVucy9Qcm9qZWN0V2l6YXJkL1N0ZXBJbmZvLmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIlN0ZXBUaXRsZSIsImNoaWxkcmVuIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCOztBQUVBLE9BQU8sSUFBTUMsWUFBWSxTQUFaQSxTQUFZO0FBQUEsTUFBR0MsUUFBSCxRQUFHQSxRQUFIO0FBQUEsU0FDdkI7QUFBQTtBQUFBLE1BQUksV0FBVSxZQUFkO0FBQTRCQTtBQUE1QixHQUR1QjtBQUFBLENBQWxCIiwiZmlsZSI6IlN0ZXBJbmZvLmpzeCIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuZXhwb3J0IGNvbnN0IFN0ZXBUaXRsZSA9ICh7IGNoaWxkcmVuIH0pID0+IChcbiAgPGgzIGNsYXNzTmFtZT1cInN0ZXAtdGl0bGVcIj57Y2hpbGRyZW59PC9oMz5cbilcbiJdfQ==

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeeBreakdownState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_TermsDialog_TermsDialogState__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_stripe__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_sample__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_errorUtil__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_memoizee__);









var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}









var testimonials = [{ quote: 'Kurt F. was great to work with and we will be using Taxfyle again for our 2017 taxes.', username: 'Matthew S' }, { quote: 'Fantastic service and he saved me $1000! Thanks so much. ', username: 'Mayuka K' }, { quote: 'The experience was quick and easy!  I\'ll do it again next year! John was great!', username: 'Terri M' }, { quote: 'Freddie was fantastic! He was extremely responsive. He thoroughly answered all of my many questions. This process was made so much easier. Thank you Freddie and the taxfyle team for putting my mind at ease! I no longer have to worry if I\'m doing my taxes correctly. What an amazing app.', username: 'Haley A' }, { quote: 'Gilbert was super helpful and did a great job of explaining everything clearly, thank you!', username: 'Jennifer A' }, { quote: 'To the point advice, and directions. Very responsive and courteous. Definitely would recommend him.', username: 'Ruben A' }, { quote: 'Joe knows what he\'s doing, very efficient service and overall experience! I will be coming back for future returns.', username: 'Jason T' }, { quote: 'Thank you for the great turnaround time!', username: 'Vastal P' }, { quote: 'This was my first time filing for a business.  Stewart was excellent with knowledge and wonderful with patience as he helped guide me through.  Thank you very much Taxfyle.', username: 'Gordon R' }];

var FeeBreakdownState = (_dec = __WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"].resolved, _dec2 = __WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"].resolved, _dec3 = __WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"].resolved, _dec4 = __WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"].resolved, (_class = function () {
  function FeeBreakdownState(_ref) {
    var wizard = _ref.wizard;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, FeeBreakdownState);

    this.stepId = 'FeeBreakdown';
    this.title = 'Checkout';
    this.trackingId = 'Onboarding - Fee Breakdown';

    _initDefineProp(this, 'view', _descriptor, this);

    _initDefineProp(this, 'couponCode', _descriptor2, this);

    _initDefineProp(this, 'showingCouponField', _descriptor3, this);

    _initDefineProp(this, 'hasAcceptedTerms', _descriptor4, this);

    _initDefineProp(this, 'discountAmount', _descriptor5, this);

    _initDefineProp(this, 'couponsUsed', _descriptor6, this);

    _initDefineProp(this, 'currentTestimonial', _descriptor7, this);

    _initDefineProp(this, 'subtotal', _descriptor8, this);

    _initDefineProp(this, 'federalPrice', _descriptor9, this);

    _initDefineProp(this, 'statePrice', _descriptor10, this);

    _initDefineProp(this, 'adminFee', _descriptor11, this);

    _initDefineProp(this, 'orderTotal', _descriptor12, this);

    _initDefineProp(this, 'fees', _descriptor13, this);

    this.wizard = wizard;
    this.termsDialog = new __WEBPACK_IMPORTED_MODULE_9_components_TermsDialog_TermsDialogState__["a" /* default */]();
    this.couponStore = wizard.rootStore.couponStore;
    this.projectStore = wizard.rootStore.projectStore;
    this.fetchPaymentMethods = this.fetchPaymentMethods.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_14_memoizee___default()(fn, { promise: true, length: 0 });
    });
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(FeeBreakdownState, [{
    key: 'setView',
    value: function setView(view) {
      this.view = view;
    }
  }, {
    key: 'showFeeBreakdown',
    value: function showFeeBreakdown() {
      this.setView('breakdown');
    }
  }, {
    key: 'showPaymentMethods',
    value: function showPaymentMethods() {
      this.setView('payment');
    }
  }, {
    key: 'toggleCouponField',
    value: function toggleCouponField() {
      this.showingCouponField = !this.showingCouponField;
    }
  }, {
    key: 'setCouponCode',
    value: function setCouponCode(code) {
      this.couponCode = code;
    }
  }, {
    key: 'activate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.discountAmount = 0;
                this.subtotal = 0;
                this.federalPrice = 0;
                this.statePrice = 0;
                this.adminFee = 0;
                this.orderTotal = 0;
                this.fees = [];
                this.fetchPaymentMethods();
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.wizard.syncJob(), this.couponStore.getCoupons()]);

              case 10:
                this.destroyPriceReaction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["reaction"])(function () {
                  return [_this.stateNames, _this.years, _this.couponStore.coupons.map(function (x) {
                    return x;
                  }), _this.legend];
                }, this.calculatePrice.bind(this), true);

                this.nextTestimonial();
                this.testimonialTimer = setInterval(this.nextTestimonial.bind(this), 7000);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate() {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'nextTestimonial',
    value: function nextTestimonial() {
      this.currentTestimonial = __WEBPACK_IMPORTED_MODULE_12_lodash_sample___default()(testimonials);
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      if (this.destroyPriceReaction) {
        this.destroyPriceReaction();
        delete this.destroyPriceReaction;
      }

      if (this.testimonialTimer) {
        clearInterval(this.testimonialTimer);
      }

      this.closeCheckout();
    }
  }, {
    key: 'applyCoupon',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.couponCode) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return this.couponStore.addCoupon(this.couponCode);

              case 4:
                result = _context2.sent;

                if (result) {
                  this.setCouponCode('');
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function applyCoupon() {
        return _ref3.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: 'calculatePrice',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(price) {
        var _this2 = this;

        var result, allCoupons;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.projectStore.calculatePrice(this.wizard.job.id);

              case 2:
                result = _context3.sent;

                if (result) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                allCoupons = this.couponStore.coupons;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["runInAction"])(function () {
                  _this2.subtotal = result.gross_amount;
                  _this2.discountAmount = result.coupon_amount;
                  _this2.federalPrice = result.federal_amount;
                  _this2.statePrice = result.state_amount;
                  _this2.adminFee = result.admin_fee_amount;
                  _this2.fees = result.fees;
                  _this2.orderTotal = result.total;
                  _this2.couponsUsed = result.coupon_codes.map(function (x) {
                    return allCoupons.find(function (y) {
                      return y.coupon.id === x;
                    });
                  }).filter(function (x) {
                    return x;
                  }).filter(function (x) {
                    return !x.coupon.expired;
                  }).map(function (x) {
                    return x.coupon.friendlyName || x.coupon.id;
                  });
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function calculatePrice(_x) {
        return _ref4.apply(this, arguments);
      }

      return calculatePrice;
    }()
  }, {
    key: 'pay',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this3 = this;

        var accepted, billingStore, handler;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.termsDialog.show();

              case 2:
                accepted = _context4.sent;

                if (accepted) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                _context4.next = 7;
                return this.fetchPaymentMethods();

              case 7:
                billingStore = this.wizard.rootStore.billingStore;

                if (!billingStore.hasAnyPaymentMethods) {
                  _context4.next = 11;
                  break;
                }

                this.showPaymentMethods();
                return _context4.abrupt('return');

              case 11:
                handler = this.checkoutHandler = __WEBPACK_IMPORTED_MODULE_10_utils_stripe__["a" /* checkout */]({
                  token: function token(_token) {
                    return _this3.saveCard(_token);
                  }
                });


                handler.open({
                  currency: 'USD',
                  name: 'Taxfyle',
                  description: this.wizard.job.name,
                  email: this.wizard.rootStore.authStore.user.email,
                  amount: this.amountDueNow * 100
                });

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function pay() {
        return _ref5.apply(this, arguments);
      }

      return pay;
    }()
  }, {
    key: 'closeCheckout',
    value: function closeCheckout() {
      if (this.checkoutHandler) {
        this.checkoutHandler.close();
      }

      this.checkoutHandler = null;
    }
  }, {
    key: 'saveCard',
    value: function saveCard(token) {
      var _this4 = this;

      var billingStore = this.wizard.rootStore.billingStore;
      return billingStore.addCard(token).then(function (card) {
        return _this4.submitJob(card.id);
      });
    }
  }, {
    key: 'selectPaymentMethod',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(card) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.wizard.rootStore.billingStore.changeDefaultMethod(card);

              case 2:
                _context5.next = 4;
                return this.submitJob(card.id);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function selectPaymentMethod(_x2) {
        return _ref6.apply(this, arguments);
      }

      return selectPaymentMethod;
    }()
  }, {
    key: 'fetchPaymentMethods',
    value: function fetchPaymentMethods() {
      var billingStore = this.wizard.rootStore.billingStore;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([billingStore.fetchCards(), billingStore.fetchCustomerRecord()]);
    }
  }, {
    key: 'submitJob',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(source) {
        var user, job;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                user = this.wizard.rootStore.authStore.user;
                job = this.wizard.job;
                _context6.prev = 2;
                _context6.next = 5;
                return this.wizard.rootStore.api.charges.create({
                  amount: this.amountDueNow * 100,
                  currency: 'usd',
                  source: source,
                  description: 'Taxfyle Service Fee',
                  statement_descriptor: 'TAXFYLE',
                  metadata: {
                    job_id: this.wizard.job.id,
                    user_id: user.id,
                    email: user.email,
                    first_name: user.firstName,
                    last_name: user.lastName,
                    full_name: user.displayName,
                    job_status: job.status,
                    payment_method: 'Card',
                    platform_mode:  true ? 'LIVE' : 'TEST',
                    platform_version: "0.14.7",
                    platform: 'customer-portal',
                    coupon_amount: this.discountAmount,
                    coupons_used: this.couponsUsed.join(', '),
                    filing_years: this.years.join(', '),
                    work_states: this.stateNames.join(', ').substring(0, 500),
                    fees: this.adminFee,
                    state_total: this.statePrice,
                    federal_total: this.federalPrice,
                    subtotal: this.subtotal
                  }
                });

              case 5:
                this.wizard.rootStore.projectStore.fetchProject.delete(this.wizard.job.id);
                _context6.next = 8;
                return this.wizard.rootStore.projectStore.fetchProject(this.wizard.job.id);

              case 8:

                this.wizard.next();
                _context6.next = 15;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](2);

                this.wizard.rootStore.flashMessageStore.create({
                  message: 'An error occurred while submitting your job: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils_errorUtil__["b" /* extractMessageFromError */])(_context6.t0),
                  type: 'error'
                });
                throw _context6.t0;

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 11]]);
      }));

      function submitJob(_x3) {
        return _ref7.apply(this, arguments);
      }

      return submitJob;
    }()
  }, {
    key: 'hideBackButton',
    get: function get() {
      return this.submitJob.pending;
    }
  }, {
    key: 'years',
    get: function get() {
      return this.wizard.getStep('TaxYears').selectedYears.map(function (x) {
        return x.year;
      });
    }
  }, {
    key: 'stateNames',
    get: function get() {
      return this.wizard.getStep('TaxStates').selectedStates.map(function (x) {
        return x.name;
      });
    }
  }, {
    key: 'orderLines',
    get: function get() {
      if (!this.legend) {
        return [];
      }

      var federalPrice = this.federalPrice;
      var statesPrice = this.statePrice;
      return [{ product: 'Federal', price: federalPrice }, { product: 'State(s)', price: statesPrice }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.fees.map(function (x) {
        return { product: x.name, price: x.price };
      }))).filter(function (x) {
        return x !== false;
      });
    }
  }, {
    key: 'breakdownTitle',
    get: function get() {
      // const type = this.legend
      // const years = this.wizard.getStep('TaxYears').selectedYears.map(x => x.year)
      // return type.name
      var typeStep = this.wizard.getStep('ProjectType');
      if (!typeStep.legend) {
        return 'Job Order';
      }

      return 'Job Order - ' + typeStep.legend.name;
    }
  }, {
    key: 'orderLinesDisplay',
    get: function get() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.orderLines), [!!this.discountAmount && {
        dashed: true,
        product: 'Discount',
        price: this.discountAmount,
        isDiscount: true,
        bold: true
      }]).filter(function (x) {
        return x !== false;
      });
    }
  }, {
    key: 'amountDueNow',
    get: function get() {
      return this.adminFee;
    }
  }, {
    key: 'legend',
    get: function get() {
      return this.wizard.getStep('ProjectType').legend;
    }
  }, {
    key: 'answers',
    get: function get() {
      return this.wizard.getStep('Questions').answers.map(function (x) {
        return x;
      });
    }
  }, {
    key: 'shouldShowFreeExtensionsInfo',
    get: function get() {
      // Only show the info if they didn't already come here for free extensions.
      return !this.wizard.hereForFreeExtensions;
    }
  }]);

  return FeeBreakdownState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'view', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 'breakdown';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'couponCode', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'showingCouponField', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'hasAcceptedTerms', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'discountAmount', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'couponsUsed', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'currentTestimonial', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return testimonials[0];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'subtotal', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'federalPrice', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'statePrice', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'adminFee', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'orderTotal', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'fees', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'hideBackButton', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'hideBackButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'years', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'years'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'stateNames', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'stateNames'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'orderLines', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'orderLines'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'breakdownTitle', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'breakdownTitle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'orderLinesDisplay', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'orderLinesDisplay'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'amountDueNow', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'amountDueNow'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'legend', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'legend'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'answers', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'answers'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'shouldShowFreeExtensionsInfo', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'shouldShowFreeExtensionsInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setView', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleCouponField', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'toggleCouponField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCouponCode', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setCouponCode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'activate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'nextTestimonial', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'nextTestimonial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deactivate', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'deactivate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'applyCoupon', [_dec], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'applyCoupon'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'calculatePrice', [__WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'calculatePrice'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'pay', [__WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'pay'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveCard', [_dec2], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'saveCard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectPaymentMethod', [_dec3], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectPaymentMethod'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fetchPaymentMethods', [__WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchPaymentMethods'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'submitJob', [_dec4], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'submitJob'), _class.prototype)), _class));

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FeeBreakdownStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_TermsDialog__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_patternMatchUtil__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_patternMatchUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_utils_patternMatchUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Boxes__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_sass__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_sass__);






var _class;







// import Modal from 'components/Modal'
// import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog'




var FeeBreakdownStep = __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FeeBreakdownStep, _React$Component);

  function FeeBreakdownStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FeeBreakdownStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FeeBreakdownStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FeeBreakdownStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FeeBreakdownStep, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.step.closeCheckout();
    }
  }, {
    key: 'render',
    value: function render() {
      var step = this.props.step;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'fee-breakdown-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
                { className: 'description-row' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'content header-content' },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'h4',
                    { className: 'main-title' },
                    'Why Taxfyle?'
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'p',
                    { className: 'subtitle' },
                    'Get your taxes done by a CPA or IRS Enrolled Agent for',
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      'strong',
                      null,
                      ' 40% cheaper'
                    ),
                    ' than H&R Block'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
                { className: 'description-row' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(QuoteBox, step.currentTestimonial)
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
                { className: 'description-row' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Timeline, null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
                { className: 'breakdown-column' },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils_patternMatchUtil__["match"])(step.view, {
                  breakdown: function breakdown() {
                    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Boxes__["FeeBreakdown"], { step: step });
                  },
                  payment: function payment() {
                    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Boxes__["PaymentMethodPicker"], { step: step });
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'footnotes has-text-centered content has-spacing-top' },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'p',
                    null,
                    'Please note that we will charge the fees up front to verify your payment method. Once your taxes have been filed, the remaining amount is charged.'
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_TermsDialog__["a" /* default */], {
          state: step.termsDialog
        })
      );
    }
  }]);

  return FeeBreakdownStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;




var Timeline = function Timeline() {
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: 'timeline' },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'h4',
      { className: 'next-steps' },
      'Next Steps'
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'bullet-img review' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: __webpack_require__(1225) })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'desc' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'p',
            null,
            'Review your order'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'bullet blue' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'desc' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'p',
            null,
            'We\'ll pair you with a Tax Pro'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'bullet blue' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'desc' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'p',
            null,
            'Chat and upload your tax docs'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'bullet-img money' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: __webpack_require__(1224) })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'desc' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'p',
            null,
            'Sit back, relax and let your Pro do the work'
          )
        )
      )
    )
  );
};

var QuoteBox = function QuoteBox(_ref) {
  var quote = _ref.quote,
      username = _ref.username;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8_components_ShadowBox___default.a,
    { className: 'quote-box', level: 1 },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'blockquote',
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'span',
        null,
        'What our customers say'
      ),
      quote,
      ' - ',
      username
    )
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LinkAccountsStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_LinkedAccountsManager__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_sass__);






var _class;







var LinkAccountsStep = __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LinkAccountsStep, _React$Component);

  function LinkAccountsStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LinkAccountsStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LinkAccountsStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LinkAccountsStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LinkAccountsStep, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.step.wizard.rootStore.linkedAccountsManager.loadAccounts();
    }
  }, {
    key: 'render',
    value: function render() {
      var step = this.props.step;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'link-accounts-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_LinkedAccountsManager__["a" /* default */], {
          manager: step.wizard.rootStore.linkedAccountsManager
        })
      );
    }
  }]);

  return LinkAccountsStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectTypeState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_memoizee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_orderBy__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx_task__);









var _dec, _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var ProjectTypeState = (_dec = __WEBPACK_IMPORTED_MODULE_8_mobx__["observable"].ref, (_class = function () {
  function ProjectTypeState(_ref) {
    var wizard = _ref.wizard;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ProjectTypeState);

    this.stepId = 'ProjectType';
    this.title = 'Hi, how can we help you?';
    this.trackingId = 'Onboarding - Project Selection';

    _initDefineProp(this, 'legend', _descriptor, this);

    _initDefineProp(this, 'legends', _descriptor2, this);

    this.wizard = wizard;
    this.rootStore = wizard.rootStore;
    this.hideBackButton = true;
    this.activate = this.activate.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_9_memoizee___default()(fn, { promise: true, length: 0 });
    });
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ProjectTypeState, [{
    key: 'activate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var legends;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.api.legends.find().then(function (arr) {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(arr.map(function (l) {
                    return _this.rootStore.api.legends.get(l.id);
                  }));
                });

              case 2:
                legends = _context.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["runInAction"])(function () {
                  var mapped = __WEBPACK_IMPORTED_MODULE_10_lodash_orderBy___default()(legends.map(function (l) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                      additionalFees: [] }, l);
                  }), ['viewOrder']);
                  _this.legends.replace(mapped);
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate() {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'selectType',
    value: function selectType(type) {
      this.legend = typeof type === 'string' ? this.legends.find(function (x) {
        return x.id === type;
      }) : type;

      this.wizard.next();
    }
  }, {
    key: 'serializeToJob',
    value: function serializeToJob() {
      return {
        legend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["toJS"])(this.legend)
      };
    }
  }, {
    key: 'hydrate',
    value: function hydrate(job) {
      if (job.legend) {
        this.legend = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["toJS"])(job.legend);
      }
    }
  }]);

  return ProjectTypeState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'legend', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'legends', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'activate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectType', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectType'), _class.prototype)), _class));

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectTypeStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ContentLoading__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ContentLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_ContentLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ContentError__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ContentError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_ContentError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_sass__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_sass__);






var _class;










var ProjectTypeStep = __WEBPACK_IMPORTED_MODULE_8_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProjectTypeStep, _React$Component);

  function ProjectTypeStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProjectTypeStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectTypeStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProjectTypeStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ProjectTypeStep, [{
    key: 'render',
    value: function render() {
      var step = this.props.step;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'project-type-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column is-8 is-offset-2' },
              step.activate.match({
                pending: function pending() {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ContentLoading___default.a, { small: true });
                },
                rejected: function rejected(err) {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_ContentError___default.a, { error: err });
                },
                resolved: function resolved() {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    { className: 'columns project-types is-multiline' },
                    step.legends.map(function (legend) {
                      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProjectType, {
                        key: legend.id,
                        title: legend.name,
                        description: legend.description,
                        type: legend.id,
                        onSelect: function onSelect() {
                          return step.selectType(legend);
                        }
                      });
                    })
                  );
                }
              })
            )
          )
        )
      );
    }
  }]);

  return ProjectTypeStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;

// const ProjectType = ({ title, isBeta, description, type, onSelect }) => (
//   <div className="column is-full project-type animated fadeInUp is-faster is-staggered">
//     <ShadowBox className="inner" level={3} onClick={() => onSelect()}>
//       <div className={cx('type-header')}>
//         <div className="type-name">{title}</div>
//       </div>
//       <div className="type-description">
//         {description}
//       </div>
//     </ShadowBox>
//   </div>
// )


var ProjectType = function ProjectType(_ref) {
  var title = _ref.title,
      isBeta = _ref.isBeta,
      type = _ref.type,
      onSelect = _ref.onSelect;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: 'column is-full project-type animated fadeInUp is-faster is-staggered' },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_components_ShadowBox___default.a,
      { level: 3, className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('inner'), onClick: function onClick() {
          return onSelect();
        } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'project-type-info has-text-centered' },
        isBeta && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'span',
          { className: 'beta-label' },
          'BETA'
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'project-type-name' },
          title
        )
      )
    )
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionsState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_last__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_misc_analytics__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__taxfyle_rules_engine__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__taxfyle_rules_engine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__taxfyle_rules_engine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mobx_task__);









var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var QuestionsState = (_dec = __WEBPACK_IMPORTED_MODULE_8_mobx__["observable"].ref, (_class = function () {
  function QuestionsState(_ref) {
    var wizard = _ref.wizard;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, QuestionsState);

    this.stepId = 'Questions';
    this.trackingId = 'Onboarding - Swipable Questions';

    _initDefineProp(this, 'currentQuestionId', _descriptor, this);

    _initDefineProp(this, 'answers', _descriptor2, this);

    _initDefineProp(this, 'engine', _descriptor3, this);

    this.wizard = wizard;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(QuestionsState, [{
    key: 'initialize',
    value: function initialize() {
      var _this = this;

      this.destroyProjectTypeReaction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["reaction"])(function () {
        return _this.wizard.getStep('ProjectType').legend;
      }, function () {
        return _this.loadQuestions();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.destroyProjectTypeReaction && this.destroyProjectTypeReaction();
    }
  }, {
    key: 'resetAnswers',
    value: function resetAnswers() {
      this.answers.replace([]);
      this.setQuestion(this.questions[0]);
    }
  }, {
    key: 'breaker',
    value: function breaker(question) {
      switch (question.action) {
        case 'GO_TO_PERSONAL_RETURN':
          return this.wizard.getStep('ProjectType').selectType('PERSONAL_TAX_RETURN');
        case 'GO_TO_PROJECTS':
        default:
          return this.wizard.setStep(this.wizard.getStep('ProjectType'));
      }
    }
  }, {
    key: 'setQuestion',
    value: function setQuestion(question) {
      this.currentQuestionId = question.id;
      this.wizard.updateIntercom({
        last_question: question.question,
        last_question_id: question.id
      });
    }
  }, {
    key: 'giveAnswer',
    value: function giveAnswer(id, answer) {
      var _this2 = this;

      var existing = this.answers.find(function (x) {
        return x.id === id;
      });
      if (existing) {
        existing.answer = answer;
      } else {
        this.answers.push({ id: id, answer: answer });
      }

      this.wizard.syncJob();

      // For tracking..
      var legendId = this.wizard.getStep('ProjectType').legend.id;
      var type = legendId;
      if (legendId === 'PERSONAL_TAX_RETURN') {
        type = 'Personal';
      } else if (legendId === 'BUSINESS_TAX_RETURN') {
        type = 'Business';
      }

      __WEBPACK_IMPORTED_MODULE_10_misc_analytics__["a" /* default */].track('Onboarding Question', {
        Type: type,
        Question: id,
        Answer: answer
      });

      // This is actually legit use of setTimeout bro
      setTimeout(function () {
        _this2.wizard.next();
      }, 100);
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.currentQuestionIndex === this.questions.length - 1) {
        var unanswered = this.questions.filter(function (x) {
          return x.answer === undefined;
        });
        if (unanswered.length === 0) {
          return true;
        } else {
          this.setQuestion(unanswered[0]);
          return false;
        }
      }

      this.setQuestion(this.questions[this.currentQuestionIndex + 1]);
    }
  }, {
    key: 'back',
    value: function back(previousStep) {
      if (this.currentQuestionIndex === 0) {
        previousStep();
        return;
      }

      this.setQuestion(this.questions[this.currentQuestionIndex - 1]);
    }
  }, {
    key: 'activate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate() {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'loadQuestions',
    value: function loadQuestions() {
      var projectTypeStep = this.wizard.getStep('ProjectType');
      var selectedLegend = projectTypeStep.legend;
      if (!selectedLegend) {
        return;
      }
      this.legend = selectedLegend;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(selectedLegend, selectedLegend);
      this.engine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__taxfyle_rules_engine__["rulesEngine"])({
        stories: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(selectedLegend.stories))
      });

      this.resetAnswers();
    }
  }, {
    key: 'serializeToJob',
    value: function serializeToJob() {
      return {
        answers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx__["toJS"])(this.answers)
      };
    }
  }, {
    key: 'hydrate',
    value: function hydrate(job) {
      if (job.answers) {
        this.answers = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(job.answers));
      }

      if (this.questions.length > 0) {
        var question = this.questions.find(function (x) {
          return x.answer === undefined;
        }) || __WEBPACK_IMPORTED_MODULE_9_lodash_last___default()(this.questions);
        this.setQuestion(question);
      }
    }
  }, {
    key: 'questions',
    get: function get() {
      if (!this.engine) {
        return [];
      }

      return this.engine.questions(this.answers);
    }
  }, {
    key: 'title',
    get: function get() {
      return 'Tell us about it';
    }
  }, {
    key: 'nextEnabled',
    get: function get() {
      if (this.currentQuestion && this.currentQuestion.type === 'BREAKER') {
        // undefined = hide button
        return undefined;
      }

      return true;
    }
  }, {
    key: 'currentQuestionIndex',
    get: function get() {
      return this.questions.indexOf(this.currentQuestion);
    }
  }, {
    key: 'currentQuestion',
    get: function get() {
      var _this3 = this;

      return this.questions.find(function (x) {
        return x.id === _this3.currentQuestionId;
      });
    }
  }]);

  return QuestionsState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'currentQuestionId', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'answers', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'engine', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'questions', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'questions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'title', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'title'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'nextEnabled', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'nextEnabled'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'currentQuestionIndex', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'currentQuestionIndex'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'currentQuestion', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'currentQuestion'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetAnswers', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'resetAnswers'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'breaker', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'breaker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setQuestion', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setQuestion'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'giveAnswer', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'giveAnswer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'next', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'next'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'back', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'back'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_12_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'activate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadQuestions', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadQuestions'), _class.prototype)), _class));

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return QuestionsStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_motion__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CheckList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_CheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CheckButton__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CheckButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_CheckButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_sass__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_sass__);








var _class;












// Each question gets 33% of screen space,
// this is used to offset the transform
// based on what question we're at.
var OFFSET_AMOUNT = 100;

var QuestionsStep = __WEBPACK_IMPORTED_MODULE_13_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(QuestionsStep, _React$Component);

  function QuestionsStep() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, QuestionsStep);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuestionsStep.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(QuestionsStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(QuestionsStep, [{
    key: 'render',
    value: function render() {
      var step = this.props.step;
      var questions = step.questions,
          currentQuestionId = step.currentQuestionId;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'questions-step' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_motion__["Motion"],
          {
            defaultStyle: {
              x: step.currentQuestionIndex * -OFFSET_AMOUNT
            },
            style: {
              x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_motion__["spring"])(step.currentQuestionIndex * -OFFSET_AMOUNT, { stiffness: 170, damping: 19 })
            }
          },
          function (_ref) {
            var x = _ref.x;
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'div',
              { className: 'questions-container', style: { transform: 'translateX(' + x + '%)' } },
              questions.map(function (question) {
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Question, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  current: true,
                  question: question,
                  onAnswer: function onAnswer(answer) {
                    return step.wizard.isProcessing === false && step.giveAnswer(question.id, answer);
                  },
                  key: question.id,
                  onBreakerClick: function onBreakerClick() {
                    return step.breaker(question);
                  }
                }, question.id !== currentQuestionId && {
                  current: false
                }));
              })
            );
          }
        )
      );
    }
  }]);

  return QuestionsStep;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component)) || _class) || _class;




var Question = function Question(_ref2) {
  var question = _ref2.question,
      onAnswer = _ref2.onAnswer,
      current = _ref2.current,
      onBreakerClick = _ref2.onBreakerClick;

  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('question', current && 'question--active') },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'question__text' },
      question.question.trim() /* Remove newline at the end */
    ),
    question.description && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'question__description' },
      question.description
    ),
    question.type === 'BOOL' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'question__answers' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'question__answer-container' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_components_CheckButton___default.a,
          {
            checked: question.answer === true,
            onChange: function onChange() {
              return current && onAnswer(true);
            }
          },
          'Yes'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'question__answer-container' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_components_CheckButton___default.a,
          {
            checked: question.answer === false,
            onChange: function onChange() {
              return current && onAnswer(false);
            }
          },
          'No'
        )
      )
    ),
    question.type === 'SELECT' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexContainer"],
      { direction: 'column', className: 'has-spacing-top' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_components_CheckList__["CheckList"],
          null,
          question.options.map(function (option) {
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_components_CheckList__["CheckListItem"],
              {
                key: option.id,
                onChange: function onChange(checked) {
                  return checked && onAnswer(option.id);
                },
                checked: question.answer === option.id
              },
              option.text
            );
          })
        )
      )
    ),
    question.type === 'BREAKER' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexContainer"],
      { direction: 'column', className: 'has-spacing-top' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'button',
          {
            className: 'button is-awesome has-chevron-right',
            onClick: function onClick() {
              return onBreakerClick();
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__["match"])(question.action, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            GO_TO_PERSONAL_RETURN: 'Start Personal Return',
            GO_TO_PROJECTS: 'Finish'
          }, __WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__["match"].DEFAULT, 'Finish'))
        )
      )
    )
  );
};

Question = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx_react__["observer"])(Question);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaxStatesState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_memoizee__);








var _desc, _value, _class, _descriptor, _desc2, _value2, _class3, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





// No pun intended
var TaxStatesState = (_class = function () {
  function TaxStatesState(_ref) {
    var _this = this;

    var wizard = _ref.wizard;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, TaxStatesState);

    this.stepId = 'TaxStates';
    this.title = 'Select the states where you earn income';
    this.trackingId = 'Onboarding - State Selection';

    _initDefineProp(this, 'states', _descriptor, this);

    this.wizard = wizard;
    this.wizard.rootStore.authStore.onLogin(function () {
      return _this.fetchStates();
    });
    this.fetchStates = this.fetchStates.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_9_memoizee___default()(fn, { promise: true, length: 0 });
    });
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(TaxStatesState, [{
    key: 'fetchStates',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.wizard.rootStore.api.states.find();

              case 2:
                data = _context.sent;

                this.setStates(data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchStates() {
        return _ref2.apply(this, arguments);
      }

      return fetchStates;
    }()
  }, {
    key: 'setStates',
    value: function setStates(data) {
      this.states.replace(data.map(function (d) {
        return new State(d);
      }));
    }
  }, {
    key: 'activate',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchStates();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function activate() {
        return _ref3.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'serializeToJob',
    value: function serializeToJob() {
      return {
        coverage_states: this.selectedStates.map(function (x) {
          return x.name;
        })
      };
    }
  }, {
    key: 'hydrate',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(job) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!job.states) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return this.fetchStates();

              case 3:
                this.states.forEach(function (y) {
                  return job.states.indexOf(y.name) > -1 && y.setSelected(true);
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function hydrate(_x) {
        return _ref4.apply(this, arguments);
      }

      return hydrate;
    }()
  }, {
    key: 'relevantStates',
    get: function get() {
      var projectType = this.wizard.getStep('ProjectType').legend;
      if (!projectType) {
        return [];
      }

      // Each state has either personal or business price, or both.
      // Filter out the ones not relevant for the current project type.
      return this.states.filter(function (x) {
        return x.properties.some(function (x) {
          return x.id === projectType.id;
        });
      });
    }
  }, {
    key: 'nextEnabled',
    get: function get() {
      return this.selectedStates.length > 0;
    }
  }, {
    key: 'selectedStates',
    get: function get() {
      return this.relevantStates.filter(function (x) {
        return x.selected;
      });
    }
  }, {
    key: 'continueButtonText',
    get: function get() {
      return this.selectedStates.length > 0 ? this.selectedStates.length + ' selected' : 'Please select';
    }
  }]);

  return TaxStatesState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'states', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'relevantStates', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'relevantStates'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'nextEnabled', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'nextEnabled'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectedStates', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectedStates'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'continueButtonText', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'continueButtonText'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fetchStates', [__WEBPACK_IMPORTED_MODULE_8_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchStates'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setStates', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setStates'), _class.prototype)), _class);

/**
 * Used in a checklist.
 */


var State = (_class3 = function () {
  function State(state) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, State);

    _initDefineProp(this, 'name', _descriptor2, this);

    _initDefineProp(this, 'properties', _descriptor3, this);

    _initDefineProp(this, 'selected', _descriptor4, this);

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this, state);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(State, [{
    key: 'setSelected',
    value: function setSelected(selected) {
      this.selected = selected;
    }
  }, {
    key: 'propertiesFor',
    value: function propertiesFor(legendId) {
      return this.properties.find(function (x) {
        return x.id === legendId;
      });
    }
  }]);

  return State;
}(), (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'name', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'properties', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'selected', [__WEBPACK_IMPORTED_MODULE_7_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'setSelected', [__WEBPACK_IMPORTED_MODULE_7_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'setSelected'), _class3.prototype)), _class3);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaxStatesStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CheckList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_CheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_sass__);






var _class;








var TaxStatesStep = __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TaxStatesStep, _React$Component);

  function TaxStatesStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TaxStatesStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TaxStatesStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TaxStatesStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TaxStatesStep, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'tax-states-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexContainer"],
          { direction: 'column', alignItems: 'center' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_components_CheckList__["CheckList"],
              null,
              this.props.step.relevantStates.map(function (state) {
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_components_CheckList__["CheckListItem"],
                  {
                    checked: state.selected,
                    onChange: function onChange(newVal) {
                      return state.setSelected(newVal);
                    },
                    key: state.name
                  },
                  state.name
                );
              })
            )
          )
        )
      );
    }
  }]);

  return TaxStatesStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaxYearsState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_range__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_range__);





var _desc, _value, _class, _descriptor, _desc2, _value2, _class3, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var TaxYearsState = (_class = function () {
  function TaxYearsState(_ref) {
    var wizard = _ref.wizard;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TaxYearsState);

    this.stepId = 'TaxYears';
    this.title = 'What year(s) are you filing taxes?';
    this.trackingId = 'Onboarding - Year Selection';

    _initDefineProp(this, 'years', _descriptor, this);

    this.wizard = wizard;

    // This year + 5 years back.
    var thisYear = new Date().getFullYear();
    this.years = __WEBPACK_IMPORTED_MODULE_5_lodash_range___default()(1, 6).map(function (i) {
      return new Year(thisYear - i);
    });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TaxYearsState, [{
    key: 'serializeToJob',
    value: function serializeToJob() {
      return {
        years: this.selectedYears.map(function (x) {
          return x.year;
        })
      };
    }
  }, {
    key: 'hydrate',
    value: function hydrate(job) {
      if (job.years) {
        this.years.forEach(function (y) {
          return job.years.indexOf(y.year) > -1 && y.setSelected(true);
        });
      }
    }
  }, {
    key: 'nextEnabled',
    get: function get() {
      return this.selectedYears.length > 0;
    }
  }, {
    key: 'selectedYears',
    get: function get() {
      return this.years.filter(function (x) {
        return x.selected;
      });
    }
  }, {
    key: 'relevant',
    get: function get() {
      var step = this.wizard.getStep('ProjectType');
      if (!step) {
        return false;
      }

      if (!step.legend) {
        return false;
      }

      return ['PERSONAL_QUARTERLY_ESTIMATES', 'BUSINESS_QUARTERLY_ESTIMATES'].includes(step.legend.id) === false;
    }
  }]);

  return TaxYearsState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'years', [__WEBPACK_IMPORTED_MODULE_4_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'nextEnabled', [__WEBPACK_IMPORTED_MODULE_4_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'nextEnabled'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectedYears', [__WEBPACK_IMPORTED_MODULE_4_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectedYears'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'relevant', [__WEBPACK_IMPORTED_MODULE_4_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'relevant'), _class.prototype)), _class);

/**
 * Used in a checklist.
 */


var Year = (_class3 = function () {
  function Year(year) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Year);

    _initDefineProp(this, 'year', _descriptor2, this);

    _initDefineProp(this, 'selected', _descriptor3, this);

    this.year = year;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Year, [{
    key: 'setSelected',
    value: function setSelected(selected) {
      this.selected = selected;
    }
  }]);

  return Year;
}(), (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'year', [__WEBPACK_IMPORTED_MODULE_4_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'selected', [__WEBPACK_IMPORTED_MODULE_4_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'setSelected', [__WEBPACK_IMPORTED_MODULE_4_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'setSelected'), _class3.prototype)), _class3);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaxYearsStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CheckList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_CheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_sass__);






var _class;








var TaxYearsStep = __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TaxYearsStep, _React$Component);

  function TaxYearsStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TaxYearsStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TaxYearsStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TaxYearsStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TaxYearsStep, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'tax-years-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexContainer"],
          { direction: 'column', alignItems: 'center' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components_Flex__["FlexItem"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_components_CheckList__["CheckList"],
              null,
              this.props.step.years.map(function (year) {
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_components_CheckList__["CheckListItem"],
                  {
                    checked: year.selected,
                    onChange: function onChange(newVal) {
                      return year.setSelected(newVal);
                    },
                    key: year.year
                  },
                  year.year
                );
              })
            )
          )
        )
      );
    }
  }]);

  return TaxYearsStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UploadDocumentsStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_FileButton__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_FileButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_FileButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Document__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_sass__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_sass__);






var _class;











var UploadDocumentsStep = __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UploadDocumentsStep, _React$Component);

  function UploadDocumentsStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UploadDocumentsStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UploadDocumentsStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UploadDocumentsStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UploadDocumentsStep, [{
    key: 'render',
    value: function render() {
      var step = this.props.step;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'upload-documents-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns is-mobile' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'has-text-centered' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(UploadButton, { onChange: function onChange(files) {
                    return step.addFiles(files);
                  } })
              ),
              step.documents.length === 0 ? step.loading ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Loading, null) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NoDocuments, null) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexContainer"],
                { className: 'documents has-spacing-top', direction: 'column' },
                step.documents.map(function (d) {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
                    { key: d.cid, className: 'document-wrapper' },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Document__["a" /* default */], {
                      document: d
                    })
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return UploadDocumentsStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;




var UploadButton = function UploadButton(_ref) {
  var onChange = _ref.onChange;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8_components_FileButton___default.a,
    { onChange: onChange, multiple: true },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'button',
      { className: 'upload-button' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Icon___default.a, { material: true, name: 'cloud upload', large: true })
    )
  );
};

var Loading = function Loading() {
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexContainer"],
    { className: 'has-spacing-top', direction: 'column' },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components_Flex__["FlexItem"],
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_ProgressSpinner___default.a, { blue: true })
    )
  );
};

var NoDocuments = function NoDocuments() {
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: 'no-documents' },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'content' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'p',
        null,
        'Upload any relevant documents'
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'p',
        { className: 'example' },
        '(i.e. W-2s, 1099s, last year\'s return)'
      )
    )
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardCompletedState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_autobind_decorator__);




var _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var WizardCompletedState = __WEBPACK_IMPORTED_MODULE_4_autobind_decorator___default()(_class = (_class2 = function () {
  function WizardCompletedState(_ref) {
    var wizard = _ref.wizard;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WizardCompletedState);

    this.stepId = 'WizardCompleted';
    this.title = ' ';
    this.trackingId = 'Onboarding - Payment Success';

    this.wizard = wizard;
    this.hideBackButton = true;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WizardCompletedState, [{
    key: 'showEmailDialog',
    value: function showEmailDialog() {
      this.wizard.rootStore.changeEmailDialogStore.show();
    }
  }, {
    key: 'currentUser',
    get: function get() {
      return this.wizard.rootStore.authStore.user;
    }
  }, {
    key: 'showPersonalFilingTip',
    get: function get() {
      var legend = this.wizard.getStep('ProjectType').legend;
      if (!legend) {
        return false;
      }

      return legend.id === 'BUSINESS_TAX_RETURN';
    }
  }, {
    key: 'job',
    get: function get() {
      return this.wizard.job;
    }
  }]);

  return WizardCompletedState;
}(), (_applyDecoratedDescriptor(_class2.prototype, 'currentUser', [__WEBPACK_IMPORTED_MODULE_3_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'currentUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showPersonalFilingTip', [__WEBPACK_IMPORTED_MODULE_3_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showPersonalFilingTip'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'job', [__WEBPACK_IMPORTED_MODULE_3_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'job'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showEmailDialog', [__WEBPACK_IMPORTED_MODULE_3_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showEmailDialog'), _class2.prototype)), _class2)) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WizardCompletedStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_trackUrlConversion__ = __webpack_require__(427);






var _class;









var WizardCompletedStep = __WEBPACK_IMPORTED_MODULE_7_decorators_scrollToTop___default()(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WizardCompletedStep, _React$Component);

  function WizardCompletedStep() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WizardCompletedStep);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WizardCompletedStep.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WizardCompletedStep)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WizardCompletedStep, [{
    key: 'render',
    value: function render() {
      var step = this.props.step;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'wizard-completed-step' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column is-8 is-offset-2 has-text-centered animated fadeIn' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'icon-container has-spacing-bottom' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: __webpack_require__(1201), className: 'checkmark-icon animated zoomIn' })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'h1',
                { className: 'title is-3 is-semibold is-blue' },
                'Thank you for using Taxfyle!'
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'content has-spacing-bottom--less' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  null,
                  'A ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'strong',
                    null,
                    'Pro'
                  ),
                  ' will be in touch with you soon.',
                  step.showPersonalFilingTip && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'span',
                    null,
                    ' By the way,we can also file your personal taxes for you.'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'content has-spacing-bottom--less' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  null,
                  'The contact email address we have on file is ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'strong',
                    null,
                    step.currentUser.email
                  ),
                  ' - if this isn\'t correct, or you can no longer access this email address, please ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'a',
                    { onClick: step.showEmailDialog },
                    'click here to change it'
                  ),
                  '.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'has-spacing-top' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_components_Link___default.a,
                  { className: 'button is-awesome has-chevron-right', to: __WEBPACK_IMPORTED_MODULE_10_misc_links__["a" /* default */].projectDetails(step.job.id) },
                  'Go to chat'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('hr', { className: 'has-spacing-top' }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'has-spacing-top' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'h1',
                  { className: 'title is-4 is-semibold is-blue' },
                  'Get notified!'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'content' },
                  'If you haven\'t already, we recommend you download the ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'strong',
                    null,
                    'Taxfyle App'
                  ),
                  ' so you will get notifications from your Pro, as well as chat & upload documents on the go.'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'app-download-buttons' },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'a',
                    {
                      onClick: function onClick() {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils_trackUrlConversion__["a" /* default */])();
                      },
                      href: 'https://itunes.apple.com/us/app/taxfyle/id1058033104?mt=8',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: __webpack_require__(1202) })
                  ),
                  '\xA0',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'a',
                    {
                      onClick: function onClick() {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils_trackUrlConversion__["a" /* default */])();
                      },
                      href: 'https://play.google.com/store/apps/details?id=com.taxfyle.TaxfyleMobile',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
                      alt: 'Get it on Google Play',
                      src: __webpack_require__(1203)
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return WizardCompletedStep;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_sass__);






var WizardFooter = function WizardFooter(_ref) {
  var wizard = _ref.wizard;

  var disabled = wizard.currentStep.nextEnabled !== true || wizard.isProcessing;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'wizard-footer' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        href: '#',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('button is-continue-button is-awesome has-chevron-right'),
        onClick: !disabled && function (e) {
          return e.preventDefault() || wizard.next();
        },
        disabled: disabled
      },
      wizard.isProcessing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ProgressSpinner___default.a, null) : wizard.currentStep.continueButtonText || 'Continue'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"])(WizardFooter));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StepInfo__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_decorators_scrollPosition__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_decorators_scrollPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_decorators_scrollPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_sass__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_motion__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_motion__);



















var WizardHeader = function WizardHeader(_ref) {
  var wizard = _ref.wizard,
      windowScrollY = _ref.windowScrollY;
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('wizard-header', (windowScrollY > 20 || !wizard.currentStep.title) && 'wizard-header--compact') },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'inner' },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'wizard-header-buttons is-left' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          HeaderButton,
          {
            visible: wizard.showBackButton,
            icon: 'arrow back',
            onClick: function onClick() {
              return wizard.back();
            }
          },
          'Back'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'wizard-header-step-info' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          CoolTransition,
          {
            transitionKey: wizard.currentStep.title
            // Based on whether we're going backwards or forwards.
            , invert: wizard.stepDelta < 0,
            wrapperClassName: 'step-title-container'
          },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__StepInfo__["a" /* StepTitle */],
            null,
            wizard.currentStep.title
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'wizard-header-buttons is-right' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          HeaderButton,
          { visible: true, icon: 'close', onClick: function onClick() {
              return wizard.syncJob();
            }, to: __WEBPACK_IMPORTED_MODULE_12_misc_links__["a" /* default */].projects(), index: true },
          'Esc'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_14_decorators_scrollPosition___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx_react__["observer"])(WizardHeader)));

var HeaderButton = function HeaderButton(_ref2) {
  var icon = _ref2.icon,
      visible = _ref2.visible,
      children = _ref2.children,
      props = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['icon', 'visible', 'children']);

  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_11_components_Link___default.a,
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('button is-header-button', !visible && 'is-invisible') }, props),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Icon___default.a, { material: true, name: icon }),
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      null,
      children
    )
  );
};

var CoolTransition = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CoolTransition, _React$Component);

  function CoolTransition() {
    var _ref3;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CoolTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref3 = CoolTransition.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CoolTransition)).call.apply(_ref3, [this].concat(args))), _this), _this.willEnter = function () {
      return {
        opacity: 0,
        y: _this.props.invert ? -40 : 40
      };
    }, _this.getStyles = function () {
      return {
        opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react_motion__["spring"])(1),
        y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react_motion__["spring"])(0)
      };
    }, _this.willLeave = function () {
      return {
        // Makes it fade out a little faster.
        opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react_motion__["spring"])(0, { stiffness: 244, damping: 21 }),
        y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react_motion__["spring"])(_this.props.invert ? 40 : -40)
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CoolTransition, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          transitionKey = _props.transitionKey,
          children = _props.children,
          wrapperClassName = _props.wrapperClassName;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_react_motion__["TransitionMotion"],
        {
          willEnter: this.willEnter,
          willLeave: this.willLeave,
          styles: [{
            key: transitionKey,
            style: this.getStyles(),
            data: children
          }]
        },
        function (interpolated) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            null,
            interpolated.map(function (_ref4) {
              var key = _ref4.key,
                  style = _ref4.style,
                  data = _ref4.data;
              return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                {
                  key: key,
                  className: wrapperClassName,
                  style: {
                    opacity: style.opacity,
                    transform: 'translateX(' + style.y + 'px)'
                  }
                },
                data
              );
            })
          );
        }
      );
    }
  }]);

  return CoolTransition;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectWizard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_keydown__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_ContentLoading__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_ContentLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_ContentLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_ContentError__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_ContentError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_ContentError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_SlideTransition__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__WizardHeader__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__WizardFooter__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_sass__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_sass__);









var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

















var ProjectWizard = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_decorators_intercomUpdate__["a" /* default */])({ screen: 'Project Wizard' }), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_keydown__["default"])('esc'), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_mobx_react__["observer"])(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ProjectWizard, _React$Component);

  function ProjectWizard() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ProjectWizard);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectWizard.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ProjectWizard)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ProjectWizard, [{
    key: 'onEscape',
    value: function onEscape() {
      this.context.router.push(__WEBPACK_IMPORTED_MODULE_15_misc_links__["a" /* default */].projects());
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.projectWizardStore.activate(this.props.params.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var rootStore = this.props.rootStore;

      var wizard = rootStore.projectWizardStore;
      var step = wizard.currentStep;
      var StepComponent = __webpack_require__(1595)("./" + step.stepId + '/index.jsx').default;
      var helmet = __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_helmet___default.a, { title: wizard.job && wizard.job.name || 'New Project' });
      return wizard.activate.match({
        pending: function pending() {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'div',
            null,
            helmet,
            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_ContentLoading___default.a, null)
          );
        },
        rejected: function rejected(err) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'div',
            null,
            helmet,
            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_ContentError___default.a, { error: err, large: true })
          );
        },
        resolved: function resolved() {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'div',
            { className: 'project-wizard animated is-faster fadeIn' },
            helmet,
            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__WizardHeader__["a" /* default */], { wizard: wizard }),
            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18_components_SlideTransition__["a" /* default */],
              {
                transitionKey: step.stepId,
                invert: wizard.stepDelta === -1,
                wrapper: WizardContent
              },
              __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(StepComponent, { step: step })
            ),
            step.nextEnabled !== undefined && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__WizardFooter__["a" /* default */], { wizard: wizard })
          );
        }
      });
    }
  }]);

  return ProjectWizard;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _class3.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onEscape', [_dec2], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onEscape'), _class2.prototype)), _class2)) || _class) || _class);



var WizardContent = function WizardContent(_ref) {
  var className = _ref.className,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['className']);

  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()('wizard-content', className) }, props));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GettingStarted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_sass__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_sass__);






var _class;










var GettingStarted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GettingStarted, _React$Component);

  function GettingStarted() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GettingStarted);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GettingStarted.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GettingStarted)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GettingStarted, [{
    key: 'render',
    value: function render() {
      var store = this.props.store;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'getting-started' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_components_ShadowBox___default.a,
          { level: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'getting-started__header' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'h2',
              { className: 'getting-started__header-title' },
              'Get started with Taxfyle'
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Progress, { max: store.progressMax, value: store.progress })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'getting-started__steps' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Step, { number: 1, title: 'Create account', subtitle: store.accountEmail, completed: true }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Step, { number: 2, title: 'Get your quote', subtitle: 'Answer a few simple questions.', completed: store.hasAnsweredQuestions }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Step, { number: 3, title: 'Submit your job order', subtitle: 'You\'ll get connected via Live Chat to a Pro specializing in your tax position.' }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Step, { number: 4, title: 'Your Pro will handle your tax needs', subtitle: 'We\'ve got you covered from start to finish.' })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'getting-started__button-container' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              Button,
              { link: store.job ? __WEBPACK_IMPORTED_MODULE_11_misc_links__["a" /* default */].projectDetails(store.job.id) : __WEBPACK_IMPORTED_MODULE_11_misc_links__["a" /* default */].newProject() },
              store.buttonText
            )
          )
        )
      );
    }
  }]);

  return GettingStarted;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class;




var Progress = function Progress(_ref) {
  var max = _ref.max,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: 'getting-started-progress' },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'getting-started-progress__progress-bar', style: { width: value / max * 100 + '%' } })
  );
};

var Step = function Step(_ref2) {
  var number = _ref2.number,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      completed = _ref2.completed;

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('getting-started-step', completed && 'getting-started-step--completed') },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'getting-started-step__number-container' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'getting-started-step__number' },
        number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'getting-started-step__text' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'p',
        { className: 'getting-started-step__title' },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'p',
        { className: 'getting-started-step__subtitle' },
        subtitle
      )
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'getting-started-step__status-container' },
      completed && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'getting-started-step__status' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Icon___default.a, { material: true, medium: true, name: 'check' })
      )
    )
  );
};

var Button = function Button(_ref3) {
  var link = _ref3.link,
      children = _ref3.children;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9_components_Link___default.a,
    { className: 'button is-awesome has-chevron-right getting-started-button', to: link },
    children
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Avatar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Flex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_FloatingBadge__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Circle__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_Circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_img_avatar_placeholder_png__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_img_avatar_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_assets_img_avatar_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_sass__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_sass__);






var _class;















var ProjectItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProjectItem, _React$Component);

  function ProjectItem() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProjectItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProjectItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ProjectItem, [{
    key: 'render',
    value: function render() {
      var project = this.props.project;

      var classes = 'unstyled is-block project-item animated is-faster fadeInUp is-staggered';
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_components_Link___default.a,
        { className: classes, to: __WEBPACK_IMPORTED_MODULE_8_misc_links__["a" /* default */].projectDetails(project.id) },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_components_ShadowBox___default.a,
          { className: 'is-relative', pad: true, level: 1 },
          project.unreadCount > 0 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_components_FloatingBadge__["a" /* default */],
            { animated: true },
            project.unreadCount
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Avatar___default.a, {
                url: project.provider ? project.provider.avatar : __WEBPACK_IMPORTED_MODULE_15_assets_img_avatar_placeholder_png___default.a,
                fallback: project.provider ? project.provider.avatarFallback : null,
                size: 64
              })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
              { className: 'has-spacing-left--less', stretch: true },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'h3',
                { className: 'project-name' },
                project.name
              ),
              project.provider ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'p',
                { className: 'project-provider-description' },
                'Assigned to ',
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'span',
                  { className: 'provider-name' },
                  project.provider.name
                )
              ) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'p',
                { className: 'project-provider-description' },
                'Not assigned yet'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProjectStatus, { project: project })
            )
          )
        )
      );
    }
  }]);

  return ProjectItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class;




var ProjectStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["observer"])(function ProjectStatus(_ref) {
  var project = _ref.project;

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('project-status', 'project-status--' + project.status) },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
      { alignItems: 'flex-end', direction: 'column' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexContainer"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
            { vcentered: true },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Circle___default.a, { filled: true, size: 12, className: 'status-indicator' })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'p',
              { className: 'last-milestone' },
              project.statusMessage
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components_Flex__["FlexItem"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'p',
          { className: 'last-updated' },
          project.relevantStatusDate.format('LL LT')
        )
      )
    )
  );
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectsScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProjectItem__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ContentLoading__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ContentLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_ContentLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Modal__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Dialog__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ContentError__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ContentError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_ContentError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ProfileEditor__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__GettingStarted__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_sass__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_sass__);






var _dec, _class;

















var ProjectsScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_decorators_intercomUpdate__["a" /* default */])({ screen: 'Projects' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProjectsScreen, _React$Component);

  function ProjectsScreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProjectsScreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectsScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProjectsScreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ProjectsScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.rootStore.projectsScreenStore.activate();
      this.props.rootStore.profileEditorStore.activate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$rootStore = this.props.rootStore,
          projectStore = _props$rootStore.projectStore,
          projectsScreenStore = _props$rootStore.projectsScreenStore,
          gettingStartedStore = _props$rootStore.gettingStartedStore,
          authStore = _props$rootStore.authStore,
          profileEditorStore = _props$rootStore.profileEditorStore;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'projects-screen' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a, { title: 'Projects' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header__["a" /* HeaderSink */]
        // hehehehe
        , { fabTo: gettingStartedStore.shouldShow === false ? __WEBPACK_IMPORTED_MODULE_15_misc_links__["a" /* default */].newProject() : null,
          pull: true
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'columns is-mobile' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'column is-8-desktop is-offset-2-desktop has-spacing-top' },
              authStore.user.needsToUpdateProfile && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'has-spacing-bottom' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_ProfileEditor__["a" /* default */], { profileEditorStore: profileEditorStore })
              ),
              !authStore.user.needsToUpdateProfile && projectsScreenStore.activate.match({
                pending: function pending() {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ContentLoading___default.a, null);
                },
                rejected: function rejected(err) {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ContentError___default.a, { error: err });
                },
                resolved: function resolved() {
                  return projectStore.projects.length === 0 ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__GettingStarted__["a" /* default */], { store: gettingStartedStore }) : gettingStartedStore.shouldShow ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__GettingStarted__["a" /* default */], { store: gettingStartedStore }) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProjectsList, { projects: projectStore.orderedJobs });
                }
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_components_Modal___default.a,
          { isOpened: projectsScreenStore.showingFreeExtensionsInfo, onRequestClose: function onRequestClose() {
              return projectsScreenStore.closeFreeExtensionsInfo();
            } },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_components_Dialog__["Dialog"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_components_Dialog__["DialogTitle"],
              null,
              'Free Extensions'
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_components_Dialog__["DialogContent"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'content is-medium' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'p',
                  null,
                  'Taxfyle will file your personal and business extensions free of charge.'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'p',
                  null,
                  'Simply answer the onboarding questions and we\'ll take care of the rest.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_components_Dialog__["DialogFooter"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_components_Dialog__["DialogButton"],
                { onClick: function onClick() {
                    return projectsScreenStore.closeFreeExtensionsInfo();
                  } },
                'Let\'s go!'
              )
            )
          )
        )
      );
    }
  }]);

  return ProjectsScreen;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class);



var ProjectsList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"])(function ProjectsList(_ref) {
  var projects = _ref.projects;

  if (projects.length === 0) {
    return null;
  }

  var closed = projects.filter(function (x) {
    return x.completed;
  });
  var ongoing = projects.filter(function (x) {
    return !x.completed;
  });
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { className: 'projects-list' },
    ongoing.length > 0 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'list-title animated fadeIn' },
      'Current'
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'list-container' },
      ongoing.map(function (project) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProjectItem__["a" /* default */], { project: project, key: project.id });
      })
    ),
    closed.length > 0 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'list-title animated fadeIn' },
      'Completed'
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'list-container' },
      closed.map(function (project) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProjectItem__["a" /* default */], { project: project, key: project.id });
      })
    )
  );
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RateProjectScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_AwesomeLoader__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_AwesomeLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_AwesomeLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ShadowBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ShadowBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_ShadowBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Rating__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_Rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CheckButton__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CheckButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_CheckButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_decorators_intercomUpdate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_misc_RatingCategories__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_sass__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_sass__);






var _dec, _class;















var RateProjectScreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_decorators_intercomUpdate__["a" /* default */])({ screen: 'Rate Project' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RateProjectScreen, _React$Component);

  function RateProjectScreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RateProjectScreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RateProjectScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RateProjectScreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RateProjectScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      return this.props.rootStore.rateProjectStore.activate(this.props.params.id);
    }
  }, {
    key: 'renderLoader',
    value: function renderLoader() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a, { title: 'Taxfyle' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_AwesomeLoader___default.a, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.rootStore.rateProjectStore;
      var currentUser = this.props.rootStore.authStore.user;
      var project = store.project;
      if (store.loading || !project) return this.renderLoader();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'rate-project-screen' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a, { title: project.name }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'inner' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'info has-text-centered' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'h1',
              { className: 'title is-2 is-semibold' },
              currentUser.firstName,
              ', thank you for using Taxfyle!'
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'p',
              { className: 'info-text' },
              'In order for us to provide the highest quality work, we ask that you rate your experience with ',
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'strong',
                null,
                project.provider.name
              ),
              '.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_components_ShadowBox___default.a,
            { level: 5, className: 'rating-box' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'box-header' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'header-text' },
                'How do you rate your experience?'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'box-content' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'rating-container' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Rating___default.a, {
                  readonly: store.disabled,
                  rating: store.rating,
                  starSize: 48,
                  onRatingClick: function onRatingClick(e, rating) {
                    return store.rate(rating);
                  }
                })
              ),
              store.hasRated && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'categories-section' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'h4',
                  { className: 'categories-prompt' },
                  store.categoriesPromptText
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'categories' },
                  __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_16_misc_RatingCategories__["a" /* default */], function (friendly, key) {
                    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      'div',
                      { className: 'category', key: key },
                      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14_components_CheckButton___default.a,
                        {
                          disabled: store.disabled,
                          checked: store.categorySelected(key),
                          onChange: function onChange() {
                            return store.toggleRatingCategory(key);
                          }
                        },
                        friendly
                      )
                    );
                  })
                )
              ),
              store.canSubmit && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'comment-box' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_autosize_textarea___default.a, {
                  disabled: store.disabled,
                  type: 'text',
                  className: 'input comment-field',
                  placeholder: 'Have any feedback for ' + project.provider.name + '?',
                  onChange: function onChange(e) {
                    return store.changeComment(e.target.value);
                  },
                  value: store.comment
                })
              ),
              store.canSubmit && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'has-spacing-top--less' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'button',
                  {
                    className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('button has-impact is-black is-medium', store.disabled && 'is-loading'), onClick: function onClick() {
                      return store.submit();
                    },
                    disabled: store.disabled
                  },
                  'Submit'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RateProjectScreen;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReferAFriend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Header__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Icon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_decorators_intercomUpdate__ = __webpack_require__(69);






var _dec, _class;









var ReferAFriend = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_decorators_intercomUpdate__["a" /* default */])({ screen: 'Refer a Friend' }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ReferAFriend, _React$Component);

  function ReferAFriend() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ReferAFriend);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReferAFriend.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ReferAFriend)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ReferAFriend, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'refer-a-friend' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a, { title: 'Refer a Friend' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_components_Header__["a" /* HeaderSink */],
          { small: true },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_components_Header__["b" /* HeaderTitle */],
            null,
            'Refer a Friend'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'has-spacing-top' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'columns' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'column is-6-desktop is-offset-3-desktop has-text-centered' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Icon___default.a, { material: true, name: 'attach money', size: 80, color: '#2395F3' }),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'h3',
                  { className: 'title is-3 is-semibold has-spacing-top' },
                  'Give $20, Get $20'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'div',
                  { className: 'content is-medium' },
                  'Refer friends to Taxfyle. They get $20 off their first tax return, you get $20 off when they complete it.'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  'h4',
                  { className: 'title is-5 is-semibold' },
                  'Your code:'
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', { type: 'text', readOnly: 'readOnly', className: 'input has-text-centered is-medium code-field', value: this.props.rootStore.authStore.user.app_metadata.referral_code })
              )
            )
          )
        )
      );
    }
  }]);

  return ReferAFriend;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component)) || _class) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var terms = function terms() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'TAXFYLE \u2013 GREAT TAX PREP GIVEAWAY 2017 SWEEPSTAKES',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'OFFICIAL RULES.',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'NO PURCHASE NECESSARY.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'COMMON TERMS USED IN THESE RULES:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'These are the official rules that govern how Taxfyle \u2013 Great Tax Prep Giveaway 2017 sweepstakes promotion will operate. This promotion will be simply referred to as the \u201CSweepstakes\u201D throughout the rest of these rules. In these rules, \u201CTaxfyle,\u201D \u201Cwe,\u201D \u201Cour,\u201D and \u201Cus\u201D refer to Tickmark, Inc., a Delaware corporation, the sponsor of the Sweepstakes. \u201CYou\u201D refers to an eligible Sweepstakes entrant.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT ARE THE START AND END DATES?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This Sweepstakes starts at 12:01 a.m. Pacific Time (PT) on March 6, 2017, and ends at 11:59 p.m. PT on March 19, 2017 with an overall prize drawing on March 20, 2017. All entries will be eligible for the overall prize drawing. '
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'CAN I ENTER?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are eligible to enter this Sweepstakes if you meet the following requirements at time of entry:'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are a legal resident of the 50 United States and District of Columbia, and are 18 years of age or older with an active MileIQ account no later than March 19, 2017.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are NOT an employee of Mobile Data Labs, Inc., Microsoft Corporation, or Tickmark, Inc.; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are NOT involved in any part of the administration and execution of this Sweepstakes; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are NOT an immediate family (parent, sibling, spouse/domestic partner, child) or household member of a Mobile Data Labs/Microsoft/Tickmark employee, or a person involved in any part of the administration and execution of this Sweepstakes.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This Sweepstakes is void outside of the geographic area described above and wherever else prohibited by law.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'HOW DO I ENTER?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'To enter, you must have an active MileIQ account, and thereafter create a Taxfyle account, prior to the deadline. You can create a Taxfyle account, by entering a valid email, at app.taxfyle.com, or via the Taxfyle mobile app. share MileIQ with a friend using the in-app refer a friend engine. For each Taxfyle signup, you will receive one entry. Limited to one entry per individual.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We are not responsible for entries that we do not receive for any reason, or for entries that we receive but are not decipherable for any reason.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We will automatically disqualify:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Any incomplete or illegible entry; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Any entries that we receive from you that are in excess of the entry limit described above.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WINNER SELECTION AND PRIZES'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'On March 20,2017, we will randomly select five (5) winners to receive free individual tax preparation services for life via the Taxfyle Platform, and fifty (50) winners to receive free 2016 individual tax preparation services the Taxfyle Platform. Prizes are limited to individual returns, not exceeding $500 cost per year. '
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If there is a dispute as to who is the potential winner, we will consider the potential winner to be the authorized account holder of the e-mail address used to enter the Sweepstakes. If you are a potential winner, we may require you to sign an Affidavit of Eligibility, Liability/Publicity Release and a W-9 tax form or W-8 BEN tax form within 10 days of notification. If you complete a tax form, you will be issued an IRS Form 1099 the following January, for the actual value of the prize. You are advised to seek independent counsel regarding the tax implications of accepting a prize. If you are a potential winner and you are 18 or older, but are considered a minor in your place of legal residence, we may require your parent or legal guardian to sign all required forms on your behalf. If you do not complete the required forms as instructed and/or return the required forms within the time period listed on the winner notification message, we may disqualify you and select an alternate, randomly selected winner.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If you are confirmed as a winner of this Sweepstakes: You may not exchange your prize for cash or any other merchandise or services. However, if for any reason an advertised prize is unavailable, we reserve the right to substitute a prize of equal or greater value; and You may not designate someone else as the winner. If you are unable or unwilling to accept your prize, we will award it to an alternate potential winner; and If you accept a prize, you will be solely responsible for all applicable federal, state, and local taxes related to accepting the prize; and If you are otherwise eligible for this Sweepstakes, but are considered a minor in your place of residence, we may award the prize to your parent/legal guardian on your behalf; and Unless otherwise noted, all prizes are subject to their manufacturer\u2019s warranty and / or terms and conditions.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT ARE YOUR ODDS OF WINNING?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Your odds of winning this Sweepstakes depend on the number of eligible entries we receive.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT OTHER CONDITIONS ARE YOU AGREEING TO BY ENTERING THIS SWEEPSTAKES?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'By entering this Sweepstakes you agree:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'To abide by these Official Rules; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'To release and hold harmless sponsor,and its respective parents, subsidiaries, affiliates, employees and agents from any and all liability or any injury, loss or damage of any kind arising from or in connection with this Sweepstakes or any prize won; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'That sponsors decisions will be final and binding on all matters related to this Sweepstakes; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'That by accepting a prize, sponsor may use of your proper name and state of residence online and in print, or in any other media, in connection with this Sweepstakes, without payment or compensation to you, except where prohibited by law.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT LAWS GOVERN THE WAY THIS SWEEPSTAKES IS EXECUTED AND ADMINISTRATED?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This Sweepstakes will be governed by the laws of the State of Florida, and you consent to the exclusive jurisdiction and venue of the courts of the State of Florida for any disputes arising out of this Sweepstakes.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT IF SOMETHING UNEXPECTED HAPPENS AND THE SWEEPSTAKES CAN\u2019T RUN AS PLANNED?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If someone cheats, or a virus, bug, bot, catastrophic event, or any other unforeseen or unexpected event that cannot be reasonably anticipated or controlled, (also referred to as force majeure) affects the fairness and / or integrity of this Sweepstakes, we reserve the right to cancel, change or suspend this Sweepstakes. This right is reserved whether the event is due to human or technical error. If a solution cannot be found to restore the integrity of the Sweepstakes, we reserve the right to select winners from among all eligible entries received before we had to cancel, change or suspend the Sweepstakes.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If you attempt or we have strong reason to believe that you have compromised the integrity or the legitimate operation of this Sweepstakes by cheating, hacking, creating a bot or other automated program, or by committing fraud in ANY way, we may seek damages from you to the fullest extent permitted by law. Further, we may disqualify you, and ban you from participating in any of our future Sweepstakes, so please play fairly.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'HOW CAN YOU FIND OUT WHO WON?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If you are a winner, we will notify you by sending a message to the e-mail address provided at time of entry within seven (7) days following the random drawing. If the notification that we send is returned as undeliverable, or you are otherwise unreachable for any reason, we may award the prize to an alternate, randomly selected winner.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We will also post the names of winners who received a prize on the Taxfyle Twitter account.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Tickmark, Inc d/b/a Taxfyle, a Delaware Corporation',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      '3059 Grand Ave, 200 Coconut Grove, FL 33133'
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (terms);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var terms = function terms(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      prizeDate = _ref.prizeDate,
      campaign = _ref.campaign,
      grandLegal = _ref.grandLegal,
      secondLegal = _ref.secondLegal,
      limitations = _ref.limitations;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'TAXFYLE \u2013 ',
      campaign,
      ' SWEEPSTAKES',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'OFFICIAL RULES.',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'NO PURCHASE NECESSARY.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'COMMON TERMS USED IN THESE RULES:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'These are the official rules that govern how Taxfyle \u2013 Free Tax Prep Giveaway 2017 sweepstakes promotion will operate. This promotion will be simply referred to as the \u201CSweepstakes\u201D throughout the rest of these rules. In these rules, \u201CTaxfyle,\u201D \u201Cwe,\u201D \u201Cour,\u201D and \u201Cus\u201D refer to Tickmark, Inc., a Delaware corporation, the sponsor of the Sweepstakes. \u201CYou\u201D refers to an eligible Sweepstakes entrant.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT ARE THE START AND END DATES?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This Sweepstakes starts at 12:01 a.m. Pacific Time (PT) on ',
      startDate,
      ', and ends at 11:59 p.m. PT on ',
      endDate,
      ' with an overall prize drawing on ',
      prizeDate,
      '. All entries will be eligible for the overall prize drawing. '
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'CAN I ENTER?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are eligible to enter this Sweepstakes if you meet the following requirements at time of entry:'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are a legal resident of the 50 United States and District of Columbia, and are 18 years of age or older with an active Taxfyle account no later than ',
        endDate,
        '.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are NOT an employee of Tickmark, Inc.; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are NOT involved in any part of the administration and execution of this Sweepstakes; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'You are NOT an immediate family (parent, sibling, spouse/domestic partner, child) or household member of a Tickmark employee, or a person involved in any part of the administration and execution of this Sweepstakes.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This Sweepstakes is void outside of the geographic area described above and wherever else prohibited by law.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'HOW DO I ENTER?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'To enter, you must have an active Taxfyle account, or thereafter create a Taxfyle account, prior to the deadline. You can create a Taxfyle account, by entering a valid email, at app.taxfyle.com, or via the Taxfyle mobile app.  Share Taxfyle with a friend using the in-app refer a friend engine. For each Taxfyle signup, you will receive one entry. Limited to one entry per individual.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We are not responsible for entries that we do not receive for any reason, or for entries that we receive but are not decipherable for any reason.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We will automatically disqualify:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Any incomplete or illegible entry; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Any entries that we receive from you that are in excess of the entry limit described above.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WINNER SELECTION AND PRIZES'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'On ',
      prizeDate,
      ', we will randomly select ',
      grandLegal,
      ', and ',
      secondLegal,
      '. ',
      limitations
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If there is a dispute as to who is the potential winner, we will consider the potential winner to be the authorized account holder of the e-mail address used to enter the Sweepstakes. If you are a potential winner, we may require you to sign an Affidavit of Eligibility, Liability/Publicity Release and a W-9 tax form or W-8 BEN tax form within 10 days of notification. If you complete a tax form, you will be issued an IRS Form 1099 the following January, for the actual value of the prize. You are advised to seek independent counsel regarding the tax implications of accepting a prize. If you are a potential winner and you are 18 or older, but are considered a minor in your place of legal residence, we may require your parent or legal guardian to sign all required forms on your behalf. If you do not complete the required forms as instructed and/or return the required forms within the time period listed on the winner notification message, we may disqualify you and select an alternate, randomly selected winner.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If you are confirmed as a winner of this Sweepstakes: You may not exchange your prize for cash or any other merchandise or services. However, if for any reason an advertised prize is unavailable, we reserve the right to substitute a prize of equal or greater value; and You may not designate someone else as the winner. If you are unable or unwilling to accept your prize, we will award it to an alternate potential winner; and If you accept a prize, you will be solely responsible for all applicable federal, state, and local taxes related to accepting the prize; and If you are otherwise eligible for this Sweepstakes, but are considered a minor in your place of residence, we may award the prize to your parent/legal guardian on your behalf; and Unless otherwise noted, all prizes are subject to their manufacturer\u2019s warranty and / or terms and conditions.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT ARE YOUR ODDS OF WINNING?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Your odds of winning this Sweepstakes depend on the number of eligible entries we receive.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT OTHER CONDITIONS ARE YOU AGREEING TO BY ENTERING THIS SWEEPSTAKES?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'By entering this Sweepstakes you agree:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'To abide by these Official Rules; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'To release and hold harmless sponsor,and its respective parents, subsidiaries, affiliates, employees and agents from any and all liability or any injury, loss or damage of any kind arising from or in connection with this Sweepstakes or any prize won; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'That sponsors decisions will be final and binding on all matters related to this Sweepstakes; and'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'That by accepting a prize, sponsor may use of your proper name and state of residence online and in print, or in any other media, in connection with this Sweepstakes, without payment or compensation to you, except where prohibited by law.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT LAWS GOVERN THE WAY THIS SWEEPSTAKES IS EXECUTED AND ADMINISTRATED?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This Sweepstakes will be governed by the laws of the State of Florida, and you consent to the exclusive jurisdiction and venue of the courts of the State of Florida for any disputes arising out of this Sweepstakes.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'WHAT IF SOMETHING UNEXPECTED HAPPENS AND THE SWEEPSTAKES CAN\u2019T RUN AS PLANNED?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If someone cheats, or a virus, bug, bot, catastrophic event, or any other unforeseen or unexpected event that cannot be reasonably anticipated or controlled, (also referred to as force majeure) affects the fairness and / or integrity of this Sweepstakes, we reserve the right to cancel, change or suspend this Sweepstakes. This right is reserved whether the event is due to human or technical error. If a solution cannot be found to restore the integrity of the Sweepstakes, we reserve the right to select winners from among all eligible entries received before we had to cancel, change or suspend the Sweepstakes.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If you attempt or we have strong reason to believe that you have compromised the integrity or the legitimate operation of this Sweepstakes by cheating, hacking, creating a bot or other automated program, or by committing fraud in ANY way, we may seek damages from you to the fullest extent permitted by law. Further, we may disqualify you, and ban you from participating in any of our future Sweepstakes, so please play fairly.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'HOW CAN YOU FIND OUT WHO WON?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'If you are a winner, we will notify you by sending a message to the e-mail address provided at time of entry within seven (7) days following the random drawing. If the notification that we send is returned as undeliverable, or you are otherwise unreachable for any reason, we may award the prize to an alternate, randomly selected winner.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We will also post the names of winners who received a prize on the Taxfyle Twitter account.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Tickmark, Inc d/b/a Taxfyle, a Delaware Corporation',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      '3059 Grand Ave, 200 Coconut Grove, FL 33133'
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (terms);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc2NyZWVucy9Td2VlcHN0YWtlcy9UZXJtcy9zdGFuZGFyZC9pbmRleC5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJ0ZXJtcyIsInN0YXJ0RGF0ZSIsImVuZERhdGUiLCJwcml6ZURhdGUiLCJjYW1wYWlnbiIsImdyYW5kTGVnYWwiLCJzZWNvbmRMZWdhbCIsImxpbWl0YXRpb25zIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxLQUFQLE1BQWtCLE9BQWxCOztBQUVBLElBQU1DLFFBQVEsU0FBUkEsS0FBUTtBQUFBLE1BQUVDLFNBQUYsUUFBRUEsU0FBRjtBQUFBLE1BQWFDLE9BQWIsUUFBYUEsT0FBYjtBQUFBLE1BQXNCQyxTQUF0QixRQUFzQkEsU0FBdEI7QUFBQSxNQUFpQ0MsUUFBakMsUUFBaUNBLFFBQWpDO0FBQUEsTUFBMkNDLFVBQTNDLFFBQTJDQSxVQUEzQztBQUFBLE1BQXVEQyxXQUF2RCxRQUF1REEsV0FBdkQ7QUFBQSxNQUFvRUMsV0FBcEUsUUFBb0VBLFdBQXBFO0FBQUEsU0FDWjtBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUE7QUFBQTtBQUNhSCxjQURiO0FBQUE7QUFFRSxxQ0FGRjtBQUFBO0FBSUUscUNBSkY7QUFBQTtBQUFBLEtBREY7QUFRRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBUkY7QUFTRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBVEY7QUFVRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBVkY7QUFXRTtBQUFBO0FBQUE7QUFBQTtBQUErREgsZUFBL0Q7QUFBQTtBQUF5R0MsYUFBekc7QUFBQTtBQUFvSkMsZUFBcEo7QUFBQTtBQUFBLEtBWEY7QUFZRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBWkY7QUFhRTtBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUE7QUFBQTtBQUFBLE9BREY7QUFFRTtBQUFBO0FBQUE7QUFBQTtBQUE4SkQsZUFBOUo7QUFBQTtBQUFBLE9BRkY7QUFHRTtBQUFBO0FBQUE7QUFBQTtBQUFBLE9BSEY7QUFJRTtBQUFBO0FBQUE7QUFBQTtBQUFBLE9BSkY7QUFLRTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBTEYsS0FiRjtBQXFCRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBckJGO0FBc0JFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0F0QkY7QUF1QkU7QUFBQTtBQUFBO0FBQUE7QUFBQSxLQXZCRjtBQXdCRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBeEJGO0FBeUJFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0F6QkY7QUEwQkU7QUFBQTtBQUFBO0FBQ0U7QUFBQTtBQUFBO0FBQUE7QUFBQSxPQURGO0FBRUU7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUZGLEtBMUJGO0FBOEJFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0E5QkY7QUErQkU7QUFBQTtBQUFBO0FBQUE7QUFBT0MsZUFBUDtBQUFBO0FBQTRDRSxnQkFBNUM7QUFBQTtBQUE4REMsaUJBQTlEO0FBQUE7QUFBNkVDO0FBQTdFLEtBL0JGO0FBZ0NFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0FoQ0Y7QUFpQ0U7QUFBQTtBQUFBO0FBQUE7QUFBQSxLQWpDRjtBQXVDRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBdkNGO0FBd0NFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0F4Q0Y7QUF5Q0U7QUFBQTtBQUFBO0FBQUE7QUFBQSxLQXpDRjtBQTBDRTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBMUNGO0FBMkNFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQTtBQUFBO0FBQUEsT0FERjtBQUVFO0FBQUE7QUFBQTtBQUFBO0FBQUEsT0FGRjtBQUdFO0FBQUE7QUFBQTtBQUFBO0FBQUEsT0FIRjtBQUlFO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFKRixLQTNDRjtBQWlERTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBakRGO0FBa0RFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0FsREY7QUFtREU7QUFBQTtBQUFBO0FBQUE7QUFBQSxLQW5ERjtBQW9ERTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBcERGO0FBcURFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0FyREY7QUFzREU7QUFBQTtBQUFBO0FBQUE7QUFBQSxLQXRERjtBQXVERTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBdkRGO0FBd0RFO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0F4REY7QUF5REU7QUFBQTtBQUFBO0FBQUE7QUFFRSxxQ0FGRjtBQUFBO0FBQUE7QUF6REYsR0FEWTtBQUFBLENBQWQ7O0FBa0VBLGVBQWVQLEtBQWYiLCJmaWxlIjoiaW5kZXguanN4Iiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG5jb25zdCB0ZXJtcyA9ICh7c3RhcnREYXRlLCBlbmREYXRlLCBwcml6ZURhdGUsIGNhbXBhaWduLCBncmFuZExlZ2FsLCBzZWNvbmRMZWdhbCwgbGltaXRhdGlvbnN9KSA9PiAoXG4gIDxkaXY+XG4gICAgPHA+XG4gICAgICBUQVhGWUxFIOKAkyB7Y2FtcGFpZ259IFNXRUVQU1RBS0VTXG4gICAgICA8YnIvPlxuICAgICAgT0ZGSUNJQUwgUlVMRVMuXG4gICAgICA8YnIvPlxuICAgICAgTk8gUFVSQ0hBU0UgTkVDRVNTQVJZLlxuICAgIDwvcD5cbiAgICA8cD5DT01NT04gVEVSTVMgVVNFRCBJTiBUSEVTRSBSVUxFUzo8L3A+XG4gICAgPHA+VGhlc2UgYXJlIHRoZSBvZmZpY2lhbCBydWxlcyB0aGF0IGdvdmVybiBob3cgVGF4ZnlsZSDigJMgRnJlZSBUYXggUHJlcCBHaXZlYXdheSAyMDE3IHN3ZWVwc3Rha2VzIHByb21vdGlvbiB3aWxsIG9wZXJhdGUuIFRoaXMgcHJvbW90aW9uIHdpbGwgYmUgc2ltcGx5IHJlZmVycmVkIHRvIGFzIHRoZSDigJxTd2VlcHN0YWtlc+KAnSB0aHJvdWdob3V0IHRoZSByZXN0IG9mIHRoZXNlIHJ1bGVzLiBJbiB0aGVzZSBydWxlcywg4oCcVGF4ZnlsZSzigJ0g4oCcd2Us4oCdIOKAnG91cizigJ0gYW5kIOKAnHVz4oCdIHJlZmVyIHRvIFRpY2ttYXJrLCBJbmMuLCBhIERlbGF3YXJlIGNvcnBvcmF0aW9uLCB0aGUgc3BvbnNvciBvZiB0aGUgU3dlZXBzdGFrZXMuIOKAnFlvdeKAnSByZWZlcnMgdG8gYW4gZWxpZ2libGUgU3dlZXBzdGFrZXMgZW50cmFudC48L3A+XG4gICAgPHA+V0hBVCBBUkUgVEhFIFNUQVJUIEFORCBFTkQgREFURVM/PC9wPlxuICAgIDxwPlRoaXMgU3dlZXBzdGFrZXMgc3RhcnRzIGF0IDEyOjAxIGEubS4gUGFjaWZpYyBUaW1lIChQVCkgb24ge3N0YXJ0RGF0ZX0sIGFuZCBlbmRzIGF0IDExOjU5IHAubS4gUFQgb24ge2VuZERhdGV9IHdpdGggYW4gb3ZlcmFsbCBwcml6ZSBkcmF3aW5nIG9uIHtwcml6ZURhdGV9LiBBbGwgZW50cmllcyB3aWxsIGJlIGVsaWdpYmxlIGZvciB0aGUgb3ZlcmFsbCBwcml6ZSBkcmF3aW5nLiA8L3A+XG4gICAgPHA+Q0FOIEkgRU5URVI/PC9wPlxuICAgIDx1bD5cbiAgICAgIDxsaT5Zb3UgYXJlIGVsaWdpYmxlIHRvIGVudGVyIHRoaXMgU3dlZXBzdGFrZXMgaWYgeW91IG1lZXQgdGhlIGZvbGxvd2luZyByZXF1aXJlbWVudHMgYXQgdGltZSBvZiBlbnRyeTo8L2xpPlxuICAgICAgPGxpPllvdSBhcmUgYSBsZWdhbCByZXNpZGVudCBvZiB0aGUgNTAgVW5pdGVkIFN0YXRlcyBhbmQgRGlzdHJpY3Qgb2YgQ29sdW1iaWEsIGFuZCBhcmUgMTggeWVhcnMgb2YgYWdlIG9yIG9sZGVyIHdpdGggYW4gYWN0aXZlIFRheGZ5bGUgYWNjb3VudCBubyBsYXRlciB0aGFuIHtlbmREYXRlfS48L2xpPlxuICAgICAgPGxpPllvdSBhcmUgTk9UIGFuIGVtcGxveWVlIG9mIFRpY2ttYXJrLCBJbmMuOyBhbmQ8L2xpPlxuICAgICAgPGxpPllvdSBhcmUgTk9UIGludm9sdmVkIGluIGFueSBwYXJ0IG9mIHRoZSBhZG1pbmlzdHJhdGlvbiBhbmQgZXhlY3V0aW9uIG9mIHRoaXMgU3dlZXBzdGFrZXM7IGFuZDwvbGk+XG4gICAgICA8bGk+WW91IGFyZSBOT1QgYW4gaW1tZWRpYXRlIGZhbWlseSAocGFyZW50LCBzaWJsaW5nLCBzcG91c2UvZG9tZXN0aWMgcGFydG5lciwgY2hpbGQpIG9yIGhvdXNlaG9sZCBtZW1iZXIgb2YgYSBUaWNrbWFyayBlbXBsb3llZSwgb3IgYSBwZXJzb24gaW52b2x2ZWQgaW4gYW55IHBhcnQgb2YgdGhlIGFkbWluaXN0cmF0aW9uIGFuZCBleGVjdXRpb24gb2YgdGhpcyBTd2VlcHN0YWtlcy48L2xpPlxuICAgIDwvdWw+XG5cbiAgICA8cD5UaGlzIFN3ZWVwc3Rha2VzIGlzIHZvaWQgb3V0c2lkZSBvZiB0aGUgZ2VvZ3JhcGhpYyBhcmVhIGRlc2NyaWJlZCBhYm92ZSBhbmQgd2hlcmV2ZXIgZWxzZSBwcm9oaWJpdGVkIGJ5IGxhdy48L3A+XG4gICAgPHA+SE9XIERPIEkgRU5URVI/PC9wPlxuICAgIDxwPlRvIGVudGVyLCB5b3UgbXVzdCBoYXZlIGFuIGFjdGl2ZSBUYXhmeWxlIGFjY291bnQsIG9yIHRoZXJlYWZ0ZXIgY3JlYXRlIGEgVGF4ZnlsZSBhY2NvdW50LCBwcmlvciB0byB0aGUgZGVhZGxpbmUuIFlvdSBjYW4gY3JlYXRlIGEgVGF4ZnlsZSBhY2NvdW50LCBieSBlbnRlcmluZyBhIHZhbGlkIGVtYWlsLCBhdCBhcHAudGF4ZnlsZS5jb20sIG9yIHZpYSB0aGUgVGF4ZnlsZSBtb2JpbGUgYXBwLiAgU2hhcmUgVGF4ZnlsZSB3aXRoIGEgZnJpZW5kIHVzaW5nIHRoZSBpbi1hcHAgcmVmZXIgYSBmcmllbmQgZW5naW5lLiBGb3IgZWFjaCBUYXhmeWxlIHNpZ251cCwgeW91IHdpbGwgcmVjZWl2ZSBvbmUgZW50cnkuIExpbWl0ZWQgdG8gb25lIGVudHJ5IHBlciBpbmRpdmlkdWFsLjwvcD5cbiAgICA8cD5XZSBhcmUgbm90IHJlc3BvbnNpYmxlIGZvciBlbnRyaWVzIHRoYXQgd2UgZG8gbm90IHJlY2VpdmUgZm9yIGFueSByZWFzb24sIG9yIGZvciBlbnRyaWVzIHRoYXQgd2UgcmVjZWl2ZSBidXQgYXJlIG5vdCBkZWNpcGhlcmFibGUgZm9yIGFueSByZWFzb24uPC9wPlxuICAgIDxwPldlIHdpbGwgYXV0b21hdGljYWxseSBkaXNxdWFsaWZ5OjwvcD5cbiAgICA8dWw+XG4gICAgICA8bGk+QW55IGluY29tcGxldGUgb3IgaWxsZWdpYmxlIGVudHJ5OyBhbmQ8L2xpPlxuICAgICAgPGxpPkFueSBlbnRyaWVzIHRoYXQgd2UgcmVjZWl2ZSBmcm9tIHlvdSB0aGF0IGFyZSBpbiBleGNlc3Mgb2YgdGhlIGVudHJ5IGxpbWl0IGRlc2NyaWJlZCBhYm92ZS48L2xpPlxuICAgIDwvdWw+XG4gICAgPHA+V0lOTkVSIFNFTEVDVElPTiBBTkQgUFJJWkVTPC9wPlxuICAgIDxwPk9uIHtwcml6ZURhdGV9LCB3ZSB3aWxsIHJhbmRvbWx5IHNlbGVjdCB7Z3JhbmRMZWdhbH0sIGFuZCB7c2Vjb25kTGVnYWx9LiB7bGltaXRhdGlvbnN9PC9wPlxuICAgIDxwPklmIHRoZXJlIGlzIGEgZGlzcHV0ZSBhcyB0byB3aG8gaXMgdGhlIHBvdGVudGlhbCB3aW5uZXIsIHdlIHdpbGwgY29uc2lkZXIgdGhlIHBvdGVudGlhbCB3aW5uZXIgdG8gYmUgdGhlIGF1dGhvcml6ZWQgYWNjb3VudCBob2xkZXIgb2YgdGhlIGUtbWFpbCBhZGRyZXNzIHVzZWQgdG8gZW50ZXIgdGhlIFN3ZWVwc3Rha2VzLiBJZiB5b3UgYXJlIGEgcG90ZW50aWFsIHdpbm5lciwgd2UgbWF5IHJlcXVpcmUgeW91IHRvIHNpZ24gYW4gQWZmaWRhdml0IG9mIEVsaWdpYmlsaXR5LCBMaWFiaWxpdHkvUHVibGljaXR5IFJlbGVhc2UgYW5kIGEgVy05IHRheCBmb3JtIG9yIFctOCBCRU4gdGF4IGZvcm0gd2l0aGluIDEwIGRheXMgb2Ygbm90aWZpY2F0aW9uLiBJZiB5b3UgY29tcGxldGUgYSB0YXggZm9ybSwgeW91IHdpbGwgYmUgaXNzdWVkIGFuIElSUyBGb3JtIDEwOTkgdGhlIGZvbGxvd2luZyBKYW51YXJ5LCBmb3IgdGhlIGFjdHVhbCB2YWx1ZSBvZiB0aGUgcHJpemUuIFlvdSBhcmUgYWR2aXNlZCB0byBzZWVrIGluZGVwZW5kZW50IGNvdW5zZWwgcmVnYXJkaW5nIHRoZSB0YXggaW1wbGljYXRpb25zIG9mIGFjY2VwdGluZyBhIHByaXplLiBJZiB5b3UgYXJlIGEgcG90ZW50aWFsIHdpbm5lciBhbmQgeW91IGFyZSAxOCBvciBvbGRlciwgYnV0IGFyZSBjb25zaWRlcmVkIGEgbWlub3IgaW4geW91ciBwbGFjZSBvZiBsZWdhbCByZXNpZGVuY2UsIHdlIG1heSByZXF1aXJlIHlvdXIgcGFyZW50IG9yIGxlZ2FsIGd1YXJkaWFuIHRvIHNpZ24gYWxsIHJlcXVpcmVkIGZvcm1zIG9uIHlvdXIgYmVoYWxmLiBJZiB5b3UgZG8gbm90IGNvbXBsZXRlIHRoZSByZXF1aXJlZCBmb3JtcyBhcyBpbnN0cnVjdGVkIGFuZC9vciByZXR1cm4gdGhlIHJlcXVpcmVkIGZvcm1zIHdpdGhpbiB0aGUgdGltZSBwZXJpb2QgbGlzdGVkIG9uIHRoZSB3aW5uZXIgbm90aWZpY2F0aW9uIG1lc3NhZ2UsIHdlIG1heSBkaXNxdWFsaWZ5IHlvdSBhbmQgc2VsZWN0IGFuIGFsdGVybmF0ZSwgcmFuZG9tbHkgc2VsZWN0ZWQgd2lubmVyLjwvcD5cbiAgICA8cD5JZiB5b3UgYXJlIGNvbmZpcm1lZCBhcyBhIHdpbm5lciBvZiB0aGlzIFN3ZWVwc3Rha2VzOlxuICAgIFlvdSBtYXkgbm90IGV4Y2hhbmdlIHlvdXIgcHJpemUgZm9yIGNhc2ggb3IgYW55IG90aGVyIG1lcmNoYW5kaXNlIG9yIHNlcnZpY2VzLiBIb3dldmVyLCBpZiBmb3IgYW55IHJlYXNvbiBhbiBhZHZlcnRpc2VkIHByaXplIGlzIHVuYXZhaWxhYmxlLCB3ZSByZXNlcnZlIHRoZSByaWdodCB0byBzdWJzdGl0dXRlIGEgcHJpemUgb2YgZXF1YWwgb3IgZ3JlYXRlciB2YWx1ZTsgYW5kXG4gICAgWW91IG1heSBub3QgZGVzaWduYXRlIHNvbWVvbmUgZWxzZSBhcyB0aGUgd2lubmVyLiBJZiB5b3UgYXJlIHVuYWJsZSBvciB1bndpbGxpbmcgdG8gYWNjZXB0IHlvdXIgcHJpemUsIHdlIHdpbGwgYXdhcmQgaXQgdG8gYW4gYWx0ZXJuYXRlIHBvdGVudGlhbCB3aW5uZXI7IGFuZFxuICAgIElmIHlvdSBhY2NlcHQgYSBwcml6ZSwgeW91IHdpbGwgYmUgc29sZWx5IHJlc3BvbnNpYmxlIGZvciBhbGwgYXBwbGljYWJsZSBmZWRlcmFsLCBzdGF0ZSwgYW5kIGxvY2FsIHRheGVzIHJlbGF0ZWQgdG8gYWNjZXB0aW5nIHRoZSBwcml6ZTsgYW5kXG4gICAgSWYgeW91IGFyZSBvdGhlcndpc2UgZWxpZ2libGUgZm9yIHRoaXMgU3dlZXBzdGFrZXMsIGJ1dCBhcmUgY29uc2lkZXJlZCBhIG1pbm9yIGluIHlvdXIgcGxhY2Ugb2YgcmVzaWRlbmNlLCB3ZSBtYXkgYXdhcmQgdGhlIHByaXplIHRvIHlvdXIgcGFyZW50L2xlZ2FsIGd1YXJkaWFuIG9uIHlvdXIgYmVoYWxmOyBhbmRcbiAgICBVbmxlc3Mgb3RoZXJ3aXNlIG5vdGVkLCBhbGwgcHJpemVzIGFyZSBzdWJqZWN0IHRvIHRoZWlyIG1hbnVmYWN0dXJlcuKAmXMgd2FycmFudHkgYW5kIC8gb3IgdGVybXMgYW5kIGNvbmRpdGlvbnMuPC9wPlxuICAgIDxwPldIQVQgQVJFIFlPVVIgT0REUyBPRiBXSU5OSU5HPzwvcD5cbiAgICA8cD5Zb3VyIG9kZHMgb2Ygd2lubmluZyB0aGlzIFN3ZWVwc3Rha2VzIGRlcGVuZCBvbiB0aGUgbnVtYmVyIG9mIGVsaWdpYmxlIGVudHJpZXMgd2UgcmVjZWl2ZS48L3A+XG4gICAgPHA+V0hBVCBPVEhFUiBDT05ESVRJT05TIEFSRSBZT1UgQUdSRUVJTkcgVE8gQlkgRU5URVJJTkcgVEhJUyBTV0VFUFNUQUtFUz88L3A+XG4gICAgPHA+QnkgZW50ZXJpbmcgdGhpcyBTd2VlcHN0YWtlcyB5b3UgYWdyZWU6PC9wPlxuICAgIDx1bD5cbiAgICAgIDxsaT5UbyBhYmlkZSBieSB0aGVzZSBPZmZpY2lhbCBSdWxlczsgYW5kPC9saT5cbiAgICAgIDxsaT5UbyByZWxlYXNlIGFuZCBob2xkIGhhcm1sZXNzIHNwb25zb3IsYW5kIGl0cyByZXNwZWN0aXZlIHBhcmVudHMsIHN1YnNpZGlhcmllcywgYWZmaWxpYXRlcywgZW1wbG95ZWVzIGFuZCBhZ2VudHMgZnJvbSBhbnkgYW5kIGFsbCBsaWFiaWxpdHkgb3IgYW55IGluanVyeSwgbG9zcyBvciBkYW1hZ2Ugb2YgYW55IGtpbmQgYXJpc2luZyBmcm9tIG9yIGluIGNvbm5lY3Rpb24gd2l0aCB0aGlzIFN3ZWVwc3Rha2VzIG9yIGFueSBwcml6ZSB3b247IGFuZDwvbGk+XG4gICAgICA8bGk+VGhhdCBzcG9uc29ycyBkZWNpc2lvbnMgd2lsbCBiZSBmaW5hbCBhbmQgYmluZGluZyBvbiBhbGwgbWF0dGVycyByZWxhdGVkIHRvIHRoaXMgU3dlZXBzdGFrZXM7IGFuZDwvbGk+XG4gICAgICA8bGk+VGhhdCBieSBhY2NlcHRpbmcgYSBwcml6ZSwgc3BvbnNvciBtYXkgdXNlIG9mIHlvdXIgcHJvcGVyIG5hbWUgYW5kIHN0YXRlIG9mIHJlc2lkZW5jZSBvbmxpbmUgYW5kIGluIHByaW50LCBvciBpbiBhbnkgb3RoZXIgbWVkaWEsIGluIGNvbm5lY3Rpb24gd2l0aCB0aGlzIFN3ZWVwc3Rha2VzLCB3aXRob3V0IHBheW1lbnQgb3IgY29tcGVuc2F0aW9uIHRvIHlvdSwgZXhjZXB0IHdoZXJlIHByb2hpYml0ZWQgYnkgbGF3LjwvbGk+XG4gICAgPC91bD5cbiAgICA8cD5XSEFUIExBV1MgR09WRVJOIFRIRSBXQVkgVEhJUyBTV0VFUFNUQUtFUyBJUyBFWEVDVVRFRCBBTkQgQURNSU5JU1RSQVRFRD88L3A+XG4gICAgPHA+VGhpcyBTd2VlcHN0YWtlcyB3aWxsIGJlIGdvdmVybmVkIGJ5IHRoZSBsYXdzIG9mIHRoZSBTdGF0ZSBvZiBGbG9yaWRhLCBhbmQgeW91IGNvbnNlbnQgdG8gdGhlIGV4Y2x1c2l2ZSBqdXJpc2RpY3Rpb24gYW5kIHZlbnVlIG9mIHRoZSBjb3VydHMgb2YgdGhlIFN0YXRlIG9mIEZsb3JpZGEgZm9yIGFueSBkaXNwdXRlcyBhcmlzaW5nIG91dCBvZiB0aGlzIFN3ZWVwc3Rha2VzLjwvcD5cbiAgICA8cD5XSEFUIElGIFNPTUVUSElORyBVTkVYUEVDVEVEIEhBUFBFTlMgQU5EIFRIRSBTV0VFUFNUQUtFUyBDQU7igJlUIFJVTiBBUyBQTEFOTkVEPzwvcD5cbiAgICA8cD5JZiBzb21lb25lIGNoZWF0cywgb3IgYSB2aXJ1cywgYnVnLCBib3QsIGNhdGFzdHJvcGhpYyBldmVudCwgb3IgYW55IG90aGVyIHVuZm9yZXNlZW4gb3IgdW5leHBlY3RlZCBldmVudCB0aGF0IGNhbm5vdCBiZSByZWFzb25hYmx5IGFudGljaXBhdGVkIG9yIGNvbnRyb2xsZWQsIChhbHNvIHJlZmVycmVkIHRvIGFzIGZvcmNlIG1hamV1cmUpIGFmZmVjdHMgdGhlIGZhaXJuZXNzIGFuZCAvIG9yIGludGVncml0eSBvZiB0aGlzIFN3ZWVwc3Rha2VzLCB3ZSByZXNlcnZlIHRoZSByaWdodCB0byBjYW5jZWwsIGNoYW5nZSBvciBzdXNwZW5kIHRoaXMgU3dlZXBzdGFrZXMuIFRoaXMgcmlnaHQgaXMgcmVzZXJ2ZWQgd2hldGhlciB0aGUgZXZlbnQgaXMgZHVlIHRvIGh1bWFuIG9yIHRlY2huaWNhbCBlcnJvci4gSWYgYSBzb2x1dGlvbiBjYW5ub3QgYmUgZm91bmQgdG8gcmVzdG9yZSB0aGUgaW50ZWdyaXR5IG9mIHRoZSBTd2VlcHN0YWtlcywgd2UgcmVzZXJ2ZSB0aGUgcmlnaHQgdG8gc2VsZWN0IHdpbm5lcnMgZnJvbSBhbW9uZyBhbGwgZWxpZ2libGUgZW50cmllcyByZWNlaXZlZCBiZWZvcmUgd2UgaGFkIHRvIGNhbmNlbCwgY2hhbmdlIG9yIHN1c3BlbmQgdGhlIFN3ZWVwc3Rha2VzLjwvcD5cbiAgICA8cD5JZiB5b3UgYXR0ZW1wdCBvciB3ZSBoYXZlIHN0cm9uZyByZWFzb24gdG8gYmVsaWV2ZSB0aGF0IHlvdSBoYXZlIGNvbXByb21pc2VkIHRoZSBpbnRlZ3JpdHkgb3IgdGhlIGxlZ2l0aW1hdGUgb3BlcmF0aW9uIG9mIHRoaXMgU3dlZXBzdGFrZXMgYnkgY2hlYXRpbmcsIGhhY2tpbmcsIGNyZWF0aW5nIGEgYm90IG9yIG90aGVyIGF1dG9tYXRlZCBwcm9ncmFtLCBvciBieSBjb21taXR0aW5nIGZyYXVkIGluIEFOWSB3YXksIHdlIG1heSBzZWVrIGRhbWFnZXMgZnJvbSB5b3UgdG8gdGhlIGZ1bGxlc3QgZXh0ZW50IHBlcm1pdHRlZCBieSBsYXcuIEZ1cnRoZXIsIHdlIG1heSBkaXNxdWFsaWZ5IHlvdSwgYW5kIGJhbiB5b3UgZnJvbSBwYXJ0aWNpcGF0aW5nIGluIGFueSBvZiBvdXIgZnV0dXJlIFN3ZWVwc3Rha2VzLCBzbyBwbGVhc2UgcGxheSBmYWlybHkuPC9wPlxuICAgIDxwPkhPVyBDQU4gWU9VIEZJTkQgT1VUIFdITyBXT04/PC9wPlxuICAgIDxwPklmIHlvdSBhcmUgYSB3aW5uZXIsIHdlIHdpbGwgbm90aWZ5IHlvdSBieSBzZW5kaW5nIGEgbWVzc2FnZSB0byB0aGUgZS1tYWlsIGFkZHJlc3MgcHJvdmlkZWQgYXQgdGltZSBvZiBlbnRyeSB3aXRoaW4gc2V2ZW4gKDcpIGRheXMgZm9sbG93aW5nIHRoZSByYW5kb20gZHJhd2luZy4gSWYgdGhlIG5vdGlmaWNhdGlvbiB0aGF0IHdlIHNlbmQgaXMgcmV0dXJuZWQgYXMgdW5kZWxpdmVyYWJsZSwgb3IgeW91IGFyZSBvdGhlcndpc2UgdW5yZWFjaGFibGUgZm9yIGFueSByZWFzb24sIHdlIG1heSBhd2FyZCB0aGUgcHJpemUgdG8gYW4gYWx0ZXJuYXRlLCByYW5kb21seSBzZWxlY3RlZCB3aW5uZXIuPC9wPlxuICAgIDxwPldlIHdpbGwgYWxzbyBwb3N0IHRoZSBuYW1lcyBvZiB3aW5uZXJzIHdobyByZWNlaXZlZCBhIHByaXplIG9uIHRoZSBUYXhmeWxlIFR3aXR0ZXIgYWNjb3VudC48L3A+XG4gICAgPHA+XG4gICAgICBUaWNrbWFyaywgSW5jIGQvYi9hIFRheGZ5bGUsIGEgRGVsYXdhcmUgQ29ycG9yYXRpb25cbiAgICAgIDxici8+XG4gICAgICAzMDU5IEdyYW5kIEF2ZSwgMjAwIENvY29udXQgR3JvdmUsIEZMIDMzMTMzXG4gICAgPC9wPlxuICA8L2Rpdj5cbilcblxuZXhwb3J0IGRlZmF1bHQgdGVybXNcbiJdfQ==

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sweepstakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SweepstakesScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_helmet__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Footer__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_validx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_validx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_validx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Form__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_body_classname__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_body_classname___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_body_classname__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_decorators_hideIntercom__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Link__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_sass__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_sass__);










var _class, _dec, _desc, _value, _class3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

















var sweepstakes = [{
  path: '/mileiq-sweepstakes',
  title: 'Taxfyle + MileIQ Sweepstakes',
  campaign: 'GREAT TAX PREP GIVEAWAY 2017',
  logo: 'mileiq-taxfyle.png',
  logoWidth: '70%',
  coupon: 'MILEIQ30',
  termsId: 'mileiq',
  startDate: 'March 6, 2017',
  endDate: 'March 19, 2017',
  prizeDate: 'March 20, 2017',
  partnerId: 'mileiq',
  grand: '<p>5 lucky winners will receive <strong>free</strong> tax preparation and filings from a Tax Pro <strong>for life</strong>. Never worry about taxes again!</p>',
  grandLegal: 'five (5) winners to receive free individual tax preparation services for life via the Taxfyle Platform',
  second: '<p>50 lucky winners will have their 2016 taxes filed for them free of charge!</p>',
  secondLegal: 'fifty (50) winners to receive free 2016 individual tax preparation services the Taxfyle Platform',
  everyone: '<p>All MileIQ members receive <strong>$30 off</strong> tax filing fees. Simply use promo code: <strong>MILEIQ30</strong> at checkout.</p>',
  limitations: 'Prizes are limited to individual returns, not exceeding $500 cost per year.'
}, {
  path: '/dharma-sweepstakes',
  title: 'Taxfyle + Dharma Merchant Services Sweepstakes',
  campaign: 'DHARMA TAX PREP GIVEAWAY 2017',
  beforeLogo: '<div style="text-align:center;width:40%;margin:0.5em auto"><img src="https://taxfyle-benefits-images.s3.amazonaws.com/1481642502767/taxfyle-logo-blue%20%282%29.png" alt="taxfyle" /><br />+</div>',
  logo: 'https://taxfyle-benefits-images.s3.amazonaws.com/1476458455612/Benefits%20and%20Promo.png',
  coupon: 'DHARMA30',
  termsId: 'standard',
  startDate: 'March 24, 2017',
  endDate: 'April 9, 2017',
  prizeDate: 'April 10, 2017',
  partnerId: 'dharma',
  grand: '<p>3 lucky winners will receive <strong>free</strong> tax preparation and filings from a Tax Pro <strong>for life</strong>. Never worry about taxes again!</p>',
  grandLegal: 'three (3) winners to receive free individual tax preparation services for life via the Taxfyle Platform',
  second: '<p>10 lucky winners will have their 2016 taxes filed for them free of charge!</p>',
  secondLegal: 'ten (10) winners to receive free 2016 individual tax preparation services the Taxfyle Platform',
  everyone: '<p>All Dharma Merchant Services members receive <strong>$30 off</strong> tax filing fees. Simply use promo code: <strong>DHARMA30</strong> at checkout.</p>',
  limitations: 'Prizes are limited to individual returns, not exceeding $500 cost per year.'
}];

var SweepstakesScreen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_decorators_hideIntercom__["a" /* default */])(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(SweepstakesScreen, _React$Component);

  function SweepstakesScreen() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, SweepstakesScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SweepstakesScreen.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(SweepstakesScreen)).call.apply(_ref, [this].concat(args))), _this), _this.login = function () {
      return _this.vm.login().then(_this.afterAuthenticate);
    }, _this.signup = function () {
      return _this.vm.signup().then(_this.afterAuthenticate);
    }, _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(SweepstakesScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.vm = new SweepstakesViewModel({
        rootStore: this.props.rootStore,
        coupon: this.props.route.coupon,
        referrer: this.props.route.path.replace('/', '').replace(/\//g, '-')
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var vm = this.vm;
      var formDisabled = vm.formDisabled;
      var TermsComponent = __webpack_require__(1596)("./" + this.props.route.termsId + '/index.jsx').default;
      var referrer = this.props.route.path.replace('/', '').replace(/\//g, '-');
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'sweepstakes-screen' },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_helmet___default.a, { title: this.props.route.title }),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_body_classname___default.a, { className: 'login' }),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'sweepstakes-container' },
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'sweepstakes-hero' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'banner' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'a',
                { href: '#learn-more', className: 'action-button' },
                'Enter to win'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'logo-area' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'prize-description', dangerouslySetInnerHTML: { __html: this.props.route.beforeLogo } }),
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', { style: { maxWidth: this.props.route.logoWidth || '40%', marginBottom: '2em' }, src: this.props.route.logo.indexOf('http') === 0 ? this.props.route.logo : __webpack_require__(1597)("./" + this.props.route.logo), alt: this.props.route.title })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'prizes' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'columns' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'column is-8 is-offset-2' },
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Prize, { title: 'Grand Prize', description: this.props.route.grand }),
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Prize, { title: 'Second Place', description: this.props.route.second }),
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Prize, { title: 'Everyone Wins', description: this.props.route.everyone })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { id: 'learn-more', className: 'learn-more' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'columns' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'column is-8 is-offset-2', style: { textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'p',
                  { className: 'prize-title' },
                  'Why is Taxfyle for you?'
                ),
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'p',
                  { className: 'prize-description' },
                  'Maximize your refund with Taxfyle \uD83D\uDCB0'
                ),
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'div',
                  { className: 'button-container' },
                  this.props.route.partnerId === undefined ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'a',
                    { href: 'https://app.taxfyle.com/?ref=sweepstakes&utm_source=' + referrer, className: 'action-button' },
                    'Learn more'
                  ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'a',
                    { href: 'https://taxfyle.com/partners/' + this.props.route.partnerId, className: 'action-button' },
                    'Learn more'
                  )
                )
              )
            )
          ),
          vm.done ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'thanks-box' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'p',
              { className: 'thanks-box__text' },
              'Thank you for entering!'
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'thanks-box__buttons' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_20_components_Link___default.a,
                { className: 'button is-hero-auth-button', to: __WEBPACK_IMPORTED_MODULE_21_misc_links__["a" /* default */].projects() },
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'span',
                  null,
                  'Let\'s file your taxes'
                )
              )
            )
          ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'submit-form' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'columns' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'column is-10 is-offset-1 prize-steps' },
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'ol',
                  null,
                  __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'li',
                    null,
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'strong',
                      null,
                      'Sign up'
                    ),
                    ' with Taxfyle',
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'div',
                      { className: 'signup-container' },
                      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'a',
                        { className: 'button signup-button is-primary', onClick: formDisabled && this.signup, disabled: !formDisabled },
                        formDisabled ? 'Sign up' : 'Thanks for signing up!'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'li',
                    null,
                    'Enter the information on the form below',
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'div',
                      { className: 'form-container' },
                      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16_components_Form__["Form"],
                        { onSubmit: function onSubmit() {
                            return vm.submit();
                          } },
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Form__["Input"], { disabled: formDisabled || vm.submit.pending, model: vm, field: 'first_name', label: 'First name' }),
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Form__["Input"], { disabled: formDisabled || vm.submit.pending, model: vm, field: 'last_name', label: 'Last name' }),
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Form__["Input"], { disabled: formDisabled || vm.submit.pending, model: vm, field: 'email', type: 'email', label: 'E-mail' }),
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                          'button',
                          { disabled: formDisabled || vm.submit.pending, className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()('button', formDisabled || 'is-primary') },
                          formDisabled ? 'Please sign up first' : 'Submit'
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'li',
                    null,
                    'Check ',
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'a',
                      { href: 'https://twitter.com/taxfyle' },
                      '@taxfyle'
                    ),
                    ' on Twitter for winners ',
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'strong',
                      null,
                      this.props.route.prizeDate,
                      '!'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'container prize-terms' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(TermsComponent, this.props.route)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'columns' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'column has-spacing-top has-spacing-bottom' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Footer__["a" /* default */], null)
            )
          )
        )
      );
    }
  }]);

  return SweepstakesScreen;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component)) || _class) || _class;




var Prize = function Prize(_ref2) {
  var title = _ref2.title,
      description = _ref2.description;
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    'div',
    { className: 'prize' },
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      'div',
      { className: 'prize-title' },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'prize-description', dangerouslySetInnerHTML: { __html: description } })
  );
};

/* eslint-disable */
var SweepstakesViewModel = (_dec = __WEBPACK_IMPORTED_MODULE_17_mobx_task__["task"].resolved, (_class3 = function () {
  function SweepstakesViewModel(_ref3) {
    var rootStore = _ref3.rootStore,
        coupon = _ref3.coupon,
        referrer = _ref3.referrer;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, SweepstakesViewModel);

    _initDefineProp(this, 'first_name', _descriptor, this);

    _initDefineProp(this, 'last_name', _descriptor2, this);

    _initDefineProp(this, 'email', _descriptor3, this);

    _initDefineProp(this, 'user_id', _descriptor4, this);

    _initDefineProp(this, 'done', _descriptor5, this);

    this.validation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["validationContext"])();

    this.coupon = coupon;
    this.rootStore = rootStore;
    this.afterAuth = this.afterAuth.bind(this);
    this.rootStore.authStore.setReferrerMeta({ referrer: referrer });
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(SweepstakesViewModel, [{
    key: 'login',
    value: function login() {
      return this.rootStore.authStore.login().then(this.afterAuth);
    }
  }, {
    key: 'signup',
    value: function signup() {
      return this.rootStore.authStore.signup({ hideLogin: true }).then(this.afterAuth);
    }
  }, {
    key: 'afterAuth',
    value: function afterAuth() {
      var user = this.rootStore.authStore.user;

      if (!user) {
        return false;
      }

      this.user_id = user.id;
      this.email = user.email;
      return true;
    }
  }, {
    key: 'submit',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var rules;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                rules = {
                  first_name: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('First name is required.')],
                  last_name: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('Last name is required.')],
                  email: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["required"])('E-mail is required'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_validx__["pattern"])({ pattern: 'email', msg: 'Not a valid e-mail.' })]
                };

                if (this.validation.reset().validate(this, rules).isValid) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return this.rootStore.api.sweep.create({
                  user_id: this.user_id,
                  first_name: this.first_name,
                  last_name: this.last_name,
                  email: this.email
                }).then(function () {
                  var data = {
                    given_name: _this2.first_name,
                    family_name: _this2.last_name,
                    email_address: _this2.email
                  };
                  return _this2.rootStore.api.profiles.patch('me', data).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(_this2.rootStore.userStore.users.set));
                }).then(function () {
                  if (!_this2.coupon) {
                    return;
                  }

                  return _this2.rootStore.couponStore.addCoupon(_this2.coupon).catch(function () {});
                }).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(function () {
                  _this2.done = true;
                }));

              case 5:
                return _context.abrupt('return', _context.sent);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit() {
        return _ref4.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'formDisabled',
    get: function get() {
      return !this.user_id;
    }
  }]);

  return SweepstakesViewModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, 'first_name', [__WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'last_name', [__WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'email', [__WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'user_id', [__WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'done', [__WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'formDisabled', [__WEBPACK_IMPORTED_MODULE_13_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'formDisabled'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'afterAuth', [__WEBPACK_IMPORTED_MODULE_13_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'afterAuth'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'submit', [_dec], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class3.prototype, 'submit'), _class3.prototype)), _class3));
/* eslint-enable */
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sass_base_sass__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sass_base_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sass_base_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_FlashMessages__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_FlashMessages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_FlashMessages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ReloadWarning__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ReloadWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_ReloadWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ConfirmDialog__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ConfirmDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_ConfirmDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ChangeEmailDialog__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Header__ = __webpack_require__(80);






var _class;










var App = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx_react__["observer"])(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(App, _React$Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (App.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(App)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(App, [{
    key: 'render',
    value: function render() {
      var rootStore = this.props.rootStore;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { id: 'root' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Header__["c" /* HeaderRenderer */], { rootStore: rootStore }),
        this.props.children,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_FlashMessages___default.a, { store: rootStore.flashMessageStore, position: 'bottomLeft' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ReloadWarning___default.a, { authStore: rootStore.authStore }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ChangeEmailDialog__["a" /* default */], { store: rootStore.changeEmailDialogStore }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_ConfirmDialog___default.a,
          { state: rootStore.billingStore.deletePaymentMethodDialog, danger: true, yes: 'Delete Payment Method' },
          'Are you sure you want to delete this payment method?'
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component)) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interceptors_authenticate__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_misc_analytics__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interceptors_trackReferrerMeta__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_screens_Login__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_screens_Projects__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_screens_ProjectDetails__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_screens_ProjectWizard__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_screens_RateProject__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_screens_LinkedAccounts__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_screens_ReferAFriend__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_screens_Coupons__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_screens_Documents__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_screens_Profile__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_screens_Billing__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_screens_Sweepstakes__ = __webpack_require__(812);






















var authenticate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__interceptors_authenticate__["a" /* default */])({ authStore: __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].authStore });
var trackReferrerMeta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__interceptors_trackReferrerMeta__["a" /* default */])({ authStore: __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].authStore });

var createElement = function createElement(Component, props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { rootStore: __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */] }));
};

var onRouterUpdate = function onRouterUpdate() {
  __WEBPACK_IMPORTED_MODULE_5_misc_analytics__["a" /* default */].page();
};

var AppRouter = function AppRouter() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router__["Router"],
    { history: __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"], createElement: createElement, onUpdate: onRouterUpdate },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
      { onEnter: trackReferrerMeta },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: '/login', component: __WEBPACK_IMPORTED_MODULE_8_screens_Login__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_19_screens_Sweepstakes__["a" /* sweepstakes */].map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ component: __WEBPACK_IMPORTED_MODULE_19_screens_Sweepstakes__["b" /* default */], key: item.path }, item));
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
        { path: '/', component: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */], onEnter: authenticate },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRoute"], { component: __WEBPACK_IMPORTED_MODULE_9_screens_Projects__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'linked-accounts', component: __WEBPACK_IMPORTED_MODULE_13_screens_LinkedAccounts__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'documents', component: __WEBPACK_IMPORTED_MODULE_16_screens_Documents__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'coupons', component: __WEBPACK_IMPORTED_MODULE_15_screens_Coupons__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'billing', component: __WEBPACK_IMPORTED_MODULE_18_screens_Billing__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'profile', component: __WEBPACK_IMPORTED_MODULE_17_screens_Profile__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'refer', component: __WEBPACK_IMPORTED_MODULE_14_screens_ReferAFriend__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'new', component: __WEBPACK_IMPORTED_MODULE_11_screens_ProjectWizard__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'project/:id', component: __WEBPACK_IMPORTED_MODULE_10_screens_ProjectDetails__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'project/:id/rate', component: __WEBPACK_IMPORTED_MODULE_12_screens_RateProject__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'project/:id/edit', component: __WEBPACK_IMPORTED_MODULE_11_screens_ProjectWizard__["a" /* default */] })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AppRouter);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAuthenticate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);




function makeAuthenticate(_ref) {
  var authStore = _ref.authStore;

  return function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nextState, replace, callback) {
      var hash, parsed;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              hash = nextState.location.hash;

              if (hash) {
                parsed = __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.parse(hash.substring(1));

                if (parsed && parsed.access_token) {
                  window.location.hash = '';
                  authStore.setToken(parsed.access_token);
                }
              }

              _context.next = 4;
              return authStore.checkAuthentication();

            case 4:
              if (_context.sent) {
                _context.next = 6;
                break;
              }

              replace({
                pathname: '/login',
                state: { nextPathname: nextState.location.pathname }
              });

            case 6:

              callback();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function authenticate(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    }

    return authenticate;
  }();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeTrackReferrerMeta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_once__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_once__);



function makeTrackReferrerMeta(_ref) {
  var authStore = _ref.authStore;

  return __WEBPACK_IMPORTED_MODULE_1_lodash_once___default()(function onEnter(p) {
    var query = p.location.query;

    var ref = query.ref,
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(query, ['ref']);

    if (ref) {
      rest.referrer = ref;
    }

    authStore.setReferrerMeta(rest);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc2hlbGwvQXBwUm91dGVyL2ludGVyY2VwdG9ycy90cmFja1JlZmVycmVyTWV0YS5qcyJdLCJuYW1lcyI6WyJvbmNlIiwibWFrZVRyYWNrUmVmZXJyZXJNZXRhIiwiYXV0aFN0b3JlIiwib25FbnRlciIsInAiLCJxdWVyeSIsImxvY2F0aW9uIiwicmVmIiwicmVzdCIsInJlZmVycmVyIiwic2V0UmVmZXJyZXJNZXRhIl0sIm1hcHBpbmdzIjoiO0FBQUEsT0FBT0EsSUFBUCxNQUFpQixhQUFqQjs7QUFFQSxlQUFlLFNBQVNDLHFCQUFULE9BQStDO0FBQUEsTUFBYkMsU0FBYSxRQUFiQSxTQUFhOztBQUM1RCxTQUFPRixLQUFLLFNBQVNHLE9BQVQsQ0FBa0JDLENBQWxCLEVBQXFCO0FBQy9CLFFBQU1DLFFBQVFELEVBQUVFLFFBQUYsQ0FBV0QsS0FBekI7O0FBRCtCLFFBR3ZCRSxHQUh1QixHQUdORixLQUhNLENBR3ZCRSxHQUh1QjtBQUFBLFFBR2ZDLElBSGUsNEJBR05ILEtBSE07O0FBSS9CLFFBQUlFLEdBQUosRUFBUztBQUNQQyxXQUFLQyxRQUFMLEdBQWdCRixHQUFoQjtBQUNEOztBQUVETCxjQUFVUSxlQUFWLENBQTBCRixJQUExQjtBQUNELEdBVE0sQ0FBUDtBQVVEIiwiZmlsZSI6InRyYWNrUmVmZXJyZXJNZXRhLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IG9uY2UgZnJvbSAnbG9kYXNoL29uY2UnXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG1ha2VUcmFja1JlZmVycmVyTWV0YSAoeyBhdXRoU3RvcmUgfSkge1xuICByZXR1cm4gb25jZShmdW5jdGlvbiBvbkVudGVyIChwKSB7XG4gICAgY29uc3QgcXVlcnkgPSBwLmxvY2F0aW9uLnF1ZXJ5XG5cbiAgICBjb25zdCB7IHJlZiwgLi4ucmVzdCB9ID0gcXVlcnlcbiAgICBpZiAocmVmKSB7XG4gICAgICByZXN0LnJlZmVycmVyID0gcmVmXG4gICAgfVxuXG4gICAgYXV0aFN0b3JlLnNldFJlZmVycmVyTWV0YShyZXN0KVxuICB9KVxufVxuIl19

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_auth0_lock__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_auth0_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_auth0_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jwt_decode__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_misc_analytics__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_domain_CurrentUser__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_misc_env__ = __webpack_require__(157);













var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

var _login = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(opts) {
    var result;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var errHandler = function errHandler(err) {
                reject(err);
              };

              _lock.once('authenticated', function (result) {
                var jwt = result.idToken;

                _lock.getProfile(jwt, function (err, profile) {
                  if (err) {
                    reject(err);
                    return;
                  }

                  // Auto-hide the lock.
                  setTimeout(function () {
                    return _lock.hide();
                  }, 1100);
                  resolve({ profile: profile, token: jwt });
                });
              });

              _lock.once('authorization_error', errHandler);
              _lock.once('unrecoverable_error', errHandler);
              _lock.once('hide', function () {
                return resolve(false);
              });
              _lock.show(opts);
            });

          case 2:
            result = _context3.sent;

            if (result) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt('return', false);

          case 5:
            return _context3.abrupt('return', result);

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function _login(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var _fetchProfile = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4(token) {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              _lock.getProfile(token, function (err, profile) {
                return err ? reject(err) : resolve(profile);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function _fetchProfile(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var _lock = new __WEBPACK_IMPORTED_MODULE_13_auth0_lock___default.a(__WEBPACK_IMPORTED_MODULE_19_misc_env__["a" /* default */].AUTH0_CLIENT_ID, __WEBPACK_IMPORTED_MODULE_19_misc_env__["a" /* default */].AUTH0_DOMAIN, {
  theme: {
    logo: __webpack_require__(217),
    primaryColor: '#A776E5'
  },
  languageDictionary: {
    title: 'Taxfyle'
  },
  auth: {
    sso: true,
    redirect: false,
    responseType: 'token',
    connections: ['taxfyle-com'],
    authParams: {
      scope: 'openid email user_metadata app_metadata picture'
    }
  }
});

var AuthStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default()(AuthStore, _Store);

  function AuthStore(_ref) {
    var storage = _ref.storage;

    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, AuthStore);

    var _this = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AuthStore.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(AuthStore)).apply(this, arguments));

    _initDefineProp(_this, 'user', _descriptor, _this);

    _initDefineProp(_this, 'token', _descriptor2, _this);

    _initDefineProp(_this, 'secondsUntilTokenExpires', _descriptor3, _this);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])('load token', function () {
      _this.token = storage.getItem('jwt');
      if (_this.tokenExpires.isBefore(__WEBPACK_IMPORTED_MODULE_15_moment___default()())) {
        _this.token = null;
      }
    });
    setInterval(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["action"])(function () {
      // Makes sure these are updated every second.
      if (!_this.token) {
        return;
      }
      var from = __WEBPACK_IMPORTED_MODULE_15_moment___default()();
      var to = _this.tokenExpires.clone();
      var diff = to.clone().startOf('second').diff(from.clone().startOf('second'));
      if (_this.secondsUntilTokenExpires < 1) {
        _this.logout();
        return;
      }
      _this.secondsUntilTokenExpires = __WEBPACK_IMPORTED_MODULE_15_moment___default.a.duration(diff).asSeconds();
    }), 1000);
    // Persist the token to storage whenever it changes.
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["autorun"])(function () {
      if (!_this.token) {
        storage.removeItem('jwt');
      } else {
        storage.setItem('jwt', _this.token);
      }
    });
    return _this;
  }

  /**
   * Decoded version of the token.
   */


  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default()(AuthStore, [{
    key: 'login',
    value: function login() {
      return this._showDialog({ initialScreen: 'login' });
    }
  }, {
    key: 'signup',
    value: function signup() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          hideLogin = _ref2.hideLogin;

      return this._showDialog({ initialScreen: 'signUp', allowLogin: !hideLogin });
    }
  }, {
    key: 'setToken',
    value: function setToken(token) {
      this.token = token;
    }
  }, {
    key: 'setReferrerMeta',
    value: function setReferrerMeta(data) {
      this.referrerParams = data;
    }
  }, {
    key: 'logout',
    value: function logout() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])('logout', function () {
        _this2.token = null;
      });
      location.reload();
    }
  }, {
    key: '_setUser',
    value: function _setUser(attributes) {
      if (false) {
        console.log('Token:', this.token);
        console.log('User:', attributes);
      } else {
        window.__token = this.token;
      }

      if (this.user) {
        this.user.set(attributes, { parse: true, stripUndefined: true });
      } else {
        var user = this.rootStore.userStore.users.get(attributes.user_id);
        if (!user) {
          user = new __WEBPACK_IMPORTED_MODULE_18_domain_CurrentUser__["a" /* default */](attributes, { rootStore: this.rootStore, stripUndefined: true, parse: true });
          this.rootStore.userStore.users.add(user);
        }

        this.user = user;
      }
      window.Intercom('boot', {
        app_id: __WEBPACK_IMPORTED_MODULE_19_misc_env__["a" /* default */].INTERCOM_APP_ID,
        email: this.user.email,
        name: this.user.displayName,
        user_id: this.user.id,
        custom_launcher_selector: '#intercom-launcher'
      });
      __WEBPACK_IMPORTED_MODULE_16_misc_analytics__["a" /* default */].identify(this.user.id, {
        name: this.user.name,
        email: this.user.displayName
      });
    }

    /**
     * Called by the router to check if we are still authenticated.
     */

  }, {
    key: 'checkAuthentication',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var expires, now, user;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                expires = this.tokenExpires;
                now = __WEBPACK_IMPORTED_MODULE_15_moment___default()();

                if (!now.add(2, 'minutes').isAfter(expires)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', false);

              case 5:
                if (this.user) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return _fetchProfile(this.token);

              case 8:
                user = _context.sent;

                this._setUser(user);

              case 10:
                return _context.abrupt('return', true);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                console.error('Error checking authentication:', _context.t0);
                return _context.abrupt('return', false);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function checkAuthentication() {
        return _ref3.apply(this, arguments);
      }

      return checkAuthentication;
    }()
  }, {
    key: 'onLogout',
    value: function onLogout(fn) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["reaction"])(function () {
        return _this3.token;
      }, function (token) {
        if (!token) {
          fn();
        }
      });
      return this;
    }
  }, {
    key: 'onLogin',
    value: function onLogin(fn) {
      var _this4 = this;

      if (this.user) {
        fn();
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["reaction"])(function () {
        return _this4.user;
      }, function (user) {
        if (user) {
          fn();
        }
      });

      return this;
    }
  }, {
    key: '_showDialog',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(opts) {
        var _this5 = this;

        var result, profile, token, _referrerParams, referrer, referrerMeta;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _login(opts);

              case 2:
                result = _context2.sent;

                if (!(result === false)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', false);

              case 5:
                profile = result.profile, token = result.token;


                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this5.token = token;
                  _this5._setUser(profile);
                });

                if (!(this.referrerParams && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.referrerParams).length > 0)) {
                  _context2.next = 11;
                  break;
                }

                _referrerParams = this.referrerParams, referrer = _referrerParams.referrer, referrerMeta = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_referrerParams, ['referrer']);
                _context2.next = 11;
                return this.rootStore.api.account.updateMeta({
                  referrer: referrer,
                  referrerMeta: referrerMeta
                });

              case 11:
                return _context2.abrupt('return', true);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _showDialog(_x2) {
        return _ref4.apply(this, arguments);
      }

      return _showDialog;
    }()
  }, {
    key: 'decodedToken',
    get: function get() {
      if (this.token) {
        return __WEBPACK_IMPORTED_MODULE_14_jwt_decode___default()(this.token);
      }

      return null;
    }
  }, {
    key: 'tokenExpires',
    get: function get() {
      var decoded = this.decodedToken;
      if (!decoded) return __WEBPACK_IMPORTED_MODULE_15_moment___default()();
      return __WEBPACK_IMPORTED_MODULE_15_moment___default.a.unix(decoded.exp);
    }
  }, {
    key: 'shouldShowReloadWarning',
    get: function get() {
      return this.secondsUntilTokenExpires <= 120;
    }
  }]);

  return AuthStore;
}(__WEBPACK_IMPORTED_MODULE_17_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'user', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'token', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'secondsUntilTokenExpires', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 9999;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'decodedToken', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'decodedToken'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tokenExpires', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'tokenExpires'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'shouldShowReloadWarning', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'shouldShowReloadWarning'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'login', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'login'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'signup', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'signup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setToken', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setToken'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setReferrerMeta', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setReferrerMeta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_setUser', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, '_setUser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'checkAuthentication', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'checkAuthentication'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_Card__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ConfirmDialog_ConfirmDialogState__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ConfirmDialog_ConfirmDialogState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_ConfirmDialog_ConfirmDialogState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_stripe__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_memoizee__);













var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}









var BillingStore = (_dec = __WEBPACK_IMPORTED_MODULE_16_mobx_task__["task"].resolved, _dec2 = __WEBPACK_IMPORTED_MODULE_16_mobx_task__["task"].resolved, _dec3 = __WEBPACK_IMPORTED_MODULE_16_mobx_task__["task"].resolved, (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default()(BillingStore, _Store);

  function BillingStore() {
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, BillingStore);

    var _this = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BillingStore.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(BillingStore)).apply(this, arguments));

    _initDefineProp(_this, 'customerRecord', _descriptor, _this);

    _this.cards = _this.collection({
      model: __WEBPACK_IMPORTED_MODULE_13_domain_Card__["a" /* default */]
    });
    _this.deletePaymentMethodDialog = new __WEBPACK_IMPORTED_MODULE_15_components_ConfirmDialog_ConfirmDialogState___default.a();
    _this.fetchCustomerRecord = _this.fetchCustomerRecord.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_18_memoizee___default()(fn, { promise: true, length: 0 });
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default()(BillingStore, [{
    key: 'showAddCardCheckout',
    value: function showAddCardCheckout() {
      var _this2 = this;

      var handler = __WEBPACK_IMPORTED_MODULE_17_utils_stripe__["a" /* checkout */]({
        token: function token(_token) {
          _this2.addCard(_token);
        }
      });

      handler.open({
        currency: 'USD',
        name: 'Taxfyle',
        description: 'Add Payment Method',
        email: this.rootStore.authStore.user.email,
        panelLabel: 'Add'
      });
    }
  }, {
    key: 'fetchCards',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, _ref3, cards;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.rootStore.api.cards.find().then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_mobx__["action"])(this.cards.set)), this.fetchCustomerRecord()]);

              case 2:
                _ref2 = _context.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 1);
                cards = _ref3[0];
                return _context.abrupt('return', cards);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCards() {
        return _ref.apply(this, arguments);
      }

      return fetchCards;
    }()
  }, {
    key: 'fetchCustomerRecord',
    value: function fetchCustomerRecord() {
      var _this3 = this;

      return this.rootStore.api.customers.get('me').then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_mobx__["action"])(function (r) {
        _this3.customerRecord = r;
        return _this3.customerRecord;
      }));
    }
  }, {
    key: 'changeDefaultMethod',
    value: function changeDefaultMethod(card) {
      var _this4 = this;

      return this.rootStore.api.customers.patch('me', {
        default_source: card.id
      }).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_mobx__["action"])(function (updated) {
        _this4.customer_record = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this4.customerRecord, updated);
      })).catch(function (err) {
        _this4.rootStore.flashMessageStore.create({
          type: 'failed',
          message: 'Changing default card failed: ' + err.message
        });
        console.error(err);
      });
    }
  }, {
    key: 'addCard',
    value: function addCard(token) {
      var _this5 = this;

      return this.rootStore.api.cards.create({
        source: token.id
      }).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_mobx__["action"])(this.cards.set)).then(function (card) {
        return _this5.changeDefaultMethod(card).then(function () {
          return card;
        });
      });
    }
  }, {
    key: 'deletePaymentMethod',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(card) {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!card.isDefaultSource) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return this.deletePaymentMethodDialog.show();

              case 4:
                if (_context2.sent) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                return _context2.abrupt('return', this.rootStore.api.cards.destroy(card.id).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_mobx__["action"])(function () {
                  return _this6.cards.remove(card);
                })));

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deletePaymentMethod(_x) {
        return _ref4.apply(this, arguments);
      }

      return deletePaymentMethod;
    }()
  }, {
    key: 'busy',
    get: function get() {
      return this.changeDefaultMethod.pending || this.fetchCards.pending || this.addCard.pending || this.deletePaymentMethod.pending;
    }
  }, {
    key: 'hasAnyPaymentMethods',
    get: function get() {
      return this.cards.length > 0;
    }
  }]);

  return BillingStore;
}(__WEBPACK_IMPORTED_MODULE_12_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'customerRecord', [__WEBPACK_IMPORTED_MODULE_14_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'busy', [__WEBPACK_IMPORTED_MODULE_14_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'busy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasAnyPaymentMethods', [__WEBPACK_IMPORTED_MODULE_14_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'hasAnyPaymentMethods'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showAddCardCheckout', [__WEBPACK_IMPORTED_MODULE_14_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showAddCardCheckout'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fetchCards', [__WEBPACK_IMPORTED_MODULE_16_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchCards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fetchCustomerRecord', [__WEBPACK_IMPORTED_MODULE_16_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchCustomerRecord'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeDefaultMethod', [_dec], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'changeDefaultMethod'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addCard', [_dec2], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'addCard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deletePaymentMethod', [_dec3], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'deletePaymentMethod'), _class.prototype)), _class));

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_Coupon__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_autobind_decorator__);








var _class;






var CouponStore = __WEBPACK_IMPORTED_MODULE_10_autobind_decorator___default()(_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CouponStore, _Store);

  function CouponStore() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CouponStore);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CouponStore.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CouponStore)).apply(this, arguments));

    _this.coupons = _this.collection({
      model: __WEBPACK_IMPORTED_MODULE_8__domain_Coupon__["a" /* UserCoupon */]
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CouponStore, [{
    key: 'getCoupons',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.retryOnNetworkFailure(function () {
                  return _this2.api.coupons.getUserCoupons();
                }).retryMessage('Network issue while loading coupons, retrying...').networkIssueMessage('Could not reach the coupon system').then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["action"])(this.coupons.set));

              case 2:
                return _context.abrupt('return', this.coupons);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCoupons() {
        return _ref.apply(this, arguments);
      }

      return getCoupons;
    }()
  }, {
    key: 'addCoupon',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(code) {
        var _this3 = this;

        var userCoupon, body;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.rootStore.retryOnNetworkFailure(function () {
                  return _this3.api.coupons.addCouponToUser(code);
                }).retryMessage('Network issue while applying coupon, retrying...').networkIssueMessage('Could not reach the coupon system');

              case 3:
                userCoupon = _context2.sent;

                if (!(userCoupon === false)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', { success: false });

              case 6:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this3.coupons.set(userCoupon);
                });
                return _context2.abrupt('return', {
                  success: true
                });

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);
                body = _context2.t0.response ? _context2.t0.response.data : { message: _context2.t0.message };

                this.rootStore.flashMessageStore.create(body.message).failed().autoDismiss();
                return _context2.abrupt('return', {
                  success: false,
                  message: body.message,
                  errors: body.errors
                });

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function addCoupon(_x) {
        return _ref2.apply(this, arguments);
      }

      return addCoupon;
    }()
  }, {
    key: 'calculateNewPrice',
    value: function calculateNewPrice(currentPrice) {
      var _this4 = this;

      return this.rootStore.retryOnNetworkFailure(function () {
        return _this4.api.coupons.calculateNewPrice(currentPrice);
      }).retryMessage('Network issue while calculating discount, retrying...').networkIssueMessage('Could not reach the coupon system.');
    }
  }, {
    key: 'api',
    get: function get() {
      return this.rootStore.api;
    }
  }]);

  return CouponStore;
}(__WEBPACK_IMPORTED_MODULE_7_libx__["Store"])) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_Document__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_arrayUtil__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_arrayUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_utils_arrayUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_memoizee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_FlashMessages_FlashMessageStore__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_FlashMessages_FlashMessageStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_FlashMessages_FlashMessageStore__);













var _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var sortByDateUpdated = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils_arrayUtil__["makeMomentSorter"])('desc', function (x) {
  return x.dateUpdated;
});

var DocumentStore = __WEBPACK_IMPORTED_MODULE_18_autobind_decorator___default()(_class = (_class2 = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default()(DocumentStore, _Store);

  function DocumentStore(_ref) {
    var storage = _ref.storage;

    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, DocumentStore);

    var _this = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumentStore.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(DocumentStore)).apply(this, arguments));

    _initDefineProp(_this, 'stagedDocuments', _descriptor, _this);

    _initDefineProp(_this, 'loading', _descriptor2, _this);

    _this.documents = _this.collection({
      model: __WEBPACK_IMPORTED_MODULE_13_domain_Document__["a" /* default */],
      getModelId: function getModelId(doc) {
        return doc.id;
      },
      idAttribute: 'Key' // on the source (AWS result)
    });

    _this.rootStore.authStore.onLogout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["action"])(function () {
      return _this.documents.clear();
    }));
    _this.fetchDocuments = __WEBPACK_IMPORTED_MODULE_17_memoizee___default()(_this.fetchDocuments, { promise: true });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default()(DocumentStore, [{
    key: 'documentsInCategory',
    value: function documentsInCategory(category) {
      var all = this.allDocuments;
      return all.filter(function (x) {
        return x.category === category;
      });
    }
  }, {
    key: 'update',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(document, data) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.api.documents.patch(document.id, {
                  meta: {
                    name: data.label,
                    year: data.year,
                    type: data.type,
                    category: data.category,
                    notes: data.description || ''
                  }
                });

              case 2:
                result = _context.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  document.set(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
                    dateUpdated: __WEBPACK_IMPORTED_MODULE_16_moment___default()(Date.parse(result.LastModified))
                  }));
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'stageFiles',
    value: function stageFiles(category, files, jobId) {
      var _this2 = this,
          _stagedDocuments;

      files = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(files);
      var documents = files.map(function (f) {
        return new __WEBPACK_IMPORTED_MODULE_13_domain_Document__["a" /* default */]({
          category: category,
          label: f.name,
          fileObject: f,
          uploaded: false,
          jobId: jobId,
          uploadedBy: _this2.rootStore.authStore.user
        }, {
          rootStore: _this2.rootStore
        });
      });

      documents.forEach(function (d) {
        return d.editor.startEditing();
      });
      (_stagedDocuments = this.stagedDocuments).unshift.apply(_stagedDocuments, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(documents));
    }
  }, {
    key: 'save',
    value: function save(document, attrs) {
      if (document.isNew) {
        document.set(attrs);
        this.upload(document);
        return;
      }

      // Update takes care of setting.
      // Returning here will defer closing the
      // editor until the document has been saved.
      return this.update(document, attrs);
    }
  }, {
    key: 'removeStagedDocument',
    value: function removeStagedDocument(document) {
      this.stagedDocuments.remove(document);
    }
  }, {
    key: 'download',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(document) {
        var waitFn, newTab, _ref4, DownloadLink;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                waitFn = 'document.write(\'' + '\n      <div style="padding: 5%; text-align: center; color: #2395F3; font-size: 28px; font-family: arial, helvetica; font-weight: 300">\n        Please wait, generating secure download link - this can take a few seconds.\n      </div>\n    ' + '\')';
                newTab = window.open('javascript:' + waitFn, '_blank');
                _context2.next = 4;
                return this.rootStore.api.documents.get(document.id);

              case 4:
                _ref4 = _context2.sent;
                DownloadLink = _ref4.DownloadLink;

                newTab.location.assign(DownloadLink);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function download(_x3) {
        return _ref3.apply(this, arguments);
      }

      return download;
    }()
  }, {
    key: 'fetchDocuments',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;

        var mapped;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.toggleLoading(true);
                _context3.prev = 1;
                _context3.next = 4;
                return this.rootStore.retryOnNetworkFailure(function () {
                  return _this3.rootStore.api.documents.find();
                }).retryMessage('Document system is unreachable, retrying...').recoveredMessage('Never mind, we\'re back!').networkIssueMessage('Could not load documents due to a network issue.');

              case 4:
                mapped = _context3.sent;

                if (!(mapped === false)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return');

              case 7:

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  var updated = _this3.documents.set(mapped);
                  var userIds = updated.map(function (x) {
                    return x.uploadedBy && x.uploadedBy.id;
                  }).filter(function (x) {
                    return x;
                  });
                  _this3.rootStore.userStore.refreshProfiles(userIds);
                });

              case 8:
                _context3.prev = 8;

                this.toggleLoading(false);
                return _context3.finish(8);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1,, 8, 11]]);
      }));

      function fetchDocuments() {
        return _ref5.apply(this, arguments);
      }

      return fetchDocuments;
    }()
  }, {
    key: 'upload',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(document) {
        var _this4 = this;

        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.rootStore.api.documents.upload({
                  file: document.fileObject,
                  job: document.jobId,
                  meta: {
                    notes: document.description,
                    category: document.category,
                    type: document.type,
                    uploader: document.uploadedBy.id,
                    year: document.year,
                    name: document.label
                  },
                  progress: function progress(_ref7) {
                    var loaded = _ref7.loaded,
                        total = _ref7.total;

                    if (total) {
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                        document.uploadProgress = loaded / total * 100;
                      });
                    }
                  }
                }).catch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["action"])(function (err) {
                  console.error('Upload failed', err);
                  _this4.rootStore.flashMessageStore.create({
                    message: 'Upload failed: ' + err.message,
                    type: __WEBPACK_IMPORTED_MODULE_19_components_FlashMessages_FlashMessageStore__["FlashMessageTypes"].ERROR
                  });
                  document.editor.startEditing();
                  return false;
                }));

              case 2:
                result = _context4.sent;


                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  // When upload completes, remove from staging and add to collection.
                  _this4.stagedDocuments.remove(document);
                  document.set(result, { parse: true });
                  document.set({
                    uploadProgress: null,
                    fileObject: null
                  });

                  _this4.documents.add(document);
                });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function upload(_x4) {
        return _ref6.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: 'toggleLoading',
    value: function toggleLoading(loading) {
      this.loading = loading;
    }
  }, {
    key: 'allDocuments',
    get: function get() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.stagedDocuments.slice()), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.documents.map(function (x) {
        return x;
      }).sort(sortByDateUpdated)));
    }
  }]);

  return DocumentStore;
}(__WEBPACK_IMPORTED_MODULE_14_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'stagedDocuments', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'loading', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'allDocuments', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'allDocuments'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'stageFiles', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'stageFiles'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'save'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeStagedDocument', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'removeStagedDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleLoading', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleLoading'), _class2.prototype)), _class2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (DocumentStore);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_JobEvent__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_memoizee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_misc_links__ = __webpack_require__(41);









var _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}











var EventStore = __WEBPACK_IMPORTED_MODULE_13_autobind_decorator___default()(_class = (_class2 = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(EventStore, _Store);

  function EventStore() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, EventStore);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EventStore.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(EventStore)).apply(this, arguments));

    _this.jobEvents = _this.collection({
      model: __WEBPACK_IMPORTED_MODULE_9_domain_JobEvent__["a" /* default */]
    });
    _this.fetchJobEvents = _this.fetchJobEvents.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_12_memoizee___default()(fn, { promise: true, length: 1 });
    });
    _this.rootStore.api.jobEvents.on('created', _this.onRemoteUpdate);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(EventStore, [{
    key: 'onRemoteUpdate',
    value: function onRemoteUpdate(data) {
      var isNew = !this.jobEvents.get(data.id);
      var event = this.jobEvents.set(data);
      if (isNew) {
        var opts = this._getNotificationOpts(event);
        if (opts) {
          this.rootStore.desktopNotificationStore.show(opts);
        }
      }
    }
  }, {
    key: 'fetchJobEvents',
    value: function fetchJobEvents(jobId) {
      return this.rootStore.api.jobEvents.find({ job: jobId }).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_mobx__["action"])(this.jobEvents.set));
    }
  }, {
    key: '_getNotificationOpts',
    value: function _getNotificationOpts(event) {
      var notifyOpts = {
        timeout: 20,
        onClick: function onClick() {
          return __WEBPACK_IMPORTED_MODULE_14_react_router__["browserHistory"].push(__WEBPACK_IMPORTED_MODULE_16_misc_links__["a" /* default */].projectDetails(event.jobId));
        }
      };
      var job = event.job;
      // Don't show notifications for events the current user initiated.
      if (event.triggeredBy === this.rootStore.authStore.user) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__["match"])(event.eventType, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        UNCLAIMED: function UNCLAIMED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' transferred to pool',
            body: event.triggeredBy.displayName + ' transferred the job to the pool.',
            icon: event.triggeredBy.avatar
          });
        },
        CLAIMED: function CLAIMED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' has been assigned',
            body: job.name + ' assigned to ' + job.provider.displayName + '.',
            icon: job.provider.avatar
          });
        },
        UPDATED: function UPDATED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' updated',
            body: event.triggeredBy.displayName + ' updated the details of ' + job.name,
            icon: event.triggeredBy.avatar
          });
        },
        AMENDED: function AMENDED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' amended',
            body: event.triggeredBy.displayName + ' amended ' + job.name,
            icon: event.triggeredBy.avatar
          });
        },
        REOPENED: function REOPENED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' reopened',
            body: event.triggeredBy.displayName + ' reopened ' + job.name,
            icon: event.triggeredBy.avatar
          });
        },
        TRANSFERRED: function TRANSFERRED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' transferred',
            body: job.name + ' transferred to ' + event.newProvider.displayName,
            icon: event.newProvider.avatar
          });
        },
        CLOSED: function CLOSED() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, notifyOpts, {
            title: job.name + ' was closed',
            body: job.name + ' was closed by ' + job.provider.displayName + '.',
            icon: job.provider.avatar
          });
        }
      }, __WEBPACK_IMPORTED_MODULE_15_utils_patternMatchUtil__["match"].DEFAULT, function () {
        return null;
      }));
    }
  }]);

  return EventStore;
}(__WEBPACK_IMPORTED_MODULE_8_libx__["Store"]), (_applyDecoratedDescriptor(_class2.prototype, 'onRemoteUpdate', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRemoteUpdate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchJobEvents', [__WEBPACK_IMPORTED_MODULE_11_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'fetchJobEvents'), _class2.prototype)), _class2)) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedAccountStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_misc_QuovoAPI__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_LinkedAccount__ = __webpack_require__(420);










var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var LinkedAccountStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(LinkedAccountStore, _Store);

  function LinkedAccountStore() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, LinkedAccountStore);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LinkedAccountStore.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(LinkedAccountStore)).apply(this, arguments));

    _this.linkedAccounts = _this.collection({
      mapperFn: function mapperFn(json) {
        return json.provider === 'quovo' ? new __WEBPACK_IMPORTED_MODULE_12_domain_LinkedAccount__["a" /* QuovoLinkedAccount */](json, { rootStore: _this.rootStore, parse: true }) : new __WEBPACK_IMPORTED_MODULE_12_domain_LinkedAccount__["b" /* PlaidLinkedAccount */](json, { rootStore: _this.rootStore, parse: true });
      }
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(LinkedAccountStore, [{
    key: 'addAccount',
    value: function addAccount(account) {
      // Accounts are created by designated providers, so no async going
      // on here.
      this.linkedAccounts.items.add(account);
    }
  }, {
    key: 'fetchLinkedAccounts',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var quovoAccounts;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.retryOnNetworkFailure(function () {
                  return _this2.quovoAPI.getAccounts().then(function (data) {
                    return data.accounts.map(function (a) {
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, a, { provider: 'quovo' });
                    });
                  });
                }).retryMessage('Could not load linked accounts, retrying...').recoveredMessage('.. and we\'re back in business!').networkIssueMessage('Linked account system is unreachable.');

              case 2:
                quovoAccounts = _context.sent;


                if (quovoAccounts !== false) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                    return _this2.linkedAccounts.set(quovoAccounts);
                  });
                }

                return _context.abrupt('return', this.linkedAccounts);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchLinkedAccounts() {
        return _ref.apply(this, arguments);
      }

      return fetchLinkedAccounts;
    }()
  }, {
    key: 'destroy',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(account) {
        var _this3 = this;

        var success;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(account instanceof __WEBPACK_IMPORTED_MODULE_12_domain_LinkedAccount__["b" /* PlaidLinkedAccount */])) {
                  _context2.next = 3;
                  break;
                }

                this.linkedAccounts.remove(account);
                return _context2.abrupt('return');

              case 3:
                _context2.next = 5;
                return this.rootStore.retryOnNetworkFailure(function () {
                  return _this3.quovoAPI.deleteAccount(account.id);
                }).retryMessage('Network issue while deleting linked account, retrying...').networkIssueMessage('Linked account system is unreachable.');

              case 5:
                success = _context2.sent;

                if (!(success === false)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return');

              case 8:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this3.linkedAccounts.remove(account);
                });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function destroy(_x) {
        return _ref2.apply(this, arguments);
      }

      return destroy;
    }()
  }, {
    key: 'quovoAPI',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_11_misc_QuovoAPI__["a" /* default */].create(this.rootStore.authStore.token);
    }
  }]);

  return LinkedAccountStore;
}(__WEBPACK_IMPORTED_MODULE_10_libx__["Store"]), (_applyDecoratedDescriptor(_class.prototype, 'quovoAPI', [__WEBPACK_IMPORTED_MODULE_9_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'quovoAPI'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addAccount', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'addAccount'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assert__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_memoizee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_domain_Message__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_domain_Conversation__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_layer_websdk__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_layer_websdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_layer_websdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_path__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils_layerUtil__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils_layerUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_utils_layerUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils_arrayUtil__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils_arrayUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_utils_arrayUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_misc_notifier__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_misc_notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_misc_notifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_misc_env__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ifvisible_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ifvisible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_ifvisible_js__);










var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}
















var sortByDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils_arrayUtil__["makeMomentSorter"])('asc', function (x) {
  return x ? x.sentAt : __WEBPACK_IMPORTED_MODULE_16_moment___default()();
});

var MessageStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(MessageStore, _Store);

  function MessageStore() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, MessageStore);

    // This store is reused across multiple projects, so we assert
    // that the injected stores have the methods we need.
    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MessageStore.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(MessageStore)).apply(this, arguments));

    __WEBPACK_IMPORTED_MODULE_10_assert___default()(_this.rootStore, 'no rootStore passed to MessageStore');
    __WEBPACK_IMPORTED_MODULE_10_assert___default()(_this.rootStore.userStore, 'rootStore needs a userStore');
    __WEBPACK_IMPORTED_MODULE_10_assert___default()(_this.rootStore.userStore.refreshProfile, 'userStore needs a refreshProfile(auth0Id) method');
    __WEBPACK_IMPORTED_MODULE_10_assert___default()(_this.rootStore.userStore.userByAuthId, 'userStore needs a userByAuthId(auth0Id) method');
    __WEBPACK_IMPORTED_MODULE_10_assert___default()(_this.rootStore.authStore, 'rootStore needs an authStore');
    __WEBPACK_IMPORTED_MODULE_10_assert___default()(_this.rootStore.authStore.onLogout, 'authStore needs an onLogout(fn) method');

    _this.markAsReadQueue = [];
    _this.onIncomingMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_misc_notifier__["createNotifier"])();
    _this.messages = _this.collection({ model: __WEBPACK_IMPORTED_MODULE_13_domain_Message__["a" /* default */] });
    _this.conversations = _this.collection({ model: __WEBPACK_IMPORTED_MODULE_14_domain_Conversation__["a" /* default */] });
    _this.fetchMessagesForConversation = __WEBPACK_IMPORTED_MODULE_11_memoizee___default()(_this.fetchMessagesForConversation, { promise: true });
    _this.getLayerClient = __WEBPACK_IMPORTED_MODULE_18_utils_layerUtil___default()({
      authStore: _this.rootStore.authStore,
      auth0ClientId: __WEBPACK_IMPORTED_MODULE_21_misc_env__["a" /* default */].AUTH0_CLIENT_ID,
      appId: __WEBPACK_IMPORTED_MODULE_21_misc_env__["a" /* default */].LAYER_APP_ID,
      delegationEndpoint: 'https://' + __WEBPACK_IMPORTED_MODULE_17_path___default.a.join(__WEBPACK_IMPORTED_MODULE_21_misc_env__["a" /* default */].AUTH0_DOMAIN, '/delegation')
    });
    _this.rootStore.authStore.onLogout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["action"])(function () {
      _this.messages.clear();
      _this.conversations.clear();
    })).onLogin(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["action"])(function () {
      _this.setupNotifications();
    }));

    __WEBPACK_IMPORTED_MODULE_22_ifvisible_js___default.a.on('focus', function () {
      return _this.drainMarkAsReadQueue();
    });
    __WEBPACK_IMPORTED_MODULE_22_ifvisible_js___default.a.on('wakeup', function () {
      return _this.drainMarkAsReadQueue();
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(MessageStore, [{
    key: 'drainMarkAsReadQueue',
    value: function drainMarkAsReadQueue() {
      var _this2 = this;

      if (this.markAsReadQueue.length === 0) {
        return;
      }

      this.markAsReadQueue.forEach(function (message) {
        _this2.markAsRead(message);
      });
      this.markAsReadQueue = [];
    }
  }, {
    key: 'setupNotifications',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var client;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getLayerClient();

              case 2:
                client = _context2.sent;

                client.on('messages:notify', function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(evt) {
                    var layerMessage, message;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            layerMessage = evt.message;

                            if (!(layerMessage instanceof __WEBPACK_IMPORTED_MODULE_15_layer_websdk___default.a.Message === false)) {
                              _context.next = 3;
                              break;
                            }

                            return _context.abrupt('return');

                          case 3:
                            _context.next = 5;
                            return _this3._addMessages([layerMessage]);

                          case 5:
                            message = _this3.messages.get(layerMessage.id);

                            _this3.onIncomingMessage.notify(message);

                          case 7:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this3);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setupNotifications() {
        return _ref.apply(this, arguments);
      }

      return setupNotifications;
    }()
  }, {
    key: 'messagesIn',
    value: function messagesIn(conversationId) {
      var messages = this.messages.filter(function (x) {
        return x.conversationId === conversationId;
      });
      return messages.sort(sortByDate);
    }

    /**
     * Gets the unread message count in the conversation.
     * @param conversationId
     */

  }, {
    key: 'unreadIn',
    value: function unreadIn(conversationId) {
      return this.messages.filter(function (x) {
        return x.conversationId === conversationId && x.isRead === false;
      }).length;
    }
  }, {
    key: 'loadMore',
    value: function loadMore(conversationId) {
      var convo = this.conversations.get(conversationId);
      convo.loadingMore = true;
      convo.query.update({
        paginationWindow: convo.paginationWindow += 30
      });
    }
  }, {
    key: '_addMessages',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(data) {
        var _this4 = this;

        var userIds;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Adds messages to the store but makes sure
                // all related entities are present first.
                // Fetch all users
                userIds = data.map(function (x) {
                  return x.sender.userId;
                }).filter(function (x) {
                  return x;
                });
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(userIds.map(function (id) {
                  return _this4.rootStore.userStore.refreshProfile(id);
                }));

              case 3:

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this4.messages.set(data);
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _addMessages(_x2) {
        return _ref3.apply(this, arguments);
      }

      return _addMessages;
    }()
  }, {
    key: 'fetchMessagesForConversation',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(conversationId) {
        var _this5 = this;

        var client, convo, query;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getLayerClient();

              case 2:
                client = _context5.sent;
                convo = this.conversations.get(conversationId);

                if (!(convo && convo.query)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt('return', this.messagesIn(conversationId));

              case 6:

                convo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  return _this5.conversations.set({
                    id: conversationId,
                    query: client.createQuery({
                      model: __WEBPACK_IMPORTED_MODULE_15_layer_websdk___default.a.Query.Message,
                      predicate: 'conversation.id = "' + conversationId + '"'
                    })
                  });
                });

                query = convo.query;
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  // This will resolve the promise the first time, and then
                  // update the messages with changes.
                  query.on('change', function () {
                    var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(evt) {
                      var data;
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              if (evt.type === 'data') {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                                  convo.loadingMore = false;
                                });
                              }

                              data = query.data;
                              _context4.next = 4;
                              return _this5._addMessages(data);

                            case 4:

                              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                                convo.hasMoreMessages = !query.pagedToEnd;
                              });

                              resolve();

                            case 6:
                            case 'end':
                              return _context4.stop();
                          }
                        }
                      }, _callee4, _this5);
                    }));

                    return function (_x4) {
                      return _ref5.apply(this, arguments);
                    };
                  }());
                }));

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchMessagesForConversation(_x3) {
        return _ref4.apply(this, arguments);
      }

      return fetchMessagesForConversation;
    }()
  }, {
    key: 'sendMessage',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(_ref7) {
        var _this6 = this;

        var conversationId = _ref7.conversationId,
            text = _ref7.text;
        var client, convo, message;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getLayerClient();

              case 2:
                client = _context6.sent;
                convo = client.getConversation(conversationId, true);
                message = convo.createMessage(text);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_mobx__["runInAction"])(function () {
                  _this6.messages.set(message, { createdHere: true });
                });
                message.send({
                  title: 'Message from ' + this.rootStore.authStore.user.displayName,
                  text: text
                });
                this.rootStore.soundStore.playSendMessage();

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendMessage(_x5) {
        return _ref6.apply(this, arguments);
      }

      return sendMessage;
    }()
  }, {
    key: 'markAsRead',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(message) {
        var client, messageInstance;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(__WEBPACK_IMPORTED_MODULE_22_ifvisible_js___default.a.now('hidden') || __WEBPACK_IMPORTED_MODULE_22_ifvisible_js___default.a.now('idle'))) {
                  _context7.next = 3;
                  break;
                }

                this.markAsReadQueue.push(message);
                return _context7.abrupt('return');

              case 3:
                _context7.next = 5;
                return this.getLayerClient();

              case 5:
                client = _context7.sent;

                // This triggers Layer to update the read status.
                messageInstance = client.getMessage(message.id);

                messageInstance.isRead = true;

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function markAsRead(_x6) {
        return _ref8.apply(this, arguments);
      }

      return markAsRead;
    }()
  }]);

  return MessageStore;
}(__WEBPACK_IMPORTED_MODULE_12_libx__["Store"]), (_applyDecoratedDescriptor(_class.prototype, 'loadMore', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadMore'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_domain_Project__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__taxfyle_web_commons_lib_utils_arrayUtil__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__taxfyle_web_commons_lib_utils_arrayUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__taxfyle_web_commons_lib_utils_arrayUtil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_memoizee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__misc_links__ = __webpack_require__(41);











var _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}











var ProjectStore = __WEBPACK_IMPORTED_MODULE_10_autobind_decorator___default()(_class = (_class2 = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(ProjectStore, _Store);

  function ProjectStore() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ProjectStore);

    var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectStore.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ProjectStore)).apply(this, arguments));

    _initDefineProp(_this, 'loading', _descriptor, _this);

    _this.rootStore.authStore.onLogout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(function () {
      _this.fetchProjects.clear();
      _this.projects.clear();
    }));
    _this.projects = _this.collection({
      model: __WEBPACK_IMPORTED_MODULE_12_domain_Project__["a" /* default */]
    });
    _this.rootStore.api.jobs.on('created', _this.onRemoteUpdate);
    _this.rootStore.api.jobs.on('updated', _this.onRemoteUpdate);
    _this.rootStore.api.jobs.on('patched', _this.onRemoteUpdate);
    _this.fetchProject = _this.fetchProject.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_17_memoizee___default()(fn, { promise: true, length: 1 });
    });
    _this.fetchProjects = _this.fetchProjects.wrap(function (fn) {
      return __WEBPACK_IMPORTED_MODULE_17_memoizee___default()(fn, { promise: true, length: 0 });
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ProjectStore, [{
    key: 'setLoading',
    value: function setLoading(loading) {
      this.loading = loading;
    }
  }, {
    key: 'onRemoteUpdate',
    value: function onRemoteUpdate(data) {
      var _this2 = this;

      return this.freshenUp(data).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(function () {
        var current = _this2.projects.get(data.id);
        var prevStatus = current && current.status;
        var updated = _this2.projects.set(data);
        if (prevStatus === 'CLAIMED' && updated.status === 'CLOSED') {
          __WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push(__WEBPACK_IMPORTED_MODULE_18__misc_links__["a" /* default */].rateProject(updated.id));
        }
        // const notifyOpts = {
        //   tag: `${updated.id}-${updated.status}`,
        //   icon: updated.provider && updated.provider.avatar,
        //   timeout: 20,
        //   onClick: () => {
        //     browserHistory.push(links.projectDetails(updated.id))
        //   }
        // }
        // if (prevStatus === 'UNCLAIMED' && updated.status === 'CLAIMED') {
        //   this.rootStore.desktopNotificationStore.show({
        //     ...notifyOpts,
        //     title: 'Job picked up!',
        //     body: `${updated.name} just got picked up by ${updated.provider.displayName} - woohoo!`
        //   })
        //   if (updated.conversation) {
        //     this.rootStore.messageStore.fetchMessagesForConversation(updated.conversation.id)
        //   }
        // } else if (prevStatus === 'CLAIMED' && updated.status === 'CLOSED') {
        //   this.rootStore.desktopNotificationStore.show({
        //     ...notifyOpts,
        //     title: 'Job closed!',
        //     body: `${updated.name} was closed by ${updated.provider.displayName} - what a great day it is!`
        //   })
        //   browserHistory.push(links.rateProject(updated.id))
        // }
        return updated;
      }));
    }
  }, {
    key: 'projectForConversation',
    value: function projectForConversation(conversationId) {
      return this.projects.find(function (x) {
        return x.conversationId === conversationId;
      });
    }
  }, {
    key: 'fetchProject',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(projectId) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.rootStore.api.jobs.get(projectId).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(this.projects.set)));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchProject(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchProject;
    }()
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var jobs;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.rootStore.retryOnNetworkFailure(function () {
                  return _this3.rootStore.api.jobs.find();
                });

              case 2:
                jobs = _context2.sent;

                if (!(jobs === false)) {
                  _context2.next = 6;
                  break;
                }

                this.fetchProjects.clear();
                return _context2.abrupt('return');

              case 6:
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(jobs.map(function (job) {
                  return _this3.freshenUp(job);
                }));

              case 8:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["runInAction"])(function () {
                  _this3.projects.set(jobs);
                });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchProjects() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'calculatePrice',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(jobId) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.rootStore.api.jobs.price(jobId));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function calculatePrice(_x2) {
        return _ref3.apply(this, arguments);
      }

      return calculatePrice;
    }()
  }, {
    key: 'freshenUp',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(job) {
        var providerId;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // `job` is not a Project instance but what we get from the API.
                providerId = job.provider_user_id;
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([providerId && this.rootStore.userStore.refreshProfile(providerId), job.layerConversation && job.status === 'CLAIMED' && this.rootStore.messageStore.fetchMessagesForConversation(job.layerConversation)]));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function freshenUp(_x3) {
        return _ref4.apply(this, arguments);
      }

      return freshenUp;
    }()
  }, {
    key: 'rate',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(project, params) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.rootStore.api.jobs.rate(project.id, params);

              case 2:
                result = _context5.sent;

                this.projects.set(result);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function rate(_x4, _x5) {
        return _ref5.apply(this, arguments);
      }

      return rate;
    }()
  }, {
    key: 'createJob',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(data) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', this.rootStore.api.jobs.create(data).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(this.projects.set)));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createJob(_x6) {
        return _ref6.apply(this, arguments);
      }

      return createJob;
    }()
  }, {
    key: 'updateJob',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(id, data) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.rootStore.api.jobs.patch(id, data).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_mobx__["action"])(this.projects.set)));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateJob(_x7, _x8) {
        return _ref7.apply(this, arguments);
      }

      return updateJob;
    }()
  }, {
    key: 'orderedJobs',
    get: function get() {
      return this.projects.map(function (x) {
        return x;
      }).sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__taxfyle_web_commons_lib_utils_arrayUtil__["makeMomentSorter"])('desc', function (x) {
        return x.dateModified;
      }));
    }
  }]);

  return ProjectStore;
}(__WEBPACK_IMPORTED_MODULE_11_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loading', [__WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setLoading', [__WEBPACK_IMPORTED_MODULE_13_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setLoading'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'orderedJobs', [__WEBPACK_IMPORTED_MODULE_13_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'orderedJobs'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRemoteUpdate', [__WEBPACK_IMPORTED_MODULE_13_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRemoteUpdate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchProject', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'fetchProject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchProjects', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'fetchProjects'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'calculatePrice', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'calculatePrice'), _class2.prototype)), _class2)) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_domain_User__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_memoizee__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_memoizee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_memoizee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx__);













var UserStore = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(UserStore, _Store);

  function UserStore() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UserStore);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UserStore.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(UserStore)).apply(this, arguments));

    _this.refreshProfile = __WEBPACK_IMPORTED_MODULE_10_memoizee___default()(_this.refreshProfile, { promise: true, length: 1 });
    _this.users = _this.collection({
      model: __WEBPACK_IMPORTED_MODULE_9_domain_User__["a" /* default */],
      idAttribute: 'user_id',
      getModelId: function getModelId(user) {
        return user.id;
      }
    });

    _this.rootStore.authStore.onLogout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(function () {
      _this.refreshProfile.clear();
      _this.users.clear();
    }));
    window.us = _this;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UserStore, [{
    key: 'userByAuthId',
    value: function userByAuthId(id) {
      return this.users.get(id);
    }
  }, {
    key: 'changeEmail',
    value: function changeEmail(newEmail) {
      return this.rootStore.api.profiles.patch('me', {
        email_address: newEmail
      }).then(this.users.set);
    }
  }, {
    key: 'refreshProfile',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var _this2 = this;

        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.api.profiles.get(id);

              case 2:
                result = _context.sent;
                return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
                  return _this2.users.set(result);
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshProfile(_x) {
        return _ref.apply(this, arguments);
      }

      return refreshProfile;
    }()
  }, {
    key: 'refreshProfiles',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(ids) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(ids.map(function (id) {
                  return _this3.refreshProfile(id);
                })));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshProfiles(_x2) {
        return _ref2.apply(this, arguments);
      }

      return refreshProfiles;
    }()
  }]);

  return UserStore;
}(__WEBPACK_IMPORTED_MODULE_8_libx__["Store"]);


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RootStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LinkedAccountsManager_LinkedAccountsManagerState__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_FlashMessages_FlashMessageStore__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_FlashMessages_FlashMessageStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_FlashMessages_FlashMessageStore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_misc_encryptedLocalStorage__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_misc_encryptedLocalStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_misc_encryptedLocalStorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_misc_localStorage__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_misc_TaxfyleAPI__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_errorUtil__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AuthStore__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProjectStore__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UserStore__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MessageStore__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CouponStore__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DocumentStore__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EventStore__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BillingStore__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LinkedAccountStore__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_ProjectDetailsStore__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_ProjectWizardStore__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_RateProjectStore__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_DocumentsScreenStore__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_SoundStore__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_DesktopNotificationStore__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_CouponsScreenStore__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_ProfileEditorStore__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_ProjectsScreenStore__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_IntercomStore__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_BillingScreenStore__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_GettingStartedStore__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_ChangeEmailDialogStore__ = __webpack_require__(828);
































// let's see how this pans out.
__WEBPACK_IMPORTED_MODULE_2_mobx___default.a.useStrict(true);

// WARNING: Changing this will invalidate everything that was
// saved with a previous password.
var storagePassword = '9264P&%oCPyk!U){r<mqc?C8yI]71Q';

var RootStore = function () {
  function RootStore() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RootStore);

    this.storage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_misc_localStorage__["a" /* storageSupported */])() ? __WEBPACK_IMPORTED_MODULE_5_misc_encryptedLocalStorage___default()(storagePassword) : __WEBPACK_IMPORTED_MODULE_6_misc_localStorage__["b" /* default */];
    var makeOpts = function makeOpts() {
      return { rootStore: _this, storage: _this.storage };
    };
    __WEBPACK_IMPORTED_MODULE_2_mobx___default.a.runInAction(function () {
      _this.authStore = new __WEBPACK_IMPORTED_MODULE_9__AuthStore__["a" /* default */](makeOpts());
      _this.api = new __WEBPACK_IMPORTED_MODULE_7_misc_TaxfyleAPI__["a" /* default */]({ authStore: _this.authStore });

      _this.documentStore = new __WEBPACK_IMPORTED_MODULE_14__DocumentStore__["a" /* default */](makeOpts());
      _this.userStore = new __WEBPACK_IMPORTED_MODULE_11__UserStore__["a" /* default */](makeOpts());
      _this.messageStore = new __WEBPACK_IMPORTED_MODULE_12__MessageStore__["a" /* default */](makeOpts());
      _this.projectStore = new __WEBPACK_IMPORTED_MODULE_10__ProjectStore__["a" /* default */](makeOpts());
      _this.linkedAccountStore = new __WEBPACK_IMPORTED_MODULE_17__LinkedAccountStore__["a" /* default */](makeOpts());
      _this.couponStore = new __WEBPACK_IMPORTED_MODULE_13__CouponStore__["a" /* default */](makeOpts());
      _this.eventStore = new __WEBPACK_IMPORTED_MODULE_15__EventStore__["a" /* default */](makeOpts());
      _this.billingStore = new __WEBPACK_IMPORTED_MODULE_16__BillingStore__["a" /* default */](makeOpts());

      _this.projectDetailsStore = new __WEBPACK_IMPORTED_MODULE_18__ui_ProjectDetailsStore__["a" /* default */](makeOpts());
      _this.projectWizardStore = new __WEBPACK_IMPORTED_MODULE_19__ui_ProjectWizardStore__["a" /* default */](makeOpts());
      _this.rateProjectStore = new __WEBPACK_IMPORTED_MODULE_20__ui_RateProjectStore__["a" /* default */](makeOpts());
      _this.projectsScreenStore = new __WEBPACK_IMPORTED_MODULE_26__ui_ProjectsScreenStore__["a" /* default */](makeOpts());
      _this.documentsScreenStore = new __WEBPACK_IMPORTED_MODULE_21__ui_DocumentsScreenStore__["a" /* default */](makeOpts());
      _this.soundStore = new __WEBPACK_IMPORTED_MODULE_22__ui_SoundStore__["a" /* default */](makeOpts());
      _this.desktopNotificationStore = new __WEBPACK_IMPORTED_MODULE_23__ui_DesktopNotificationStore__["a" /* default */](makeOpts());
      _this.linkedAccountsManager = new __WEBPACK_IMPORTED_MODULE_3_components_LinkedAccountsManager_LinkedAccountsManagerState__["a" /* default */](makeOpts());
      _this.couponsScreenStore = new __WEBPACK_IMPORTED_MODULE_24__ui_CouponsScreenStore__["a" /* default */](makeOpts());
      _this.flashMessageStore = new __WEBPACK_IMPORTED_MODULE_4_components_FlashMessages_FlashMessageStore___default.a(makeOpts());
      _this.profileEditorStore = new __WEBPACK_IMPORTED_MODULE_25__ui_ProfileEditorStore__["a" /* default */](makeOpts());
      _this.intercomStore = new __WEBPACK_IMPORTED_MODULE_27__ui_IntercomStore__["a" /* default */](makeOpts());
      _this.billingScreenStore = new __WEBPACK_IMPORTED_MODULE_28__ui_BillingScreenStore__["a" /* default */](makeOpts());
      _this.gettingStartedStore = new __WEBPACK_IMPORTED_MODULE_29__ui_GettingStartedStore__["a" /* default */](makeOpts());
      _this.changeEmailDialogStore = new __WEBPACK_IMPORTED_MODULE_30__ui_ChangeEmailDialogStore__["a" /* default */](makeOpts());
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RootStore, [{
    key: 'retryOnNetworkFailure',
    value: function retryOnNetworkFailure(fn) {
      var _this2 = this;

      var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_errorUtil__["a" /* retryOnNetworkFailure */])(fn);
      promise.retryMessage = function (msg) {
        return promise.firstRetry(function () {
          return _this2.flashMessageStore.create(msg);
        });
      };

      promise.recoveredMessage = function (msg) {
        return promise.recovered(function (message) {
          return message.done(msg).show().autoDismiss();
        });
      };

      promise.networkIssueMessage = function (msg) {
        return promise.doneRetrying(function (_, message) {
          message.failed(msg).show().autoDismiss();
          return false;
        });
      };

      return promise.retryMessage('Having network issues, trying again...').recoveredMessage('Connectivity appears to have been restored.').networkIssueMessage('Unable to connect to the server, are you connected to the Internet?');
    }
  }]);

  return RootStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (new RootStore());
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc3RvcmUvaW5kZXguanMiXSwibmFtZXMiOlsibW9ieCIsIkxpbmtlZEFjY291bnRzTWFuYWdlclN0YXRlIiwiRmxhc2hNZXNzYWdlU3RvcmUiLCJlbmNyeXB0ZWRTdG9yYWdlIiwic3RvcmFnZSIsInN0b3JhZ2VTdXBwb3J0ZWQiLCJUYXhmeWxlQVBJIiwicmV0cnlPbk5ldHdvcmtGYWlsdXJlIiwiQXV0aFN0b3JlIiwiUHJvamVjdFN0b3JlIiwiVXNlclN0b3JlIiwiTWVzc2FnZVN0b3JlIiwiQ291cG9uU3RvcmUiLCJEb2N1bWVudFN0b3JlIiwiRXZlbnRTdG9yZSIsIkJpbGxpbmdTdG9yZSIsIkxpbmtlZEFjY291bnRTdG9yZSIsIlByb2plY3REZXRhaWxzU3RvcmUiLCJQcm9qZWN0V2l6YXJkU3RvcmUiLCJSYXRlUHJvamVjdFN0b3JlIiwiRG9jdW1lbnRzU2NyZWVuU3RvcmUiLCJTb3VuZFN0b3JlIiwiRGVza3RvcE5vdGlmaWNhdGlvblN0b3JlIiwiQ291cG9uc1NjcmVlblN0b3JlIiwiUHJvZmlsZUVkaXRvclN0b3JlIiwiUHJvamVjdHNTY3JlZW5TdG9yZSIsIkludGVyY29tU3RvcmUiLCJCaWxsaW5nU2NyZWVuU3RvcmUiLCJHZXR0aW5nU3RhcnRlZFN0b3JlIiwiQ2hhbmdlRW1haWxEaWFsb2dTdG9yZSIsInVzZVN0cmljdCIsInN0b3JhZ2VQYXNzd29yZCIsIlJvb3RTdG9yZSIsIm1ha2VPcHRzIiwicm9vdFN0b3JlIiwicnVuSW5BY3Rpb24iLCJhdXRoU3RvcmUiLCJhcGkiLCJkb2N1bWVudFN0b3JlIiwidXNlclN0b3JlIiwibWVzc2FnZVN0b3JlIiwicHJvamVjdFN0b3JlIiwibGlua2VkQWNjb3VudFN0b3JlIiwiY291cG9uU3RvcmUiLCJldmVudFN0b3JlIiwiYmlsbGluZ1N0b3JlIiwicHJvamVjdERldGFpbHNTdG9yZSIsInByb2plY3RXaXphcmRTdG9yZSIsInJhdGVQcm9qZWN0U3RvcmUiLCJwcm9qZWN0c1NjcmVlblN0b3JlIiwiZG9jdW1lbnRzU2NyZWVuU3RvcmUiLCJzb3VuZFN0b3JlIiwiZGVza3RvcE5vdGlmaWNhdGlvblN0b3JlIiwibGlua2VkQWNjb3VudHNNYW5hZ2VyIiwiY291cG9uc1NjcmVlblN0b3JlIiwiZmxhc2hNZXNzYWdlU3RvcmUiLCJwcm9maWxlRWRpdG9yU3RvcmUiLCJpbnRlcmNvbVN0b3JlIiwiYmlsbGluZ1NjcmVlblN0b3JlIiwiZ2V0dGluZ1N0YXJ0ZWRTdG9yZSIsImNoYW5nZUVtYWlsRGlhbG9nU3RvcmUiLCJmbiIsInByb21pc2UiLCJyZXRyeU1lc3NhZ2UiLCJtc2ciLCJmaXJzdFJldHJ5IiwiY3JlYXRlIiwicmVjb3ZlcmVkTWVzc2FnZSIsInJlY292ZXJlZCIsIm1lc3NhZ2UiLCJkb25lIiwic2hvdyIsImF1dG9EaXNtaXNzIiwibmV0d29ya0lzc3VlTWVzc2FnZSIsImRvbmVSZXRyeWluZyIsIl8iLCJmYWlsZWQiXSwibWFwcGluZ3MiOiI7O0FBQUEsT0FBT0EsSUFBUCxNQUFpQixNQUFqQjtBQUNBLE9BQU9DLDBCQUFQLE1BQXVDLDZEQUF2QztBQUNBLE9BQU9DLGlCQUFQLE1BQThCLDRDQUE5QjtBQUNBLE9BQU9DLGdCQUFQLE1BQTZCLDRCQUE3QjtBQUNBLE9BQU9DLE9BQVAsSUFBa0JDLGdCQUFsQixRQUEwQyxtQkFBMUM7QUFDQSxPQUFPQyxVQUFQLE1BQXVCLGlCQUF2QjtBQUNBLFNBQVNDLCtDQUFULFFBQXNDLG9CQUF0QztBQUNBLE9BQU9DLFNBQVAsTUFBc0IsYUFBdEI7QUFDQSxPQUFPQyxZQUFQLE1BQXlCLGdCQUF6QjtBQUNBLE9BQU9DLFNBQVAsTUFBc0IsYUFBdEI7QUFDQSxPQUFPQyxZQUFQLE1BQXlCLGdCQUF6QjtBQUNBLE9BQU9DLFdBQVAsTUFBd0IsZUFBeEI7QUFDQSxPQUFPQyxhQUFQLE1BQTBCLGlCQUExQjtBQUNBLE9BQU9DLFVBQVAsTUFBdUIsY0FBdkI7QUFDQSxPQUFPQyxZQUFQLE1BQXlCLGdCQUF6QjtBQUNBLE9BQU9DLGtCQUFQLE1BQStCLHNCQUEvQjtBQUNBLE9BQU9DLG1CQUFQLE1BQWdDLDBCQUFoQztBQUNBLE9BQU9DLGtCQUFQLE1BQStCLHlCQUEvQjtBQUNBLE9BQU9DLGdCQUFQLE1BQTZCLHVCQUE3QjtBQUNBLE9BQU9DLG9CQUFQLE1BQWlDLDJCQUFqQztBQUNBLE9BQU9DLFVBQVAsTUFBdUIsaUJBQXZCO0FBQ0EsT0FBT0Msd0JBQVAsTUFBcUMsK0JBQXJDO0FBQ0EsT0FBT0Msa0JBQVAsTUFBK0IseUJBQS9CO0FBQ0EsT0FBT0Msa0JBQVAsTUFBK0IseUJBQS9CO0FBQ0EsT0FBT0MsbUJBQVAsTUFBZ0MsMEJBQWhDO0FBQ0EsT0FBT0MsYUFBUCxNQUEwQixvQkFBMUI7QUFDQSxPQUFPQyxrQkFBUCxNQUErQix5QkFBL0I7QUFDQSxPQUFPQyxtQkFBUCxNQUFnQywwQkFBaEM7QUFDQSxPQUFPQyxzQkFBUCxNQUFtQyw2QkFBbkM7O0FBRUE7QUFDQTdCLEtBQUs4QixTQUFMLENBQWUsSUFBZjs7QUFFQTtBQUNBO0FBQ0EsSUFBTUMsa0JBQWtCLGdDQUF4Qjs7QUFFQSxXQUFhQyxTQUFiO0FBQ0UsdUJBQWU7QUFBQTs7QUFBQTs7QUFDYixTQUFLNUIsT0FBTCxHQUFlQyxxQkFBcUJGLGlCQUFpQjRCLGVBQWpCLENBQXJCLEdBQXlEM0IsT0FBeEU7QUFDQSxRQUFNNkIsV0FBVyxTQUFYQSxRQUFXO0FBQUEsYUFBTyxFQUFFQyxnQkFBRixFQUFtQjlCLFNBQVMsTUFBS0EsT0FBakMsRUFBUDtBQUFBLEtBQWpCO0FBQ0FKLFNBQUttQyxXQUFMLENBQWlCLFlBQU07QUFDckIsWUFBS0MsU0FBTCxHQUFpQixJQUFJNUIsU0FBSixDQUFjeUIsVUFBZCxDQUFqQjtBQUNBLFlBQUtJLEdBQUwsR0FBVyxJQUFJL0IsVUFBSixDQUFlLEVBQUU4QixXQUFXLE1BQUtBLFNBQWxCLEVBQWYsQ0FBWDs7QUFFQSxZQUFLRSxhQUFMLEdBQXFCLElBQUl6QixhQUFKLENBQWtCb0IsVUFBbEIsQ0FBckI7QUFDQSxZQUFLTSxTQUFMLEdBQWlCLElBQUk3QixTQUFKLENBQWN1QixVQUFkLENBQWpCO0FBQ0EsWUFBS08sWUFBTCxHQUFvQixJQUFJN0IsWUFBSixDQUFpQnNCLFVBQWpCLENBQXBCO0FBQ0EsWUFBS1EsWUFBTCxHQUFvQixJQUFJaEMsWUFBSixDQUFpQndCLFVBQWpCLENBQXBCO0FBQ0EsWUFBS1Msa0JBQUwsR0FBMEIsSUFBSTFCLGtCQUFKLENBQXVCaUIsVUFBdkIsQ0FBMUI7QUFDQSxZQUFLVSxXQUFMLEdBQW1CLElBQUkvQixXQUFKLENBQWdCcUIsVUFBaEIsQ0FBbkI7QUFDQSxZQUFLVyxVQUFMLEdBQWtCLElBQUk5QixVQUFKLENBQWVtQixVQUFmLENBQWxCO0FBQ0EsWUFBS1ksWUFBTCxHQUFvQixJQUFJOUIsWUFBSixDQUFpQmtCLFVBQWpCLENBQXBCOztBQUVBLFlBQUthLG1CQUFMLEdBQTJCLElBQUk3QixtQkFBSixDQUF3QmdCLFVBQXhCLENBQTNCO0FBQ0EsWUFBS2Msa0JBQUwsR0FBMEIsSUFBSTdCLGtCQUFKLENBQXVCZSxVQUF2QixDQUExQjtBQUNBLFlBQUtlLGdCQUFMLEdBQXdCLElBQUk3QixnQkFBSixDQUFxQmMsVUFBckIsQ0FBeEI7QUFDQSxZQUFLZ0IsbUJBQUwsR0FBMkIsSUFBSXhCLG1CQUFKLENBQXdCUSxVQUF4QixDQUEzQjtBQUNBLFlBQUtpQixvQkFBTCxHQUE0QixJQUFJOUIsb0JBQUosQ0FBeUJhLFVBQXpCLENBQTVCO0FBQ0EsWUFBS2tCLFVBQUwsR0FBa0IsSUFBSTlCLFVBQUosQ0FBZVksVUFBZixDQUFsQjtBQUNBLFlBQUttQix3QkFBTCxHQUFnQyxJQUFJOUIsd0JBQUosQ0FBNkJXLFVBQTdCLENBQWhDO0FBQ0EsWUFBS29CLHFCQUFMLEdBQTZCLElBQUlwRCwwQkFBSixDQUErQmdDLFVBQS9CLENBQTdCO0FBQ0EsWUFBS3FCLGtCQUFMLEdBQTBCLElBQUkvQixrQkFBSixDQUF1QlUsVUFBdkIsQ0FBMUI7QUFDQSxZQUFLc0IsaUJBQUwsR0FBeUIsSUFBSXJELGlCQUFKLENBQXNCK0IsVUFBdEIsQ0FBekI7QUFDQSxZQUFLdUIsa0JBQUwsR0FBMEIsSUFBSWhDLGtCQUFKLENBQXVCUyxVQUF2QixDQUExQjtBQUNBLFlBQUt3QixhQUFMLEdBQXFCLElBQUkvQixhQUFKLENBQWtCTyxVQUFsQixDQUFyQjtBQUNBLFlBQUt5QixrQkFBTCxHQUEwQixJQUFJL0Isa0JBQUosQ0FBdUJNLFVBQXZCLENBQTFCO0FBQ0EsWUFBSzBCLG1CQUFMLEdBQTJCLElBQUkvQixtQkFBSixDQUF3QkssVUFBeEIsQ0FBM0I7QUFDQSxZQUFLMkIsc0JBQUwsR0FBOEIsSUFBSS9CLHNCQUFKLENBQTJCSSxVQUEzQixDQUE5QjtBQUNELEtBNUJEO0FBNkJEOztBQWpDSDtBQUFBO0FBQUEsMENBbUN5QjRCLEVBbkN6QixFQW1DNkI7QUFBQTs7QUFDekIsVUFBTUMsVUFBVXZELHVCQUFzQnNELEVBQXRCLENBQWhCO0FBQ0FDLGNBQVFDLFlBQVIsR0FBdUIsVUFBQ0MsR0FBRDtBQUFBLGVBQ3JCRixRQUFRRyxVQUFSLENBQW1CO0FBQUEsaUJBQU0sT0FBS1YsaUJBQUwsQ0FBdUJXLE1BQXZCLENBQThCRixHQUE5QixDQUFOO0FBQUEsU0FBbkIsQ0FEcUI7QUFBQSxPQUF2Qjs7QUFJQUYsY0FBUUssZ0JBQVIsR0FBMkIsVUFBQ0gsR0FBRDtBQUFBLGVBQ3pCRixRQUFRTSxTQUFSLENBQWtCLFVBQUNDLE9BQUQ7QUFBQSxpQkFBYUEsUUFBUUMsSUFBUixDQUFhTixHQUFiLEVBQWtCTyxJQUFsQixHQUF5QkMsV0FBekIsRUFBYjtBQUFBLFNBQWxCLENBRHlCO0FBQUEsT0FBM0I7O0FBSUFWLGNBQVFXLG1CQUFSLEdBQThCLFVBQUNULEdBQUQ7QUFBQSxlQUM1QkYsUUFBUVksWUFBUixDQUFxQixVQUFDQyxDQUFELEVBQUlOLE9BQUosRUFBZ0I7QUFDbkNBLGtCQUFRTyxNQUFSLENBQWVaLEdBQWYsRUFBb0JPLElBQXBCLEdBQTJCQyxXQUEzQjtBQUNBLGlCQUFPLEtBQVA7QUFDRCxTQUhELENBRDRCO0FBQUEsT0FBOUI7O0FBT0EsYUFBT1YsUUFDSkMsWUFESSxDQUNTLHdDQURULEVBRUpJLGdCQUZJLENBRWEsNkNBRmIsRUFHSk0sbUJBSEksQ0FHZ0IscUVBSGhCLENBQVA7QUFJRDtBQXhESDs7QUFBQTtBQUFBOztBQTJEQSxlQUFlLElBQUl6QyxTQUFKLEVBQWYiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgbW9ieCBmcm9tICdtb2J4J1xuaW1wb3J0IExpbmtlZEFjY291bnRzTWFuYWdlclN0YXRlIGZyb20gJ2NvbXBvbmVudHMvTGlua2VkQWNjb3VudHNNYW5hZ2VyL0xpbmtlZEFjY291bnRzTWFuYWdlclN0YXRlJ1xuaW1wb3J0IEZsYXNoTWVzc2FnZVN0b3JlIGZyb20gJ2NvbXBvbmVudHMvRmxhc2hNZXNzYWdlcy9GbGFzaE1lc3NhZ2VTdG9yZSdcbmltcG9ydCBlbmNyeXB0ZWRTdG9yYWdlIGZyb20gJ21pc2MvZW5jcnlwdGVkTG9jYWxTdG9yYWdlJ1xuaW1wb3J0IHN0b3JhZ2UsIHsgc3RvcmFnZVN1cHBvcnRlZCB9IGZyb20gJ21pc2MvbG9jYWxTdG9yYWdlJ1xuaW1wb3J0IFRheGZ5bGVBUEkgZnJvbSAnbWlzYy9UYXhmeWxlQVBJJ1xuaW1wb3J0IHsgcmV0cnlPbk5ldHdvcmtGYWlsdXJlIH0gZnJvbSAnLi4vdXRpbHMvZXJyb3JVdGlsJ1xuaW1wb3J0IEF1dGhTdG9yZSBmcm9tICcuL0F1dGhTdG9yZSdcbmltcG9ydCBQcm9qZWN0U3RvcmUgZnJvbSAnLi9Qcm9qZWN0U3RvcmUnXG5pbXBvcnQgVXNlclN0b3JlIGZyb20gJy4vVXNlclN0b3JlJ1xuaW1wb3J0IE1lc3NhZ2VTdG9yZSBmcm9tICcuL01lc3NhZ2VTdG9yZSdcbmltcG9ydCBDb3Vwb25TdG9yZSBmcm9tICcuL0NvdXBvblN0b3JlJ1xuaW1wb3J0IERvY3VtZW50U3RvcmUgZnJvbSAnLi9Eb2N1bWVudFN0b3JlJ1xuaW1wb3J0IEV2ZW50U3RvcmUgZnJvbSAnLi9FdmVudFN0b3JlJ1xuaW1wb3J0IEJpbGxpbmdTdG9yZSBmcm9tICcuL0JpbGxpbmdTdG9yZSdcbmltcG9ydCBMaW5rZWRBY2NvdW50U3RvcmUgZnJvbSAnLi9MaW5rZWRBY2NvdW50U3RvcmUnXG5pbXBvcnQgUHJvamVjdERldGFpbHNTdG9yZSBmcm9tICcuL3VpL1Byb2plY3REZXRhaWxzU3RvcmUnXG5pbXBvcnQgUHJvamVjdFdpemFyZFN0b3JlIGZyb20gJy4vdWkvUHJvamVjdFdpemFyZFN0b3JlJ1xuaW1wb3J0IFJhdGVQcm9qZWN0U3RvcmUgZnJvbSAnLi91aS9SYXRlUHJvamVjdFN0b3JlJ1xuaW1wb3J0IERvY3VtZW50c1NjcmVlblN0b3JlIGZyb20gJy4vdWkvRG9jdW1lbnRzU2NyZWVuU3RvcmUnXG5pbXBvcnQgU291bmRTdG9yZSBmcm9tICcuL3VpL1NvdW5kU3RvcmUnXG5pbXBvcnQgRGVza3RvcE5vdGlmaWNhdGlvblN0b3JlIGZyb20gJy4vdWkvRGVza3RvcE5vdGlmaWNhdGlvblN0b3JlJ1xuaW1wb3J0IENvdXBvbnNTY3JlZW5TdG9yZSBmcm9tICcuL3VpL0NvdXBvbnNTY3JlZW5TdG9yZSdcbmltcG9ydCBQcm9maWxlRWRpdG9yU3RvcmUgZnJvbSAnLi91aS9Qcm9maWxlRWRpdG9yU3RvcmUnXG5pbXBvcnQgUHJvamVjdHNTY3JlZW5TdG9yZSBmcm9tICcuL3VpL1Byb2plY3RzU2NyZWVuU3RvcmUnXG5pbXBvcnQgSW50ZXJjb21TdG9yZSBmcm9tICcuL3VpL0ludGVyY29tU3RvcmUnXG5pbXBvcnQgQmlsbGluZ1NjcmVlblN0b3JlIGZyb20gJy4vdWkvQmlsbGluZ1NjcmVlblN0b3JlJ1xuaW1wb3J0IEdldHRpbmdTdGFydGVkU3RvcmUgZnJvbSAnLi91aS9HZXR0aW5nU3RhcnRlZFN0b3JlJ1xuaW1wb3J0IENoYW5nZUVtYWlsRGlhbG9nU3RvcmUgZnJvbSAnLi91aS9DaGFuZ2VFbWFpbERpYWxvZ1N0b3JlJ1xuXG4vLyBsZXQncyBzZWUgaG93IHRoaXMgcGFucyBvdXQuXG5tb2J4LnVzZVN0cmljdCh0cnVlKVxuXG4vLyBXQVJOSU5HOiBDaGFuZ2luZyB0aGlzIHdpbGwgaW52YWxpZGF0ZSBldmVyeXRoaW5nIHRoYXQgd2FzXG4vLyBzYXZlZCB3aXRoIGEgcHJldmlvdXMgcGFzc3dvcmQuXG5jb25zdCBzdG9yYWdlUGFzc3dvcmQgPSAnOTI2NFAmJW9DUHlrIVUpe3I8bXFjP0M4eUldNzFRJ1xuXG5leHBvcnQgY2xhc3MgUm9vdFN0b3JlIHtcbiAgY29uc3RydWN0b3IgKCkge1xuICAgIHRoaXMuc3RvcmFnZSA9IHN0b3JhZ2VTdXBwb3J0ZWQoKSA/IGVuY3J5cHRlZFN0b3JhZ2Uoc3RvcmFnZVBhc3N3b3JkKSA6IHN0b3JhZ2VcbiAgICBjb25zdCBtYWtlT3B0cyA9ICgpID0+ICh7IHJvb3RTdG9yZTogdGhpcywgc3RvcmFnZTogdGhpcy5zdG9yYWdlIH0pXG4gICAgbW9ieC5ydW5JbkFjdGlvbigoKSA9PiB7XG4gICAgICB0aGlzLmF1dGhTdG9yZSA9IG5ldyBBdXRoU3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMuYXBpID0gbmV3IFRheGZ5bGVBUEkoeyBhdXRoU3RvcmU6IHRoaXMuYXV0aFN0b3JlIH0pXG5cbiAgICAgIHRoaXMuZG9jdW1lbnRTdG9yZSA9IG5ldyBEb2N1bWVudFN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLnVzZXJTdG9yZSA9IG5ldyBVc2VyU3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMubWVzc2FnZVN0b3JlID0gbmV3IE1lc3NhZ2VTdG9yZShtYWtlT3B0cygpKVxuICAgICAgdGhpcy5wcm9qZWN0U3RvcmUgPSBuZXcgUHJvamVjdFN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmxpbmtlZEFjY291bnRTdG9yZSA9IG5ldyBMaW5rZWRBY2NvdW50U3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMuY291cG9uU3RvcmUgPSBuZXcgQ291cG9uU3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMuZXZlbnRTdG9yZSA9IG5ldyBFdmVudFN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmJpbGxpbmdTdG9yZSA9IG5ldyBCaWxsaW5nU3RvcmUobWFrZU9wdHMoKSlcblxuICAgICAgdGhpcy5wcm9qZWN0RGV0YWlsc1N0b3JlID0gbmV3IFByb2plY3REZXRhaWxzU3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMucHJvamVjdFdpemFyZFN0b3JlID0gbmV3IFByb2plY3RXaXphcmRTdG9yZShtYWtlT3B0cygpKVxuICAgICAgdGhpcy5yYXRlUHJvamVjdFN0b3JlID0gbmV3IFJhdGVQcm9qZWN0U3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMucHJvamVjdHNTY3JlZW5TdG9yZSA9IG5ldyBQcm9qZWN0c1NjcmVlblN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmRvY3VtZW50c1NjcmVlblN0b3JlID0gbmV3IERvY3VtZW50c1NjcmVlblN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLnNvdW5kU3RvcmUgPSBuZXcgU291bmRTdG9yZShtYWtlT3B0cygpKVxuICAgICAgdGhpcy5kZXNrdG9wTm90aWZpY2F0aW9uU3RvcmUgPSBuZXcgRGVza3RvcE5vdGlmaWNhdGlvblN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmxpbmtlZEFjY291bnRzTWFuYWdlciA9IG5ldyBMaW5rZWRBY2NvdW50c01hbmFnZXJTdGF0ZShtYWtlT3B0cygpKVxuICAgICAgdGhpcy5jb3Vwb25zU2NyZWVuU3RvcmUgPSBuZXcgQ291cG9uc1NjcmVlblN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmZsYXNoTWVzc2FnZVN0b3JlID0gbmV3IEZsYXNoTWVzc2FnZVN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLnByb2ZpbGVFZGl0b3JTdG9yZSA9IG5ldyBQcm9maWxlRWRpdG9yU3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMuaW50ZXJjb21TdG9yZSA9IG5ldyBJbnRlcmNvbVN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmJpbGxpbmdTY3JlZW5TdG9yZSA9IG5ldyBCaWxsaW5nU2NyZWVuU3RvcmUobWFrZU9wdHMoKSlcbiAgICAgIHRoaXMuZ2V0dGluZ1N0YXJ0ZWRTdG9yZSA9IG5ldyBHZXR0aW5nU3RhcnRlZFN0b3JlKG1ha2VPcHRzKCkpXG4gICAgICB0aGlzLmNoYW5nZUVtYWlsRGlhbG9nU3RvcmUgPSBuZXcgQ2hhbmdlRW1haWxEaWFsb2dTdG9yZShtYWtlT3B0cygpKVxuICAgIH0pXG4gIH1cblxuICByZXRyeU9uTmV0d29ya0ZhaWx1cmUgKGZuKSB7XG4gICAgY29uc3QgcHJvbWlzZSA9IHJldHJ5T25OZXR3b3JrRmFpbHVyZShmbilcbiAgICBwcm9taXNlLnJldHJ5TWVzc2FnZSA9IChtc2cpID0+IChcbiAgICAgIHByb21pc2UuZmlyc3RSZXRyeSgoKSA9PiB0aGlzLmZsYXNoTWVzc2FnZVN0b3JlLmNyZWF0ZShtc2cpKVxuICAgIClcblxuICAgIHByb21pc2UucmVjb3ZlcmVkTWVzc2FnZSA9IChtc2cpID0+IChcbiAgICAgIHByb21pc2UucmVjb3ZlcmVkKChtZXNzYWdlKSA9PiBtZXNzYWdlLmRvbmUobXNnKS5zaG93KCkuYXV0b0Rpc21pc3MoKSlcbiAgICApXG5cbiAgICBwcm9taXNlLm5ldHdvcmtJc3N1ZU1lc3NhZ2UgPSAobXNnKSA9PiAoXG4gICAgICBwcm9taXNlLmRvbmVSZXRyeWluZygoXywgbWVzc2FnZSkgPT4ge1xuICAgICAgICBtZXNzYWdlLmZhaWxlZChtc2cpLnNob3coKS5hdXRvRGlzbWlzcygpXG4gICAgICAgIHJldHVybiBmYWxzZVxuICAgICAgfSlcbiAgICApXG5cbiAgICByZXR1cm4gcHJvbWlzZVxuICAgICAgLnJldHJ5TWVzc2FnZSgnSGF2aW5nIG5ldHdvcmsgaXNzdWVzLCB0cnlpbmcgYWdhaW4uLi4nKVxuICAgICAgLnJlY292ZXJlZE1lc3NhZ2UoJ0Nvbm5lY3Rpdml0eSBhcHBlYXJzIHRvIGhhdmUgYmVlbiByZXN0b3JlZC4nKVxuICAgICAgLm5ldHdvcmtJc3N1ZU1lc3NhZ2UoJ1VuYWJsZSB0byBjb25uZWN0IHRvIHRoZSBzZXJ2ZXIsIGFyZSB5b3UgY29ubmVjdGVkIHRvIHRoZSBJbnRlcm5ldD8nKVxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IG5ldyBSb290U3RvcmUoKVxuIl19

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BillingScreenStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx_task__);







var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var BillingScreenStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(BillingScreenStore, _Store);

  function BillingScreenStore() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BillingScreenStore);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BillingScreenStore.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BillingScreenStore)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BillingScreenStore, [{
    key: 'activate',
    value: function activate() {
      return this.fetchCards();
    }
  }, {
    key: 'fetchCards',
    value: function fetchCards() {
      return this.rootStore.billingStore.fetchCards();
    }
  }]);

  return BillingScreenStore;
}(__WEBPACK_IMPORTED_MODULE_6_libx__["Store"]), (_applyDecoratedDescriptor(_class.prototype, 'fetchCards', [__WEBPACK_IMPORTED_MODULE_7_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchCards'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc3RvcmUvdWkvQmlsbGluZ1NjcmVlblN0b3JlLmpzIl0sIm5hbWVzIjpbIlN0b3JlIiwidGFzayIsIkJpbGxpbmdTY3JlZW5TdG9yZSIsImZldGNoQ2FyZHMiLCJyb290U3RvcmUiLCJiaWxsaW5nU3RvcmUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsS0FBVCxRQUFzQixNQUF0QjtBQUNBLFNBQVNDLElBQVQsUUFBcUIsV0FBckI7O0lBRXFCQyxrQjs7Ozs7Ozs7Ozs7K0JBQ1A7QUFDVixhQUFPLEtBQUtDLFVBQUwsRUFBUDtBQUNEOzs7aUNBRW1CO0FBQ2xCLGFBQU8sS0FBS0MsU0FBTCxDQUFlQyxZQUFmLENBQTRCRixVQUE1QixFQUFQO0FBQ0Q7Ozs7RUFQNkNILEssK0RBSzdDQyxJO1NBTGtCQyxrQiIsImZpbGUiOiJCaWxsaW5nU2NyZWVuU3RvcmUuanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL2plZmYvUHJvamVjdHMvdGF4ZnlsZS9jdXN0b21lci1wb3J0YWwiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdG9yZSB9IGZyb20gJ2xpYngnXG5pbXBvcnQgeyB0YXNrIH0gZnJvbSAnbW9ieC10YXNrJ1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBCaWxsaW5nU2NyZWVuU3RvcmUgZXh0ZW5kcyBTdG9yZSB7XG4gIGFjdGl2YXRlICgpIHtcbiAgICByZXR1cm4gdGhpcy5mZXRjaENhcmRzKClcbiAgfVxuXG4gIEB0YXNrIGZldGNoQ2FyZHMgKCkge1xuICAgIHJldHVybiB0aGlzLnJvb3RTdG9yZS5iaWxsaW5nU3RvcmUuZmV0Y2hDYXJkcygpXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeEmailDialogStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_validx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_autobind_decorator__);








var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var ChangeEmailDialogStore = (_dec = __WEBPACK_IMPORTED_MODULE_9_mobx_task__["task"].resolved, __WEBPACK_IMPORTED_MODULE_11_autobind_decorator___default()(_class = (_class2 = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ChangeEmailDialogStore, _Store);

  function ChangeEmailDialogStore() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ChangeEmailDialogStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ChangeEmailDialogStore.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ChangeEmailDialogStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showing', _descriptor, _this), _initDefineProp(_this, 'email', _descriptor2, _this), _this.validation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_validx__["validationContext"])(), _this.rules = {
      email: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_validx__["required"])('New email is required'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_validx__["pattern"])({
        pattern: 'email',
        msg: 'Not a valid email address'
      })]
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ChangeEmailDialogStore, [{
    key: 'show',
    value: function show() {
      this.email = this.user.email;
      this.showing = true;
    }
  }, {
    key: 'close',
    value: function close() {
      this.showing = false;
    }
  }, {
    key: 'save',
    value: function save() {
      if (!this.validation.reset().validate(this, this.rules).isValid) {
        return;
      }

      return this.rootStore.userStore.changeEmail(this.email).then(this.emailChanged);
    }
  }, {
    key: 'emailChanged',
    value: function emailChanged() {
      this.close();
      this.rootStore.flashMessageStore.create('E-mail address successfully changed.').done().autoDismiss(4000);
    }
  }, {
    key: 'user',
    get: function get() {
      return this.rootStore.authStore.user;
    }
  }]);

  return ChangeEmailDialogStore;
}(__WEBPACK_IMPORTED_MODULE_7_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showing', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'email', [__WEBPACK_IMPORTED_MODULE_8_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'user', [__WEBPACK_IMPORTED_MODULE_8_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'user'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'show', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'show'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'close'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [_dec], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'save'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'emailChanged', [__WEBPACK_IMPORTED_MODULE_8_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'emailChanged'), _class2.prototype)), _class2)) || _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponsScreenStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);










var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var CouponsScreenStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(CouponsScreenStore, _Store);

  function CouponsScreenStore() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, CouponsScreenStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CouponsScreenStore.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(CouponsScreenStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'couponCode', _descriptor, _this), _initDefineProp(_this, 'fetching', _descriptor2, _this), _initDefineProp(_this, 'processing', _descriptor3, _this), _initDefineProp(_this, 'errorMessage', _descriptor4, _this), _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(CouponsScreenStore, [{
    key: 'toggleFetching',
    value: function toggleFetching(fetching) {
      this.fetching = fetching;
    }
  }, {
    key: 'setCouponCode',
    value: function setCouponCode(code) {
      this.couponCode = code;
    }
  }, {
    key: 'toggleProcessing',
    value: function toggleProcessing(processing) {
      this.processing = processing;
    }
  }, {
    key: 'setError',
    value: function setError(message) {
      this.errorMessage = message;
    }
  }, {
    key: 'activate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.toggleFetching(true);
                _context.prev = 1;
                _context.next = 4;
                return this.rootStore.couponStore.getCoupons();

              case 4:
                _context.prev = 4;

                this.toggleFetching(false);
                return _context.finish(4);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 4, 7]]);
      }));

      function activate() {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'applyCoupon',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.couponCode) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                this.toggleProcessing(true);
                this.setError(null);
                _context2.prev = 4;
                _context2.next = 7;
                return this.rootStore.couponStore.addCoupon(this.couponCode);

              case 7:
                result = _context2.sent;

                if (!result.success) {
                  this.setError(result.message);
                }

              case 9:
                _context2.prev = 9;

                this.toggleProcessing(false);
                return _context2.finish(9);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4,, 9, 12]]);
      }));

      function applyCoupon() {
        return _ref3.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: 'coupons',
    get: function get() {
      return this.rootStore.couponStore.coupons.filter(function (x) {
        return x.redeemed === false;
      });
    }
  }]);

  return CouponsScreenStore;
}(__WEBPACK_IMPORTED_MODULE_9_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'couponCode', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'fetching', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'processing', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'errorMessage', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'coupons', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'coupons'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleFetching', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'toggleFetching'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCouponCode', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setCouponCode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleProcessing', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'toggleProcessing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setError', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setError'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopNotificationStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_notifyjs__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_misc_localStorage__ = __webpack_require__(267);










var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var DesktopNotificationStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(DesktopNotificationStore, _Store);

  function DesktopNotificationStore() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DesktopNotificationStore);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DesktopNotificationStore.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(DesktopNotificationStore)).apply(this, arguments));

    _initDefineProp(_this, 'isSupported', _descriptor, _this);

    _initDefineProp(_this, 'isEnabled', _descriptor2, _this);

    _this.isSupported = __WEBPACK_IMPORTED_MODULE_10_notifyjs___default.a.needsPermission === false || __WEBPACK_IMPORTED_MODULE_10_notifyjs___default.a.isSupported();

    _this.rootStore.authStore.onLogin(function () {
      // Restore enabled state.
      var stored = __WEBPACK_IMPORTED_MODULE_12_misc_localStorage__["b" /* default */].getItem('desktopNotifications');
      var enabled = stored !== 'disabled';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
        _this.isEnabled = enabled;
      });
      _this.setEnabled(enabled);
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DesktopNotificationStore, [{
    key: 'setEnabled',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(enabled) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!enabled) {
                  _context.next = 6;
                  break;
                }

                if (!(this.isEnabled && __WEBPACK_IMPORTED_MODULE_10_notifyjs___default.a.needsPermission === false)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return this._getPermission();

              case 5:
                enabled = _context.sent;

              case 6:

                __WEBPACK_IMPORTED_MODULE_12_misc_localStorage__["b" /* default */].setItem('desktopNotifications', enabled ? 'enabled' : 'disabled');
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
                  _this2.isEnabled = enabled;
                });

                if (this.isEnabled) {
                  this.show({
                    title: 'Nice!',
                    body: 'Desktop notifications have been enabled. You rock!',
                    tag: 'notifications-enabled'
                  });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setEnabled(_x) {
        return _ref.apply(this, arguments);
      }

      return setEnabled;
    }()
  }, {
    key: '_getPermission',
    value: function _getPermission() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!__WEBPACK_IMPORTED_MODULE_10_notifyjs___default.a.needsPermission) {
          return resolve(true);
        }

        if (!_this3.isSupported) {
          return resolve(false);
        }

        __WEBPACK_IMPORTED_MODULE_10_notifyjs___default.a.requestPermission(function () {
          return resolve(true);
        }, function () {
          return resolve(false);
        });
      });
    }
  }, {
    key: 'show',
    value: function show(opts) {
      if (!this.isEnabled) {
        return;
      }

      var notification = new __WEBPACK_IMPORTED_MODULE_10_notifyjs___default.a(opts.title, {
        tag: opts.tag,
        body: opts.body,
        icon: opts.icon || __webpack_require__(217),
        badge: __webpack_require__(217),
        timeout: opts.timeout || 5,
        notifyClick: function notifyClick() {
          window.focus();
          if (opts.onClick) {
            opts.onClick();
          }
          notification.close();
        }
      });

      notification.show();
    }
  }]);

  return DesktopNotificationStore;
}(__WEBPACK_IMPORTED_MODULE_9_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isSupported', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isEnabled', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentsScreenStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mobx__);










var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var DocumentsScreenStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(DocumentsScreenStore, _Store);

  function DocumentsScreenStore() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DocumentsScreenStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DocumentsScreenStore.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(DocumentsScreenStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'loading', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DocumentsScreenStore, [{
    key: 'setLoading',
    value: function setLoading(loading) {
      this.loading = loading;
    }
  }, {
    key: 'activate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return this.rootStore.documentStore.fetchDocuments();

              case 4:
                _context.prev = 4;

                this.setLoading(false);
                return _context.finish(4);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 4, 7]]);
      }));

      function activate() {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'documents',
    get: function get() {
      return this.rootStore.documentStore.allDocuments;
    }
  }]);

  return DocumentsScreenStore;
}(__WEBPACK_IMPORTED_MODULE_9_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'loading', [__WEBPACK_IMPORTED_MODULE_10_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'documents', [__WEBPACK_IMPORTED_MODULE_10_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'documents'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setLoading', [__WEBPACK_IMPORTED_MODULE_10_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setLoading'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc3RvcmUvdWkvRG9jdW1lbnRzU2NyZWVuU3RvcmUuanMiXSwibmFtZXMiOlsiU3RvcmUiLCJhY3Rpb24iLCJvYnNlcnZhYmxlIiwiY29tcHV0ZWQiLCJEb2N1bWVudHNTY3JlZW5TdG9yZSIsImxvYWRpbmciLCJzZXRMb2FkaW5nIiwicm9vdFN0b3JlIiwiZG9jdW1lbnRTdG9yZSIsImZldGNoRG9jdW1lbnRzIiwiYWxsRG9jdW1lbnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLFNBQVNBLEtBQVQsUUFBc0IsTUFBdEI7QUFDQSxTQUFTQyxNQUFULEVBQWlCQyxVQUFqQixFQUE2QkMsUUFBN0IsUUFBNkMsTUFBN0M7O0lBRXFCQyxvQjs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsrQkFPQ0MsTyxFQUFTO0FBQzNCLFdBQUtBLE9BQUwsR0FBZUEsT0FBZjtBQUNEOzs7Ozs7Ozs7QUFHQyxxQkFBS0MsVUFBTCxDQUFnQixJQUFoQjs7O3VCQUVRLEtBQUtDLFNBQUwsQ0FBZUMsYUFBZixDQUE2QkMsY0FBN0IsRTs7Ozs7QUFFTixxQkFBS0gsVUFBTCxDQUFnQixLQUFoQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt3QkFidUI7QUFDekIsYUFBTyxLQUFLQyxTQUFMLENBQWVDLGFBQWYsQ0FBNkJFLFlBQXBDO0FBQ0Q7Ozs7RUFMK0NWLEssMEVBQy9DRSxVOzs7V0FBcUIsSzs7OERBRXJCQyxRLGtKQUlBRixNO1NBUGtCRyxvQiIsImZpbGUiOiJEb2N1bWVudHNTY3JlZW5TdG9yZS5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvamVmZi9Qcm9qZWN0cy90YXhmeWxlL2N1c3RvbWVyLXBvcnRhbCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0b3JlIH0gZnJvbSAnbGlieCdcbmltcG9ydCB7IGFjdGlvbiwgb2JzZXJ2YWJsZSwgY29tcHV0ZWQgfSBmcm9tICdtb2J4J1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEb2N1bWVudHNTY3JlZW5TdG9yZSBleHRlbmRzIFN0b3JlIHtcbiAgQG9ic2VydmFibGUgbG9hZGluZyA9IGZhbHNlXG5cbiAgQGNvbXB1dGVkIGdldCBkb2N1bWVudHMgKCkge1xuICAgIHJldHVybiB0aGlzLnJvb3RTdG9yZS5kb2N1bWVudFN0b3JlLmFsbERvY3VtZW50c1xuICB9XG5cbiAgQGFjdGlvbiBzZXRMb2FkaW5nIChsb2FkaW5nKSB7XG4gICAgdGhpcy5sb2FkaW5nID0gbG9hZGluZ1xuICB9XG5cbiAgYXN5bmMgYWN0aXZhdGUgKCkge1xuICAgIHRoaXMuc2V0TG9hZGluZyh0cnVlKVxuICAgIHRyeSB7XG4gICAgICBhd2FpdCB0aGlzLnJvb3RTdG9yZS5kb2N1bWVudFN0b3JlLmZldGNoRG9jdW1lbnRzKClcbiAgICB9IGZpbmFsbHkge1xuICAgICAgdGhpcy5zZXRMb2FkaW5nKGZhbHNlKVxuICAgIH1cbiAgfVxufVxuIl19

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GettingStartedStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_identity__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_identity__);







var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





var STEP_COUNT = 4;

var GettingStartedStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GettingStartedStore, _Store);

  function GettingStartedStore() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GettingStartedStore);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GettingStartedStore.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GettingStartedStore)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GettingStartedStore, [{
    key: 'progressMax',
    get: function get() {
      return STEP_COUNT;
    }
  }, {
    key: 'progress',
    get: function get() {
      var job = this.job;
      if (!job) {
        return 1;
      }

      if (!job.hasAnsweredAllQuestions) {
        // Each answer counts towards visible progress
        return 1 + job.answers.length / job.questions.length;
      }

      if (job.states.length === 0) {
        return 2;
      }

      return 3;
    }
  }, {
    key: 'job',
    get: function get() {
      return this.rootStore.projectStore.projects.find(function (x) {
        return x.status === 'UNDER_CONSTRUCTION';
      });
    }
  }, {
    key: 'hasAnsweredQuestions',
    get: function get() {
      var job = this.job;
      if (!job) {
        return false;
      }

      return [job.years.length > 0, job.states.length > 0, job.hasAnsweredAllQuestions].every(__WEBPACK_IMPORTED_MODULE_8_lodash_identity___default.a);
    }
  }, {
    key: 'accountEmail',
    get: function get() {
      return this.rootStore.authStore.user.email;
    }
  }, {
    key: 'buttonText',
    get: function get() {
      var progress = this.progress;
      if (progress === 1) {
        return 'Get Started';
      }

      if (!this.hasAnsweredQuestions) {
        return 'Continue';
      }

      return 'Go to Checkout';
    }
  }, {
    key: 'shouldShow',
    get: function get() {
      var projectStore = this.rootStore.projectStore;


      if (projectStore.projects.length === 0) {
        return true;
      }

      if (projectStore.projects.length === 1) {
        var firstProject = projectStore.projects.map(function (x) {
          return x;
        })[0];
        return firstProject.status === 'UNDER_CONSTRUCTION';
      }

      return false;
    }
  }]);

  return GettingStartedStore;
}(__WEBPACK_IMPORTED_MODULE_6_libx__["Store"]), (_applyDecoratedDescriptor(_class.prototype, 'progressMax', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'progressMax'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'progress', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'progress'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'job', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'job'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasAnsweredQuestions', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'hasAnsweredQuestions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'accountEmail', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'accountEmail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buttonText', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'buttonText'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'shouldShow', [__WEBPACK_IMPORTED_MODULE_7_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'shouldShow'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntercomStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_debounce__);









var IntercomStore = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IntercomStore, _Store);

  function IntercomStore() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IntercomStore);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IntercomStore.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(IntercomStore)).apply(this, arguments));

    _this._dispatchUpdate = __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(_this._dispatchUpdate.bind(_this), 1000);
    return _this;
  }

  /**
   * Batches up attributes and fires when we're done spamming.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IntercomStore, [{
    key: 'update',
    value: function update(attrs) {
      var authStore = this.rootStore.authStore;
      if (authStore.user) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, attrs, {
          user_id: authStore.user.id,
          email: authStore.user.email,
          last_updated: new Date()
        });
        this._data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._data, data);
        this._dispatchUpdate();
      }
    }
  }, {
    key: '_dispatchUpdate',
    value: function _dispatchUpdate() {
      window.Intercom('update', this._data);
      this._data = null;
    }
  }]);

  return IntercomStore;
}(__WEBPACK_IMPORTED_MODULE_6_libx__["Store"]);


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileEditorStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_validx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_validx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_validx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_path__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_path__);











var _dec, _dec2, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var ProfileEditorStore = (_dec = __WEBPACK_IMPORTED_MODULE_13_mobx_task__["task"].resolved, _dec2 = __WEBPACK_IMPORTED_MODULE_13_mobx_task__["task"].resolved, (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(ProfileEditorStore, _Store);

  function ProfileEditorStore() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ProfileEditorStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ProfileEditorStore.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ProfileEditorStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'firstName', _descriptor, _this), _initDefineProp(_this, 'lastName', _descriptor2, _this), _initDefineProp(_this, 'email', _descriptor3, _this), _this.validation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_validx__["validationContext"])(_this, {
      firstName: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_validx__["required"])('First name is required')],
      lastName: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_validx__["required"])('Last name is required')],
      email: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_validx__["required"])('Email is required'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_validx__["pattern"])({ pattern: 'email', msg: 'Not a valid email' })]
    }), _temp), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ProfileEditorStore, [{
    key: 'activate',
    value: function activate() {
      var user = this.rootStore.authStore.user;
      this.validation.reset();
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this, {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email
      });
    }
  }, {
    key: 'save',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.validation.reset().validate().isValid) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                data = {
                  given_name: this.firstName,
                  family_name: this.lastName,
                  email_address: this.email
                };
                _context.next = 5;
                return this.rootStore.api.profiles.patch('me', data).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(this.rootStore.userStore.users.set)).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(function () {
                  _this2.rootStore.flashMessageStore.create({
                    type: 'success',
                    message: 'Your profile has been updated!'
                  }).autoDismiss();
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _ref2.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: 'uploadPicture',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
        var maxSize, ext, isSupported, msg;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                maxSize = 1024 * 1024 * 2; // 2mb

                ext = __WEBPACK_IMPORTED_MODULE_14_path___default.a.extname(file.name);
                isSupported = /(jpe?g|png)/i.test(ext);

                if (isSupported) {
                  _context2.next = 6;
                  break;
                }

                this.rootStore.flashMessageStore.create({
                  type: 'error',
                  message: 'We only support PNG, JPEG and JPG files for profile picture.'
                }).autoDismiss();
                return _context2.abrupt('return');

              case 6:
                if (!(maxSize < file.size)) {
                  _context2.next = 9;
                  break;
                }

                this.rootStore.flashMessageStore.create({
                  type: 'error',
                  message: 'Max image size is 2mb.'
                }).autoDismiss();
                return _context2.abrupt('return');

              case 9:
                msg = this.rootStore.flashMessageStore.create({
                  inProgress: true,
                  message: 'Uploading new profile picture...'
                });
                _context2.next = 12;
                return this.rootStore.api.profiles.uploadPicture(file).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(this.rootStore.userStore.users.set)).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(function () {
                  msg.done('Successfully changed your profile picture!').autoDismiss();
                })).catch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(function (err) {
                  msg.failed(err.message);
                  console.error(err);
                }));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function uploadPicture(_x) {
        return _ref3.apply(this, arguments);
      }

      return uploadPicture;
    }()
  }, {
    key: 'canSetEmail',
    get: function get() {
      // Can only set the email if we don't already have it.
      // return !this.rootStore.authStore.user.email
      return true;
    }
  }, {
    key: 'picture',
    get: function get() {
      return this.rootStore.authStore.user.avatar;
    }
  }]);

  return ProfileEditorStore;
}(__WEBPACK_IMPORTED_MODULE_10_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'firstName', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'lastName', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'email', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'canSetEmail', [__WEBPACK_IMPORTED_MODULE_11_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'canSetEmail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'picture', [__WEBPACK_IMPORTED_MODULE_11_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'picture'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'activate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'save', [_dec], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'save'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'uploadPicture', [_dec2], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'uploadPicture'), _class.prototype)), _class));

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectDetailsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_autobind_decorator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ifvisible_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ifvisible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ifvisible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_misc_links__ = __webpack_require__(41);











var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






// noinspection JSFileReferences



var ProjectDetailsStore = __WEBPACK_IMPORTED_MODULE_12_autobind_decorator___default()(_class = (_class2 = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(ProjectDetailsStore, _Store);

  function ProjectDetailsStore() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ProjectDetailsStore);

    var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectDetailsStore.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ProjectDetailsStore)).apply(this, arguments));

    _initDefineProp(_this, 'project', _descriptor, _this);

    _initDefineProp(_this, 'composerText', _descriptor2, _this);

    _initDefineProp(_this, 'loadingMessages', _descriptor3, _this);

    _initDefineProp(_this, 'notFound', _descriptor4, _this);

    _initDefineProp(_this, 'detailsTab', _descriptor5, _this);

    _this.rootStore.messageStore.onIncomingMessage(_this.onIncomingMessage);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ProjectDetailsStore, [{
    key: 'changeComposerText',
    value: function changeComposerText(newValue) {
      this.composerText = newValue;
    }
  }, {
    key: 'activate',
    value: function activate(projectId) {
      var _this2 = this;

      var breakIfUnderConstruction = function breakIfUnderConstruction(p) {
        if (p.status === 'UNDER_CONSTRUCTION') {
          __WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].replace(__WEBPACK_IMPORTED_MODULE_16_misc_links__["a" /* default */].projectEditor(p.id));
          return true;
        }

        return false;
      };
      this.rootStore.rateProjectStore.ensureAllRated();
      this.project = null;
      this.notFound = false;
      this.composerText = '';
      this.loadingMessages = true;
      this.detailsTab = 'INFO';

      var projectStore = this.rootStore.projectStore;
      var project = projectStore.projects.get(projectId);
      if (project) {
        if (breakIfUnderConstruction(project)) {
          return;
        }
        this.project = project;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.loadMessages(), this.loadDocuments(), this.loadEvents()]);
      }

      return projectStore.fetchProject(projectId).then(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["action"])(function (project) {
        if (project) {
          if (breakIfUnderConstruction(project)) {
            return;
          }
        }
        _this2.project = project;
        _this2.notFound = !project;
        if (project) {
          _this2.loadMessages();
          _this2.loadDocuments();
          _this2.loadEvents();
        }
      }));
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.project = null;
      this.notFound = false;
      this.composerText = '';
    }
  }, {
    key: 'changeDetailsTab',
    value: function changeDetailsTab(newTab) {
      this.detailsTab = newTab;
    }
  }, {
    key: 'stageFiles',
    value: function stageFiles(files) {
      var category = this.project.documentsCategory;
      var jobId = this.project.id;
      return this.rootStore.documentStore.stageFiles(category, files, jobId);
    }

    /**
     * Triggered when a new message comes in from the wire.
     * We need to figure out what to do with it based on
     * what project the user is currently viewing.
     *
     * @param message
     */

  }, {
    key: 'onIncomingMessage',
    value: function onIncomingMessage(message) {
      var _this3 = this;

      this.rootStore.soundStore.playGotMessage();
      if (this.project && this.project.conversationId === message.conversationId && __WEBPACK_IMPORTED_MODULE_15_ifvisible_js___default.a.now()) {
        // Don't notify with desktop notifications when we're already viewing the
        // messages for the conversation the message belongs to.
        return;
      }

      this.rootStore.desktopNotificationStore.show({
        title: 'New message from ' + message.sender.name,
        icon: message.sender.avatar,
        body: message.text,
        onClick: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
            var project;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    project = _this3.rootStore.projectStore.projectForConversation(message.conversationId);

                    if (project) {
                      __WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].push(__WEBPACK_IMPORTED_MODULE_16_misc_links__["a" /* default */].projectDetails(project.id));
                    }

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function onClick() {
            return _ref.apply(this, arguments);
          };
        }()
      });
    }
  }, {
    key: 'sendMessage',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.composerText || !this.composerText.trim())) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return this.rootStore.messageStore.sendMessage({
                  conversationId: this.project.conversationId,
                  text: this.composerText
                });

              case 4:

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
                  _this4.composerText = '';
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendMessage() {
        return _ref2.apply(this, arguments);
      }

      return sendMessage;
    }()
  }, {
    key: 'loadMessages',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this5 = this;

        var messageStore;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.project.provider) {
                  _context3.next = 3;
                  break;
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
                  _this5.loadingMessages = false;
                });

                return _context3.abrupt('return');

              case 3:

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
                  _this5.loadingMessages = true;
                });

                messageStore = this.rootStore.messageStore;
                _context3.prev = 5;
                _context3.next = 8;
                return messageStore.fetchMessagesForConversation(this.project.conversationId);

              case 8:
                _context3.prev = 8;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_mobx__["runInAction"])(function () {
                  _this5.loadingMessages = false;
                });
                return _context3.finish(8);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5,, 8, 11]]);
      }));

      function loadMessages() {
        return _ref3.apply(this, arguments);
      }

      return loadMessages;
    }()
  }, {
    key: 'loadEvents',
    value: function loadEvents() {
      return this.rootStore.eventStore.fetchJobEvents(this.project.id);
    }
  }, {
    key: 'loadDocuments',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.rootStore.documentStore.fetchDocuments();

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadDocuments() {
        return _ref4.apply(this, arguments);
      }

      return loadDocuments;
    }()
  }, {
    key: 'conversation',
    get: function get() {
      if (!this.project) {
        return null;
      }

      return this.rootStore.messageStore.conversations.get(this.project.conversationId);
    }
  }, {
    key: 'messages',
    get: function get() {
      if (!this.project) {
        return [];
      }

      return this.rootStore.messageStore.messagesIn(this.project.conversationId);
    }
  }, {
    key: 'unreadMessagesCount',
    get: function get() {
      return this.messages.filter(function (x) {
        return x.isRead === false;
      }).length;
    }
  }]);

  return ProjectDetailsStore;
}(__WEBPACK_IMPORTED_MODULE_10_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'project', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'composerText', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'loadingMessages', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'notFound', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'detailsTab', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 'INFO';
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'conversation', [__WEBPACK_IMPORTED_MODULE_11_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'conversation'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'messages', [__WEBPACK_IMPORTED_MODULE_11_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'messages'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'unreadMessagesCount', [__WEBPACK_IMPORTED_MODULE_11_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'unreadMessagesCount'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeComposerText', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'changeComposerText'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'activate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deactivate', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'deactivate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeDetailsTab', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'changeDetailsTab'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'stageFiles', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'stageFiles'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadEvents', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'loadEvents'), _class2.prototype)), _class2)) || _class;


//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectWizardStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mobx_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_promiseUtil__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_misc_analytics__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_screens_ProjectWizard_Steps_ProjectType_ProjectTypeState__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_screens_ProjectWizard_Steps_TaxYears_TaxYearsState__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_screens_ProjectWizard_Steps_TaxStates_TaxStatesState__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_screens_ProjectWizard_Steps_Questions_QuestionsState__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_screens_ProjectWizard_Steps_FeeBreakdown_FeeBreakdownState__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_screens_ProjectWizard_Steps_WizardCompleted_WizardCompletedState__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__misc_links__ = __webpack_require__(41);












var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}








// Step states
// import LinkAccountsState from 'screens/ProjectWizard/Steps/LinkAccounts/LinkAccountsState'




// import UploadDocumentsState from 'screens/ProjectWizard/Steps/UploadDocuments/UploadDocumentsState'




var ProjectWizardStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default()(ProjectWizardStore, _Store);

  // this is for animation purposes

  function ProjectWizardStore() {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default()(this, ProjectWizardStore);

    var _this = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProjectWizardStore.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(ProjectWizardStore)).apply(this, arguments));

    _initDefineProp(_this, 'currentStep', _descriptor, _this);

    _initDefineProp(_this, 'steps', _descriptor2, _this);

    _initDefineProp(_this, 'isProcessing', _descriptor3, _this);

    _initDefineProp(_this, 'hereForFreeExtensions', _descriptor4, _this);

    _initDefineProp(_this, 'job', _descriptor5, _this);

    _initDefineProp(_this, 'stepDelta', _descriptor6, _this);

    _this._doSyncJob = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils_promiseUtil__["a" /* debouncePromise */])(_this._doSyncJob);
    _this.rootStore.authStore.onLogin(function () {
      return _this.resetSteps();
    });
    _this.rootStore.authStore.onLogout(function () {
      return _this.resetSteps();
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default()(ProjectWizardStore, [{
    key: 'getStep',


    /**
     * Used by steps to derive data from other steps.
     */
    value: function getStep(stepId) {
      var step = this.steps.find(function (x) {
        return x.stepId === stepId;
      });
      if (!step) {
        throw new Error('Step "' + stepId + '" not found.');
      }

      return step;
    }

    /**
     * Called by the view when activated.
     */

  }, {
    key: 'activate',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var job;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.rootStore.rateProjectStore.ensureAllRated();

                if (!id) {
                  _context.next = 17;
                  break;
                }

                if (!(this.job && this.job.id === id)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return this.rootStore.projectStore.fetchProject(id);

              case 6:
                job = _context.sent;

                if (!(job.status !== 'UNDER_CONSTRUCTION')) {
                  _context.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].replace(__WEBPACK_IMPORTED_MODULE_23__misc_links__["a" /* default */].projectDetails(job.id));
                return _context.abrupt('return');

              case 10:
                this.setJob(job);
                _context.next = 13;
                return this.hydrateJob();

              case 13:
                this._restoreStep();
                return _context.abrupt('return');

              case 17:
                this.setJob(null);

              case 18:

                this.resetSteps();

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate(_x) {
        return _ref.apply(this, arguments);
      }

      return activate;
    }()

    /**
     * Sets the current job being edited.
     */

  }, {
    key: 'setJob',
    value: function setJob(job) {
      this.job = job;
    }

    /**
     * Trashes current state.
     */

  }, {
    key: 'resetSteps',
    value: function resetSteps() {
      this.steps.forEach(function (step) {
        step.deactivate && step.deactivate();
        step.destroy && step.destroy();
      });
      var steps = this._createSteps([__WEBPACK_IMPORTED_MODULE_17_screens_ProjectWizard_Steps_ProjectType_ProjectTypeState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18_screens_ProjectWizard_Steps_TaxYears_TaxYearsState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20_screens_ProjectWizard_Steps_Questions_QuestionsState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19_screens_ProjectWizard_Steps_TaxStates_TaxStatesState__["a" /* default */],
      // LinkAccountsState,
      // UploadDocumentsState,
      __WEBPACK_IMPORTED_MODULE_21_screens_ProjectWizard_Steps_FeeBreakdown_FeeBreakdownState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22_screens_ProjectWizard_Steps_WizardCompleted_WizardCompletedState__["a" /* default */]]);
      this.steps.replace(steps);
      this.steps.forEach(function (step) {
        return step.initialize && step.initialize();
      });
      this.setStep(this.steps[0]);
    }
  }, {
    key: 'setStep',
    value: function setStep(step) {
      if (!step) {
        return;
      }
      var idxBefore = this.steps.indexOf(this.currentStep);
      var idxAfter = this.steps.indexOf(step);
      if (step.relevant === false) {
        var direction = idxBefore - idxAfter < 0 ? 1 : -1;
        return this.setStep(this.steps[idxAfter + direction]);
      }

      // Give the step a hook to clean up
      if (this.currentStep && this.currentStep.deactivate) {
        this.currentStep.deactivate();
      }
      this.currentStep = step;
      this.stepDelta = idxAfter - idxBefore < 0 ? -1 : 1;
      // Give the step a hook to load data when relevant.
      if (this.currentStep.activate) {
        this.currentStep.activate();
      }
      this.updateIntercom({
        wizard_step: this.currentStep.stepId
      });
      this.trackStep();
    }
  }, {
    key: 'setProcessing',
    value: function setProcessing(processing) {
      this.isProcessing = processing;
    }
  }, {
    key: 'back',
    value: function back() {
      var _this2 = this;

      var idx = this.steps.indexOf(this.currentStep);
      if (idx === 0) return;
      var prevStep = this.steps[idx - 1];
      var back = function back() {
        return _this2.setStep(prevStep);
      };
      if (this.currentStep.back) {
        // Step can hijack the back function
        // Inject the actual back call so it
        // can call it when ready.
        this.currentStep.back(back);
        return;
      }

      back();
    }
  }, {
    key: 'next',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var canContinue, idx, nextStep;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.currentStep.next) {
                  _context2.next = 8;
                  break;
                }

                this.setProcessing(true);
                // This step wants to handle "next"
                _context2.next = 4;
                return this.currentStep.next();

              case 4:
                canContinue = _context2.sent;

                if (canContinue) {
                  _context2.next = 8;
                  break;
                }

                this.setProcessing(false);
                return _context2.abrupt('return');

              case 8:

                this.setProcessing(true);
                _context2.prev = 9;
                _context2.next = 12;
                return this.syncJob();

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](9);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this3.rootStore.flashMessageStore.create(_context2.t0.message).failed().autoDismiss();
                });
                throw _context2.t0;

              case 18:
                _context2.prev = 18;

                this.setProcessing(false);
                return _context2.finish(18);

              case 21:
                idx = this.steps.indexOf(this.currentStep);

                if (!(idx === this.steps.length - 1)) {
                  _context2.next = 24;
                  break;
                }

                return _context2.abrupt('return');

              case 24:
                nextStep = this.steps[idx + 1];

                this.setStep(nextStep);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 14, 18, 21]]);
      }));

      function next() {
        return _ref2.apply(this, arguments);
      }

      return next;
    }()
  }, {
    key: 'syncJob',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.currentStep === this.getStep('ProjectType') || this.currentStep === this.getStep('FeeBreakdown'))) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                return _context3.abrupt('return', this._doSyncJob());

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function syncJob() {
        return _ref3.apply(this, arguments);
      }

      return syncJob;
    }()
  }, {
    key: '_doSyncJob',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data, newJob;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = this.steps.map(function (x) {
                  return x.serializeToJob && x.serializeToJob();
                }).reduce(function (x, y) {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["toJS"])(y));
                }, {});

                if (this.job) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 4;
                return this.rootStore.projectStore.createJob(data);

              case 4:
                newJob = _context4.sent;

                this.setJob(newJob);
                __WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].replace(__WEBPACK_IMPORTED_MODULE_23__misc_links__["a" /* default */].projectEditor(this.job.id));
                _context4.next = 11;
                break;

              case 9:
                _context4.next = 11;
                return this.rootStore.projectStore.updateJob(this.job.id, data);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _doSyncJob() {
        return _ref4.apply(this, arguments);
      }

      return _doSyncJob;
    }()
  }, {
    key: 'hydrateJob',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.resetSteps();
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(this.steps.map(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["action"])(function (x) {
                  return x.hydrate && x.hydrate(_this4.job);
                })));

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function hydrateJob() {
        return _ref5.apply(this, arguments);
      }

      return hydrateJob;
    }()
  }, {
    key: '_restoreStep',
    value: function _restoreStep() {
      if (this.currentStep === this.getStep('ProjectType')) {
        // Check to see if we can guess what step to put them on.
        var step = this.getStep('TaxYears');
        if (this.job.years.length > 0 || step.relevant === false) {
          step = this.getStep('Questions');
          if (this.job.hasAnsweredAllQuestions) {
            step = this.getStep('TaxStates');
            if (this.job.states.length > 0 || step.relevant === false) {
              step = this.getStep('FeeBreakdown');
            }
          }
        }

        this.setStep(step);
      }
    }

    /**
     * Shortcut to instantiate the steps, passing in this wizard instance.
     */

  }, {
    key: '_createSteps',
    value: function _createSteps(stepStates) {
      var _this5 = this;

      return stepStates.map(function (StepState) {
        return new StepState({ wizard: _this5 });
      });
    }

    /**
     * Updates Intercom attributes.
     */

  }, {
    key: 'updateIntercom',
    value: function updateIntercom(attrs) {
      this.rootStore.intercomStore.update(attrs);
    }

    /**
     * Sends data to Segment.
     */

  }, {
    key: 'trackStep',
    value: function trackStep() {
      if (this.currentStep.trackingId) {
        __WEBPACK_IMPORTED_MODULE_16_misc_analytics__["a" /* default */].page(this.currentStep.trackingId);
      }
    }
  }, {
    key: 'showBackButton',
    get: function get() {
      // Only show back button after the first step,
      // and not on the last step (which is after payment)
      return !this.currentStep.hideBackButton;
    }
  }]);

  return ProjectWizardStore;
}(__WEBPACK_IMPORTED_MODULE_11_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'currentStep', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'steps', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isProcessing', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'hereForFreeExtensions', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'job', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'stepDelta', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'showBackButton', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showBackButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'activate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setJob', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setJob'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetSteps', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'resetSteps'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setStep', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setStep'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setProcessing', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setProcessing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'back', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'back'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'next', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'next'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_restoreStep', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, '_restoreStep'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectScreenStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_misc_links__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mobx_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mobx_task__);











var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var ProjectScreenStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(ProjectScreenStore, _Store);

  function ProjectScreenStore() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ProjectScreenStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ProjectScreenStore.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ProjectScreenStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showingFreeExtensionsInfo', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ProjectScreenStore, [{
    key: 'fetchProjects',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.projectStore.fetchProjects();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchProjects() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'activate',
    value: function activate() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.rootStore.rateProjectStore.ensureAllRated(), this.fetchProjects()]);
    }
  }, {
    key: 'showFreeExtensionsInfo',
    value: function showFreeExtensionsInfo() {
      this.showingFreeExtensionsInfo = true;
    }
  }, {
    key: 'closeFreeExtensionsInfo',
    value: function closeFreeExtensionsInfo() {
      this.showingFreeExtensionsInfo = false;
      this.rootStore.projectWizardStore.hereForFreeExtensions = true;
      __WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push(__WEBPACK_IMPORTED_MODULE_13_misc_links__["a" /* default */].newProject());
    }
  }]);

  return ProjectScreenStore;
}(__WEBPACK_IMPORTED_MODULE_10_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'showingFreeExtensionsInfo', [__WEBPACK_IMPORTED_MODULE_11_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'fetchProjects', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchProjects'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activate', [__WEBPACK_IMPORTED_MODULE_14_mobx_task__["task"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'activate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showFreeExtensionsInfo', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showFreeExtensionsInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeFreeExtensionsInfo', [__WEBPACK_IMPORTED_MODULE_11_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'closeFreeExtensionsInfo'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RateProjectStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__misc_links__ = __webpack_require__(41);











var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var RateProjectStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(RateProjectStore, _Store);

  function RateProjectStore() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, RateProjectStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RateProjectStore.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(RateProjectStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'project', _descriptor, _this), _initDefineProp(_this, 'loading', _descriptor2, _this), _initDefineProp(_this, 'disabled', _descriptor3, _this), _initDefineProp(_this, 'rating', _descriptor4, _this), _initDefineProp(_this, 'comment', _descriptor5, _this), _initDefineProp(_this, 'selectedCategories', _descriptor6, _this), _temp), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(RateProjectStore, [{
    key: 'categorySelected',
    value: function categorySelected(key) {
      return this.selectedCategories.indexOf(key) > -1;
    }
  }, {
    key: 'rate',
    value: function rate(rating) {
      this.rating = rating;
    }
  }, {
    key: 'toggleRatingCategory',
    value: function toggleRatingCategory(key) {
      var selected = this.categorySelected(key);
      if (selected) {
        this.selectedCategories.remove(key);
      } else {
        this.selectedCategories.push(key);
      }
    }
  }, {
    key: 'changeComment',
    value: function changeComment(comment) {
      this.comment = comment;
    }
  }, {
    key: 'activate',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(projectId) {
        var _this2 = this;

        var project;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this2.rating = 5;
                  _this2.comment = '';
                  _this2.selectedCategories = [];
                  _this2.loading = true;
                });
                _context.prev = 1;
                _context.next = 4;
                return this.rootStore.projectStore.fetchProject(projectId);

              case 4:
                project = _context.sent;

                if (!(!project.completed || project.partnerRating)) {
                  _context.next = 8;
                  break;
                }

                // Project either not completed, or we already have a rating for it.
                __WEBPACK_IMPORTED_MODULE_11_react_router__["browserHistory"].replace(__WEBPACK_IMPORTED_MODULE_13__misc_links__["a" /* default */].projectDetails(project.id));
                return _context.abrupt('return');

              case 8:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this2.project = project;
                });

              case 9:
                _context.prev = 9;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this2.loading = false;
                });
                return _context.finish(9);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 9, 12]]);
      }));

      function activate(_x) {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'ensureAllRated',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var projects, unrated, _unrated, first;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.rootStore.projectStore.fetchProjects();

              case 2:
                projects = this.rootStore.projectStore.projects.map(function (x) {
                  return x;
                });
                unrated = projects.filter(function (x) {
                  return x.completed && !x.partnerRating;
                });
                _unrated = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(unrated, 1), first = _unrated[0];

                if (first) {
                  __WEBPACK_IMPORTED_MODULE_11_react_router__["browserHistory"].push(__WEBPACK_IMPORTED_MODULE_13__misc_links__["a" /* default */].rateProject(first.id));
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ensureAllRated() {
        return _ref3.apply(this, arguments);
      }

      return ensureAllRated;
    }()
  }, {
    key: 'submit',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this3.disabled = true;
                });

                _context3.prev = 1;
                _context3.next = 4;
                return this.rootStore.projectStore.rate(this.project, {
                  rating_submitted: this.rating,
                  rating_submitted_comment: this.comment,
                  rating_submitted_categories: this.selectedCategories
                });

              case 4:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  __WEBPACK_IMPORTED_MODULE_11_react_router__["browserHistory"].replace(__WEBPACK_IMPORTED_MODULE_13__misc_links__["a" /* default */].projectDetails(_this3.project.id));
                });

              case 5:
                _context3.prev = 5;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_mobx__["runInAction"])(function () {
                  _this3.disabled = false;
                });
                return _context3.finish(5);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1,, 5, 8]]);
      }));

      function submit() {
        return _ref4.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'hasRated',
    get: function get() {
      return this.rating > 0;
    }
  }, {
    key: 'categoriesPromptText',
    get: function get() {
      if (this.rating <= 3) return 'What went wrong?';
      if (this.rating <= 4) return 'What went well?';
      return 'What was awesome?';
    }
  }, {
    key: 'canSubmit',
    get: function get() {
      return this.hasRated;
    }
  }]);

  return RateProjectStore;
}(__WEBPACK_IMPORTED_MODULE_10_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'project', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'loading', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'disabled', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'rating', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return 5;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'comment', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'selectedCategories', [__WEBPACK_IMPORTED_MODULE_12_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'hasRated', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'hasRated'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'categoriesPromptText', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'categoriesPromptText'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'canSubmit', [__WEBPACK_IMPORTED_MODULE_12_mobx__["computed"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'canSubmit'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'rate', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'rate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleRatingCategory', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'toggleRatingCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeComment', [__WEBPACK_IMPORTED_MODULE_12_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'changeComment'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SoundStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_libx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_memoize__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_misc_localStorage__ = __webpack_require__(267);









var _desc, _value, _class, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var sounds = {
  gotMessage: {
    mp3: __webpack_require__(1123),
    ogg: __webpack_require__(1124)
  },
  sendMessage: {
    mp3: __webpack_require__(1125),
    ogg: __webpack_require__(1126)
  }
};

var SoundStore = (_class = function (_Store) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(SoundStore, _Store);

  function SoundStore() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, SoundStore);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SoundStore.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(SoundStore)).apply(this, arguments));

    _initDefineProp(_this, 'isEnabled', _descriptor, _this);

    _this._getAudio = __WEBPACK_IMPORTED_MODULE_10_lodash_memoize___default()(_this._getAudio);
    _this.setEnabled(__WEBPACK_IMPORTED_MODULE_11_misc_localStorage__["b" /* default */].getItem('soundEnabled') !== 'disabled');
    // Initialize all audio objects
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(sounds).forEach(function (key) {
      return _this._getAudio(key);
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(SoundStore, [{
    key: 'setEnabled',
    value: function setEnabled(enabled) {
      this.isEnabled = enabled;
      __WEBPACK_IMPORTED_MODULE_11_misc_localStorage__["b" /* default */].setItem('soundEnabled', enabled ? 'enabled' : 'disabled');
    }
  }, {
    key: 'playSendMessage',
    value: function playSendMessage() {
      return this._play('sendMessage');
    }
  }, {
    key: 'playGotMessage',
    value: function playGotMessage() {
      return this._play('gotMessage');
    }
  }, {
    key: '_play',
    value: function _play(id) {
      if (!this.isEnabled) {
        return;
      }

      var audio = this._getAudio(id);
      audio.pause();
      // Prevents some stupid DOMException, only way to do it.
      // When in doubt, setTimeout
      setTimeout(function () {
        audio.currentTime = 0;
        audio.play();
      }, 10);
    }
  }, {
    key: '_getAudio',
    value: function _getAudio(id) {
      var audio = new Audio();
      var type = audio.canPlayType('audio/mpeg') ? 'mp3' : 'ogg';
      audio.volume = 0.6;
      audio.type = type === 'mp3' ? 'audio/mpeg' : 'audio/ogg';
      audio.src = sounds[id][type];
      return audio;
    }
  }]);

  return SoundStore;
}(__WEBPACK_IMPORTED_MODULE_8_libx__["Store"]), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isEnabled', [__WEBPACK_IMPORTED_MODULE_9_mobx__["observable"]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setEnabled', [__WEBPACK_IMPORTED_MODULE_9_mobx__["action"]], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setEnabled'), _class.prototype)), _class);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateAvatarFallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/**
 * Given a name, extracts initials and generates a fallback avatar url.
 */
function generateAvatarFallback(name) {
  if (!name) {
    return null;
  }

  var initials = getInitials(name);
  return 'https://dummyimage.com/128/2395F3/fff.png&text=+' + initials + '+';
}

function getInitials(str) {
  if (str.indexOf('@') > -1) {
    // It's an email, take the first and last part.
    var _$exec = /(.*?)@(.*)/.exec(str),
        _$exec2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_$exec, 3),
        user = _$exec2[1],
        domain = _$exec2[2];

    return '' + user.charAt(0) + domain.charAt(0);
  }

  var _str$split = str.split(' '),
      _str$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_str$split, 2),
      first = _str$split2[0],
      last = _str$split2[1];

  return '' + first.charAt(0) + last.charAt(0);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvdXRpbHMvZHVtbXlJbWFnZVV0aWwuanMiXSwibmFtZXMiOlsiZ2VuZXJhdGVBdmF0YXJGYWxsYmFjayIsIm5hbWUiLCJpbml0aWFscyIsImdldEluaXRpYWxzIiwic3RyIiwiaW5kZXhPZiIsImV4ZWMiLCJ1c2VyIiwiZG9tYWluIiwiY2hhckF0Iiwic3BsaXQiLCJmaXJzdCIsImxhc3QiXSwibWFwcGluZ3MiOiI7QUFBQTs7O0FBR0EsT0FBTyxTQUFTQSxzQkFBVCxDQUFpQ0MsSUFBakMsRUFBdUM7QUFDNUMsTUFBSSxDQUFDQSxJQUFMLEVBQVc7QUFDVCxXQUFPLElBQVA7QUFDRDs7QUFFRCxNQUFNQyxXQUFXQyxZQUFZRixJQUFaLENBQWpCO0FBQ0EsOERBQTBEQyxRQUExRDtBQUNEOztBQUVELFNBQVNDLFdBQVQsQ0FBc0JDLEdBQXRCLEVBQTJCO0FBQ3pCLE1BQUlBLElBQUlDLE9BQUosQ0FBWSxHQUFaLElBQW1CLENBQUMsQ0FBeEIsRUFBMkI7QUFDekI7QUFEeUIsaUJBRUEsYUFBYUMsSUFBYixDQUFrQkYsR0FBbEIsQ0FGQTtBQUFBO0FBQUEsUUFFaEJHLElBRmdCO0FBQUEsUUFFVkMsTUFGVTs7QUFHekIsZ0JBQVVELEtBQUtFLE1BQUwsQ0FBWSxDQUFaLENBQVYsR0FBMkJELE9BQU9DLE1BQVAsQ0FBYyxDQUFkLENBQTNCO0FBQ0Q7O0FBTHdCLG1CQU9ITCxJQUFJTSxLQUFKLENBQVUsR0FBVixDQVBHO0FBQUE7QUFBQSxNQU9sQkMsS0FQa0I7QUFBQSxNQU9YQyxJQVBXOztBQVF6QixjQUFVRCxNQUFNRixNQUFOLENBQWEsQ0FBYixDQUFWLEdBQTRCRyxLQUFLSCxNQUFMLENBQVksQ0FBWixDQUE1QjtBQUNEIiwiZmlsZSI6ImR1bW15SW1hZ2VVdGlsLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBHaXZlbiBhIG5hbWUsIGV4dHJhY3RzIGluaXRpYWxzIGFuZCBnZW5lcmF0ZXMgYSBmYWxsYmFjayBhdmF0YXIgdXJsLlxuICovXG5leHBvcnQgZnVuY3Rpb24gZ2VuZXJhdGVBdmF0YXJGYWxsYmFjayAobmFtZSkge1xuICBpZiAoIW5hbWUpIHtcbiAgICByZXR1cm4gbnVsbFxuICB9XG5cbiAgY29uc3QgaW5pdGlhbHMgPSBnZXRJbml0aWFscyhuYW1lKVxuICByZXR1cm4gYGh0dHBzOi8vZHVtbXlpbWFnZS5jb20vMTI4LzIzOTVGMy9mZmYucG5nJnRleHQ9KyR7aW5pdGlhbHN9K2Bcbn1cblxuZnVuY3Rpb24gZ2V0SW5pdGlhbHMgKHN0cikge1xuICBpZiAoc3RyLmluZGV4T2YoJ0AnKSA+IC0xKSB7XG4gICAgLy8gSXQncyBhbiBlbWFpbCwgdGFrZSB0aGUgZmlyc3QgYW5kIGxhc3QgcGFydC5cbiAgICBjb25zdCBbLCB1c2VyLCBkb21haW5dID0gLyguKj8pQCguKikvLmV4ZWMoc3RyKVxuICAgIHJldHVybiBgJHt1c2VyLmNoYXJBdCgwKX0ke2RvbWFpbi5jaGFyQXQoMCl9YFxuICB9XG5cbiAgY29uc3QgW2ZpcnN0LCBsYXN0XSA9IHN0ci5zcGxpdCgnICcpXG4gIHJldHVybiBgJHtmaXJzdC5jaGFyQXQoMCl9JHtsYXN0LmNoYXJBdCgwKX1gXG59XG4iXX0=

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debouncePromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);



function debouncePromise(fn) {
  var promise = void 0,
      nextArgs = void 0;
  function debounced() {
    var _this = this;

    nextArgs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arguments);
    if (promise) {
      return promise;
    }

    var args = nextArgs;
    promise = __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.try(function () {
      return fn.apply(_this, args);
    }).then(function (result) {
      promise = null;
      if (args !== nextArgs) {
        return debounced.apply(_this, nextArgs);
      }
      return result;
    }).catch(function (err) {
      promise = null;
      nextArgs = null;
      throw err;
    });
    return promise;
  }

  return debounced;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvdXRpbHMvcHJvbWlzZVV0aWwuanMiXSwibmFtZXMiOlsiUHJvbWlzZSIsImRlYm91bmNlUHJvbWlzZSIsImZuIiwicHJvbWlzZSIsIm5leHRBcmdzIiwiZGVib3VuY2VkIiwiYXJndW1lbnRzIiwiYXJncyIsInRyeSIsImFwcGx5IiwidGhlbiIsInJlc3VsdCIsImNhdGNoIiwiZXJyIl0sIm1hcHBpbmdzIjoiO0FBQUEsT0FBT0EsT0FBUCxNQUFvQixVQUFwQjs7QUFFQSxPQUFPLFNBQVNDLGVBQVQsQ0FBMEJDLEVBQTFCLEVBQThCO0FBQ25DLE1BQUlDLGdCQUFKO0FBQUEsTUFBYUMsaUJBQWI7QUFDQSxXQUFTQyxTQUFULEdBQXNCO0FBQUE7O0FBQ3BCRCxlQUFXLFlBQVdFLFNBQVgsQ0FBWDtBQUNBLFFBQUlILE9BQUosRUFBYTtBQUNYLGFBQU9BLE9BQVA7QUFDRDs7QUFFRCxRQUFJSSxPQUFPSCxRQUFYO0FBQ0FELGNBQVVILFFBQVFRLEdBQVIsQ0FBWTtBQUFBLGFBQU1OLEdBQUdPLEtBQUgsUUFBZUYsSUFBZixDQUFOO0FBQUEsS0FBWixFQUF3Q0csSUFBeEMsQ0FBNkMsa0JBQVU7QUFDL0RQLGdCQUFVLElBQVY7QUFDQSxVQUFJSSxTQUFTSCxRQUFiLEVBQXVCO0FBQ3JCLGVBQU9DLFVBQVVJLEtBQVYsUUFBc0JMLFFBQXRCLENBQVA7QUFDRDtBQUNELGFBQU9PLE1BQVA7QUFDRCxLQU5TLEVBTVBDLEtBTk8sQ0FNRCxlQUFPO0FBQ2RULGdCQUFVLElBQVY7QUFDQUMsaUJBQVcsSUFBWDtBQUNBLFlBQU1TLEdBQU47QUFDRCxLQVZTLENBQVY7QUFXQSxXQUFPVixPQUFQO0FBQ0Q7O0FBRUQsU0FBT0UsU0FBUDtBQUNEIiwiZmlsZSI6InByb21pc2VVdGlsLmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9qZWZmL1Byb2plY3RzL3RheGZ5bGUvY3VzdG9tZXItcG9ydGFsIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb21pc2UgZnJvbSAnYmx1ZWJpcmQnXG5cbmV4cG9ydCBmdW5jdGlvbiBkZWJvdW5jZVByb21pc2UgKGZuKSB7XG4gIGxldCBwcm9taXNlLCBuZXh0QXJnc1xuICBmdW5jdGlvbiBkZWJvdW5jZWQgKCkge1xuICAgIG5leHRBcmdzID0gQXJyYXkuZnJvbShhcmd1bWVudHMpXG4gICAgaWYgKHByb21pc2UpIHtcbiAgICAgIHJldHVybiBwcm9taXNlXG4gICAgfVxuXG4gICAgbGV0IGFyZ3MgPSBuZXh0QXJnc1xuICAgIHByb21pc2UgPSBQcm9taXNlLnRyeSgoKSA9PiBmbi5hcHBseSh0aGlzLCBhcmdzKSkudGhlbihyZXN1bHQgPT4ge1xuICAgICAgcHJvbWlzZSA9IG51bGxcbiAgICAgIGlmIChhcmdzICE9PSBuZXh0QXJncykge1xuICAgICAgICByZXR1cm4gZGVib3VuY2VkLmFwcGx5KHRoaXMsIG5leHRBcmdzKVxuICAgICAgfVxuICAgICAgcmV0dXJuIHJlc3VsdFxuICAgIH0pLmNhdGNoKGVyciA9PiB7XG4gICAgICBwcm9taXNlID0gbnVsbFxuICAgICAgbmV4dEFyZ3MgPSBudWxsXG4gICAgICB0aHJvdyBlcnJcbiAgICB9KVxuICAgIHJldHVybiBwcm9taXNlXG4gIH1cblxuICByZXR1cm4gZGVib3VuY2VkXG59XG4iXX0=

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(873), __esModule: true };

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(874), __esModule: true };

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(877), __esModule: true };

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(882), __esModule: true };

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(885), __esModule: true };

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(9);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
__webpack_require__(910);
module.exports = __webpack_require__(30).Array.from;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162);
__webpack_require__(132);
module.exports = __webpack_require__(908);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162);
__webpack_require__(132);
module.exports = __webpack_require__(909);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(30)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294);
__webpack_require__(132);
__webpack_require__(162);
__webpack_require__(912);
__webpack_require__(922);
module.exports = __webpack_require__(30).Map;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(913);
module.exports = __webpack_require__(30).Object.assign;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(914);
var $Object = __webpack_require__(30).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(915);
var $Object = __webpack_require__(30).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(916);
var $Object = __webpack_require__(30).Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(917);
module.exports = __webpack_require__(30).Object.getPrototypeOf;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(918);
module.exports = __webpack_require__(30).Object.keys;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(919);
module.exports = __webpack_require__(30).Object.setPrototypeOf;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294);
__webpack_require__(132);
__webpack_require__(162);
__webpack_require__(920);
module.exports = __webpack_require__(30).Promise;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(921);
__webpack_require__(294);
__webpack_require__(923);
__webpack_require__(924);
module.exports = __webpack_require__(30).Symbol;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
__webpack_require__(162);
module.exports = __webpack_require__(292).f('iterator');

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(203);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(94)
  , toLength  = __webpack_require__(207)
  , toIndex   = __webpack_require__(907);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(91)
  , IObject  = __webpack_require__(280)
  , toObject = __webpack_require__(131)
  , toLength = __webpack_require__(207)
  , asc      = __webpack_require__(891);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93)
  , isArray  = __webpack_require__(448)
  , SPECIES  = __webpack_require__(44)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(890);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(60).f
  , create      = __webpack_require__(205)
  , redefineAll = __webpack_require__(286)
  , ctx         = __webpack_require__(91)
  , anInstance  = __webpack_require__(277)
  , defined     = __webpack_require__(202)
  , forOf       = __webpack_require__(203)
  , $iterDefine = __webpack_require__(281)
  , step        = __webpack_require__(451)
  , setSpecies  = __webpack_require__(456)
  , DESCRIPTORS = __webpack_require__(70)
  , fastKey     = __webpack_require__(282).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(201)
  , from    = __webpack_require__(887);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(54)
  , $export        = __webpack_require__(59)
  , meta           = __webpack_require__(282)
  , fails          = __webpack_require__(106)
  , hide           = __webpack_require__(92)
  , redefineAll    = __webpack_require__(286)
  , forOf          = __webpack_require__(203)
  , anInstance     = __webpack_require__(277)
  , isObject       = __webpack_require__(93)
  , setToStringTag = __webpack_require__(161)
  , dP             = __webpack_require__(60).f
  , each           = __webpack_require__(889)(0)
  , DESCRIPTORS    = __webpack_require__(70);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(60)
  , createDesc      = __webpack_require__(160);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(130)
  , gOPS    = __webpack_require__(284)
  , pIE     = __webpack_require__(206);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(205)
  , descriptor     = __webpack_require__(160)
  , setToStringTag = __webpack_require__(161)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(92)(IteratorPrototype, __webpack_require__(44)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(130)
  , toIObject = __webpack_require__(94);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(54)
  , macrotask = __webpack_require__(457).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(159)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(130)
  , gOPS     = __webpack_require__(284)
  , pIE      = __webpack_require__(206)
  , toObject = __webpack_require__(131)
  , IObject  = __webpack_require__(280)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(106)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(60)
  , anObject = __webpack_require__(81)
  , getKeys  = __webpack_require__(130);

module.exports = __webpack_require__(70) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(94)
  , gOPN      = __webpack_require__(452).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(93)
  , anObject = __webpack_require__(81);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(91)(Function.call, __webpack_require__(283).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(81)
  , aFunction = __webpack_require__(276)
  , SPECIES   = __webpack_require__(44)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(289)
  , defined   = __webpack_require__(202);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(289)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(81)
  , get      = __webpack_require__(293);
module.exports = __webpack_require__(30).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(201)
  , ITERATOR  = __webpack_require__(44)('iterator')
  , Iterators = __webpack_require__(129);
module.exports = __webpack_require__(30).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(91)
  , $export        = __webpack_require__(59)
  , toObject       = __webpack_require__(131)
  , call           = __webpack_require__(449)
  , isArrayIter    = __webpack_require__(447)
  , toLength       = __webpack_require__(207)
  , createProperty = __webpack_require__(895)
  , getIterFn      = __webpack_require__(293);

$export($export.S + $export.F * !__webpack_require__(450)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(886)
  , step             = __webpack_require__(451)
  , Iterators        = __webpack_require__(129)
  , toIObject        = __webpack_require__(94);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(281)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(892);

// 23.1 Map Objects
module.exports = __webpack_require__(894)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(59);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(901)});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(59)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(205)});

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(59);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(70), 'Object', {defineProperty: __webpack_require__(60).f});

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(94)
  , $getOwnPropertyDescriptor = __webpack_require__(283).f;

__webpack_require__(285)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(131)
  , $getPrototypeOf = __webpack_require__(453);

__webpack_require__(285)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(131)
  , $keys    = __webpack_require__(130);

__webpack_require__(285)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(59);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(904).set});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(204)
  , global             = __webpack_require__(54)
  , ctx                = __webpack_require__(91)
  , classof            = __webpack_require__(201)
  , $export            = __webpack_require__(59)
  , isObject           = __webpack_require__(93)
  , aFunction          = __webpack_require__(276)
  , anInstance         = __webpack_require__(277)
  , forOf              = __webpack_require__(203)
  , speciesConstructor = __webpack_require__(905)
  , task               = __webpack_require__(457).set
  , microtask          = __webpack_require__(900)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(44)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(286)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(161)($Promise, PROMISE);
__webpack_require__(456)(PROMISE);
Wrapper = __webpack_require__(30)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(450)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(54)
  , has            = __webpack_require__(107)
  , DESCRIPTORS    = __webpack_require__(70)
  , $export        = __webpack_require__(59)
  , redefine       = __webpack_require__(455)
  , META           = __webpack_require__(282).KEY
  , $fails         = __webpack_require__(106)
  , shared         = __webpack_require__(288)
  , setToStringTag = __webpack_require__(161)
  , uid            = __webpack_require__(208)
  , wks            = __webpack_require__(44)
  , wksExt         = __webpack_require__(292)
  , wksDefine      = __webpack_require__(291)
  , keyOf          = __webpack_require__(899)
  , enumKeys       = __webpack_require__(896)
  , isArray        = __webpack_require__(448)
  , anObject       = __webpack_require__(81)
  , toIObject      = __webpack_require__(94)
  , toPrimitive    = __webpack_require__(290)
  , createDesc     = __webpack_require__(160)
  , _create        = __webpack_require__(205)
  , gOPNExt        = __webpack_require__(903)
  , $GOPD          = __webpack_require__(283)
  , $DP            = __webpack_require__(60)
  , $keys          = __webpack_require__(130)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(452).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(206).f  = $propertyIsEnumerable;
  __webpack_require__(284).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(204)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(92)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(59);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(893)('Map')});

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291)('asyncIterator');

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291)('observable');

/***/ }),
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(371);


/***/ }),
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d5327099487df746f402c30466ae6e5b.mp3";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20507c8d92ae23b4d9aaddcd156f3fc5.ogg";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6a7090c10c130bab16aaaec901064a60.mp3";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2688cf832e4fb63543e50fd58a2a12d3.ogg";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "node_modules/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-128.gif";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "node_modules/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-256.gif";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "node_modules/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-512.gif";

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/amex@2x.png";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/amex@3x.png";

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/bofa@2x.png";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/bofa@3x.png";

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/capone.png";

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/capone360.png";

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/capone360@2x.png";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/capone360@3x.png";

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/chase@3x.png";

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/citi@2x.png";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/citi@3x.png";

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/etrade.png";

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/fidelity@2x.png";

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/fidelity@3x.png";

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/merrill.png";

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAABWCAMAAADhYGq7AAAC/VBMVEUAAAAAQHUJQHsJQnsAQ3kJQnsJQ3wJQ30KRHwKRH0JRH0KRHwJQ3wIRH0JQnsJQ3wJRH0KRHwKQ3wJQ30JRHwKQ3wJRHwJRH0KQ3wAK1UJQ3sJQ30JQ30KQ3wJQ30APXoKRH0FQHoJQ3wKQ30JRHwKQ3wKQ30KQ3wAAAAAOnQJRHwJRHsJRHwJRHwAOXEJQHYKQ3wKQ30AM2YFQX0AAFUAAAAJQXwKQ3wJQ30JRH0KRHwKRH0KQ3wJQ30JQ3wIQ3wJRHcKRHwAQGAHQXoJQ3wHQ3oKQ30AN20JRHwIQ3sJRH0KQ30JQ30IQ3sJQ3wKRHwJQ3wIQ3wJQ3wJQnwJRH0JQ30KQ3wJQnwIQnwKQ3sIQnwGQ3kJRH0HQXwKQ30AO3YHPnwJRH0KQHsJQ3kJQ3wJRH0IQn0HQ3kKRHwJQnsJRHwAQGoJQnsKQn0JRHwIQnsJQ3wJQ3wJRHwKRHsJQ3wAOXEKQ30HQXwGQHoIQnwJQnwGQ3oGQHkIQ3sJQ3sHQ3wAQHAJQ30AQHMJRHwJQnsKRHwJQXkAM2YJRH0KRHwJQ3wJQ3wHQ3wAQEAJRH0IQHgJQ30IQXoKRHwJRHwIQnwFQnoJQ3wJRHwJQ3sJRHwJQ30JPnsKQnsFRH0KQXwIQnwJQ3wKQ3wIQ3oKQnsIRHsJRH0JQ30JRHwHQnoKRHwALnQJQ3wJQ3wJQ30KQ3gJRH0JRHwAJG0JQ30ARHcKQ3wJQ3wJQX0JQ30JQnsHQnwKQ3sJRH0JQ30JQ3sKRH0JQ3wKQ30KQ3wKRHwIRHgAPHgJRHwJRH0APXkKRH0IQ3kIRHwIQXkJRH0JQ3wJQ3wJQ3wIPnwGQX0JRHwIRH0GRH0JRHwKQ3wJQ3wIQnsKRHwKQ30JRHsKO3YIRHwJQ30KQ3wIQ30IQn0JQ3wJQ30HQnwJQXkIQ3sJQnsKRH0KQ3sKRH0KRHwKQ3sKRH0KQ3wKQ3wIQ3wJQnsKQ3wJQ30KRHwHRHoIRH0AQ3oHQHgKQX0JRHwIQ3wIQnsGPnwJRH2eGxl/AAAA/3RSTlMAGDg2E1WUwub/4bWKXhuj+fCG88eh/P23BlfK46DGGe0w4O911OtnARaxeN7DCRzotgUvAwJSzt/b7unR+8V5HmkIR6RFug6meo/nvn7BgOSY/o7IWOySQp17Kosn1Q0lqjQ5+pNkJp469AxZg9ofvattT/YShUosf3cuKFt2TBCuFOJ0zzsK5eqvc0gE9SD3Q9KiYTKo+G6Ish1NMU5ljLNBaHzAlalJuQuQ8rA1h8sH3Q+cp1aRUUZqvNly8VSZu9MiEZbXFWY9RD/E2L/JIStxYi2ta9xdhIFTGkCJzVxgb40jN19wtJvM1p+4UIJjbNCsmkuXFyQzpX0+KVqjedmuAAANOklEQVR4Ae3bBXwUx8PG8QfnwS13RBpSjtALTpogSVPBK6FwyItrsOAt7oSUQLBQHOqCN5CitbSpkLq7u7v39ezdzs7unORu2zf5vHz+30pcfszc7ezugP9nqlStVh3nqeo1ataqzTJ16tar3wDnm2oNG5Fs3KRpsygHHXQ2rxGN80hMLBl3gTO+BRIa4sKWrlaJZOuL3DhPJLUhm7at3q59B2iB6Nipc3ITJ9nsYpQv2iwFUop4JxTuaCnZ/LnWbyHIz7V+mVmq+hGLLq1JxnXtxu5du3Z1pJX9L52XdG1MMqMVykWzSyFdRt3lsLqCUuMe0PSkoReselPo46Tg6guLfhSuhJ+rro7lNZmZvdg/s0ziJZll4jOuzcwckDHQM8gdUSAvDCNwME2GQJOcRmFoKiz+jcKw4TSMgNlII71OD6hGtRvdZ8xYoJ9jHMqMb4gyE9gTmJg1abKnV3JEgcPLD5xCs87wmkrDNFh0o65TSotsCkOnw2Q8hRlQzZzVYpKrLG22YypkIObMBXAdr7/IUzOiwHnzyw1cQDNHFWgW0rAAZosoTAIW07AEBiz1UDfYDcWIxsuGcTmAFVxkDlzZaBWA1Qk5rTgkrEChVXmB7jW0yIUmujGFG2B2JYW1QN46CuvzYMinMBGKDc6NmxLjtezBs2AO7LG5BoAtBYPcfZqOjiSwXWo5gVtpdSO8ttHQACbNqItzA9hOwwYIOyjshGLLrpnY7akGIMWzxxKIvd4Z22TXvgZp8WEFCjeVExhFxc3Q3ELDrTAgyUndbQCQegOFqztAdzt1u7ZA0a9275iM2DvK3Mm77vC6u4/v5f7a2v9v2XXgjkk8GEngodCBh7Pp05W6I74pc5TCPRDMQ1YIzTAadsOnkMIxKC72MCzHwwncTB/PlJCB9enjKqQufZNyKGtaFODhda86XFynf1pz6tL7QrF/wInpdbtN15w8NN1n9Snfy1UZp7UXN/PA9PlHV4YReEoMzZmQgXOM4/kA66Q+S8N9EIqy1efWZRkU7odmIoWLoChKG4Gi7EnQPHAE1scgHnwImllrgIanwggcOJA+xYdDBO5z0udhPELdXGg6GC08AuEghaXQ7aewJhoASqh7NAWKLtyCjewJzZr71cC9A6G5jY9hZVpKGIFLqbsiRKB41t81HbdQt+txaA5Q6A7hCerOQSgtpvAkgKf8x91w5hxQM7sIAPI8T6uBo66B5hluR7TrqTAC8Sx9EkMEPkefukBegfVPpAYNU6CLoy4ThiUUum0CnjcviRSxU4H4F6B5kS+pgbnnoHmck4DmTcIJnEHdHUEDq5oPBc2pawbN4XkUXobPzRRGw1DUksIruIM6x0ioorNWAO3aQPMqZ6uBd8bBq1FzYM/ccAKj0+nzmn+gMuU8VQC8rozYaxQegE9mwNXNEApvpLSnbj/8NOByYN4j+lNRdTXwTRe81nQHrmgfTiDeoo+jY5DA6AT6xAPAFmX5OYNCo+nwOk5dW5i4B1OIoq5xDvws5fXoy7eh6c0iNfBsBrxiMzZhyBthBV7uMH7hwIHvULcCmkTq6rgBYGwBhbPQvOuh7kWYraWfVvD3HtNbDmBaS816ttRtzm7pk8463pcFjGu5PjusQOOwnF4UOHCv9SH1PoVh0NxD4SQ0T1I3GFZzqbi3CP6msU3+cSbma5oxX5f1ge+l8a7WjfPz2zUOL7A3dW8GDCzNsj7pP0UhCpoPKdR2W1YtL8PqsUa0ehgBPMb5GKZP/63sAJ+hH4np1AheN9wNTD0XXqB7Fn1eCBj4sbJoTEmjrulhADjRiMIOAHnz6ONpAMUntGiPQPL4KS7XT8E/Yyl8EkTg52nwuvoAkP98eIH4grrCQIFdqavqdymlPjRfUrjLfILRH6pVCTTxFCKg4p5I3fUlNC/xRXUEX18DTarjDJDYL8zAVZuNOecfuMgyATXLlQPDRzQfGr8yLzoVH9OkIQIbvAIY8zU0s/mqOoJtv4EmiZehKOOyMAONX2pXjn/gKMunauY7qHPuA4DHs4y3c+CuTR9HEvwkz6JhXkcEtvgB4Ntdh72fn7FRHcH9faC5icNwkEvDDbyZusv8AlNqUzdnv9BYudz3HYU3UUhdCQL4noYfEEShIwmf64ec7h+rI1gyyTckrk24IA7hBiJeHNpS1MCNDOU5aH6ksBMzqfsRgbioyziMINzp92MLL4Cm7hNq4JqfvJ/TqR+iGz8SfuCH1J1VA08xpM8AICeDOlfKz/TJehyBJFC3C0F9Mvipp9JaP6V5LfYpn+Imvpd3eFZoL7bz2FNfsDD8wKL1Yh4qgX3nMaQnoCmhsJy6LxHQ0DACkzYzLLcj/EAco66hNXAyQ0uIBoCLKNSm7kOEP4Kqes6nVx3vuurEiRNLufaEV9pO38vFD2r/H1fQ5MRM7ogkcLaTPrusge1ZjncAIMlBRcHYvxFYevS5Dr19l7tnLYFXQkN4zTnincRD+04p+AWRBMoFpyXwMZanDTTPU/Ea7ExReWpVE3PqdABwpha8hvoCpzfqCaDKvNzUZwfkRBa4MWDgtdS5HrKIpZBVCnmSKNWAjRGU9vP0jqwmALY6WphH8OHiHgB+fbBH24y1iCzQ/UaAQPe9QZYd22nwHqlaOGmRnff3AqOPZ5zN9fwGuLvVMweW/A7gil03r2AuIgzEhgCBTwVb+OfIoA+gqUWLfrAVKJV+nfV987QXgcziEzKwKicAvzk+fouZiDhw/jz/wJOUl9MkJch7+2c3LW6xGShNL2n0LNvl57fnYO/5YLepR37Irdnw4NpXf9zdz3k/Ig/EVL/ADsWUl9MkZby9c6ijhyaNi+wGStFRZEbCl7tHfPlj4egWT8YMGzasy5upqV1e2bC+uAbsBE7wC5xhuZZp8SkNtVOMxZ7wLewHSgu7kZ5HqowZ87hvim6pnflZLMnV78JWIF5QA7+jvJymSqTBu+J/iCY9bQda5O2ZR2Y3dz53s3cbSdzQu0m+cT1gM/BzJfBdhzzP8/OW8owym1LrTfYDrU7c7z3ddnYu6F8zi2TW3N5unGcuvG74B97lVdo1n3z4B85PyTsWTnsX//KPyPvDIulEtO3vIZXOn+5GECl/SDmwcP9hSIUiMZiqeCcxqHHyCpzk7NSs38zePWAWkxjUi0Au/XnSbuz3Zg/4e5NSxh8wm05DRygYzNZQp4CvqoFSQZ83U2C4k0Etk4F+Eq6AnxJKyrXkwxUSKJ2r4bYZKF0FRQMnTX6ulEDp0HybgdJlsGpLi6WVMkWldn/+3cCCBrD4hhafVM4ISm8k2QuU3oJZIa2uTqnkQN7tjiSwaePGjed5QmzvqUnFwkinaPEKq9mmwIErFDnmwPi/ynzWu/6RS2j2pHX37P4VivkiUD6kOsbMpcHZAwZ5c/lZ6g5EGrgOKhn4DPzJwO8grC2htL6HZQSnQaUGel0X6HeV+4wKxnnEaycqIRCpMz3mIbQRiJ+VbX6w3D3eiw/ktzccrohAeQ9KGGwr8FigwOpZxs6Tt+UG80oJLHqUgucPO4FyjlaB3zudpahG4c9KCcQ7NMywESg312SlwvC1vNnt7iTvu/2fPgY/DhLYoSmFenYCnw9wfWukeZ/wt8ZWMHfFj6D1PtuXNgKf8lAXA8P7claap8gz/9gIxh6yqhIqUA5tvDnwhUNWpQED71tnfFc3hNR15n2CfbOomxrRCBastpgiA/09FipwIYVz8kDvbx+AVhTmlP3I/DaH5IKz/3wYelpXbw9QdzQP9hfbE20HTqTQSY5g4MBcBnHulWRI/07dBGheprBcjmAFBl5MYZetwM0lmTtgNlbcSxjghmYchT6VPILZtgITDg2fXAUmr6h7Lo09KM4GlRF4UK5GbU/RrGPJMPSnrjd8BlFYUhlTdDmFljYChSgIL4oDR2MRvZXCmH9oBH85Y1U9VGC9wIeJ8WesVoUOlJvUM/3uNSYXU5gQ/ghuPmnxmO0DfXvzvYorwjzQ35GUlNRiyvVtKMiFjHHH+YN+QmsKkyrqdEnK2UXhh8hXMr0oFHSQ+4ODG5pc4YH/QcPByAOX0lAIr18Z0vcVvRZtIaePY2zkgW65VP8cmh6NGVJ+BQcmt6dhjp0T3m+sd8QRw9CyqlfoFH33Ukqn7QTWUnagdWY5fqrAEXx3gYtSXLKdwHzr3y2t4mA5jv8TIzhzueIZc+CN2nsm3/XVGA/NulgvG167XPGfAQN/p5Bm2cQx75XtZqaB/S9L4M6pVqEDg9orA4PJL+/K9msBAzNpOAHgRrkVzuIgDXssU1RlP/BjhhQ73V7grTT8BVxI4RVYFB2lMCDVfqD9ETyeA3uBKy3XrK6ivJxmNZ6G3phe4YE1o2Ez8E8aFmBTetC/O/LfNPSq8BG89D3AbiCGyuOEaThzoViVJVfRYys0sHGvjYDdQMuBb6h7LoU/Q93R3h4q0CWcg+pNV1CngDtdVgmt6/x8za9fDEuG2SuuoLYB17mElyC0dRkKO4nXXoDC8vPvOewK6n8BxPbRgNjgR6IAAAAASUVORK5CYII="

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/nfcu@2x.png";

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/nfcu@3x.png";

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/pnc@2x.png";

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/pnc@3x.png";

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/schwab.png";

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/schwab@2x.png";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/schwab@3x.png";

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/scottrade.png";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/suntrust.png";

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/suntrust@2x.png";

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/suntrust@3x.png";

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/svb@2x.png";

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/svb@3x.png";

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/td@3x.png";

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/us@2x.png";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/us@3x.png";

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAAA4CAMAAADadaTrAAAC/VBMVEUAAAAAK1UANVsANloANVoANVoANloANVsANVsANlsANVsANVoANFoANlgAAFUANFgANlsANlsANlsANFUANVsANloAMzMAAAAANloAM1kAMlkAM1sANlkANFoANFsANVoALlEANVoANFsANFoANVoANlsANVoAAAAANloANlsANVsANVkANVoANVoANlsAM1UANFcAM1cAJFsANVoANFoANlkANVkANloAMloANVsAMlgAMVUANFoAMlcANVoANVoANVoANVoANVoANVoANVkANlsANVoAM1cANFoANVoAAEAANFoANVoANFkANloAM00ANlkALlIANFgANVkANVsANVoANVoANFkANlsANVsAMFAANloANVkANFsANloANlkANloANloANlsANVcANlgANlsANVgANlsANVoANFoANVoANVoANloANlsANFkANVoANFoANVoAMFgANloANlsANVoANVsAJEkANloANVoANVoANVgANlsANlsANlsANVkANVkANVoANlsANVoAM1kAIEAANVoANVoANlEANVsANVkANFsAM1kAMVgANlsANVUANVoANVsANlsANVsANloANVoANVsANloANlkANVoANloANlsANloANFsANVsANloANVsALkYAMVUANFoANlsANVoANVoANVoANFgANVsANVsANVgANFgANloALVoANVsANVoANloANVkANVoAJ04ANloALFkANVoANVsANVsANVsAM1cANVsANVsAK1UAMlkANloANVoANVsANVoANloAMVoANVoAM1IANVoANFsANloANFoAMlUANloANVoANFkANVsANlkANVoANloANVkANVkAHFUAMFoAM1oANVoAK1UANVoANlcAM1gANVoANFoANlsAMlcANloAM1kANFoANFgAM1gANlsANVkANVoANFkALlUANloAMVcANlkANVsANVkANVoANVsAM1UANVoANlsANVoANVoANVoANVsANVoANVoANFkAL1UANVsBWzL/AAAA/3RSTlMABq72/vnz7+fQt55xNANi//KrJ7HfBQHtKC4tbV1JMBathF7BplsCnLThYbL41g8sIw7JNnJqrzN5PSpKOIu75d19pX6dszJYwASXglmqCnscMSuH2fBw8fUQ/JqStV/uhWg1UdVDws6NtojD3lORT6wgd1qZVwe+lNQ66Uy5XFak97hQCIObE49IOxQa4xi6+tvNoerm4DkisMhVa/1H9AsVeorXqHRUvKkdTpMRc2+9jNIN6BfrZaDYRr/sDELaYMrczB9SGW52omMk0cZ1o2SQ+3iGCSVBxBKnJks+f5gpjjxsQDfkP+JFIYAvidNNz8Uelsdmy0SBn3xnG5WNMZq4AAAK5ElEQVR4AdzP03prUQBF4Rk7mbFt59inVmob7/8U7c63orVrd/+342rgVjq9wWgyW6w2u8PpckObPBzh9fmhRQGOCYagPeEIx0WhPTFK4tCeBIf0yVQ6Aw3KciiHjyyUDxSKJR3UyhEOVfCBhatU1OphyNJUNJpUtPCS2rFO9NNn3KDcF8YtwmUBKh0KX75C8o2K7z/Y8xP3kfol/Ibsjyh/Me7f/4lJKoxT+uk0oGanYMMtZijMQvabfca5DMbMU7GwyJ6lLu5hmcIKZKuirGHE+kaQY1rTm5BtsW8bN9uhsAvZXw7t7Xcx5D7glcPu0TF7TkS81endk2cYOp+kykUMshqFy1rtOrCJrF0D+BOaond7HzS4Q5bi7u52y6Kl2Bru7lbcaXFLi7u7O6xhWxa3dXf3TXrOGctMcu/9vu/3DxJ9Z+acVyYvwdnLVF6Bxas06tkLmkoMKAr0ptCnLcLq6xxkMwr9oLga005/WA2gNBDOBlEZDIshNBs6DNJw9YkjKHUZWRBh9HcOchSFjJBGj6GtsbAaR2U8HDWjMiEKZhMnTa793JSpnanEt4pBqmkMmA54m1DJXH0GQprpHOQUCtMgPU97s2Ax2+18AHRzqJkLsyh4ys2bjwVdu1BZ2Ax+LdIyYBEA18zSVKJbexBCo/BBLoZQnAYJiUuyZ6aw1PkccVkLOIhaTs1UWORbQbL3ROQuSs2AtsBK0XjALzdWraZmzXg4q+4c5FoKdZGqRX0qS15eFQW/Vesy+kg2tEshSn44SKIueb19ET4pF5otpOLrumEjA4rBb1PzPEjaTM2WF+Bkq3OQ2yhsR6oiVDZ6oWm3w81iMNvpo25qmDQpFIfJLkoJfSusf6k0lY4if62D33R22b0nx95YKsnDXbC3L3yQ+5FqKKUDMKl20BpkGxokx8DWoc40yOiYQg7/t6d8KZoVgN8RkkePeRcdd1M5cRK2qjgHOYjCKQR4TlNIewZmrrMwO0ej1rB1nkZdClqPr+5CbeTvQINYLwIu0u/SStS+QE2ay7BxzDnIKxSaI+AqpR0IYx5NmsDWGJq8ZvPRivv4Itfraamo7f64ePCNq543J1CJaLA+xAFtBaeyoygC3qLUEmHMoknCbNhQ61a5YCkGkq9dT09N5huuqzfdlBog1S3twRxl306hMuF2OU+OrH3fga54+CB7IyAPpTQI7U4sU/kovey4qxvdhUGBN88AyD0ygUqH/Bi/hMI9pJqfVnuwFmpupy7eci7WOgc5ncJ9BDyglLYCQipO4eFhCgNgo4x60L4VaZFr/MSknRiWhZomb3mPHaVfSgyEyT4qJR7hygoajTRG4hzkEPOXnEApE0KqS+FxVwruywjyHIXTMS9S2AyjxfRzd6+Js+OoRPY/Ezc4xXhlP7mmP7jp0J2nEdS1hO5x+CCbI9UkKoO9UJwX2+kcjynddm5+nuEmpbbQvUshpduDFp06Ulk+2VNuP9+D1LZg1LoXqaQ/77k8lJo60J0Mf7luVxe25lJtOGqjff3RaSkchFWLZRSeYJDdt3qfSs4PWhTM5KZyvRq2fQjpScf/ajH7mY9KxY8MJ/4pdE/CBzlJfrGPqXFPvQsH5yh8Agx1nIxOpLDQg/XxFD71QDOXup4nUekCFd+sDVDuRLLMZ2g7wJBrrrbYl078NQm6j8Lvrv1sBp7s8sa7IZPkx15gMqX2sPgfCpvEPEN44tQ0l7przISToLlOsurnKF6PSubXXXu+KMMui3vB4MvwxUApSFlo5C5UzSFJqtpvTwqFaA9M4kob1uEtSi0dm+aEA2XLvpcQPGz4in7xM2PO9I+kkrgLyOEFckCXNXxZVxXSoa9pNqmSU5IUY7T9lGrA5JhxRy3oo3C6BZRvvh2+dnqnul2oHO7hyTUpqK2ZqLWad7tTc+HGyRH9MzyFblj4An0olLIZaea+ecQ+SXYwX+AtYTLAVLrcp1QLygx4F929g6xDqfmuLXZdJOmOgyYuhULRL/E4kSZ1oFsUPsgt0Hjbd6FZ+nswqmtK7S+4qfIJDN6iVB4BlW26svcTycjj36PGt1R8PzwYfTuteat+RqnLD7Nd/gcNfoAuLnzT3BAG5cbQrMsoa5LUvz7WUJpoN3L5EakuU0p7B5IrmgERrdZ7Xz5N5fRP3gU3f4DB7M1Ucq6LWtDQIcgZ4YNcCpNdP9Mk5XFwkrwO4XVKxaDzfkrhAwiXKI0KmqB/XNzzYGwXKj9/hBkwMm451z7E+99SmQmDlLAznkywSBpAo9MLgpJkFQjl7eYbv1BIKQjhNq37eH5qfqyEPKeouGfBKCaf560m1Oz4Xj/xn8EgZ9iR5CwEOXudBlOtSTJhPqRrlEZAM9U6DXgU1JU9ps69dAHWRtO+ekq8/hzyn6AS8fTOgzqdA3+pDqOBFPo7BrkbNmotoaZLeQhdrWdEHwaWgFIhgsJkKAetXdljGiW3mRHza7xqLkx+o/v5gjm2xlJZMQoFb/0+pQJMMjiG0ozCF7Dj+SOZSnVLkpwCpZx+kqxJsvMZKE8p3deC9NW/dpia7NswrBADzsPkFkl/BXvkNzeVNUNcgLfcKzAo6jjVmKzvD7ZqJFA6hVQjKMTegaZDUOt8ncJDaPJQcg9Dqu/vrQe8ZzNS07wA7mUg+TlMctEvUMFWWkNNukvjktkYBqUc77JVDjc53URpubkZi4zWRVDqbS2x0kXrqLSByclxhqFrQe+tw9GwkO1MmmGeHulpVAwGNymUjoHFDxR2wsG7lHxR8PvTxxDc3yPVOwylDMyiqhyl0nGv69BjWKShEP/FnUObIqlLA4O/KO2Chdy0jsLJaEpuPRM4ex0B3o8ZUltYxL2XQOXcNyHu/60YhEfdqRlqezNkNcxWUvgNTmb4KKRVB8WZWg9JDK0vgtwtRc1sWOQY66OyvR1qnaPUzS7l010NRp7tFKbDySuULsGvNsOoCb+HDK2eF8F+OahOJYIVOEUlZXBZ143MhmpfKUdl8xm7Mxwfg1RlEeS4qcloyTAKA4iLZxi9YEPNcjLBzqv1qUzo4Zk9M5FMOxMmA6lcnw3lTDFrqXWgfrek0TAq4qOhhJqRjkLnElnSrG5SIlvVoVmGZjv1MTUDTUvo6+sGPydQ+Q22Zrf0kXwTtlyvx1L5bh4w+6oHZu9Qc/gPcTJdg05QaQbhBsnk7tU/uSOPwtkdbkorvIb6yFcNJr/kpFIbqEgh8huYtMtJKXYG7BXoTWaFg4IjfVROVT6bVLlnORgtykxd/KnG3WY1j6VmsxdCPgoJF7q27zu1p896362ftSJVvqGyW086L8GiFZUpcNL6Wzj7cgxNqsDkBp25e0FKopMxHgBXuzjexPqZ0oSotym4y8NimJtSNjjyIpTpiTRYChNvGjpqBaUtHXy6wdg5Zo6B1ZtUekTo82qrC5QSHuD/ybW1o/MPGe7UpT33DWgW0N6KuwjoSWEwglSIp6T9pQiCDKeSF/9vG551cfwBZVQdN21ETobOG0k7Rf80pcyIYQg2lBaxMQhyJIHS6Tj8/+WR6T1+GII0HUOrhK7DYDSNwZbt8+rFoWPH8uhTmlWGjUZUJuJfMSSRpHsf7Hz53grq3NcOXIbZkTmX0tKk4r71kB5/8bB3h54ldsHWottfGDz9ELZK9rtWZk2/Lc93y4V/iWtv9p734OTPUYN/ruf39V/b5sPWhqZD8m56eD86fkLGlwa9gP+UfwDGyNFiqMetXAAAAABJRU5ErkJggg=="

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/usaa@2x.png";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/usaa@3x.png";

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/wells@2x.png";

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/bank-logos/wells@3x.png";

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/icons/amendments.png";

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANIAAACgCAMAAABOrcK6AAAAmVBMVEUAAAChjPijjvqijfmijfmkjvqlkPujjvqok/2nkv2nkvyok/2nkv2nkv2lkPuok/2kkPuok/2ok/6nkfyok/6nkv2nkv2nkv2okv2ok/2okv2xn/qrmPqsmfmplP+vnfqxn/qqlf+qlf+rl/qrl/+rlv+rl/+sl/+tmvmrmPqrl/2smfqsmP+xn/qvnPuunPqwnvuxn/qum/pdFfh1AAAAM3RSTlMAeeaEj+BNmgZBpTqtNNcP5iy75tElwRcey8dwe+bm5ubYsXnm3eGa7v3z/Ytz/fL982zu505ZAAAC00lEQVR4AezWBZbrQBBD0TAzMyf73+FHDUMNVI+ciuQV3PNsd+euffl8LtjyhUI+nCiQCaJAJogCmSAKZiqCA1MkEUyRRFgxnAimUCKYQolgCiWCKZAIpgCiAKZSoUAwEUUwhRKVK1cvkkgiiSSqSvR8EkkkUU2iCKK6RM6TqCHRFyaRRBI1b04kkUQStUxRW6KsizoSkddt9YxJJJHDJOpL5DyJBhJ9fxJJNDQ2kij7orFEzpNoIlHWN40gkmgmUdZFc4nYooVEWd/sBkULid7bchVOtF6nNs3mG2PeIpjSioZvPglEMDEbTX1FMLEaDb1F27Wvid9ou7VM6RtNvEWJTbOR1chftE5lgojQKKlpTGgEVCLTmNAIlUCyTe6Nuv4ioPxNTBFQ/iZbNHAV7bbP5mAii3a755WcTf2fF+3cOvFFILl14otgMjsRRIROBBGhE0NE6NTf+4u4nWzRwVVkmJDJNmVKZHd6ZDpyRP6dvmFqE0X2NQImgsjFZHQii/w7eYpqOYzciS4idILoZAyiq+nUPFuiliEidOKK/DtxRYROfJFtQibblDGR3ck28UX+nfgiw7T9fKe6KWpAxDIZneii9J3qF67Iv9Pv6uwYqaEYBoNwxwG4RF5isB3ufzhmCxWI4WfcZdWr+GZHlQ5Egk4C0UEngeis04HoViJJp7czkaCTRlSmlAmTQpQ7ddOhSNDpJhNhyud03R//iV4LFJ65JbpjUolyJ0SYTKLc6RpjlEkkCp0QZdMH66JOiIKpRKJOiIqEySRiPn+ZrjmzCZHIhAhSMCFSmdac2YRIZUIUTYhUJkTRhMhi+ikaf5gQqUxrwwmdEKlMa29MoZNJhAnRTp1cIkxPRKnTu4lTptjp8eXy5E6QVhP5OyHSmypTF/k7BZG5Uxf5O3WRv1OJ9KYiBZHV1EV+Uxf5TV3kN3WR39RFflMX+U3PLvKbXkz0DZsrj2nR87msAAAAAElFTkSuQmCC"

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/img/download-appstore.png";

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/img/download-googleplay.png";

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/assets/img/logo-white@2x.png";

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/Header/header-background@2x.png";

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/apple.png";

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/devices@2x.png";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/devices@3x.png";

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/icon-chat.png";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/icon-doc.png";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/icon-pro.png";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/icon-w2.png";

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/logo-businessinsider.png";

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/logo-forbes.png";

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/logo-venturebeat.png";

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/logo.png";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/logo@2x.png";

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/ornament-left-white.png";

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/components/LandingPage/img/ornament-right-white.png";

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/screens/Sweepstakes/img/mileiq-banner.jpg";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/client/screens/Sweepstakes/img/mileiq-taxfyle.png";

/***/ }),
/* 1228 */,
/* 1229 */
/***/ (function(module, exports) {

IntlPolyfill.__addLocaleData({locale:"en",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:true,formats:{short:"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}",long:"{1} 'at' {0}",availableFormats:{"d":"d","E":"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss","y":"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],short:["BC","AD","BCE","CE"],long:["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],short:["Before R.O.C.","Minguo"],long:["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1272 */,
/* 1273 */,
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(517);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(511),
    baseIsNaN = __webpack_require__(1286),
    strictIndexOf = __webpack_require__(1363);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1287 */,
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(115),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 1298 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1299 */,
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(508),
    values = __webpack_require__(543);

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

module.exports = baseSample;


/***/ }),
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(169);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1307 */,
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(117);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(518);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1298),
    isIterateeCall = __webpack_require__(228),
    toFinite = __webpack_require__(541);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1274),
    hasUnicode = __webpack_require__(318),
    unicodeSize = __webpack_require__(1367);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1275),
    hasUnicode = __webpack_require__(318),
    unicodeToArray = __webpack_require__(1368);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1366 */,
/* 1367 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(173);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),
/* 1370 */,
/* 1371 */,
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(83),
    now = __webpack_require__(1385),
    toNumber = __webpack_require__(542);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1380);


/***/ }),
/* 1377 */,
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(1271),
    baseEach = __webpack_require__(137),
    castFunction = __webpack_require__(1308),
    isArray = __webpack_require__(35);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1379 */,
/* 1380 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1282),
    isArrayLike = __webpack_require__(118),
    isString = __webpack_require__(323),
    toInteger = __webpack_require__(173),
    values = __webpack_require__(543);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1288),
    baseUnary = __webpack_require__(317),
    nodeUtil = __webpack_require__(527);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1383 */,
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(510),
    baseForOwn = __webpack_require__(512),
    baseIteratee = __webpack_require__(73);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(74);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var before = __webpack_require__(1369);

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(519),
    castSlice = __webpack_require__(1309),
    hasUnicode = __webpack_require__(318),
    isObject = __webpack_require__(83),
    isRegExp = __webpack_require__(1382),
    stringSize = __webpack_require__(1364),
    stringToArray = __webpack_require__(1365),
    toInteger = __webpack_require__(173),
    toString = __webpack_require__(326);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

module.exports = truncate;


/***/ }),
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Notify = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

































var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/*
 * Author: Alex Gibson
 * https://github.com/alexgibson/notify.js
 * License: MIT license
 */

var N = window.Notification;

function isFunction(item) {
    return typeof item === 'function';
}

function Notify(title) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    if (typeof title !== 'string') {
        throw new Error('Notify(): first arg (title) must be a string.');
    }

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
        throw new Error('Notify(): second arg (options) must be an object.');
    }

    var _options$notifyShow = options.notifyShow,
        notifyShow = _options$notifyShow === undefined ? null : _options$notifyShow,
        _options$notifyClose = options.notifyClose,
        notifyClose = _options$notifyClose === undefined ? null : _options$notifyClose,
        _options$notifyClick = options.notifyClick,
        notifyClick = _options$notifyClick === undefined ? null : _options$notifyClick,
        _options$notifyError = options.notifyError,
        notifyError = _options$notifyError === undefined ? null : _options$notifyError,
        _options$closeOnClick = options.closeOnClick,
        closeOnClick = _options$closeOnClick === undefined ? false : _options$closeOnClick,
        _options$timeout = options.timeout,
        timeout = _options$timeout === undefined ? null : _options$timeout,
        rest = objectWithoutProperties(options, ['notifyShow', 'notifyClose', 'notifyClick', 'notifyError', 'closeOnClick', 'timeout']);


    this.title = title;
    this.options = rest;
    this.permission = null;
    this.closeOnClick = closeOnClick;
    this.timeout = timeout;

    //callback when notification is displayed
    if (isFunction(notifyShow)) {
        this.onShowCallback = notifyShow;
    }

    //callback when notification is closed
    if (isFunction(notifyClose)) {
        this.onCloseCallback = notifyClose;
    }

    //callback when notification is clicked
    if (isFunction(notifyClick)) {
        this.onClickCallback = notifyClick;
    }

    //callback when notification throws error
    if (isFunction(notifyError)) {
        this.onErrorCallback = notifyError;
    }
}

// returns true if the browser supports Web Notifications
// https://developers.google.com/web/updates/2015/05/Notifying-you-of-notificiation-changes
// @param {perm} for test purposes only
Notify.isSupported = function (perm) {
    if (!N || !N.requestPermission) {
        return false;
    }

    if (perm === 'granted' || N.permission === 'granted') {
        throw new Error('You must only call this before calling Notification.requestPermission(), otherwise this feature detect would trigger an actual notification!');
    }

    try {
        new N('');
    } catch (e) {
        if (e.name === 'TypeError') {
            return false;
        }
    }
    return true;
};

// true if the permission is not granted
Notify.needsPermission = N && N.permission && N.permission === 'granted' ? false : true;

// asks the user for permission to display notifications.  Then calls the callback functions is supplied.
Notify.requestPermission = function (onPermissionGrantedCallback, onPermissionDeniedCallback) {
    N.requestPermission(function (perm) {
        switch (perm) {
            case 'granted':
                Notify.needsPermission = false;
                if (isFunction(onPermissionGrantedCallback)) {
                    onPermissionGrantedCallback();
                }
                break;
            case 'denied':
                Notify.needsPermission = true;
                if (isFunction(onPermissionDeniedCallback)) {
                    onPermissionDeniedCallback();
                }
                break;
        }
    });
};

Notify.prototype.show = function () {
    this.myNotify = new N(this.title, this.options);

    if (!this.options.requireInteraction && this.timeout && !isNaN(this.timeout)) {
        setTimeout(this.close.bind(this), this.timeout * 1000);
    }

    this.myNotify.addEventListener('show', this, false);
    this.myNotify.addEventListener('error', this, false);
    this.myNotify.addEventListener('close', this, false);
    this.myNotify.addEventListener('click', this, false);
};

Notify.prototype.onShowNotification = function (e) {
    if (this.onShowCallback) {
        this.onShowCallback(e);
    }
};

Notify.prototype.onCloseNotification = function (e) {
    if (this.onCloseCallback) {
        this.onCloseCallback(e);
    }
    this.destroy();
};

Notify.prototype.onClickNotification = function (e) {
    if (this.onClickCallback) {
        this.onClickCallback(e);
    }

    if (this.closeOnClick) {
        this.close();
    }
};

Notify.prototype.onErrorNotification = function (e) {
    if (this.onErrorCallback) {
        this.onErrorCallback(e);
    }
    this.destroy();
};

Notify.prototype.destroy = function () {
    this.myNotify.removeEventListener('show', this, false);
    this.myNotify.removeEventListener('error', this, false);
    this.myNotify.removeEventListener('close', this, false);
    this.myNotify.removeEventListener('click', this, false);
};

Notify.prototype.close = function () {
    this.myNotify.close();
};

Notify.prototype.handleEvent = function (e) {
    switch (e.type) {
        case 'show':
            this.onShowNotification(e);
            break;
        case 'close':
            this.onCloseNotification(e);
            break;
        case 'click':
            this.onClickNotification(e);
            break;
        case 'error':
            this.onErrorNotification(e);
            break;
    }
};

return Notify;

})));


/***/ }),
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = Deferred
Deferred.defer = defer

function Deferred(Promise) {
  if (Promise == null) Promise = global.Promise
  if (this instanceof Deferred) return defer(Promise, this)
  else return defer(Promise, Object.create(Deferred.prototype))
}

function defer(Promise, deferred) {
  deferred.promise = new Promise(function(resolve, reject) {
    deferred.resolve = resolve
    deferred.reject = reject
  })

  return deferred
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1432);
exports.encode = exports.stringify = __webpack_require__(1433);


/***/ }),
/* 1435 */,
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(47),__webpack_require__(0),__webpack_require__(1513),__webpack_require__(50)):"function"==typeof define&&define.amd?define(["moment","react","react-onclickoutside","react-dom"],t):"object"==typeof exports?exports.DatePicker=t(require("moment"),require("react"),require("react-onclickoutside"),require("react-dom")):e.DatePicker=t(e.moment,e.React,e.onClickOutside,e.ReactDOM)}(this,function(e,t,n,o){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return e[o].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),c=n(1),u=o(c),p=n(4),f=o(p),d=n(5),h=(o(d),n(19)),m=o(h),y=n(10),g=o(y),v=n(17),b=n(2),w=o(b),_=n(11),D=o(_),O="react-datepicker-ignore-onclickoutside",k=(0,D.default)(u.default),C=function(e){function t(e){a(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.getInitialState=function(){var e=n.props.openToDate?(0,w.default)(n.props.openToDate):n.props.selectsEnd&&n.props.startDate?(0,w.default)(n.props.startDate):n.props.selectsStart&&n.props.endDate?(0,w.default)(n.props.endDate):(0,w.default)(),t=(0,v.getEffectiveMinDate)(n.props),o=(0,v.getEffectiveMaxDate)(n.props),r=t&&e.isBefore(t)?t:o&&e.isAfter(o)?o:e;return{open:!1,preventFocus:!1,preSelection:n.props.selected?(0,w.default)(n.props.selected):r}},n.clearPreventFocusTimeout=function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)},n.setFocus=function(){n.refs.input.focus()},n.setOpen=function(e){n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.getInitialState().preSelection})},n.handleFocus=function(e){n.state.preventFocus||(n.props.onFocus(e),n.setOpen(!0))},n.cancelFocusInput=function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null},n.deferFocusInput=function(){n.cancelFocusInput(),n.inputFocusTimeout=window.setTimeout(function(){return n.setFocus()},1)},n.handleDropdownFocus=function(){n.cancelFocusInput()},n.handleBlur=function(e){n.state.open?n.deferFocusInput():n.props.onBlur(e)},n.handleCalendarClickOutside=function(e){n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()},n.handleChange=function(e){if(!n.props.onChangeRaw||(n.props.onChangeRaw(e),!e.isDefaultPrevented())){n.setState({inputValue:e.target.value});var t=(0,v.parseDate)(e.target.value,n.props);!t&&e.target.value||n.setSelected(t,e,!0)}},n.handleSelect=function(e,t){n.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),n.setSelected(e,t),n.setOpen(!1)},n.setSelected=function(e,t,o){var r=e;null!==r&&(0,v.isDayDisabled)(r,n.props)||((0,v.isSameDay)(n.props.selected,r)||(null!==r&&(n.props.selected&&(r=(0,w.default)(r).set({hour:n.props.selected.hour(),minute:n.props.selected.minute(),second:n.props.selected.second()})),n.setState({preSelection:r})),n.props.onChange(r,t)),n.props.onSelect(r,t),o||n.setState({inputValue:null}))},n.setPreSelection=function(e){var t="undefined"!=typeof n.props.minDate&&"undefined"!=typeof n.props.maxDate,o=!t||!e||(0,v.isDayInRange)(e,n.props.minDate,n.props.maxDate);o&&n.setState({preSelection:e})},n.onInputClick=function(){n.props.disabled||n.setOpen(!0)},n.onInputKeyDown=function(e){if(!n.state.open&&!n.props.inline)return void(/^Arrow/.test(e.key)&&n.onInputClick());var t=(0,w.default)(n.state.preSelection);if("Enter"===e.key?(e.preventDefault(),n.handleSelect(t,e)):"Escape"===e.key?(e.preventDefault(),n.setOpen(!1)):"Tab"===e.key&&n.setOpen(!1),!n.props.disabledKeyboardNavigation){var o=void 0;switch(e.key){case"ArrowLeft":e.preventDefault(),o=t.subtract(1,"days");break;case"ArrowRight":e.preventDefault(),o=t.add(1,"days");break;case"ArrowUp":e.preventDefault(),o=t.subtract(1,"weeks");break;case"ArrowDown":e.preventDefault(),o=t.add(1,"weeks");break;case"PageUp":e.preventDefault(),o=t.subtract(1,"months");break;case"PageDown":e.preventDefault(),o=t.add(1,"months");break;case"Home":e.preventDefault(),o=t.subtract(1,"years");break;case"End":e.preventDefault(),o=t.add(1,"years")}n.setPreSelection(o)}},n.onClearClick=function(e){e.preventDefault(),n.props.onChange(null,e)},n.renderCalendar=function(){return n.props.inline||n.state.open&&!n.props.disabled?f.default.createElement(k,{ref:"calendar",locale:n.props.locale,dateFormat:n.props.dateFormatCalendar,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,highlightDates:n.props.highlightDates,includeDates:n.props.includeDates,inline:n.props.inline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,forceShowMonthNavigation:n.props.forceShowMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,todayButton:n.props.todayButton,utcOffset:n.props.utcOffset,outsideClickIgnoreClass:O,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,className:n.props.calendarClassName},n.props.children):null},n.renderDateInput=function(){var e=(0,g.default)(n.props.className,r({},O,n.state.open)),t=n.props.customInput||f.default.createElement("input",{type:"text"}),o="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:(0,v.safeDateFormat)(n.props.selected,n.props);return f.default.cloneElement(t,{ref:"input",value:o,onBlur:n.handleBlur,onChange:n.handleChange,onClick:n.onInputClick,onFocus:n.handleFocus,onKeyDown:n.onInputKeyDown,id:n.props.id,name:n.props.name,autoFocus:n.props.autoFocus,placeholder:n.props.placeholderText,disabled:n.props.disabled,autoComplete:n.props.autoComplete,className:e,title:n.props.title,readOnly:n.props.readOnly,required:n.props.required,tabIndex:n.props.tabIndex})},n.renderClearButton=function(){return n.props.isClearable&&null!=n.props.selected?f.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:n.onClearClick}):null},n.state=n.getInitialState(),n}return s(t,e),l(t,null,[{key:"defaultProps",get:function(){return{dateFormat:"L",dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},popoverAttachment:"top left",popoverTargetAttachment:"bottom left",popoverTargetOffset:"10px 0",tetherConstraints:[{to:"window",attachment:"together"}],utcOffset:(0,w.default)().utcOffset(),monthsShown:1,withPortal:!1}}}]),l(t,[{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?f.default.createElement("div",null,this.props.inline?null:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?f.default.createElement("div",{className:"react-datepicker__portal"},e):null):f.default.createElement(m.default,{classPrefix:"react-datepicker__tether",attachment:this.props.popoverAttachment,targetAttachment:this.props.popoverTargetAttachment,targetOffset:this.props.popoverTargetOffset,renderElementTo:this.props.renderCalendarTo,constraints:this.props.tetherConstraints},f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),e)}}]),t}(f.default.Component);t.default=C},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(2),c=o(l),u=n(3),p=o(u),f=n(12),d=o(f),h=n(14),m=o(h),y=n(4),g=o(y),v=n(5),b=(o(v),n(10)),w=o(b),_=n(17),D=["react-datepicker__year-select","react-datepicker__month-select"],O=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return D.some(function(e){return t.indexOf(e)>=0})},k=function(e){function t(e){r(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleClickOutside=function(e){n.props.onClickOutside(e)},n.handleDropdownFocus=function(e){O(e.target)&&n.props.onDropdownFocus()},n.getDateInView=function(){var e=n.props,t=e.preSelection,o=e.selected,r=e.openToDate,a=e.utcOffset,i=(0,_.getEffectiveMinDate)(n.props),s=(0,_.getEffectiveMaxDate)(n.props),l=c.default.utc().utcOffset(a),u=t||o;return u?u:i&&s&&r&&r.isBetween(i,s)?r:i&&r&&r.isAfter(i)?r:i&&i.isAfter(l)?i:s&&r&&r.isBefore(s)?r:s&&s.isBefore(l)?s:r?r:l},n.localizeMoment=function(e){return e.clone().locale(n.props.locale||c.default.locale())},n.increaseMonth=function(){n.setState({date:n.state.date.clone().add(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.decreaseMonth=function(){n.setState({date:n.state.date.clone().subtract(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.handleDayClick=function(e,t){return n.props.onSelect(e,t)},n.handleDayMouseEnter=function(e){return n.setState({selectingDate:e})},n.handleMonthMouseLeave=function(){return n.setState({selectingDate:null})},n.handleMonthChange=function(e){n.props.onMonthChange&&n.props.onMonthChange(e)},n.changeYear=function(e){n.setState({date:n.state.date.clone().set("year",e)})},n.changeMonth=function(e){n.setState({date:n.state.date.clone().set("month",e)},function(){return n.handleMonthChange(n.state.date)})},n.header=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=e.clone().startOf("week"),o=[];return n.props.showWeekNumbers&&o.push(g.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},"#")),o.concat([0,1,2,3,4,5,6].map(function(e){var n=t.clone().add(e,"days");return g.default.createElement("div",{key:e,className:"react-datepicker__day-name"},n.localeData().weekdaysMin(n))}))},n.renderPreviousMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledBefore)(n.state.date,"month",n.props))return g.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:n.decreaseMonth})},n.renderNextMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledAfter)(n.state.date,"month",n.props))return g.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--next",onClick:n.increaseMonth})},n.renderCurrentMonth=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),g.default.createElement("div",{className:t.join(" ")},e.format(n.props.dateFormat))},n.renderYearDropdown=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return g.default.createElement(p.default,{dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:n.state.date.year(),scrollableYearDropdown:n.props.scrollableYearDropdown})},n.renderMonthDropdown=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown)return g.default.createElement(d.default,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,onChange:n.changeMonth,month:n.state.date.month()})},n.renderTodayButton=function(){if(n.props.todayButton)return g.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(c.default.utc().utcOffset(n.props.utcOffset).startOf("date"),e)}},n.props.todayButton)},n.renderMonths=function(){for(var e=[],t=0;t<n.props.monthsShown;++t){var o=n.state.date.clone().add(t,"M"),r="month-"+t;e.push(g.default.createElement("div",{key:r,className:"react-datepicker__month-container"},g.default.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(o),g.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+n.props.dropdownMode,onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==t),n.renderYearDropdown(0!==t)),g.default.createElement("div",{className:"react-datepicker__day-names"},n.header(o))),g.default.createElement(m.default,{day:o,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,utcOffset:n.props.utcOffset})))}return e},n.state={date:n.localizeMoment(n.getDateInView()),selectingDate:null},n}return i(t,e),s(t,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},utcOffset:c.default.utc().utcOffset(),monthsShown:1,forceShowMonthNavigation:!1}}}]),s(t,[{key:"componentWillReceiveProps",value:function(e){e.preSelection&&!(0,_.isSameDay)(e.preSelection,this.props.preSelection)?this.setState({date:this.localizeMoment(e.preSelection)}):e.openToDate&&!(0,_.isSameDay)(e.openToDate,this.props.openToDate)&&this.setState({date:this.localizeMoment(e.openToDate)})}},{key:"render",value:function(){return g.default.createElement("div",{className:(0,w.default)("react-datepicker",this.props.className)},g.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.props.children)}}]),t}(g.default.Component);t.default=k},function(t,n){t.exports=e},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(4),c=o(l),u=n(5),p=(o(u),n(9)),f=o(p),d=n(11),h=o(d),m=(0,h.default)(f.default),y=function(e){function t(){var e,n,o,i;r(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=o=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),o.state={dropdownVisible:!1},o.renderSelectOptions=function(){for(var e=o.props.minDate?o.props.minDate.year():1900,t=o.props.maxDate?o.props.maxDate.year():2100,n=[],r=e;r<=t;r++)n.push(c.default.createElement("option",{key:r,value:r},r));return n},o.onSelectChange=function(e){o.onChange(e.target.value)},o.renderSelectMode=function(){return c.default.createElement("select",{value:o.props.year,className:"react-datepicker__year-select",onChange:o.onSelectChange},o.renderSelectOptions())},o.renderReadView=function(e){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:o.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),c.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},o.props.year))},o.renderDropdown=function(){return c.default.createElement(m,{key:"dropdown",ref:"options",year:o.props.year,onChange:o.onChange,onCancel:o.toggleDropdown,scrollableYearDropdown:o.props.scrollableYearDropdown})},o.renderScrollMode=function(){var e=o.state.dropdownVisible,t=[o.renderReadView(!e)];return e&&t.unshift(o.renderDropdown()),t},o.onChange=function(e){o.toggleDropdown(),e!==o.props.year&&o.props.onChange(e)},o.toggleDropdown=function(){o.setState({dropdownVisible:!o.state.dropdownVisible})},i=n,a(o,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=void 0;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return c.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},e)}}]),t}(c.default.Component);t.default=y},function(e,n){e.exports=t},function(e,t,n){e.exports=n(6)()},function(e,t,n){"use strict";var o=n(7),r=n(8);e.exports=function(){function e(){r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=o,n.PropTypes=n,n}},function(e,t){"use strict";function n(e){return function(){return e}}var o=function(){};o.thatReturns=n,o.thatReturnsFalse=n(!1),o.thatReturnsTrue=n(!0),o.thatReturnsNull=n(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,n){"use strict";function o(e,t,n,o,a,i,s,l){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,o,a,i,s,l],p=0;c=new Error(t.replace(/%s/g,function(){return u[p++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};e.exports=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e,t){for(var n=[],o=0;o<2*t;o++)n.push(e+t-o);return n}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),c=n(4),u=o(c),p=n(5),f=(o(p),n(10)),d=o(f),h=function(e){function t(e){r(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map(function(t){return u.default.createElement("div",{className:"react-datepicker__year-option",key:t,ref:t,onClick:n.onChange.bind(n,t)},e===t?u.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)});return t.unshift(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),t.push(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)},n.state={yearsList:n.props.scrollableYearDropdown?s(n.props.year,10):s(n.props.year,5)},n}return i(t,e),l(t,[{key:"render",value:function(){var e=(0,d.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return u.default.createElement("div",{className:e},this.renderOptions())}}]),t}(u.default.Component);t.default=h},function(e,t,n){var o,r;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var o=arguments[t];if(o){var r=typeof o;if("string"===r||"number"===r)e.push(o);else if(Array.isArray(o))e.push(n.apply(null,o));else if("object"===r)for(var i in o)a.call(o,i)&&o[i]&&e.push(i)}}return e.join(" ")}var a={}.hasOwnProperty;"undefined"!=typeof e&&e.exports?e.exports=n:(o=[],r=function(){return n}.apply(t,o),!(void 0!==r&&(e.exports=r)))}()},function(e,t){e.exports=n},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(4),c=o(l),u=n(5),p=(o(u),n(13)),f=o(p),d=n(11),h=o(d),m=n(2),y=o(m),g=(0,h.default)(f.default),v=function(e){function t(){var e,n,o,i;r(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=o=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),o.state={dropdownVisible:!1},o.renderSelectOptions=function(e){return e.map(function(e,t){return c.default.createElement("option",{key:t,value:t},e)})},o.renderSelectMode=function(e){return c.default.createElement("select",{value:o.props.month,className:"react-datepicker__month-select",onChange:function(e){return o.onChange(e.target.value)}},o.renderSelectOptions(e))},o.renderReadView=function(e,t){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:o.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},t[o.props.month]),c.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},o.renderDropdown=function(e){return c.default.createElement(g,{key:"dropdown",ref:"options",month:o.props.month,monthNames:e,onChange:o.onChange,onCancel:o.toggleDropdown})},o.renderScrollMode=function(e){var t=o.state.dropdownVisible,n=[o.renderReadView(!t,e)];return t&&n.unshift(o.renderDropdown(e)),n},o.onChange=function(e){o.toggleDropdown(),e!==o.props.month&&o.props.onChange(e)},o.toggleDropdown=function(){return o.setState({dropdownVisible:!o.state.dropdownVisible})},i=n,a(o,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=y.default.localeData(this.props.locale),t=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(t){return e.months((0,y.default)({M:t}))}),n=void 0;switch(this.props.dropdownMode){case"scroll":n=this.renderScrollMode(t);break;case"select":n=this.renderSelectMode(t)}return c.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},n)}}]),t}(c.default.Component);t.default=v},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(4),c=o(l),u=n(5),p=(o(u),function(e){function t(){var e,n,o,i;r(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=o=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),o.renderOptions=function(){return o.props.monthNames.map(function(e,t){return c.default.createElement("div",{className:"react-datepicker__month-option",key:e,ref:e,onClick:o.onChange.bind(o,t)},o.props.month===t?c.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})},o.onChange=function(e){return o.props.onChange(e)},o.handleClickOutside=function(){return o.props.onCancel()},i=n,a(o,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(c.default.Component));t.default=p},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(4),c=o(l),u=n(5),p=(o(u),n(10)),f=o(p),d=n(15),h=o(d),m=6,y=function(e){function t(){var e,n,o,i;r(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=o=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),o.handleDayClick=function(e,t){o.props.onDayClick&&o.props.onDayClick(e,t)},o.handleDayMouseEnter=function(e){o.props.onDayMouseEnter&&o.props.onDayMouseEnter(e)},o.handleMouseLeave=function(){o.props.onMouseLeave&&o.props.onMouseLeave()},o.isWeekInMonth=function(e){var t=o.props.day,n=e.clone().add(6,"days");return e.isSame(t,"month")||n.isSame(t,"month")},o.renderWeeks=function(){for(var e=[],t=o.props.fixedHeight,n=o.props.day.clone().startOf("month").startOf("week"),r=0,a=!1;;){if(e.push(c.default.createElement(h.default,{key:r,day:n,month:o.props.day.month(),onDayClick:o.handleDayClick,onDayMouseEnter:o.handleDayMouseEnter,minDate:o.props.minDate,maxDate:o.props.maxDate,excludeDates:o.props.excludeDates,includeDates:o.props.includeDates,inline:o.props.inline,highlightDates:o.props.highlightDates,selectingDate:o.props.selectingDate,filterDate:o.props.filterDate,preSelection:o.props.preSelection,selected:o.props.selected,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,showWeekNumber:o.props.showWeekNumbers,startDate:o.props.startDate,endDate:o.props.endDate,utcOffset:o.props.utcOffset})),a)break;r++,n=n.clone().add(1,"weeks");var i=t&&r>=m,s=!t&&!o.isWeekInMonth(n);if(i||s){if(!o.props.peekNextMonth)break;a=!0}}return e},o.getClassNames=function(){var e=o.props,t=e.selectingDate,n=e.selectsStart,r=e.selectsEnd;return(0,f.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(n||r)})},i=n,a(o,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(4),c=o(l),u=n(5),p=(o(u),n(16)),f=o(p),d=n(18),h=o(d),m=function(e){function t(){var e,n,o,i;r(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=o=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),o.handleDayClick=function(e,t){o.props.onDayClick&&o.props.onDayClick(e,t)},o.handleDayMouseEnter=function(e){o.props.onDayMouseEnter&&o.props.onDayMouseEnter(e)},o.renderDays=function(){var e=o.props.day.clone().startOf("week"),t=[];return o.props.showWeekNumber&&t.push(c.default.createElement(h.default,{key:"W",weekNumber:parseInt(e.format("w"),10)})),t.concat([0,1,2,3,4,5,6].map(function(t){var n=e.clone().add(t,"days");return c.default.createElement(f.default,{key:t,day:n,month:o.props.month,onClick:o.handleDayClick.bind(o,n),onMouseEnter:o.handleDayMouseEnter.bind(o,n),minDate:o.props.minDate,maxDate:o.props.maxDate,excludeDates:o.props.excludeDates,includeDates:o.props.includeDates,inline:o.props.inline,highlightDates:o.props.highlightDates,selectingDate:o.props.selectingDate,filterDate:o.props.filterDate,preSelection:o.props.preSelection,selected:o.props.selected,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,startDate:o.props.startDate,endDate:o.props.endDate,utcOffset:o.props.utcOffset})}))},i=n,a(o,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}]),t}(c.default.Component);t.default=m},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(2),c=o(l),u=n(4),p=o(u),f=n(5),d=(o(f),n(10)),h=o(d),m=n(17),y=function(e){function t(){var e,n,o,i;r(this,t);for(var s=arguments.length,l=Array(s),u=0;u<s;u++)l[u]=arguments[u];return n=o=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),o.handleClick=function(e){!o.isDisabled()&&o.props.onClick&&o.props.onClick(e)},o.handleMouseEnter=function(e){!o.isDisabled()&&o.props.onMouseEnter&&o.props.onMouseEnter(e)},o.isSameDay=function(e){return(0,m.isSameDay)(o.props.day,e)},o.isKeyboardSelected=function(){return!o.props.inline&&!o.isSameDay(o.props.selected)&&o.isSameDay(o.props.preSelection)},o.isDisabled=function(){return(0,m.isDayDisabled)(o.props.day,o.props)},o.isHighlighted=function(){var e=o.props,t=e.day,n=e.highlightDates;return!!n&&n.some(function(e){return(0,m.isSameDay)(t,e)})},o.isInRange=function(){var e=o.props,t=e.day,n=e.startDate,r=e.endDate;return!(!n||!r)&&(0,m.isDayInRange)(t,n,r)},o.isInSelectingRange=function(){var e=o.props,t=e.day,n=e.selectsStart,r=e.selectsEnd,a=e.selectingDate,i=e.startDate,s=e.endDate;return!(!n&&!r||!a||o.isDisabled())&&(n&&s&&a.isSameOrBefore(s)?(0,m.isDayInRange)(t,a,s):!!(r&&i&&a.isSameOrAfter(i))&&(0,m.isDayInRange)(t,i,a))},o.isSelectingRangeStart=function(){if(!o.isInSelectingRange())return!1;var e=o.props,t=e.day,n=e.selectingDate,r=e.startDate,a=e.selectsStart;return a?(0,m.isSameDay)(t,n):(0,m.isSameDay)(t,r)},o.isSelectingRangeEnd=function(){if(!o.isInSelectingRange())return!1;var e=o.props,t=e.day,n=e.selectingDate,r=e.endDate,a=e.selectsEnd;return a?(0,m.isSameDay)(t,n):(0,m.isSameDay)(t,r)},o.isRangeStart=function(){var e=o.props,t=e.day,n=e.startDate,r=e.endDate;return!(!n||!r)&&(0,m.isSameDay)(n,t)},o.isRangeEnd=function(){var e=o.props,t=e.day,n=e.startDate,r=e.endDate;return!(!n||!r)&&(0,m.isSameDay)(r,t)},o.isWeekend=function(){var e=o.props.day.day();return 0===e||6===e},o.isOutsideMonth=function(){return void 0!==o.props.month&&o.props.month!==o.props.day.month()},o.getClassNames=function(){return(0,h.default)("react-datepicker__day",{"react-datepicker__day--disabled":o.isDisabled(),"react-datepicker__day--selected":o.isSameDay(o.props.selected),"react-datepicker__day--keyboard-selected":o.isKeyboardSelected(),"react-datepicker__day--highlighted":o.isHighlighted(),"react-datepicker__day--range-start":o.isRangeStart(),"react-datepicker__day--range-end":o.isRangeEnd(),"react-datepicker__day--in-range":o.isInRange(),"react-datepicker__day--in-selecting-range":o.isInSelectingRange(),"react-datepicker__day--selecting-range-start":o.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":o.isSelectingRangeEnd(),"react-datepicker__day--today":o.isSameDay(c.default.utc().utcOffset(o.props.utcOffset)),"react-datepicker__day--weekend":o.isWeekend(),"react-datepicker__day--outside-month":o.isOutsideMonth()})},i=n,a(o,i)}return i(t,e),s(t,[{key:"render",value:function(){return p.default.createElement("div",{className:this.getClassNames(),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+this.props.day.date(),role:"option"},this.props.day.date())}}]),t}(p.default.Component);y.defaultProps={utcOffset:c.default.utc().utcOffset()},t.default=y},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){return e&&t?e.isSame(t,"day"):!e&&!t}function a(e,t){return e&&t?e.utcOffset()===t.utcOffset():!e&&!t}function i(e,t,n){var o=t.clone().startOf("day").subtract(1,"seconds"),r=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(o,r)}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,o=t.maxDate,a=t.excludeDates,i=t.includeDates,s=t.filterDate;return n&&e.isBefore(n,"day")||o&&e.isAfter(o,"day")||a&&a.some(function(t){return r(e,t)})||i&&!i.some(function(t){return r(e,t)})||s&&!s(e.clone())||!1}function l(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=n.minDate,r=n.includeDates,a=e.clone().subtract(1,t);return o&&a.isBefore(o,t)||r&&r.every(function(e){return a.isBefore(e,t)})||!1}function c(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=n.maxDate,r=n.includeDates,a=e.clone().add(1,t);return o&&a.isAfter(o,t)||r&&r.every(function(e){return a.isAfter(e,t)})||!1}function u(e){var t=e.minDate,n=e.includeDates;return n&&t?m.default.min(n.filter(function(e){return t.isSameOrBefore(e,"day")})):n?m.default.min(n):t}function p(e){var t=e.maxDate,n=e.includeDates;return n&&t?m.default.max(n.filter(function(e){return t.isSameOrAfter(e,"day")})):n?m.default.max(n):t}function f(e,t){var n=t.dateFormat,o=t.locale,r=(0,m.default)(e,n,o||m.default.locale(),!0);return r.isValid()?r:null}function d(e,t){var n=t.dateFormat,o=t.locale;return e&&e.clone().locale(o||m.default.locale()).format(Array.isArray(n)?n[0]:n)||""}Object.defineProperty(t,"__esModule",{value:!0}),t.isSameDay=r,t.isSameUtcOffset=a,t.isDayInRange=i,t.isDayDisabled=s,t.allDaysDisabledBefore=l,t.allDaysDisabledAfter=c,t.getEffectiveMinDate=u,t.getEffectiveMaxDate=p,t.parseDate=f,t.safeDateFormat=d;var h=n(2),m=o(h)},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),l=n(4),c=o(l),u=n(5),p=(o(u),function(e){function t(){return r(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week-number","aria-label":"week-"+this.props.weekNumber},this.props.weekNumber)}}]),t}(c.default.Component));t.default=p},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){var n={};for(var o in e)t.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),u=n(4),p=o(u),f=n(5),d=(o(f),n(20)),h=o(d),m=n(21),y=o(m),g=function(e){function t(){var e,n,o,s;a(this,t);for(var c=arguments.length,u=Array(c),p=0;p<c;p++)u[p]=arguments[p];return n=o=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),o.disable=function(){return o._tether.disable()},o.enable=function(){return o._tether.enable()},o.position=function(){return o._tether.position()},o._destroy=function(){o._elementParentNode&&(h.default.unmountComponentAtNode(o._elementParentNode),o._elementParentNode.parentNode.removeChild(o._elementParentNode)),o._tether&&o._tether.destroy(),o._elementParentNode=null,o._tether=null},o._update=function(){var e=o.props,t=e.children,n=e.renderElementTag,r=e.renderElementTo,a=t[1];if(!a)return void(o._tether&&o._destroy());if(!o._elementParentNode){o._elementParentNode=document.createElement(n);var i=r||document.body;i.appendChild(o._elementParentNode)}h.default.unstable_renderSubtreeIntoContainer(o,a,o._elementParentNode,function(){o._updateTether()})},o._updateTether=function(){var e=o.props,t=(e.renderElementTag,e.renderElementTo,r(e,["renderElementTag","renderElementTo"])),n=l({target:o._targetNode,element:o._elementParentNode},t);o._tether?o._tether.setOptions(n):o._tether=new y.default(n),o._tether.position()},s=n,i(o,s)}return s(t,e),c(t,[{key:"componentDidMount",value:function(){this._targetNode=h.default.findDOMNode(this),this._update()}},{key:"componentDidUpdate",value:function(){this._update()}},{key:"componentWillUnmount",value:function(){this._destroy()}},{key:"render",value:function(){var e=this.props.children,t=null;return p.default.Children.forEach(e,function(e,n){if(0===n)return t=e,!1}),t}}]),t}(p.default.Component);g.defaultProps={renderElementTag:"div",renderElementTo:null},t.default=g},function(e,t){e.exports=o},function(e,t,n){var o,r;/*! tether 1.4.0 */
!function(a,i){o=i,r="function"==typeof o?o.call(t,n,t,e):o,!(void 0!==r&&(e.exports=r))}(this,function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e){var t=e.getBoundingClientRect(),n={};for(var o in t)n[o]=t[o];if(e.ownerDocument!==document){var a=e.ownerDocument.defaultView.frameElement;if(a){var i=r(a);n.top+=i.top,n.bottom+=i.top,n.left+=i.left,n.right+=i.left}}return n}function a(e){var t=getComputedStyle(e)||{},n=t.position,o=[];if("fixed"===n)return[e];for(var r=e;(r=r.parentNode)&&r&&1===r.nodeType;){var a=void 0;try{a=getComputedStyle(r)}catch(e){}if("undefined"==typeof a||null===a)return o.push(r),o;var i=a,s=i.overflow,l=i.overflowX,c=i.overflowY;/(auto|scroll)/.test(s+c+l)&&("absolute"!==n||["relative","absolute","fixed"].indexOf(a.position)>=0)&&o.push(r)}return o.push(e.ownerDocument.body),e.ownerDocument!==document&&o.push(e.ownerDocument.defaultView),o}function i(){C&&document.body.removeChild(C),C=null}function s(e){var t=void 0;e===document?(t=document,e=document.documentElement):t=e.ownerDocument;var n=t.documentElement,o=r(e),a=M();return o.top-=a.top,o.left-=a.left,"undefined"==typeof o.width&&(o.width=document.body.scrollWidth-o.left-o.right),"undefined"==typeof o.height&&(o.height=document.body.scrollHeight-o.top-o.bottom),o.top=o.top-n.clientTop,o.left=o.left-n.clientLeft,o.right=t.body.clientWidth-o.width-o.left,o.bottom=t.body.clientHeight-o.height-o.top,o}function l(e){return e.offsetParent||document.documentElement}function c(){if(x)return x;var e=document.createElement("div");e.style.width="100%",e.style.height="200px";var t=document.createElement("div");u(t.style,{position:"absolute",top:0,left:0,pointerEvents:"none",visibility:"hidden",width:"200px",height:"150px",overflow:"hidden"}),t.appendChild(e),document.body.appendChild(t);var n=e.offsetWidth;t.style.overflow="scroll";var o=e.offsetWidth;n===o&&(o=t.clientWidth),document.body.removeChild(t);var r=n-o;return x={width:r,height:r}}function u(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],t=[];return Array.prototype.push.apply(t,arguments),t.slice(1).forEach(function(t){if(t)for(var n in t)({}).hasOwnProperty.call(t,n)&&(e[n]=t[n])}),e}function p(e,t){if("undefined"!=typeof e.classList)t.split(" ").forEach(function(t){t.trim()&&e.classList.remove(t)});else{var n=new RegExp("(^| )"+t.split(" ").join("|")+"( |$)","gi"),o=h(e).replace(n," ");m(e,o)}}function f(e,t){if("undefined"!=typeof e.classList)t.split(" ").forEach(function(t){t.trim()&&e.classList.add(t)});else{p(e,t);var n=h(e)+(" "+t);m(e,n)}}function d(e,t){if("undefined"!=typeof e.classList)return e.classList.contains(t);var n=h(e);return new RegExp("(^| )"+t+"( |$)","gi").test(n)}function h(e){return e.className instanceof e.ownerDocument.defaultView.SVGAnimatedString?e.className.baseVal:e.className}function m(e,t){e.setAttribute("class",t)}function y(e,t,n){n.forEach(function(n){t.indexOf(n)===-1&&d(e,n)&&p(e,n)}),t.forEach(function(t){d(e,t)||f(e,t)})}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function g(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function v(e,t){var n=arguments.length<=2||void 0===arguments[2]?1:arguments[2];return e+n>=t&&t>=e-n}function b(){return"undefined"!=typeof performance&&"undefined"!=typeof performance.now?performance.now():+new Date}function w(){for(var e={top:0,left:0},t=arguments.length,n=Array(t),o=0;o<t;o++)n[o]=arguments[o];return n.forEach(function(t){var n=t.top,o=t.left;"string"==typeof n&&(n=parseFloat(n,10)),"string"==typeof o&&(o=parseFloat(o,10)),e.top+=n,e.left+=o}),e}function _(e,t){return"string"==typeof e.left&&e.left.indexOf("%")!==-1&&(e.left=parseFloat(e.left,10)/100*t.width),"string"==typeof e.top&&e.top.indexOf("%")!==-1&&(e.top=parseFloat(e.top,10)/100*t.height),e}function D(e,t){return"scrollParent"===t?t=e.scrollParents[0]:"window"===t&&(t=[pageXOffset,pageYOffset,innerWidth+pageXOffset,innerHeight+pageYOffset]),t===document&&(t=t.documentElement),"undefined"!=typeof t.nodeType&&!function(){var e=t,n=s(t),o=n,r=getComputedStyle(t);if(t=[o.left,o.top,n.width+o.left,n.height+o.top],e.ownerDocument!==document){var a=e.ownerDocument.defaultView;t[0]+=a.pageXOffset,t[1]+=a.pageYOffset,t[2]+=a.pageXOffset,t[3]+=a.pageYOffset}$.forEach(function(e,n){e=e[0].toUpperCase()+e.substr(1),"Top"===e||"Left"===e?t[n]+=parseFloat(r["border"+e+"Width"]):t[n]-=parseFloat(r["border"+e+"Width"])})}(),t}var O=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),k=void 0;"undefined"==typeof k&&(k={modules:[]});var C=null,E=function(){var e=0;return function(){return++e}}(),S={},M=function(){var e=C;e&&document.body.contains(e)||(e=document.createElement("div"),e.setAttribute("data-tether-id",E()),u(e.style,{top:0,left:0,position:"absolute"}),document.body.appendChild(e),C=e);var t=e.getAttribute("data-tether-id");return"undefined"==typeof S[t]&&(S[t]=r(e),T(function(){delete S[t]})),S[t]},x=null,P=[],T=function(e){P.push(e)},j=function(){for(var e=void 0;e=P.pop();)e()},N=function(){function e(){o(this,e)}return O(e,[{key:"on",value:function(e,t,n){var o=!(arguments.length<=3||void 0===arguments[3])&&arguments[3];"undefined"==typeof this.bindings&&(this.bindings={}),"undefined"==typeof this.bindings[e]&&(this.bindings[e]=[]),this.bindings[e].push({handler:t,ctx:n,once:o})}},{key:"once",value:function(e,t,n){this.on(e,t,n,!0)}},{key:"off",value:function(e,t){if("undefined"!=typeof this.bindings&&"undefined"!=typeof this.bindings[e])if("undefined"==typeof t)delete this.bindings[e];else for(var n=0;n<this.bindings[e].length;)this.bindings[e][n].handler===t?this.bindings[e].splice(n,1):++n}},{key:"trigger",value:function(e){if("undefined"!=typeof this.bindings&&this.bindings[e]){for(var t=0,n=arguments.length,o=Array(n>1?n-1:0),r=1;r<n;r++)o[r-1]=arguments[r];for(;t<this.bindings[e].length;){var a=this.bindings[e][t],i=a.handler,s=a.ctx,l=a.once,c=s;"undefined"==typeof c&&(c=this),i.apply(c,o),l?this.bindings[e].splice(t,1):++t}}}}]),e}();k.Utils={getActualBoundingClientRect:r,getScrollParents:a,getBounds:s,getOffsetParent:l,extend:u,addClass:f,removeClass:p,hasClass:d,updateClasses:y,defer:T,flush:j,uniqueId:E,Evented:N,getScrollBarSize:c,removeUtilElements:i};var A=function(){function e(e,t){var n=[],o=!0,r=!1,a=void 0;try{for(var i,s=e[Symbol.iterator]();!(o=(i=s.next()).done)&&(n.push(i.value),!t||n.length!==t);o=!0);}catch(e){r=!0,a=e}finally{try{!o&&s.return&&s.return()}finally{if(r)throw a}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),O=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),F=function(e,t,n){for(var o=!0;o;){var r=e,a=t,i=n;o=!1,null===r&&(r=Function.prototype);var s=Object.getOwnPropertyDescriptor(r,a);if(void 0!==s){if("value"in s)return s.value;var l=s.get;if(void 0===l)return;return l.call(i)}var c=Object.getPrototypeOf(r);if(null===c)return;e=c,t=a,n=i,o=!0,s=c=void 0}};if("undefined"==typeof k)throw new Error("You must include the utils.js file before tether.js");var R=k.Utils,a=R.getScrollParents,s=R.getBounds,l=R.getOffsetParent,u=R.extend,f=R.addClass,p=R.removeClass,y=R.updateClasses,T=R.defer,j=R.flush,c=R.getScrollBarSize,i=R.removeUtilElements,B=function(){if("undefined"==typeof document)return"";for(var e=document.createElement("div"),t=["transform","WebkitTransform","OTransform","MozTransform","msTransform"],n=0;n<t.length;++n){var o=t[n];if(void 0!==e.style[o])return o}}(),Y=[],W=function(){Y.forEach(function(e){e.position(!1)}),j()};!function(){var e=null,t=null,n=null,o=function o(){return"undefined"!=typeof t&&t>16?(t=Math.min(t-16,250),void(n=setTimeout(o,250))):void("undefined"!=typeof e&&b()-e<10||(null!=n&&(clearTimeout(n),n=null),e=b(),W(),t=b()-e))};"undefined"!=typeof window&&"undefined"!=typeof window.addEventListener&&["resize","scroll","touchmove"].forEach(function(e){window.addEventListener(e,o)})}();var I={center:"center",left:"right",right:"left"},L={middle:"middle",top:"bottom",bottom:"top"},V={top:0,left:0,middle:"50%",center:"50%",bottom:"100%",right:"100%"},z=function(e,t){var n=e.left,o=e.top;return"auto"===n&&(n=I[t.left]),"auto"===o&&(o=L[t.top]),{left:n,top:o}},H=function(e){var t=e.left,n=e.top;return"undefined"!=typeof V[e.left]&&(t=V[e.left]),"undefined"!=typeof V[e.top]&&(n=V[e.top]),{left:t,top:n}},X=function(e){var t=e.split(" "),n=A(t,2),o=n[0],r=n[1];return{top:o,left:r}},q=X,U=function(e){function t(e){var n=this;o(this,t),F(Object.getPrototypeOf(t.prototype),"constructor",this).call(this),this.position=this.position.bind(this),Y.push(this),this.history=[],this.setOptions(e,!1),k.modules.forEach(function(e){"undefined"!=typeof e.initialize&&e.initialize.call(n)}),this.position()}return g(t,e),O(t,[{key:"getClass",value:function(){var e=arguments.length<=0||void 0===arguments[0]?"":arguments[0],t=this.options.classes;return"undefined"!=typeof t&&t[e]?this.options.classes[e]:this.options.classPrefix?this.options.classPrefix+"-"+e:e}},{key:"setOptions",value:function(e){var t=this,n=arguments.length<=1||void 0===arguments[1]||arguments[1],o={offset:"0 0",targetOffset:"0 0",targetAttachment:"auto auto",classPrefix:"tether"};this.options=u(o,e);var r=this.options,i=r.element,s=r.target,l=r.targetModifier;if(this.element=i,this.target=s,this.targetModifier=l,"viewport"===this.target?(this.target=document.body,this.targetModifier="visible"):"scroll-handle"===this.target&&(this.target=document.body,this.targetModifier="scroll-handle"),["element","target"].forEach(function(e){if("undefined"==typeof t[e])throw new Error("Tether Error: Both element and target must be defined");"undefined"!=typeof t[e].jquery?t[e]=t[e][0]:"string"==typeof t[e]&&(t[e]=document.querySelector(t[e]))}),f(this.element,this.getClass("element")),this.options.addTargetClasses!==!1&&f(this.target,this.getClass("target")),!this.options.attachment)throw new Error("Tether Error: You must provide an attachment");this.targetAttachment=q(this.options.targetAttachment),this.attachment=q(this.options.attachment),this.offset=X(this.options.offset),this.targetOffset=X(this.options.targetOffset),"undefined"!=typeof this.scrollParents&&this.disable(),"scroll-handle"===this.targetModifier?this.scrollParents=[this.target]:this.scrollParents=a(this.target),this.options.enabled!==!1&&this.enable(n)}},{key:"getTargetBounds",value:function(){if("undefined"==typeof this.targetModifier)return s(this.target);if("visible"===this.targetModifier){if(this.target===document.body)return{top:pageYOffset,left:pageXOffset,height:innerHeight,width:innerWidth};var e=s(this.target),t={height:e.height,width:e.width,top:e.top,left:e.left};return t.height=Math.min(t.height,e.height-(pageYOffset-e.top)),t.height=Math.min(t.height,e.height-(e.top+e.height-(pageYOffset+innerHeight))),t.height=Math.min(innerHeight,t.height),t.height-=2,t.width=Math.min(t.width,e.width-(pageXOffset-e.left)),t.width=Math.min(t.width,e.width-(e.left+e.width-(pageXOffset+innerWidth))),t.width=Math.min(innerWidth,t.width),t.width-=2,t.top<pageYOffset&&(t.top=pageYOffset),t.left<pageXOffset&&(t.left=pageXOffset),t}if("scroll-handle"===this.targetModifier){var e=void 0,n=this.target;n===document.body?(n=document.documentElement,e={left:pageXOffset,top:pageYOffset,height:innerHeight,width:innerWidth}):e=s(n);var o=getComputedStyle(n),r=n.scrollWidth>n.clientWidth||[o.overflow,o.overflowX].indexOf("scroll")>=0||this.target!==document.body,a=0;r&&(a=15);var i=e.height-parseFloat(o.borderTopWidth)-parseFloat(o.borderBottomWidth)-a,t={width:15,height:.975*i*(i/n.scrollHeight),left:e.left+e.width-parseFloat(o.borderLeftWidth)-15},l=0;i<408&&this.target===document.body&&(l=-11e-5*Math.pow(i,2)-.00727*i+22.58),this.target!==document.body&&(t.height=Math.max(t.height,24));var c=this.target.scrollTop/(n.scrollHeight-i);return t.top=c*(i-t.height-l)+e.top+parseFloat(o.borderTopWidth),this.target===document.body&&(t.height=Math.max(t.height,24)),t}}},{key:"clearCache",value:function(){this._cache={}}},{key:"cache",value:function(e,t){return"undefined"==typeof this._cache&&(this._cache={}),"undefined"==typeof this._cache[e]&&(this._cache[e]=t.call(this)),this._cache[e]}},{key:"enable",value:function(){var e=this,t=arguments.length<=0||void 0===arguments[0]||arguments[0];this.options.addTargetClasses!==!1&&f(this.target,this.getClass("enabled")),f(this.element,this.getClass("enabled")),this.enabled=!0,this.scrollParents.forEach(function(t){t!==e.target.ownerDocument&&t.addEventListener("scroll",e.position)}),t&&this.position()}},{key:"disable",value:function(){var e=this;p(this.target,this.getClass("enabled")),p(this.element,this.getClass("enabled")),this.enabled=!1,"undefined"!=typeof this.scrollParents&&this.scrollParents.forEach(function(t){t.removeEventListener("scroll",e.position)})}},{key:"destroy",value:function(){var e=this;this.disable(),Y.forEach(function(t,n){t===e&&Y.splice(n,1)}),0===Y.length&&i()}},{key:"updateAttachClasses",value:function(e,t){var n=this;e=e||this.attachment,t=t||this.targetAttachment;var o=["left","top","bottom","right","middle","center"];"undefined"!=typeof this._addAttachClasses&&this._addAttachClasses.length&&this._addAttachClasses.splice(0,this._addAttachClasses.length),"undefined"==typeof this._addAttachClasses&&(this._addAttachClasses=[]);var r=this._addAttachClasses;e.top&&r.push(this.getClass("element-attached")+"-"+e.top),e.left&&r.push(this.getClass("element-attached")+"-"+e.left),t.top&&r.push(this.getClass("target-attached")+"-"+t.top),t.left&&r.push(this.getClass("target-attached")+"-"+t.left);var a=[];o.forEach(function(e){a.push(n.getClass("element-attached")+"-"+e),a.push(n.getClass("target-attached")+"-"+e)}),T(function(){"undefined"!=typeof n._addAttachClasses&&(y(n.element,n._addAttachClasses,a),n.options.addTargetClasses!==!1&&y(n.target,n._addAttachClasses,a),delete n._addAttachClasses)})}},{key:"position",value:function(){var e=this,t=arguments.length<=0||void 0===arguments[0]||arguments[0];if(this.enabled){this.clearCache();var n=z(this.targetAttachment,this.attachment);this.updateAttachClasses(this.attachment,n);var o=this.cache("element-bounds",function(){return s(e.element)}),r=o.width,a=o.height;if(0===r&&0===a&&"undefined"!=typeof this.lastSize){var i=this.lastSize;r=i.width,a=i.height}else this.lastSize={width:r,height:a};var u=this.cache("target-bounds",function(){return e.getTargetBounds()}),p=u,f=_(H(this.attachment),{width:r,height:a}),d=_(H(n),p),h=_(this.offset,{width:r,height:a}),m=_(this.targetOffset,p);f=w(f,h),d=w(d,m);for(var y=u.left+d.left-f.left,g=u.top+d.top-f.top,v=0;v<k.modules.length;++v){var b=k.modules[v],D=b.position.call(this,{left:y,top:g,targetAttachment:n,targetPos:u,elementPos:o,offset:f,targetOffset:d,manualOffset:h,manualTargetOffset:m,scrollbarSize:S,attachment:this.attachment});if(D===!1)return!1;"undefined"!=typeof D&&"object"==typeof D&&(g=D.top,y=D.left)}var O={page:{top:g,left:y},viewport:{top:g-pageYOffset,bottom:pageYOffset-g-a+innerHeight,left:y-pageXOffset,right:pageXOffset-y-r+innerWidth}},C=this.target.ownerDocument,E=C.defaultView,S=void 0;return E.innerHeight>C.documentElement.clientHeight&&(S=this.cache("scrollbar-size",c),O.viewport.bottom-=S.height),E.innerWidth>C.documentElement.clientWidth&&(S=this.cache("scrollbar-size",c),O.viewport.right-=S.width),["","static"].indexOf(C.body.style.position)!==-1&&["","static"].indexOf(C.body.parentElement.style.position)!==-1||(O.page.bottom=C.body.scrollHeight-g-a,O.page.right=C.body.scrollWidth-y-r),"undefined"!=typeof this.options.optimizations&&this.options.optimizations.moveElement!==!1&&"undefined"==typeof this.targetModifier&&!function(){var t=e.cache("target-offsetparent",function(){return l(e.target)}),n=e.cache("target-offsetparent-bounds",function(){return s(t)}),o=getComputedStyle(t),r=n,a={};if(["Top","Left","Bottom","Right"].forEach(function(e){a[e.toLowerCase()]=parseFloat(o["border"+e+"Width"])}),n.right=C.body.scrollWidth-n.left-r.width+a.right,n.bottom=C.body.scrollHeight-n.top-r.height+a.bottom,O.page.top>=n.top+a.top&&O.page.bottom>=n.bottom&&O.page.left>=n.left+a.left&&O.page.right>=n.right){var i=t.scrollTop,c=t.scrollLeft;O.offset={top:O.page.top-n.top+i-a.top,left:O.page.left-n.left+c-a.left}}}(),this.move(O),this.history.unshift(O),this.history.length>3&&this.history.pop(),t&&j(),!0}}},{key:"move",value:function(e){var t=this;if("undefined"!=typeof this.element.parentNode){var n={};for(var o in e){n[o]={};for(var r in e[o]){for(var a=!1,i=0;i<this.history.length;++i){var s=this.history[i];if("undefined"!=typeof s[o]&&!v(s[o][r],e[o][r])){a=!0;break}}a||(n[o][r]=!0)}}var c={top:"",left:"",right:"",bottom:""},p=function(e,n){var o="undefined"!=typeof t.options.optimizations,r=o?t.options.optimizations.gpu:null;if(r!==!1){var a=void 0,i=void 0;if(e.top?(c.top=0,a=n.top):(c.bottom=0,a=-n.bottom),e.left?(c.left=0,i=n.left):(c.right=0,i=-n.right),window.matchMedia){var s=window.matchMedia("only screen and (min-resolution: 1.3dppx)").matches||window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 1.3)").matches;s||(i=Math.round(i),a=Math.round(a))}c[B]="translateX("+i+"px) translateY("+a+"px)","msTransform"!==B&&(c[B]+=" translateZ(0)")}else e.top?c.top=n.top+"px":c.bottom=n.bottom+"px",e.left?c.left=n.left+"px":c.right=n.right+"px"},f=!1;if((n.page.top||n.page.bottom)&&(n.page.left||n.page.right)?(c.position="absolute",p(n.page,e.page)):(n.viewport.top||n.viewport.bottom)&&(n.viewport.left||n.viewport.right)?(c.position="fixed",p(n.viewport,e.viewport)):"undefined"!=typeof n.offset&&n.offset.top&&n.offset.left?!function(){c.position="absolute";var o=t.cache("target-offsetparent",function(){return l(t.target)});l(t.element)!==o&&T(function(){t.element.parentNode.removeChild(t.element),o.appendChild(t.element)}),p(n.offset,e.offset),f=!0}():(c.position="absolute",p({top:!0,left:!0},e.page)),!f)if(this.options.bodyElement)this.options.bodyElement.appendChild(this.element);else{for(var d=!0,h=this.element.parentNode;h&&1===h.nodeType&&"BODY"!==h.tagName;){if("static"!==getComputedStyle(h).position){d=!1;break}h=h.parentNode}d||(this.element.parentNode.removeChild(this.element),this.element.ownerDocument.body.appendChild(this.element))}var m={},y=!1;for(var r in c){var g=c[r],b=this.element.style[r];b!==g&&(y=!0,m[r]=g)}y&&T(function(){u(t.element.style,m),t.trigger("repositioned")})}}}]),t}(N);U.modules=[],k.position=W;var K=u(U,k),A=function(){function e(e,t){var n=[],o=!0,r=!1,a=void 0;try{for(var i,s=e[Symbol.iterator]();!(o=(i=s.next()).done)&&(n.push(i.value),!t||n.length!==t);o=!0);}catch(e){r=!0,a=e}finally{try{!o&&s.return&&s.return()}finally{if(r)throw a}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),R=k.Utils,s=R.getBounds,u=R.extend,y=R.updateClasses,T=R.defer,$=["left","top","right","bottom"];k.modules.push({position:function(e){var t=this,n=e.top,o=e.left,r=e.targetAttachment;if(!this.options.constraints)return!0;var a=this.cache("element-bounds",function(){return s(t.element)}),i=a.height,l=a.width;if(0===l&&0===i&&"undefined"!=typeof this.lastSize){var c=this.lastSize;l=c.width,i=c.height}var p=this.cache("target-bounds",function(){return t.getTargetBounds()}),f=p.height,d=p.width,h=[this.getClass("pinned"),this.getClass("out-of-bounds")];this.options.constraints.forEach(function(e){var t=e.outOfBoundsClass,n=e.pinnedClass;t&&h.push(t),n&&h.push(n)}),h.forEach(function(e){["left","top","right","bottom"].forEach(function(t){h.push(e+"-"+t)})});var m=[],g=u({},r),v=u({},this.attachment);return this.options.constraints.forEach(function(e){var a=e.to,s=e.attachment,c=e.pin;"undefined"==typeof s&&(s="");var u=void 0,p=void 0;if(s.indexOf(" ")>=0){var h=s.split(" "),y=A(h,2);p=y[0],u=y[1]}else u=p=s;var b=D(t,a);"target"!==p&&"both"!==p||(n<b[1]&&"top"===g.top&&(n+=f,g.top="bottom"),n+i>b[3]&&"bottom"===g.top&&(n-=f,g.top="top")),"together"===p&&("top"===g.top&&("bottom"===v.top&&n<b[1]?(n+=f,g.top="bottom",n+=i,v.top="top"):"top"===v.top&&n+i>b[3]&&n-(i-f)>=b[1]&&(n-=i-f,g.top="bottom",v.top="bottom")),"bottom"===g.top&&("top"===v.top&&n+i>b[3]?(n-=f,g.top="top",n-=i,v.top="bottom"):"bottom"===v.top&&n<b[1]&&n+(2*i-f)<=b[3]&&(n+=i-f,g.top="top",v.top="top")),"middle"===g.top&&(n+i>b[3]&&"top"===v.top?(n-=i,v.top="bottom"):n<b[1]&&"bottom"===v.top&&(n+=i,v.top="top"))),"target"!==u&&"both"!==u||(o<b[0]&&"left"===g.left&&(o+=d,g.left="right"),o+l>b[2]&&"right"===g.left&&(o-=d,g.left="left")),"together"===u&&(o<b[0]&&"left"===g.left?"right"===v.left?(o+=d,g.left="right",o+=l,v.left="left"):"left"===v.left&&(o+=d,g.left="right",o-=l,v.left="right"):o+l>b[2]&&"right"===g.left?"left"===v.left?(o-=d,g.left="left",o-=l,v.left="right"):"right"===v.left&&(o-=d,g.left="left",o+=l,v.left="left"):"center"===g.left&&(o+l>b[2]&&"left"===v.left?(o-=l,v.left="right"):o<b[0]&&"right"===v.left&&(o+=l,v.left="left"))),"element"!==p&&"both"!==p||(n<b[1]&&"bottom"===v.top&&(n+=i,v.top="top"),n+i>b[3]&&"top"===v.top&&(n-=i,v.top="bottom")),"element"!==u&&"both"!==u||(o<b[0]&&("right"===v.left?(o+=l,v.left="left"):"center"===v.left&&(o+=l/2,v.left="left")),o+l>b[2]&&("left"===v.left?(o-=l,v.left="right"):"center"===v.left&&(o-=l/2,v.left="right"))),"string"==typeof c?c=c.split(",").map(function(e){return e.trim()}):c===!0&&(c=["top","left","right","bottom"]),c=c||[];var w=[],_=[];n<b[1]&&(c.indexOf("top")>=0?(n=b[1],w.push("top")):_.push("top")),n+i>b[3]&&(c.indexOf("bottom")>=0?(n=b[3]-i,w.push("bottom")):_.push("bottom")),o<b[0]&&(c.indexOf("left")>=0?(o=b[0],w.push("left")):_.push("left")),o+l>b[2]&&(c.indexOf("right")>=0?(o=b[2]-l,w.push("right")):_.push("right")),w.length&&!function(){var e=void 0;e="undefined"!=typeof t.options.pinnedClass?t.options.pinnedClass:t.getClass("pinned"),m.push(e),w.forEach(function(t){m.push(e+"-"+t)})}(),_.length&&!function(){var e=void 0;e="undefined"!=typeof t.options.outOfBoundsClass?t.options.outOfBoundsClass:t.getClass("out-of-bounds"),m.push(e),_.forEach(function(t){m.push(e+"-"+t)})}(),(w.indexOf("left")>=0||w.indexOf("right")>=0)&&(v.left=g.left=!1),(w.indexOf("top")>=0||w.indexOf("bottom")>=0)&&(v.top=g.top=!1),g.top===r.top&&g.left===r.left&&v.top===t.attachment.top&&v.left===t.attachment.left||(t.updateAttachClasses(v,g),t.trigger("update",{attachment:v,targetAttachment:g}))}),T(function(){t.options.addTargetClasses!==!1&&y(t.target,m,h),y(t.element,m,h)}),{top:n,left:o}}});var R=k.Utils,s=R.getBounds,y=R.updateClasses,T=R.defer;k.modules.push({position:function(e){var t=this,n=e.top,o=e.left,r=this.cache("element-bounds",function(){return s(t.element)}),a=r.height,i=r.width,l=this.getTargetBounds(),c=n+a,u=o+i,p=[];n<=l.bottom&&c>=l.top&&["left","right"].forEach(function(e){var t=l[e];t!==o&&t!==u||p.push(e)}),o<=l.right&&u>=l.left&&["top","bottom"].forEach(function(e){var t=l[e];t!==n&&t!==c||p.push(e)});var f=[],d=[],h=["left","top","right","bottom"];return f.push(this.getClass("abutted")),h.forEach(function(e){f.push(t.getClass("abutted")+"-"+e)}),p.length&&d.push(this.getClass("abutted")),p.forEach(function(e){d.push(t.getClass("abutted")+"-"+e)}),T(function(){t.options.addTargetClasses!==!1&&y(t.target,d,f),y(t.element,d,f)}),!0}});var A=function(){function e(e,t){var n=[],o=!0,r=!1,a=void 0;try{for(var i,s=e[Symbol.iterator]();!(o=(i=s.next()).done)&&(n.push(i.value),!t||n.length!==t);o=!0);}catch(e){r=!0,a=e}finally{try{!o&&s.return&&s.return()}finally{if(r)throw a}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();return k.modules.push({position:function(e){var t=e.top,n=e.left;if(this.options.shift){var o=this.options.shift;"function"==typeof this.options.shift&&(o=this.options.shift.call(this,{top:t,left:n}));var r=void 0,a=void 0;if("string"==typeof o){o=o.split(" "),o[1]=o[1]||o[0];var i=o,s=A(i,2);r=s[0],a=s[1],r=parseFloat(r,10),a=parseFloat(a,10)}else r=o.top,a=o.left;return t+=r,n+=a,{top:t,left:n}}}}),K})}])});

/***/ }),
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * A higher-order-component for handling onClickOutside for React components.
 */
(function(root) {

  // administrative
  var registeredComponents = [];
  var handlers = [];
  var IGNORE_CLASS = 'ignore-react-onclickoutside';
  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];

  /**
   * Check whether some DOM node is our Component's node.
   */
  var isNodeFound = function(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    }
    // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) {
      return current.correspondingElement.classList.contains(ignoreClass);
    }
    return current.classList.contains(ignoreClass);
  };

  /**
   * Try to find our node in a hierarchy of nodes, returning the document
   * node as highest noode if our node is not found in the path up.
   */
  var findHighest = function(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    }

    // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    while(current.parentNode) {
      if (isNodeFound(current, componentNode, ignoreClass)) {
        return true;
      }
      current = current.parentNode;
    }
    return current;
  };

  /**
   * Check if the browser scrollbar was clicked
   */
  var clickedScrollbar = function(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
  };

  /**
   * Generate the event handler that checks whether a clicked DOM node
   * is inside of, or lives outside of, our Component's node tree.
   */
  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
    return function(evt) {
      if (preventDefault) {
        evt.preventDefault();
      }
      if (stopPropagation) {
        evt.stopPropagation();
      }
      var current = evt.target;
      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
        return;
      }
      eventHandler(evt);
    };
  };

  /**
   * This function generates the HOC function that you'll use
   * in order to impart onOutsideClick listening to an
   * arbitrary component. It gets called at the end of the
   * bootstrapping code to yield an instance of the
   * onClickOutsideHOC function defined inside setupHOC().
   */
  function setupHOC(root, React, ReactDOM, createReactClass) {

    // The actual Component-wrapping HOC:
    return function onClickOutsideHOC(Component, config) {
      var wrapComponentWithOnClickOutsideHandling = createReactClass({
        statics: {
          /**
           * Access the wrapped Component's class.
           */
          getClass: function() {
            if (Component.getClass) {
              return Component.getClass();
            }
            return Component;
          }
        },

        /**
         * Access the wrapped Component's instance.
         */
        getInstance: function() {
          return Component.prototype.isReactComponent ? this.refs.instance : this;
        },

        // this is given meaning in componentDidMount
        __outsideClickHandler: function() {},

        getDefaultProps: function() {
          return {
            excludeScrollbar: config && config.excludeScrollbar
          };
        },

        /**
         * Add click listeners to the current document,
         * linked to this component's state.
         */
        componentDidMount: function() {
          // If we are in an environment without a DOM such
          // as shallow rendering or snapshots then we exit
          // early to prevent any unhandled errors being thrown.
          if (typeof document === 'undefined' || !document.createElement){
            return;
          }

          var instance = this.getInstance();
          var clickOutsideHandler;

          if(config && typeof config.handleClickOutside === 'function') {
            clickOutsideHandler = config.handleClickOutside(instance);
            if(typeof clickOutsideHandler !== 'function') {
              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
            }
          } else if(typeof instance.handleClickOutside === 'function') {
            if (React.Component.prototype.isPrototypeOf(instance)) {
              clickOutsideHandler = instance.handleClickOutside.bind(instance);
            } else {
              clickOutsideHandler = instance.handleClickOutside;
            }
          } else if(typeof instance.props.handleClickOutside === 'function') {
            clickOutsideHandler = instance.props.handleClickOutside;
          } else {
            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
          }

          var componentNode = ReactDOM.findDOMNode(instance);
          if (componentNode === null) {
            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
            console.warn([
              'This is typically caused by having a component that starts life with a render function that',
              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
              'decision of whether or not to show your component is handled by the parent, in their render()',
              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
              'the parent is always responsible for deciding whether or not to render any of its children.',
              'It is not the child\'s responsibility to decide whether a render instruction from above should',
              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
              'for that decision.'
            ].join(' '));
          }

          var fn = this.__outsideClickHandler = generateOutsideCheck(
            componentNode,
            instance,
            clickOutsideHandler,
            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
            this.props.preventDefault || false,
            this.props.stopPropagation || false
          );

          var pos = registeredComponents.length;
          registeredComponents.push(this);
          handlers[pos] = fn;

          // If there is a truthy disableOnClickOutside property for this
          // component, don't immediately start listening for outside events.
          if (!this.props.disableOnClickOutside) {
            this.enableOnClickOutside();
          }
        },

        /**
        * Track for disableOnClickOutside props changes and enable/disable click outside
        */
        componentWillReceiveProps: function(nextProps) {
          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
            this.enableOnClickOutside();
          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
            this.disableOnClickOutside();
          }
        },

        /**
         * Remove the document's event listeners
         */
        componentWillUnmount: function() {
          this.disableOnClickOutside();
          this.__outsideClickHandler = false;
          var pos = registeredComponents.indexOf(this);
          if( pos>-1) {
            // clean up so we don't leak memory
            if (handlers[pos]) { handlers.splice(pos, 1); }
            registeredComponents.splice(pos, 1);
          }
        },

        /**
         * Can be called to explicitly enable event listening
         * for clicks and touches outside of this element.
         */
        enableOnClickOutside: function() {
          var fn = this.__outsideClickHandler;
          if (typeof document !== 'undefined') {
            var events = this.props.eventTypes || DEFAULT_EVENTS;
            if (!events.forEach) {
              events = [events];
            }
            events.forEach(function (eventName) {
              document.addEventListener(eventName, fn);
            });
          }
        },

        /**
         * Can be called to explicitly disable event listening
         * for clicks and touches outside of this element.
         */
        disableOnClickOutside: function() {
          var fn = this.__outsideClickHandler;
          if (typeof document !== 'undefined') {
            var events = this.props.eventTypes || DEFAULT_EVENTS;
            if (!events.forEach) {
              events = [events];
            }
            events.forEach(function (eventName) {
              document.removeEventListener(eventName, fn);
            });
          }
        },

        /**
         * Pass-through render
         */
        render: function() {
          var passedProps = this.props;
          var props = {};
          Object.keys(this.props).forEach(function(key) {
            if (key !== 'excludeScrollbar') {
              props[key] = passedProps[key];
            }
          });
          if (Component.prototype.isReactComponent) {
            props.ref = 'instance';
          }
          props.disableOnClickOutside = this.disableOnClickOutside;
          props.enableOnClickOutside = this.enableOnClickOutside;
          return React.createElement(Component, props);
        }
      });

      // Add display name for React devtools
      (function bindWrappedComponentName(c, wrapper) {
        var componentName = c.displayName || c.name || 'Component';
        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
      }(Component, wrapComponentWithOnClickOutsideHandling));

      return wrapComponentWithOnClickOutsideHandling;
    };
  }

  /**
   * This function sets up the library in ways that
   * work with the various modulde loading solutions
   * used in JavaScript land today.
   */
  function setupBinding(root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0),__webpack_require__(50),__webpack_require__(71)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
        if (!createReactClass) createReactClass = React.createClass;
        return factory(root, React, ReactDom, createReactClass);
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
      // Node. Note that this does not work with strict
      // CommonJS, but only CommonJS-like environments
      // that support module.exports
      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
    } else {
      // Browser globals (root is window)
      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
    }
  }

  // Make it all happen
  setupBinding(root, setupHOC);

}(this));


/***/ }),
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1554);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(28)))

/***/ }),
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.Scrollparent = factory();
  }
}(this, function () {
  var regex = /(auto|scroll)/;

  var parents = function (node, ps) {
    if (node.parentNode === null) { return ps; }

    return parents(node.parentNode, ps.concat([node]));
  };

  var style = function (node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
  };

  var overflow = function (node) {
    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
  };

  var scroll = function (node) {
   return regex.test(overflow(node));
  };

  var scrollParent = function (node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return ;
    }

    var ps = parents(node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent;
}));


/***/ }),
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./amex.png": 1151,
	"./amex@2x.png": 1152,
	"./amex@3x.png": 1153,
	"./bofa.png": 1154,
	"./bofa@2x.png": 1155,
	"./bofa@3x.png": 1156,
	"./capone.png": 1157,
	"./capone360.png": 1158,
	"./capone360@2x.png": 1159,
	"./capone360@3x.png": 1160,
	"./chase.png": 1161,
	"./chase@2x.png": 1162,
	"./chase@3x.png": 1163,
	"./citi.png": 1164,
	"./citi@2x.png": 1165,
	"./citi@3x.png": 1166,
	"./etrade.png": 1167,
	"./fidelity.png": 1168,
	"./fidelity@2x.png": 1169,
	"./fidelity@3x.png": 1170,
	"./merrill.png": 1171,
	"./nfcu.png": 1172,
	"./nfcu@2x.png": 1173,
	"./nfcu@3x.png": 1174,
	"./pnc.png": 1175,
	"./pnc@2x.png": 1176,
	"./pnc@3x.png": 1177,
	"./schwab.png": 1178,
	"./schwab@2x.png": 1179,
	"./schwab@3x.png": 1180,
	"./scottrade.png": 1181,
	"./suntrust.png": 1182,
	"./suntrust@2x.png": 1183,
	"./suntrust@3x.png": 1184,
	"./svb.png": 1185,
	"./svb@2x.png": 1186,
	"./svb@3x.png": 1187,
	"./td.png": 1188,
	"./td@2x.png": 1189,
	"./td@3x.png": 1190,
	"./us.png": 1191,
	"./us@2x.png": 1192,
	"./us@3x.png": 1193,
	"./usaa.png": 1194,
	"./usaa@2x.png": 1195,
	"./usaa@3x.png": 1196,
	"./wells.png": 1197,
	"./wells@2x.png": 1198,
	"./wells@3x.png": 1199
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1593;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./apple.png": 1208,
	"./devices.png": 481,
	"./devices@2x.png": 1209,
	"./devices@3x.png": 1210,
	"./icon-chat.png": 1211,
	"./icon-doc.png": 1212,
	"./icon-pro.png": 1213,
	"./icon-w2.png": 1214,
	"./logo-blue.png": 482,
	"./logo-businessinsider.png": 1215,
	"./logo-forbes.png": 1216,
	"./logo-icon.png": 483,
	"./logo-macworld.png": 1217,
	"./logo-venturebeat.png": 1218,
	"./logo-yahoo.png": 1219,
	"./logo.png": 1220,
	"./logo@2x.png": 1221,
	"./ornament-left-white.png": 1222,
	"./ornament-left.png": 484,
	"./ornament-right-white.png": 1223,
	"./ornament-right.png": 485,
	"./step1.png": 486,
	"./step2.png": 487,
	"./step3.png": 488
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1594;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./FeeBreakdown/Boxes/index.jsx": 424,
	"./FeeBreakdown/index.jsx": 789,
	"./LinkAccounts/index.jsx": 790,
	"./ProjectType/index.jsx": 792,
	"./Questions/index.jsx": 794,
	"./TaxStates/index.jsx": 796,
	"./TaxYears/index.jsx": 798,
	"./UploadDocuments/index.jsx": 799,
	"./WizardCompleted/index.jsx": 801
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1595;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./mileiq/index.jsx": 810,
	"./standard/index.jsx": 811
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1596;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./mileiq-banner.jpg": 1226,
	"./mileiq-taxfyle.png": 1227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1597;

/***/ }),
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(609);


/***/ })
],[1604]);


// WEBPACK FOOTER //
// app.js